import e, { useState as t, useEffect as n, useContext as r, useMemo as i, Component as a, memo as o, createContext as s, useCallback as l, useRef as c, isValidElement as d, cloneElement as u, createElement as p, Fragment as m, forwardRef as f } from "react";
import g, { css as _ } from "styled-components";
function y(e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;
  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
      i = document.createElement("style");
    i.type = "text/css", "top" === n && r.firstChild ? r.insertBefore(i, r.firstChild) : r.appendChild(i), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e));
  }
}
var h = "style_header__1Gz6u",
  v = "style_headerSecondary__PaZZJ",
  b = "style_sticky__me7O0",
  x = "style_headerLogoWrapper__24PsC",
  E = "style_linkCollection__2QWrT",
  k = "style_headerDark__3rKRM",
  T = "style_headerMiddle__2f0dG",
  w = "style_headerRight__g0FtS",
  A = "style_headerBright__3IAXm";
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.style_header__1Gz6u {\n  border-radius: 0px;\n  padding: 0 15px;\n  max-height: 72px;\n  min-height: 72px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 10;\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px; }\n  .style_header__1Gz6u > div {\n    width: 100%; }\n  @media (max-width: 440px) {\n    .style_header__1Gz6u {\n      padding: 0 20px !important; } }\n  @media (max-width: 380px) {\n    .style_header__1Gz6u {\n      padding: 0 10px !important; } }\n  .style_header__1Gz6u img {\n    height: 40px; }\n  .style_headerSecondary__PaZZJ {\n    min-height: 52px;\n    max-height: 52px; }\n\n.style_sticky__me7O0 {\n  position: sticky !important;\n  top: 0 !important; }\n\n.style_header__1Gz6u > * {\n  padding: 0; }\n  .style_header__1Gz6u > * a {\n    text-decoration: none; }\n  .style_header__1Gz6u > * h3 {\n    padding: 0 !important;\n    margin: 0; }\n\n.style_headerLogoWrapper__24PsC {\n  display: flex;\n  flex-direction: row;\n  padding-bottom: 0; }\n\n.style_linkCollection__2QWrT > *, .style_linkCollection__2QWrT > * > *, .style_linkCollection__2QWrT > * > * > * {\n  display: flex;\n  margin-left: 10px;\n  align-items: center; }\n  .style_linkCollection__2QWrT > * [class*="menuItem"] a, .style_linkCollection__2QWrT > * > * [class*="menuItem"] a, .style_linkCollection__2QWrT > * > * > * [class*="menuItem"] a {\n    color: #fff !important; }\n\n.style_headerDark__3rKRM .style_headerLeft__2hYmS, .style_headerDark__3rKRM .style_headerMiddle__2f0dG, .style_headerDark__3rKRM .style_headerRight__g0FtS {\n  display: flex;\n  align-items: center; }\n  .style_headerDark__3rKRM .style_headerLeft__2hYmS [class*="menuItem"] a, .style_headerDark__3rKRM .style_headerMiddle__2f0dG [class*="menuItem"] a, .style_headerDark__3rKRM .style_headerRight__g0FtS [class*="menuItem"] a {\n    color: #fff !important; }\n\n.style_headerBright__3IAXm .style_headerLeft__2hYmS, .style_headerBright__3IAXm .style_headerMiddle__2f0dG, .style_headerBright__3IAXm .style_headerRight__g0FtS {\n  display: flex;\n  align-items: center; }\n');
var C = function (t) {
    var n = t.context,
      r = t.left,
      i = t.middle,
      a = t.right,
      o = t.level,
      s = void 0 === o ? "primary" : o,
      l = t.menu,
      c = void 0 !== l && l,
      d = t.sticky,
      u = void 0 !== d && d,
      p = t.noLogo,
      m = t.logoVariant,
      f = t.logoUrl,
      g = t.profile,
      _ = t.loggedInAs,
      y = t.loginAsModal,
      C = t.logout,
      S = t.logOutAs,
      N = t.transparent,
      O = void 0 !== N && N,
      R = t.background,
      I = t.subMenu,
      L = t.siteMap,
      j = t.theme,
      D = void 0 === j ? "bright" : j,
      F = t.title,
      M = void 0 === F ? "" : F,
      P = t.linkCollection,
      B = t.avatarLinks,
      H = function (t) {
        return e.createElement("div", {
          style: {
            whiteSpace: "nowrap",
            marginLeft: "15px",
            marginTop: "2px"
          }
        }, t && "/", " ", t);
      };
    return e.createElement("div", {
      className: "".concat(h, " ").concat("dark" === D ? k : A, " ").concat(u ? b : "", " ").concat("secondary" === s ? v : ""),
      style: {
        borderBottom: O ? "none" : "solid 1px rgba(0, 0, 0, 0.16)",
        backgroundColor: R || (O ? "rgba(50, 0, 0, 0)" : "dark" === D ? "#181818" : "rgba(255,255,255,1)")
      }
    }, e.createElement(Qt, {
      breakpoints: [0, 368, 768, 962, 1200],
      top: "0px",
      right: "0px",
      bottom: "0px",
      left: "0px"
    }, e.createElement(en, {
      cols: P ? [12, 12, 12, 3] : i ? [6, 3, 3, 3] : [12, 6, 6, 6]
    }, e.createElement("div", {
      className: x,
      style: {
        display: "flex",
        alignItems: "center",
        height: "secondary" === s ? 52 : 72
      }
    }, e.createElement(K, {
      direction: "row"
    }, f ? e.createElement(K, {
      direction: "row",
      align: "center",
      nowrap: !0
    }, L ? e.createElement(Nn, t) : null, p ? null : e.createElement(Bl, {
      padding: "16px 14px",
      theme: D
    }, e.createElement("a", {
      href: f
    }, e.createElement(Wc, {
      title: I ? "" : H(M),
      variant: "".concat(m),
      context: n,
      menu: c,
      size: "xlarge",
      color: "dark" === D ? "white" : "black"
    })))) : e.createElement(K, {
      direction: "row",
      align: "center"
    }, L ? e.createElement(Nn, t) : null, p ? null : e.createElement(Wc, {
      title: I ? "" : H(M),
      variant: "".concat(m || "default"),
      context: n,
      menu: c,
      size: "xlarge",
      color: "dark" === D ? "white" : "black"
    }))), I ? e.createElement(tc, {
      position: "bottom",
      zonePadding: "9px 14px",
      trigger: e.createElement("div", {
        style: {
          margin: -10,
          marginRight: 10
        }
      }, e.createElement(K, {
        direction: "row",
        align: "center"
      }, e.createElement(Wc, {
        title: H(M),
        menu: c
      }), e.createElement(nd, {
        icon: "keyboard_arrow_down"
      }))),
      content: e.createElement("div", {
        style: {
          minWidth: 300
        }
      }, e.createElement(dn, {
        stretch: !0,
        direction: "column",
        data: I
      }))
    }) : null, r || null)), i && !P ? e.createElement(en, {
      cols: [0, 6, 6]
    }, e.createElement("div", {
      className: T,
      style: {
        display: "flex",
        alignItems: "center",
        height: "secondary" === s ? 52 : 72
      }
    }, i)) : null, P ? null : e.createElement(en, {
      cols: i ? [6, 3, 3] : [0, 6, 6]
    }, a || g ? e.createElement("div", {
      className: w,
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        height: "secondary" === s ? 52 : 72
      }
    }, e.createElement(K, {
      direction: "row",
      align: "center"
    }, a, e.createElement(Ys, {
      profile: g,
      loggedInAs: _,
      loginAsModal: y,
      logout: C,
      logOutAs: S,
      theme: D,
      links: B
    }))) : null), P ? e.createElement(en, {
      cols: [0, 0, 9]
    }, e.createElement("div", {
      className: E,
      style: {
        display: "flex",
        alignItems: "right",
        justifyContent: "flex-end",
        height: "secondary" === s ? 52 : 72
      }
    }, e.createElement(K, {
      direction: "row",
      align: "right",
      justifyContent: ""
    }, P))) : null));
  },
  S = "footer_footerWrapper__AX66-",
  N = "footer_footerUpper__Vsvbm",
  O = "footer_footerLower__1BaMV";
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n/*\n@mixin desk-1050{\n    @media (max-width: 1050px){\n        @content;\n    }\n}\n*/\n.footer_footerWrapper__AX66- {\n  background-color: #181818;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%; }\n  .footer_footerWrapper__AX66- section.footer_footerUpper__Vsvbm, .footer_footerWrapper__AX66- section.footer_footerLower__1BaMV {\n    width: 100%;\n    padding: 60px 100px;\n    justify-content: center; }\n    @media all and (max-width: 768px) {\n      .footer_footerWrapper__AX66- section.footer_footerUpper__Vsvbm, .footer_footerWrapper__AX66- section.footer_footerLower__1BaMV {\n        padding: 25px 0 25px 25px; } }\n    .footer_footerWrapper__AX66- section.footer_footerUpper__Vsvbm h4, .footer_footerWrapper__AX66- section.footer_footerLower__1BaMV h4 {\n      color: #f5f5f5;\n      margin-bottom: 10px; }\n    .footer_footerWrapper__AX66- section.footer_footerUpper__Vsvbm p, .footer_footerWrapper__AX66- section.footer_footerLower__1BaMV p {\n      color: #f5f5f5;\n      font-size: 16px; }\n  .footer_footerWrapper__AX66- section.footer_footerUpper__Vsvbm {\n    margin: 0; }\n    .footer_footerWrapper__AX66- section.footer_footerUpper__Vsvbm h4 {\n      font-weight: bolder;\n      color: #f5f5f5;\n      font-size: 24px; }\n      @media all and (max-width: 650px) {\n        .footer_footerWrapper__AX66- section.footer_footerUpper__Vsvbm h4 {\n          font-size: 20px; } }\n    .footer_footerWrapper__AX66- section.footer_footerUpper__Vsvbm p {\n      color: #f5f5f5;\n      font-size: 16px;\n      font-weight: normal; }\n  .footer_footerWrapper__AX66- section.footer_footerLower__1BaMV {\n    background-color: #292929; }\n    .footer_footerWrapper__AX66- section.footer_footerLower__1BaMV h4 {\n      font-weight: bolder;\n      font-size: 16px;\n      color: #f5f5f5; }\n    .footer_footerWrapper__AX66- section.footer_footerLower__1BaMV p {\n      color: #f5f5f5;\n      font-size: 16px;\n      font-weight: normal; }\n');
var R = function (t) {
  var n = t.footerData,
    r = n;
  return n ? e.createElement(Qt, {
    className: S,
    colspan: 12,
    padding: "0"
  }, e.createElement(en, {
    cols: 12,
    tag: "section",
    className: N
  }, e.createElement(Qt, {
    cssMode: "flex",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0"
  }, Ff(r)[0].menu.map(function (t, n) {
    var r = t.title,
      i = t.link;
    return e.createElement(en, {
      key: n,
      cols: [6, 4, 2]
    }, e.createElement(K, {
      align: "flex-start",
      justify: "flex-start"
    }, e.createElement("h4", null, r), i.map(function (t, n) {
      return e.createElement("a", {
        key: n,
        href: "".concat(t.url)
      }, e.createElement("p", null, t.text));
    })));
  }))), e.createElement(en, {
    cols: 12,
    tag: "section",
    className: O
  }, e.createElement(Qt, {
    top: "0",
    right: "0",
    bottom: "0",
    left: "0"
  }, Ff(r)[1].menu.map(function (t, n) {
    var r = t.title,
      i = t.link;
    return e.createElement(en, {
      key: n,
      cols: [6, 3, 2]
    }, e.createElement(K, {
      align: "flex-start",
      justify: "flex-start"
    }, e.createElement("h4", null, r), i[0].url ? e.createElement("a", {
      href: "".concat(i[0].url)
    }, e.createElement("p", null, i[0].text)) : e.createElement("p", null, i[0].text)));
  })))) : null;
};
function I(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function L(e, t) {
  if (e) {
    if ("string" == typeof e) return I(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? I(e, t) : void 0;
  }
}
function j(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);
    if (null != n) {
      var r,
        i,
        a = [],
        o = !0,
        s = !1;
      try {
        for (n = n.call(e); !(o = (r = n.next()).done) && (a.push(r.value), !t || a.length !== t); o = !0);
      } catch (e) {
        s = !0, i = e;
      } finally {
        try {
          o || null == n.return || n.return();
        } finally {
          if (s) throw i;
        }
      }
      return a;
    }
  }(e, t) || L(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function D(e) {
  return "function" != typeof matchMedia ? null : matchMedia(e);
}
function F(e) {
  return e ? {
    media: e.media,
    matches: e.matches
  } : null;
}
function M(t) {
  var n = e.useState(function () {
      return F(D(t));
    }),
    r = n[1],
    i = e.useCallback(function (e) {
      return r(F(e));
    }, [r]);
  return e.useEffect(function () {
    var e = D(t);
    return i(e), e.addListener(i), function () {
      return e.removeListener(i);
    };
  }, [i, t]), n[0];
}
var P = {
    useMedia: M,
    useMediaPredicate: function (e) {
      var t = M(e);
      return t && t.matches || !1;
    }
  },
  B = {
    ttroot: "style_ttroot__1B77j",
    borders: "style_borders__29fdz",
    gridMenu: "style_gridMenu__2iNMQ",
    gridMain: "style_gridMain__240R3",
    mainWrapper: "style_mainWrapper__8XGei",
    gridMainWider: "style_gridMainWider__2ipLk",
    gridFooter: "style_gridFooter__2P118",
    bright: "style_bright__1jI0u",
    shady: "style_shady__MqRrQ"
  };
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\nhtml {\n  scroll-behavior: smooth;\n  width: 100%;\n  min-height: 100%; }\n\nbody {\n  min-height: 100%; }\n\nbody {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  background-color: #4c565c;\n  justify-content: center; }\n  body > div {\n    width: 100%;\n    min-height: 100%; }\n\n.style_ttroot__1B77j {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  display: flex;\n  flex-direction: column;\n  width: 100%; }\n  .style_ttroot__1B77j h1 {\n    font-family: "Montserrat", sans-serif;\n    font-size: 72px;\n    font-weight: 600;\n    color: rgba(0, 0, 0, 0.75);\n    line-height: 93px; }\n  .style_ttroot__1B77j h2 {\n    font-size: 48px;\n    line-height: 52px;\n    font-weight: 600;\n    color: #222222;\n    margin-top: 15px;\n    margin-bottom: 0; }\n  .style_ttroot__1B77j h3 {\n    font-family: "Roboto", sans-serif;\n    font-size: 28px;\n    font-weight: 600;\n    color: #222;\n    line-height: 36px; }\n  .style_ttroot__1B77j h4 {\n    font-family: "Roboto", sans-serif;\n    font-size: 20px;\n    font-weight: 600;\n    color: rgba(0, 0, 0, 0.75);\n    line-height: 27px; }\n  .style_ttroot__1B77j h5 {\n    font-family: "Roboto", sans-serif;\n    font-size: 20px;\n    font-weight: 400;\n    color: #181818;\n    line-height: 27px; }\n  .style_ttroot__1B77j p {\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 400;\n    color: #222;\n    max-width: 760px;\n    margin: 15px 0; }\n  .style_ttroot__1B77j label {\n    font-size: 16px; }\n  .style_ttroot__1B77j a {\n    color: #3f51bf !important;\n    text-decoration: none; }\n  .style_ttroot__1B77j ul li {\n    margin: 16px 0px; }\n  .style_ttroot__1B77j hr {\n    border: none;\n    border-bottom: solid 1px #D8D8D8; }\n  .style_ttroot__1B77j table {\n    max-width: 100%;\n    min-width: 100%;\n    margin: 0;\n    margin-top: 16px;\n    margin-bottom: 16px;\n    padding: 0;\n    border-collapse: collapse;\n    border-spacing: 0; }\n    .style_ttroot__1B77j table tr:nth-child(even) {\n      background-color: #f1f1f1; }\n    .style_ttroot__1B77j table th, .style_ttroot__1B77j table td {\n      margin: 0; }\n    .style_ttroot__1B77j table thead th {\n      text-align: left;\n      border-bottom: none; }\n    .style_ttroot__1B77j table tbody tr:last-of-type td {\n      border-bottom: none; }\n  .style_ttroot__1B77j label {\n    margin-top: 10px;\n    margin-right: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: fit-content; }\n  .style_ttroot__1B77j select {\n    cursor: pointer;\n    min-width: 340px;\n    border-radius: 2px;\n    border: solid 1px #dbdbdb;\n    margin: 10px 10px 10px 0;\n    background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);\n    background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;\n    background-size: 5px 5px, 5px 5px, 1px 1.5em;\n    background-repeat: no-repeat; }\n    .style_ttroot__1B77j select option {\n      cursor: pointer !important;\n      background-color: #f8f8f8;\n      padding: 10px;\n      position: absolute;\n      top: 100%;\n      left: 0;\n      right: 0;\n      z-index: 99; }\n  .style_ttroot__1B77j select:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #000; }\n  .style_ttroot__1B77j fieldset {\n    border: 1px solid #00000029;\n    border-bottom: none;\n    border-right: none;\n    border-left: none;\n    padding: 10px 10px 10px 20px;\n    margin-right: 10px;\n    margin-top: 10px;\n    display: flex; }\n    .style_ttroot__1B77j fieldset legend {\n      padding: 0 1ex; }\n    .style_ttroot__1B77j fieldset label {\n      margin: 0;\n      padding: 0; }\n  .style_ttroot__1B77j input {\n    margin: 10px 10px 10px 0;\n    background-color: #f8f8f8;\n    border-color: #bdbdbd;\n    font-family: roboto; }\n    .style_ttroot__1B77j input[type=text], .style_ttroot__1B77j input[type=time], .style_ttroot__1B77j input[type=email], .style_ttroot__1B77j input[type=date], .style_ttroot__1B77j input[type=number] {\n      border-radius: 2px;\n      border: solid 1px #dbdbdb;\n      background-color: #f8f8f8;\n      font-size: 16px;\n      font-weight: normal;\n      font-stretch: normal;\n      font-style: normal;\n      line-height: 1.19;\n      letter-spacing: normal;\n      padding: 10px;\n      color: rgba(0, 0, 0, 0.87);\n      min-width: 320px; }\n    .style_ttroot__1B77j input[type=time], .style_ttroot__1B77j input[type=date] {\n      padding-top: 8px;\n      padding-bottom: 8px; }\n    .style_ttroot__1B77j input[type=checkbox], .style_ttroot__1B77j input[type=radio] {\n      cursor: pointer;\n      width: 20px;\n      height: 20px;\n      border: solid 2px rgba(0, 0, 0, 0.55); }\n    .style_ttroot__1B77j input[type=checkbox] {\n      cursor: pointer;\n      border-radius: 3px; }\n  .style_ttroot__1B77j textarea {\n    border-radius: 2px;\n    border: solid 1px #dbdbdb;\n    background-color: #f8f8f8;\n    font-size: 16px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    font-family: roboto;\n    line-height: 1.19;\n    letter-spacing: normal;\n    padding: 10px;\n    color: rgba(0, 0, 0, 0.87);\n    min-width: 320px;\n    min-height: 80px; }\n\n.style_borders__29fdz > * {\n  border: solid 1px #333;\n  padding: 20px; }\n\n.style_gridMenu__2iNMQ {\n  padding: 20px;\n  min-width: 240px;\n  position: -webkit-sticky;\n  /* Safari */\n  position: sticky;\n  top: 0px; }\n  .style_gridMenu__2iNMQ ul {\n    list-style-type: none;\n    padding: 0 0 0 15px;\n    margin: 0; }\n\n.style_gridMain__240R3 {\n  padding: 20px 160px 20px 20px; }\n\n.style_mainWrapper__8XGei {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0;\n  background-color: #fff; }\n\n.style_gridMainWider__2ipLk {\n  grid-column: 1/13;\n  grid-row: 1/1;\n  width: 100%; }\n\n.style_gridFooter__2P118 {\n  grid-column: 1/13;\n  grid-row: 2/2; }\n\n.style_bright__1jI0u {\n  background: #f0f0f0; }\n\n.style_shady__MqRrQ {\n  color: #fff;\n  background: -moz-radial-gradient(center, ellipse cover, #7d868b 0%, #5f676d 100%);\n  /* ff3.6+ */\n  background: -webkit-gradient(radial, center center, 0px, center center, 100%, color-stop(0%, #7d868b), color-stop(100%, #5f676d));\n  /* safari4+,chrome */\n  background: -webkit-radial-gradient(center, ellipse cover, #7d868b 0%, #5f676d 100%);\n  /* safari5.1+,chrome10+ */\n  background: -o-radial-gradient(center, ellipse cover, #7d868b 0%, #5f676d 100%);\n  /* opera 11.10+ */\n  background: -ms-radial-gradient(center, ellipse cover, #7d868b 0%, #5f676d 100%);\n  /* ie10+ */\n  background: radial-gradient(ellipse at center, #7d868b 0%, #5f676d 100%);\n  /* w3c */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#7D868B\', endColorstr=\'#5F676D\',GradientType=1 );\n  /* ie6-9 */ }\n  .style_shady__MqRrQ h1, .style_shady__MqRrQ h2, .style_shady__MqRrQ h3 {\n    color: #fff; }\n  .style_shady__MqRrQ label {\n    color: rgba(255, 255, 255, 0.87); }\n\n@media only screen and (max-width: 667px) {\n  .style_ttroot__1B77j h2 {\n    font-size: 28px !important;\n    line-weight: 36px; } }\n');
var H = function (r) {
    var i = r.borders,
      a = r.header,
      o = r.modals,
      s = void 0 === o ? [] : o,
      l = r.fullWidth,
      c = void 0 !== l && l,
      d = r.activeModal,
      u = r.resetModal,
      p = r.resetToasts,
      m = r.footer,
      f = r.muteMessage,
      g = r.theme,
      _ = void 0 === g ? "bright" : g,
      y = r.messages,
      h = void 0 === y ? [] : y,
      v = r.toasts,
      b = void 0 === v ? [] : v,
      x = P.useMediaPredicate("(prefers-color-scheme: dark)"),
      E = j(t(!0), 2),
      k = E[0],
      T = E[1],
      w = j(t("https://ttnewsagency-designsystem.s3-eu-west-1.amazonaws.com/favicon-black.ico"), 2),
      A = w[0],
      C = w[1];
    return n(function () {
      var e, t, n;
      e = A, t = document.querySelector("head"), (n = document.createElement("link")).setAttribute("href", e), n.setAttribute("rel", "shortcut icon"), n.setAttribute("type", "image/x-icon"), t.appendChild(n), x ? C("https://ttnewsagency-designsystem.s3-eu-west-1.amazonaws.com/favicon-white.ico") : x || C("https://ttnewsagency-designsystem.s3-eu-west-1.amazonaws.com/favicon-black.ico");
    }, [A]), n(function () {
      T(!1);
    }), e.createElement("div", {
      className: "".concat(B.ttroot, "\n      ").concat(function () {
        switch (_) {
          case "shady":
            return B.shady;
          default:
            return B.bright;
        }
      }(), "\n      ").concat(i ? B.borders : "", "\n    "),
      style: {
        display: k ? "none" : "block"
      }
    }, Ff(h).map(function (t) {
      return e.createElement(yn, {
        message: t.message || t,
        mute: f,
        readOnly: t.readOnly
      });
    }), b && b.map && b.map(function (t, n) {
      return e.createElement(xl, {
        key: n,
        position: t.position,
        message: t.message,
        ttninjs: t.ttninjs,
        visible: "".concat(t.visible ? "true" : "false"),
        reset: p || t.reset
      });
    }), s.map(function (t, n) {
      return t.id === d && e.createElement(jc, {
        key: n,
        isVisible: t.id === d,
        reset: u,
        heading: t.heading,
        footer: t.footer
      }, t.content);
    }), e.createElement("div", null, a || null), e.createElement("div", {
      className: B.mainWrapper,
      style: {
        maxWidth: c ? "auto" : "1980px"
      }
    }, r.children), m ? e.createElement(R, null) : null);
  },
  z = "table_interactiveRow__TeeLb",
  U = "table_activeRow__2ZDS_";
y(".table_interactiveRow__TeeLb:hover {\n  cursor: pointer;\n  background-color: #E8E8E8 !important; }\n\n.table_activeRow__2ZDS_ {\n  background-color: #E6E9FF !important; }\n");
var W = function (t) {
  var n = t.head,
    r = void 0 === n ? [] : n,
    i = t.body,
    a = void 0 === i ? [] : i,
    o = t.dividers,
    s = void 0 === o ? [] : o,
    l = t.stretch,
    c = t.activeRow,
    d = t.isInteractive,
    u = void 0 !== d && d;
  return e.createElement("table", {
    style: {
      width: l ? "100%" : "auto"
    }
  }, e.createElement("thead", null, e.createElement("tr", null, r.map && r.map(function (t, n) {
    return e.createElement("th", {
      key: n
    }, t);
  }))), e.createElement("tbody", null, a.map && a.map(function (t, n) {
    var r = n + 1;
    return e.createElement("tr", {
      key: n,
      className: "".concat(u && z, " ").concat(n === c && U)
    }, t.map(function (t, n) {
      return e.createElement("td", {
        key: n,
        style: {
          borderBottom: "".concat(s.includes(r) ? "1px solid black" : void 0)
        }
      }, t);
    }));
  })));
};
function X(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var G = "style_flexWrapper__1doF6";
function V(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Y(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? V(Object(n), !0).forEach(function (t) {
      X(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : V(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
y(".style_flexWrapper__1doF6 {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap; }\n");
var K = function (t) {
  var n = t.direction,
    r = t.style,
    i = t.justify,
    a = void 0 === i ? "flex-start" : i,
    o = t.align,
    s = void 0 === o ? "flex-start" : o,
    l = t.gap,
    c = void 0 === l ? 0 : l,
    d = t.stretchHeight,
    u = t.nowrap,
    p = void 0 !== u && u;
  return e.createElement("div", {
    className: G,
    style: Y(Y({}, r), {}, {
      gap: c,
      height: d ? "100%" : "auto",
      flexDirection: n || "column",
      justifyContent: a,
      alignItems: s,
      flexWrap: p ? "nowrap" : "wrap"
    })
  }, t.children);
};
function Z() {
  return (Z = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function q(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function J(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Q(e, t, n) {
  return t && J(e.prototype, t), n && J(e, n), e;
}
function $(e, t) {
  return ($ = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function ee(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && $(e, t);
}
var te = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function ne(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function re(e, t, n) {
  return e(n = {
    path: t,
    exports: {},
    require: function (e, t) {
      return function () {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
      }(null == t && n.path);
    }
  }, n.exports), n.exports;
}
function ie(e) {
  if (e.__esModule) return e;
  var t = Object.defineProperty({}, "__esModule", {
    value: !0
  });
  return Object.keys(e).forEach(function (n) {
    var r = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(t, n, r.get ? r : {
      enumerable: !0,
      get: function () {
        return e[n];
      }
    });
  }), t;
}
var ae = ne(re(function (e) {
  function t(n) {
    return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? (e.exports = t = function (e) {
      return typeof e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = t = function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0), t(n);
  }
  e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
}));
function oe(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function se(e, t) {
  return !t || "object" !== ae(t) && "function" != typeof t ? oe(e) : t;
}
function le(e) {
  return (le = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function ce(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
}
var de = "function" == typeof Symbol && Symbol.for,
  ue = de ? Symbol.for("react.element") : 60103,
  pe = de ? Symbol.for("react.portal") : 60106,
  me = de ? Symbol.for("react.fragment") : 60107,
  fe = de ? Symbol.for("react.strict_mode") : 60108,
  ge = de ? Symbol.for("react.profiler") : 60114,
  _e = de ? Symbol.for("react.provider") : 60109,
  ye = de ? Symbol.for("react.context") : 60110,
  he = de ? Symbol.for("react.async_mode") : 60111,
  ve = de ? Symbol.for("react.concurrent_mode") : 60111,
  be = de ? Symbol.for("react.forward_ref") : 60112,
  xe = de ? Symbol.for("react.suspense") : 60113,
  Ee = de ? Symbol.for("react.suspense_list") : 60120,
  ke = de ? Symbol.for("react.memo") : 60115,
  Te = de ? Symbol.for("react.lazy") : 60116,
  we = de ? Symbol.for("react.block") : 60121,
  Ae = de ? Symbol.for("react.fundamental") : 60117,
  Ce = de ? Symbol.for("react.responder") : 60118,
  Se = de ? Symbol.for("react.scope") : 60119;
function Ne(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;
    switch (t) {
      case ue:
        switch (e = e.type) {
          case he:
          case ve:
          case me:
          case ge:
          case fe:
          case xe:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case ye:
              case be:
              case Te:
              case ke:
              case _e:
                return e;
              default:
                return t;
            }
        }
      case pe:
        return t;
    }
  }
}
function Oe(e) {
  return Ne(e) === ve;
}
var Re = {
    AsyncMode: he,
    ConcurrentMode: ve,
    ContextConsumer: ye,
    ContextProvider: _e,
    Element: ue,
    ForwardRef: be,
    Fragment: me,
    Lazy: Te,
    Memo: ke,
    Portal: pe,
    Profiler: ge,
    StrictMode: fe,
    Suspense: xe,
    isAsyncMode: function (e) {
      return Oe(e) || Ne(e) === he;
    },
    isConcurrentMode: Oe,
    isContextConsumer: function (e) {
      return Ne(e) === ye;
    },
    isContextProvider: function (e) {
      return Ne(e) === _e;
    },
    isElement: function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === ue;
    },
    isForwardRef: function (e) {
      return Ne(e) === be;
    },
    isFragment: function (e) {
      return Ne(e) === me;
    },
    isLazy: function (e) {
      return Ne(e) === Te;
    },
    isMemo: function (e) {
      return Ne(e) === ke;
    },
    isPortal: function (e) {
      return Ne(e) === pe;
    },
    isProfiler: function (e) {
      return Ne(e) === ge;
    },
    isStrictMode: function (e) {
      return Ne(e) === fe;
    },
    isSuspense: function (e) {
      return Ne(e) === xe;
    },
    isValidElementType: function (e) {
      return "string" == typeof e || "function" == typeof e || e === me || e === ve || e === ge || e === fe || e === xe || e === Ee || "object" == typeof e && null !== e && (e.$$typeof === Te || e.$$typeof === ke || e.$$typeof === _e || e.$$typeof === ye || e.$$typeof === be || e.$$typeof === Ae || e.$$typeof === Ce || e.$$typeof === Se || e.$$typeof === we);
    },
    typeOf: Ne
  },
  Ie = ce(function (e, t) {
    "production" !== process.env.NODE_ENV && function () {
      var e = "function" == typeof Symbol && Symbol.for,
        n = e ? Symbol.for("react.element") : 60103,
        r = e ? Symbol.for("react.portal") : 60106,
        i = e ? Symbol.for("react.fragment") : 60107,
        a = e ? Symbol.for("react.strict_mode") : 60108,
        o = e ? Symbol.for("react.profiler") : 60114,
        s = e ? Symbol.for("react.provider") : 60109,
        l = e ? Symbol.for("react.context") : 60110,
        c = e ? Symbol.for("react.async_mode") : 60111,
        d = e ? Symbol.for("react.concurrent_mode") : 60111,
        u = e ? Symbol.for("react.forward_ref") : 60112,
        p = e ? Symbol.for("react.suspense") : 60113,
        m = e ? Symbol.for("react.suspense_list") : 60120,
        f = e ? Symbol.for("react.memo") : 60115,
        g = e ? Symbol.for("react.lazy") : 60116,
        _ = e ? Symbol.for("react.block") : 60121,
        y = e ? Symbol.for("react.fundamental") : 60117,
        h = e ? Symbol.for("react.responder") : 60118,
        v = e ? Symbol.for("react.scope") : 60119;
      function b(e) {
        if ("object" == typeof e && null !== e) {
          var t = e.$$typeof;
          switch (t) {
            case n:
              var m = e.type;
              switch (m) {
                case c:
                case d:
                case i:
                case o:
                case a:
                case p:
                  return m;
                default:
                  var _ = m && m.$$typeof;
                  switch (_) {
                    case l:
                    case u:
                    case g:
                    case f:
                    case s:
                      return _;
                    default:
                      return t;
                  }
              }
            case r:
              return t;
          }
        }
      }
      var x = c,
        E = d,
        k = l,
        T = s,
        w = n,
        A = u,
        C = i,
        S = g,
        N = f,
        O = r,
        R = o,
        I = a,
        L = p,
        j = !1;
      function D(e) {
        return b(e) === d;
      }
      t.AsyncMode = x, t.ConcurrentMode = E, t.ContextConsumer = k, t.ContextProvider = T, t.Element = w, t.ForwardRef = A, t.Fragment = C, t.Lazy = S, t.Memo = N, t.Portal = O, t.Profiler = R, t.StrictMode = I, t.Suspense = L, t.isAsyncMode = function (e) {
        return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), D(e) || b(e) === c;
      }, t.isConcurrentMode = D, t.isContextConsumer = function (e) {
        return b(e) === l;
      }, t.isContextProvider = function (e) {
        return b(e) === s;
      }, t.isElement = function (e) {
        return "object" == typeof e && null !== e && e.$$typeof === n;
      }, t.isForwardRef = function (e) {
        return b(e) === u;
      }, t.isFragment = function (e) {
        return b(e) === i;
      }, t.isLazy = function (e) {
        return b(e) === g;
      }, t.isMemo = function (e) {
        return b(e) === f;
      }, t.isPortal = function (e) {
        return b(e) === r;
      }, t.isProfiler = function (e) {
        return b(e) === o;
      }, t.isStrictMode = function (e) {
        return b(e) === a;
      }, t.isSuspense = function (e) {
        return b(e) === p;
      }, t.isValidElementType = function (e) {
        return "string" == typeof e || "function" == typeof e || e === i || e === d || e === o || e === a || e === p || e === m || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === f || e.$$typeof === s || e.$$typeof === l || e.$$typeof === u || e.$$typeof === y || e.$$typeof === h || e.$$typeof === v || e.$$typeof === _);
      }, t.typeOf = b;
    }();
  });
Ie.AsyncMode, Ie.ConcurrentMode, Ie.ContextConsumer, Ie.ContextProvider, Ie.Element, Ie.ForwardRef, Ie.Fragment, Ie.Lazy, Ie.Memo, Ie.Portal, Ie.Profiler, Ie.StrictMode, Ie.Suspense, Ie.isAsyncMode, Ie.isConcurrentMode, Ie.isContextConsumer, Ie.isContextProvider, Ie.isElement, Ie.isForwardRef, Ie.isFragment, Ie.isLazy, Ie.isMemo, Ie.isPortal, Ie.isProfiler, Ie.isStrictMode, Ie.isSuspense, Ie.isValidElementType, Ie.typeOf;
var Le = ce(function (e) {
    "production" === process.env.NODE_ENV ? e.exports = Re : e.exports = Ie;
  }),
  je = Object.getOwnPropertySymbols,
  De = Object.prototype.hasOwnProperty,
  Fe = Object.prototype.propertyIsEnumerable;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function Me(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
var Pe = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, r, i = Me(e), a = 1; a < arguments.length; a++) {
      for (var o in n = Object(arguments[a])) De.call(n, o) && (i[o] = n[o]);
      if (je) {
        r = je(n);
        for (var s = 0; s < r.length; s++) Fe.call(n, r[s]) && (i[r[s]] = n[r[s]]);
      }
    }
    return i;
  },
  Be = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  He = function () {};
if ("production" !== process.env.NODE_ENV) {
  var ze = Be,
    Ue = {},
    We = Function.call.bind(Object.prototype.hasOwnProperty);
  He = function (e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);
    try {
      throw new Error(t);
    } catch (e) {}
  };
}
function Xe(e, t, n, r, i) {
  if ("production" !== process.env.NODE_ENV) for (var a in e) if (We(e, a)) {
    var o;
    try {
      if ("function" != typeof e[a]) {
        var s = Error((r || "React class") + ": " + n + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.");
        throw s.name = "Invariant Violation", s;
      }
      o = e[a](t, a, r, n, null, ze);
    } catch (e) {
      o = e;
    }
    if (!o || o instanceof Error || He((r || "React class") + ": type specification of " + n + " `" + a + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof o + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), o instanceof Error && !(o.message in Ue)) {
      Ue[o.message] = !0;
      var l = i ? i() : "";
      He("Failed " + n + " type: " + o.message + (null != l ? l : ""));
    }
  }
}
Xe.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (Ue = {});
};
var Ge = Xe,
  Ve = Function.call.bind(Object.prototype.hasOwnProperty),
  Ye = function () {};
function Ke() {
  return null;
}
"production" !== process.env.NODE_ENV && (Ye = function (e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);
  try {
    throw new Error(t);
  } catch (e) {}
});
var Ze = function (e, t) {
  var n = "function" == typeof Symbol && Symbol.iterator;
  var r = "<<anonymous>>",
    i = {
      array: l("array"),
      bool: l("boolean"),
      func: l("function"),
      number: l("number"),
      object: l("object"),
      string: l("string"),
      symbol: l("symbol"),
      any: s(Ke),
      arrayOf: function (e) {
        return s(function (t, n, r, i, a) {
          if ("function" != typeof e) return new o("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
          var s = t[n];
          if (!Array.isArray(s)) return new o("Invalid " + i + " `" + a + "` of type `" + d(s) + "` supplied to `" + r + "`, expected an array.");
          for (var l = 0; l < s.length; l++) {
            var c = e(s, l, r, i, a + "[" + l + "]", Be);
            if (c instanceof Error) return c;
          }
          return null;
        });
      },
      element: s(function (t, n, r, i, a) {
        var s = t[n];
        return e(s) ? null : new o("Invalid " + i + " `" + a + "` of type `" + d(s) + "` supplied to `" + r + "`, expected a single ReactElement.");
      }),
      elementType: s(function (e, t, n, r, i) {
        var a = e[t];
        return Le.isValidElementType(a) ? null : new o("Invalid " + r + " `" + i + "` of type `" + d(a) + "` supplied to `" + n + "`, expected a single ReactElement type.");
      }),
      instanceOf: function (e) {
        return s(function (t, n, i, a, s) {
          if (!(t[n] instanceof e)) {
            var l = e.name || r;
            return new o("Invalid " + a + " `" + s + "` of type `" + (((c = t[n]).constructor && c.constructor.name ? c.constructor.name : r) + "` supplied to `") + i + "`, expected instance of `" + l + "`.");
          }
          var c;
          return null;
        });
      },
      node: s(function (e, t, n, r, i) {
        return c(e[t]) ? null : new o("Invalid " + r + " `" + i + "` supplied to `" + n + "`, expected a ReactNode.");
      }),
      objectOf: function (e) {
        return s(function (t, n, r, i, a) {
          if ("function" != typeof e) return new o("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
          var s = t[n],
            l = d(s);
          if ("object" !== l) return new o("Invalid " + i + " `" + a + "` of type `" + l + "` supplied to `" + r + "`, expected an object.");
          for (var c in s) if (Ve(s, c)) {
            var u = e(s, c, r, i, a + "." + c, Be);
            if (u instanceof Error) return u;
          }
          return null;
        });
      },
      oneOf: function (e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && Ye(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), Ke;
        function t(t, n, r, i, s) {
          for (var l = t[n], c = 0; c < e.length; c++) if (a(l, e[c])) return null;
          var d = JSON.stringify(e, function (e, t) {
            return "symbol" === u(t) ? String(t) : t;
          });
          return new o("Invalid " + i + " `" + s + "` of value `" + String(l) + "` supplied to `" + r + "`, expected one of " + d + ".");
        }
        return s(t);
      },
      oneOfType: function (e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && Ye("Invalid argument supplied to oneOfType, expected an instance of array."), Ke;
        for (var t = 0; t < e.length; t++) {
          var n = e[t];
          if ("function" != typeof n) return Ye("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + p(n) + " at index " + t + "."), Ke;
        }
        return s(function (t, n, r, i, a) {
          for (var s = 0; s < e.length; s++) if (null == (0, e[s])(t, n, r, i, a, Be)) return null;
          return new o("Invalid " + i + " `" + a + "` supplied to `" + r + "`.");
        });
      },
      shape: function (e) {
        return s(function (t, n, r, i, a) {
          var s = t[n],
            l = d(s);
          if ("object" !== l) return new o("Invalid " + i + " `" + a + "` of type `" + l + "` supplied to `" + r + "`, expected `object`.");
          for (var c in e) {
            var u = e[c];
            if (u) {
              var p = u(s, c, r, i, a + "." + c, Be);
              if (p) return p;
            }
          }
          return null;
        });
      },
      exact: function (e) {
        return s(function (t, n, r, i, a) {
          var s = t[n],
            l = d(s);
          if ("object" !== l) return new o("Invalid " + i + " `" + a + "` of type `" + l + "` supplied to `" + r + "`, expected `object`.");
          var c = Pe({}, t[n], e);
          for (var u in c) {
            var p = e[u];
            if (!p) return new o("Invalid " + i + " `" + a + "` key `" + u + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
            var m = p(s, u, r, i, a + "." + u, Be);
            if (m) return m;
          }
          return null;
        });
      }
    };
  function a(e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  }
  function o(e) {
    this.message = e, this.stack = "";
  }
  function s(e) {
    if ("production" !== process.env.NODE_ENV) var n = {},
      i = 0;
    function a(a, s, l, c, d, u, p) {
      if (c = c || r, u = u || l, p !== Be) {
        if (t) {
          var m = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw m.name = "Invariant Violation", m;
        }
        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var f = c + ":" + l;
          !n[f] && i < 3 && (Ye("You are manually calling a React.PropTypes validation function for the `" + u + "` prop on `" + c + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[f] = !0, i++);
        }
      }
      return null == s[l] ? a ? null === s[l] ? new o("The " + d + " `" + u + "` is marked as required in `" + c + "`, but its value is `null`.") : new o("The " + d + " `" + u + "` is marked as required in `" + c + "`, but its value is `undefined`.") : null : e(s, l, c, d, u);
    }
    var s = a.bind(null, !1);
    return s.isRequired = a.bind(null, !0), s;
  }
  function l(e) {
    return s(function (t, n, r, i, a, s) {
      var l = t[n];
      return d(l) !== e ? new o("Invalid " + i + " `" + a + "` of type `" + u(l) + "` supplied to `" + r + "`, expected `" + e + "`.") : null;
    });
  }
  function c(t) {
    switch (typeof t) {
      case "number":
      case "string":
      case "undefined":
        return !0;
      case "boolean":
        return !t;
      case "object":
        if (Array.isArray(t)) return t.every(c);
        if (null === t || e(t)) return !0;
        var r = function (e) {
          var t = e && (n && e[n] || e["@@iterator"]);
          if ("function" == typeof t) return t;
        }(t);
        if (!r) return !1;
        var i,
          a = r.call(t);
        if (r !== t.entries) {
          for (; !(i = a.next()).done;) if (!c(i.value)) return !1;
        } else for (; !(i = a.next()).done;) {
          var o = i.value;
          if (o && !c(o[1])) return !1;
        }
        return !0;
      default:
        return !1;
    }
  }
  function d(e) {
    var t = typeof e;
    return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
      return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
    }(t, e) ? "symbol" : t;
  }
  function u(e) {
    if (null == e) return "" + e;
    var t = d(e);
    if ("object" === t) {
      if (e instanceof Date) return "date";
      if (e instanceof RegExp) return "regexp";
    }
    return t;
  }
  function p(e) {
    var t = u(e);
    switch (t) {
      case "array":
      case "object":
        return "an " + t;
      case "boolean":
      case "date":
      case "regexp":
        return "a " + t;
      default:
        return t;
    }
  }
  return o.prototype = Error.prototype, i.checkPropTypes = Ge, i.resetWarningCache = Ge.resetWarningCache, i.PropTypes = i, i;
};
function qe() {}
function Je() {}
Je.resetWarningCache = qe;
var Qe = ce(function (e) {
    if ("production" !== process.env.NODE_ENV) {
      var t = Le;
      e.exports = Ze(t.isElement, !0);
    } else e.exports = function () {
      function e(e, t, n, r, i, a) {
        if (a !== Be) {
          var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw o.name = "Invariant Violation", o;
        }
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: Je,
        resetWarningCache: qe
      };
      return n.PropTypes = n, n;
    }();
  }),
  $e = ce(function (e) {
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */
    !function () {
      var t = {}.hasOwnProperty;
      function n() {
        for (var e = [], r = 0; r < arguments.length; r++) {
          var i = arguments[r];
          if (i) {
            var a = typeof i;
            if ("string" === a || "number" === a) e.push(i);else if (Array.isArray(i) && i.length) {
              var o = n.apply(null, i);
              o && e.push(o);
            } else if ("object" === a) for (var s in i) t.call(i, s) && i[s] && e.push(s);
          }
        }
        return e.join(" ");
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    }();
  }),
  et = e.createContext(),
  tt = function (e) {
    return !!e && e.constructor === Array;
  };
var nt = function (e) {
  var t = e.prop,
    n = e.defaultProp,
    r = e.breakpoints.length,
    i = function (e, t) {
      return e ? tt(e) ? e : [e] : tt(t) ? t : t ? [t] : [e];
    }(t, n);
  return i.length < r && (i = function (e) {
    for (var t = e.array, n = e.breakpointsLength, r = t[t.length - 1]; t.length < n;) t.push(r);
    return t;
  }({
    array: i,
    breakpointsLength: r
  })), i.length > r && (i = i.splice(r)), i;
};
function rt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function it() {
  return (it = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function at(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ot(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? at(Object(n), !0).forEach(function (t) {
      rt(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : at(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function st(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function lt(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
    var n = [],
      r = !0,
      i = !1,
      a = void 0;
    try {
      for (var o, s = e[Symbol.iterator](); !(r = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); r = !0);
    } catch (e) {
      i = !0, a = e;
    } finally {
      try {
        r || null == s.return || s.return();
      } finally {
        if (i) throw a;
      }
    }
    return n;
  }(e, t) || dt(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function ct(e) {
  return function (e) {
    if (Array.isArray(e)) return ut(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
  }(e) || dt(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function dt(e, t) {
  if (e) {
    if ("string" == typeof e) return ut(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ut(e, t) : void 0;
  }
}
function ut(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function pt() {
  var e = st(["\n      @media (min-width: ", "px)", " {\n        ", ";\n      }\n    "]);
  return pt = function () {
    return e;
  }, e;
}
var mt = function (e, t, n) {
  return "grid" === t && n ? e.map(function (e) {
    switch (e) {
      case "left":
        return "start";
      case "right":
        return "end";
      case "top":
        return "start";
      case "bottom":
        return "end";
      default:
        return e;
    }
  }) : e.map(function (e) {
    switch (e) {
      case "left":
        return "flex-start";
      case "right":
        return "flex-end";
      case "top":
        return "flex-start";
      case "bottom":
        return "flex-end";
      default:
        return e;
    }
  });
};
function ft() {
  var e = st(["\n      ", "   \n    "]);
  return ft = function () {
    return e;
  }, e;
}
function gt() {
  var e = st(["\n        ", "\n        ", "\n        ", "\n      "]);
  return gt = function () {
    return e;
  }, e;
}
function _t() {
  var e = st(["\n        display: flex;\n        align-items: stretch;\n        justify-content: stretch;\n      "]);
  return _t = function () {
    return e;
  }, e;
}
function yt() {
  var e = st(["  \n  position: relative;\n  width: 100%;\n  \n  ", "\n  ", "\n"]);
  return yt = function () {
    return e;
  }, e;
}
var ht = g(function (t) {
    var n = t.className,
      r = t.children;
    return e.createElement("div", {
      className: n
    }, r);
  })(yt(), function (e) {
    return e.media.map(function (t, n) {
      return e.hasChildBoxes ? t(_t()) : t(gt(), (e.alignX[n] || e.alignY[n]) && "\n          display: flex;\n        ", e.alignX[n] && "justify-content: ".concat(e.alignX[n], ";"), e.alignY[n] && "align-items: ".concat(e.alignY[n], ";"));
    });
  }, function (e) {
    return e.media.map(function (t, n) {
      return t(ft(), e.style && e.style[n]);
    });
  }),
  vt = function (t) {
    var n = t.media,
      r = t.className,
      i = t.alignX,
      a = t.alignY,
      o = t.style,
      s = t.children,
      l = t.hasChildBoxes;
    return "grid" === t.cssMode ? s : e.createElement(ht, {
      className: r,
      media: n,
      alignX: i,
      alignY: a,
      style: o,
      hasChildBoxes: l
    }, s);
  };
function bt() {
  var e = st(["\n      width: calc(100% + (", "));      \n      margin-left: calc(-", " / 2);\n      margin-right: calc(-", " / 2);\n      margin-top: calc(-", " / 2);\n      margin-bottom: calc(-", " / 2);\n\n      align-items: ", ";\n      justify-content: ", ";    \n      \n      padding: ", ";\n    "]);
  return bt = function () {
    return e;
  }, e;
}
function xt() {
  var e = st(["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  ", "\n"]);
  return xt = function () {
    return e;
  }, e;
}
var Et = g(function (t) {
    t.reset;
    var n = t.className,
      r = t.children;
    return e.createElement("div", {
      className: n
    }, r);
  })(xt(), function (e) {
    return e.media.map(function (t, n) {
      return t(bt(), e.gutterX[n], e.gutterX[n], e.gutterX[n], e.gutterY[n], e.gutterY[n], e.alignY[n], e.alignX[n], e.padding && e.padding[n]);
    });
  }),
  kt = function (t) {
    return "grid" === t.cssMode ? t.children : t.hasChildBoxes ? e.createElement(Et, t) : t.children;
  },
  Tt = e.forwardRef(function (t, n) {
    var r = t.className,
      i = t.children,
      a = t.attrs,
      o = void 0 === a ? {} : a,
      s = t.tag,
      l = void 0 === s ? "div" : s;
    return e.createElement(l, ot(ot({}, o), {}, {
      className: r,
      ref: n
    }), "img" !== l ? i : void 0);
  });
function wt() {
  var e = st(["\n      position: ", ";\n      padding-left: ", ";\n      padding-right: ", ";\n      padding-top: ", ";\n      padding-bottom: ", ";\n      ", "\n    "]);
  return wt = function () {
    return e;
  }, e;
}
function At() {
  var e = st(["\n  display: flex;\n  align-items: stretch;\n  box-sizing: border-box;\n\n  ", "\n  ", "\n"]);
  return At = function () {
    return e;
  }, e;
}
function Ct() {
  var e = st(["\n      position: ", ";\n      padding-left: ", ";\n      padding-right: ", ";\n      padding-top: ", ";\n      padding-bottom: ", ";\n      grid-column-gap: ", ";\n      grid-row-gap: ", ";\n      ", "\n      align-content: ", ";\n      align-items: ", ";\n    "]);
  return Ct = function () {
    return e;
  }, e;
}
function St() {
  var e = st(["\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  grid-auto-columns: ", "fr;\n  grid-auto-rows: min-content;\n  box-sizing: border-box;\n\n  ", "\n  ", "\n"]);
  return St = function () {
    return e;
  }, e;
}
var Nt = "\n  width: 100%;\n  z-index: 10000;\n  left: 0; \n  top: 0; \n  bottom: 0;\n  margin: 0;\n  grid-auto-rows: auto;\n  pointer-events: none;\n",
  Ot = g(Tt)(St(), function (e) {
    return e.colspan;
  }, function (e) {
    return e.colspan;
  }, function (e) {
    return e.media.map(function (t, n) {
      return t(Ct(), function (e) {
        return e.position[n];
      }, e.left[n], e.right[n], e.top[n], e.bottom[n], e.gutterX[n], e.gutterY[n], e.style[n], function (e) {
        return e.alignY[n];
      }, function (e) {
        return e.alignY[n];
      });
    });
  }, function (e) {
    return e.isControl && Nt;
  }),
  Rt = g(Tt)(At(), function (e) {
    return e.media.map(function (t, n) {
      return t(wt(), function (e) {
        return e.position[n];
      }, e.left[n], e.right[n], e.top[n], e.bottom[n], e.style[n]);
    });
  }, function (e) {
    return e.isControl && Nt;
  }),
  It = e.forwardRef(function (t, n) {
    switch (t.cssMode) {
      case "flex":
        return e.createElement(Rt, it({}, t, {
          ref: n
        }));
      case "grid":
        return e.createElement(Ot, it({}, t, {
          ref: n
        }));
    }
  }),
  Lt = function (e) {
    var t = e.margin,
      n = e.cols,
      r = e.parent,
      i = e.cssMode,
      a = e.gutterX;
    return "grid" === i ? t.map(function (e, t) {
      return e ? "calc(((100% + ".concat(a[t], ") / ").concat(n[t], ") * ").concat(e, ")") : void 0;
    }) : t.map(function (e, t) {
      return e ? "".concat(100 * e / r[t], "%") : void 0;
    });
  };
function jt(e) {
  var t = e.stack,
    n = e.rest,
    r = e.alignX;
  return t.map(function () {
    switch (r) {
      case "start":
        return 0;
      case "center":
        return n / 2;
      default:
        return n;
    }
  });
}
var Dt = function (t) {
  var n = t.children,
    r = t.cssMode,
    i = t.breakpoints,
    a = t.colsTotal,
    o = t.alignX,
    s = t.alignXRaw;
  return n && "flex" !== r && s ? function (e) {
    var t = [];
    return e.forEach(function (e) {
      e.forEach(function (e, n) {
        t[n] ? t[n] = [].concat(ct(t[n]), [e]) : t[n] = [e];
      });
    }), t;
  }(function (e, t) {
    var n = [];
    return e.forEach(function (e, r) {
      var i = [];
      t.forEach(function (e) {
        i.push({
          cols: e.cols[r],
          left: e.left[r],
          right: e.right[r],
          total: e.total[r]
        });
      }), n.push(i);
    }), n;
  }(i, function (t, n, r) {
    return e.Children.map(t, function (e) {
      var t = e.type.displayName,
        i = e.props;
      if ("Box" !== t) return null;
      var a = nt({
          prop: i.left,
          breakpoints: n
        }),
        o = nt({
          prop: i.right,
          breakpoints: n
        }),
        s = nt({
          prop: i.cols,
          defaultProp: r,
          breakpoints: n
        });
      return {
        left: a,
        right: o,
        cols: s,
        total: function (e, t, n) {
          return e.map(function (e, r) {
            return e + t[r] + n[r];
          });
        }(s, a, o)
      };
    }).filter(function (e) {
      return null !== e;
    });
  }(n, i, a)).map(function (e, t) {
    if (!e.length) return e;
    for (var n = 0, r = [], i = [], s = 0; s < e.length + 1; s++) {
      var l = e[s];
      l ? n + l.total > a[t] ? (r = [].concat(ct(r), ct(jt({
        stack: i,
        rest: a[t] - n,
        alignX: o[t]
      }))), i = [l], n = 0, n += l.total) : n + l.total === a[t] ? (i.push(l), r = [].concat(ct(r), ct(i.map(function () {
        return 0;
      }))), i = [], n = 0) : (i.push(l), n += l.total) : n && (r = [].concat(ct(r), ct(jt({
        stack: i,
        rest: a[t] - n,
        alignX: o[t]
      }))));
    }
    return r;
  })) : null;
};
function Ft() {
  var e = st(["\n      width: ", "%;\n      \n      padding-left: calc(", " / 2);\n      padding-right: calc(", " / 2);\n      padding-top: calc(", " / 2);\n      padding-bottom: calc(", " / 2);\n\n      margin-left: ", ";\n      margin-right: ", ";\n      margin-top: ", ";\n      margin-bottom: ", ";\n    "]);
  return Ft = function () {
    return e;
  }, e;
}
function Mt() {
  var e = st(["\n  display: flex;\n  box-sizing: border-box;\n\n  ", "\n"]);
  return Mt = function () {
    return e;
  }, e;
}
function Pt() {
  var e = st(["\n      ", "\n      position: relative;\n      grid-column: auto / span ", ";\n      left: ", ";\n      margin-left: ", ";\n      margin-right: ", ";\n      margin-top: ", ";\n      margin-bottom: ", ";\n      align-content: ", ";\n      align-items: ", ";\n      padding: ", ";\n      ", "\n    "]);
  return Pt = function () {
    return e;
  }, e;
}
function Bt() {
  var e = st(["\n      ", "\n      ", "\n      ", "\n    "]);
  return Bt = function () {
    return e;
  }, e;
}
function Ht() {
  var e = st(["\n      grid-template-columns: repeat(", ", 1fr);\n      grid-auto-columns: ", "fr;\n      grid-auto-rows: min-content;\n      grid-column-gap: ", ";\n      grid-row-gap: ", ";\n    "]);
  return Ht = function () {
    return e;
  }, e;
}
function zt() {
  var e = st(["\n  box-sizing: border-box;\n  ", ";\n\n  ", "\n  ", "\n  ", "\n\n  ", "\n"]);
  return zt = function () {
    return e;
  }, e;
}
var Ut = g(Tt)(zt(), function (e) {
    return e.hasChildBoxes && "display: grid;";
  }, function (e) {
    return e.hasChildBoxes && e.media.map(function (t, n) {
      return t(Ht(), function (e) {
        return e.colspan[n];
      }, function (e) {
        return e.colspan[n];
      }, e.gutterX[n], e.gutterY[n]);
    });
  }, function (e) {
    return !e.hasChildBoxes && e.media.map(function (t, n) {
      return "flex-start" === e.alignX[n] && "flex-start" === e.alignY[n] ? "" : t(Bt(), (e.alignX[n] || e.alignY[n]) && "display: flex;", e.alignX[n] && "justify-content: ".concat(e.alignX[n], ";"), e.alignY[n] && "align-items: ".concat(e.alignY[n], ";"));
    });
  }, function (e) {
    return e.media.map(function (t, n) {
      return t(Pt(), e.colsNumber[n] ? "" : "display: none;", e.cols[n], e.rest[n], e.left[n], e.right[n], e.top[n], e.bottom[n], e.alignY[n], e.alignY[n], e.padding[n], e.style[n]);
    });
  }, function (e) {
    return "img" === e.tag && e.controlIsVisible && "\n    box-shadow: 0 0 999em ".concat(e.controlColor, " inset;\n  ");
  }),
  Wt = g(Tt)(Mt(), function (e) {
    return e.media.map(function (t, n) {
      return t(Ft(), e.cols[n], e.gutterX[n], e.gutterX[n], e.gutterY[n], e.gutterY[n], e.left[n], e.right[n], e.top[n], e.bottom[n]);
    });
  }),
  Xt = e.forwardRef(function (t, n) {
    switch (t.cssMode) {
      case "flex":
        return e.createElement(Wt, it({}, t, {
          ref: n
        }));
      case "grid":
        return e.createElement(Ut, it({}, t, {
          ref: n
        }));
    }
  }),
  Gt = e.forwardRef(function (a, o) {
    var s = a.className,
      l = a.cols,
      c = a.alignX,
      d = a.alignY,
      u = a.children,
      p = a.left,
      m = a.right,
      f = a.top,
      g = a.bottom,
      _ = a.padding,
      y = a.style,
      h = a.hasChildBoxes,
      v = a.tag,
      b = a.attrs,
      x = a.rest,
      E = a.href,
      k = a.onClick,
      T = r(et),
      w = T.cssMode,
      A = T.breakpoints,
      C = T.gutterX,
      S = T.gutterY,
      N = T.colspan,
      O = T.parent,
      R = T.media,
      I = T.controlIsVisible,
      L = T.controlColor,
      j = T.register,
      D = lt(t(void 0), 2),
      F = D[0],
      M = D[1],
      P = i(function () {
        return t = F, "boolean" == typeof (e = h) ? e : t;
        var e, t;
      }, [h, F]),
      B = i(function () {
        return mt(nt({
          prop: c,
          breakpoints: A
        }), w, P);
      }, [c, A, w, P]),
      H = i(function () {
        return mt(nt({
          prop: d,
          breakpoints: A
        }), w, P);
      }, [d, A, w, P]),
      z = i(function () {
        return nt({
          prop: p,
          breakpoints: A
        });
      }, [p, A]),
      U = i(function () {
        return nt({
          prop: m,
          breakpoints: A
        });
      }, [m, A]),
      W = i(function () {
        return nt({
          prop: x,
          breakpoints: A
        });
      }, [x, A]),
      X = i(function () {
        return nt({
          prop: l,
          defaultProp: O,
          breakpoints: A
        });
      }, [l, O, A]),
      G = i(function () {
        return nt({
          prop: f,
          breakpoints: A
        });
      }, [f, A]),
      V = i(function () {
        return nt({
          prop: g,
          breakpoints: A
        });
      }, [g, A]),
      Y = i(function () {
        return nt({
          prop: _,
          breakpoints: A
        });
      }, [_, A]),
      K = i(function () {
        return function (e) {
          var t = e.cols,
            n = e.left,
            r = e.right,
            i = e.parent;
          return "grid" === e.cssMode ? t.map(function (e, t) {
            return e + n[t] + r[t];
          }) : t.map(function (e, t) {
            return 100 * e / i[t];
          });
        }({
          cols: X,
          left: z,
          right: U,
          parent: O,
          cssMode: w
        });
      }, [X, z, U, O, w]),
      Z = i(function () {
        return Lt({
          margin: W,
          cols: K,
          gutterX: C,
          parent: O,
          cssMode: w
        });
      }, [W, K, C, O, w]),
      q = i(function () {
        return Lt({
          margin: z,
          cols: K,
          gutterX: C,
          parent: O,
          cssMode: w
        });
      }, [z, K, C, O, w]),
      J = i(function () {
        return Lt({
          margin: U,
          cols: K,
          gutterX: C,
          parent: O,
          cssMode: w
        });
      }, [U, K, C, O, w]),
      Q = i(function () {
        return Lt({
          margin: G,
          cols: K,
          gutterX: C,
          parent: O,
          cssMode: w
        });
      }, [G, K, C, O, w]),
      $ = i(function () {
        return Lt({
          margin: V,
          cols: K,
          gutterX: C,
          parent: O,
          cssMode: w
        });
      }, [V, K, C, O, w]),
      ee = i(function () {
        return nt({
          prop: y,
          breakpoints: A
        });
      }, [y, A]),
      te = i(function () {
        return Dt({
          children: u,
          breakpoints: A,
          cssMode: w,
          colsTotal: X,
          alignX: B,
          alignXRaw: c
        });
      }, [c, B, A, u, X, w]);
    return n(function () {
      j && j();
    }, []), e.createElement(Xt, {
      cssMode: w,
      breakpoints: A,
      className: "grid" === w ? $e(["Box", s]) : "Box",
      cols: K,
      rest: Z,
      colsNumber: X,
      media: R,
      gutterX: C,
      gutterY: S,
      colspan: X,
      hasChildBoxes: P,
      alignX: B,
      alignY: H,
      tag: v,
      left: q,
      right: J,
      top: Q,
      bottom: $,
      padding: Y,
      controlIsVisible: I,
      controlColor: L,
      style: "grid" === w && ee,
      ref: o,
      attrs: ot(ot(ot({}, b), E && E), k && k)
    }, e.createElement(vt, {
      cssMode: w,
      media: R,
      alignX: B,
      alignY: H,
      style: ee,
      hasChildBoxes: h,
      className: $e(["Box__Inner", s])
    }, I && e.createElement(Zt, {
      controlColor: L
    }), e.createElement(kt, {
      cssMode: w,
      className: "Box__Resetter",
      hasChildBoxes: P,
      media: R,
      gutterX: C,
      gutterY: S,
      alignX: B,
      alignY: H,
      breakpoints: A,
      padding: Y
    }, e.createElement(et.Provider, {
      value: {
        breakpoints: A,
        gutterX: C,
        gutterY: S,
        colspan: N,
        media: R,
        parent: X,
        controlIsVisible: I,
        controlColor: L,
        cssMode: w,
        register: function () {
          F || M(!0);
        }
      }
    }, e.Children.toArray(u).map(function (t, n) {
      return t.type && "Box" === t.type.displayName ? e.cloneElement(t, {
        rest: te && te[n]
      }) : t;
    })))));
  });
function Vt() {
  var e = st(["\n  position: absolute;\n  z-index: 10000;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n  pointer-events: none;\n"]);
  return Vt = function () {
    return e;
  }, e;
}
Gt.displayName = "Box", Gt.propTypes = {
  cols: Qe.oneOfType([Qe.arrayOf(Qe.number), Qe.number]),
  left: Qe.oneOfType([Qe.arrayOf(Qe.number), Qe.number]),
  right: Qe.oneOfType([Qe.arrayOf(Qe.number), Qe.number]),
  top: Qe.oneOfType([Qe.arrayOf(Qe.number), Qe.number]),
  bottom: Qe.oneOfType([Qe.arrayOf(Qe.number), Qe.number]),
  padding: Qe.oneOfType([Qe.arrayOf(Qe.string), Qe.string]),
  alignX: Qe.oneOfType([Qe.array, Qe.string]),
  alignY: Qe.oneOfType([Qe.array, Qe.string]),
  style: Qe.oneOfType([Qe.array, Qe.string]),
  tag: Qe.string,
  attrs: Qe.object,
  hasChildBoxes: Qe.bool,
  className: Qe.string,
  children: Qe.node,
  rest: Qe.array,
  href: Qe.string,
  onClick: Qe.func
}, Gt.defaultProps = {
  className: "",
  cols: void 0,
  alignX: "",
  alignY: "",
  children: null,
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  padding: null,
  style: "",
  hasChildBoxes: void 0,
  tag: "div",
  attrs: {},
  rest: [0],
  href: "",
  onClick: null
};
var Yt = function (t) {
    return e.createElement(qt, it({}, t, {
      position: "absolute",
      className: "Grid--Control",
      alignY: "stretch",
      isControl: !0
    }), ct(Array(t.colspan)).map(function (n, r) {
      return e.createElement(Gt, {
        key: r,
        cols: 1,
        style: "\n            background-color: ".concat(t.controlColor, ";\n          ")
      });
    }));
  },
  Kt = g("div")(Vt(), function (e) {
    return e.controlColor;
  }),
  Zt = function (t) {
    return e.createElement(Kt, t);
  },
  qt = e.forwardRef(function (r, a) {
    var o = r.breakpoints,
      s = r.left,
      l = r.right,
      c = r.top,
      d = r.bottom,
      u = r.gutterX,
      p = r.gutterY,
      m = r.alignX,
      f = r.alignY,
      g = r.colspan,
      y = r.control,
      h = r.controlColor,
      v = r.position,
      b = r.className,
      x = r.style,
      E = r.children,
      k = r.cssMode,
      T = r.tag,
      w = r.attrs,
      A = r.isControl,
      C = function (e) {
        var r = lt(t(!1), 2),
          i = r[0],
          a = r[1];
        return n(function () {
          function t(e) {
            27 === e.keyCode && a(function (e) {
              return !e;
            });
          }
          if (e) return document.addEventListener("keyup", t), function () {
            return document.removeEventListener("keyup", t);
          };
        }, []), i;
      }(y),
      S = function (e) {
        var r = lt(t(e), 2),
          i = r[0],
          a = r[1];
        return n(function () {
          if (!i) {
            var e = window.CSS && window.CSS.supports || window.supportsCSS || !1;
            e && e("grid-template-rows", "none") || a("flex");
          }
        }, []), i;
      }(k || "grid"),
      N = i(function () {
        return o;
      }, [o]),
      O = function (e) {
        var r = lt(t({
            index: 1,
            value: 0
          }), 2),
          i = r[0],
          a = r[1];
        return n(function () {
          function t() {
            var t = window.innerWidth,
              n = {
                index: 1,
                value: 0
              };
            e.forEach(function (e, r) {
              e <= t && (n = {
                index: r + 1,
                value: e
              });
            }), a(n);
          }
          return t(), window.addEventListener("resize", t), function () {
            return window.removeEventListener("resize", t);
          };
        }, [e]), i;
      }(N),
      R = i(function () {
        return nt({
          prop: u,
          breakpoints: N
        });
      }, [u, N]),
      I = i(function () {
        return nt({
          prop: p,
          breakpoints: N
        });
      }, [p, N]),
      L = i(function () {
        return mt(nt({
          prop: m,
          breakpoints: N
        }), S, !0);
      }, [m, N, S]),
      j = i(function () {
        return mt(nt({
          prop: f,
          breakpoints: N
        }), S, !0);
      }, [f, N, S]),
      D = i(function () {
        return function (e) {
          var t = e.length;
          return e.map(function (n, r) {
            var i = r !== t - 1 ? " and (max-width: ".concat(e[r + 1] - 1, "px)") : "";
            return function () {
              return _(pt(), n, i, _.apply(void 0, arguments));
            };
          });
        }(N);
      }, [N]),
      F = i(function () {
        return nt({
          prop: g,
          breakpoints: N
        });
      }, [g, N]),
      M = i(function () {
        return nt({
          prop: s,
          breakpoints: N
        });
      }, [s, N]),
      P = i(function () {
        return nt({
          prop: l,
          breakpoints: N
        });
      }, [l, N]),
      B = i(function () {
        return nt({
          prop: c,
          breakpoints: N
        });
      }, [c, N]),
      H = i(function () {
        return nt({
          prop: d,
          breakpoints: N
        });
      }, [d, N]),
      z = i(function () {
        return nt({
          prop: v,
          breakpoints: N
        });
      }, [v, N]),
      U = i(function () {
        return nt({
          prop: x,
          breakpoints: o
        });
      }, [x, o]),
      W = i(function () {
        return Dt({
          children: E,
          breakpoints: o,
          colsTotal: nt({
            prop: g,
            breakpoints: o
          }),
          alignX: L,
          cssMode: k,
          alignXRaw: m
        });
      }, [m, L, o, E, g, k]);
    return e.createElement(It, {
      cssMode: S,
      colspan: g,
      className: $e(["Grid", "bp-".concat(O.index), "bp-".concat(O.value), b]),
      gutterX: R,
      gutterY: I,
      alignX: L,
      alignY: j,
      media: D,
      left: M,
      right: P,
      top: B,
      bottom: H,
      position: z,
      tag: T,
      attrs: w,
      style: U,
      ref: a,
      isControl: A
    }, y && C && e.createElement(Yt, {
      cssMode: S,
      colspan: g,
      breakpoints: o,
      gutterX: u,
      gutterY: p,
      left: s,
      right: l,
      top: c,
      bottom: d,
      controlColor: h
    }), e.createElement(vt, {
      cssMode: S,
      className: "Grid__Inner",
      gutterX: R,
      gutterY: I,
      alignX: L,
      alignY: j,
      media: D,
      controlColor: h
    }, e.createElement(kt, {
      cssMode: S,
      className: "Grid__Resetter",
      hasChildBoxes: !0,
      gutterX: R,
      gutterY: I,
      alignX: L,
      alignY: j,
      media: D
    }, e.createElement(et.Provider, {
      value: {
        cssMode: S,
        breakpoints: N,
        gutterX: R,
        gutterY: I,
        media: D,
        colspan: g,
        parent: F,
        controlIsVisible: C,
        controlColor: h
      }
    }, W ? e.Children.map(E, function (t, n) {
      return e.cloneElement(t, {
        rest: W && W[n]
      });
    }) : E))));
  });
function Jt(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
qt.propTypes = {
  breakpoints: Qe.array,
  colspan: Qe.number,
  left: Qe.oneOfType([Qe.array, Qe.string]),
  right: Qe.oneOfType([Qe.array, Qe.string]),
  top: Qe.oneOfType([Qe.array, Qe.string]),
  bottom: Qe.oneOfType([Qe.array, Qe.string]),
  gutterX: Qe.oneOfType([Qe.array, Qe.string]),
  gutterY: Qe.oneOfType([Qe.array, Qe.string]),
  alignX: Qe.oneOfType([Qe.array, Qe.string]),
  alignY: Qe.oneOfType([Qe.array, Qe.string]),
  control: Qe.bool,
  controlColor: Qe.string,
  position: Qe.oneOfType([Qe.array, Qe.string]),
  className: Qe.string,
  style: Qe.oneOfType([Qe.array, Qe.string]),
  children: Qe.node,
  cssMode: Qe.string,
  tag: Qe.string,
  attrs: Qe.object,
  isControl: Qe.bool
}, qt.defaultProps = {
  breakpoints: [0, 432, 768, 1024, 1200, 1400],
  left: "0",
  right: "0",
  top: "0",
  bottom: "0",
  gutterX: "0",
  gutterY: "0",
  alignX: "",
  alignY: "",
  colspan: 1,
  control: !1,
  controlColor: "rgba(0, 0, 0, 0.1)",
  position: "relative",
  style: "",
  className: "",
  children: null,
  cssMode: void 0,
  tag: "div",
  attrs: {},
  isControl: !1
};
var Qt = function (t) {
  ee(r, a);
  var n = Jt(r);
  function r() {
    return q(this, r), n.apply(this, arguments);
  }
  return Q(r, [{
    key: "render",
    value: function () {
      var t = this.props,
        n = t.control,
        r = t.padding,
        i = t.top,
        a = t.right,
        o = t.bottom,
        s = t.left,
        l = t.gutter,
        c = t.colspan,
        d = t.breakpoints;
      return e.createElement(qt, Z({}, this.props, {
        control: n,
        controlColor: "rgba(240,0,0,.1)",
        colspan: c || 12,
        breakpoints: d || [0, 768, 962, 1200],
        top: i || r || ["10px", "10px", "20px"],
        right: a || r || ["10px", "10px", "20px"],
        bottom: o || r || ["10px", "10px", "20px"],
        left: s || r || ["10px", "10px", "20px"],
        gutterX: l || "10px",
        gutterY: l || "10px"
      }), this.props.children);
    }
  }]), r;
}();
function $t(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
var en = function (t) {
    ee(r, a);
    var n = $t(r);
    function r() {
      return q(this, r), n.apply(this, arguments);
    }
    return Q(r, [{
      key: "render",
      value: function () {
        return e.createElement(Gt, Z({}, this.props, {
          cols: this.props.cols
        }), this.props.children || null);
      }
    }]), r;
  }(),
  tn = "menu_headerItem__37c0t",
  nn = "menu_darkThemeLink__pphmS",
  rn = "menu_brightThemeLink__1Xvzn",
  an = "menu_menu__3ApNL",
  on = "menu_menuItem__3QEsI",
  sn = "menu_menuItem2__TKIaN",
  ln = "menu_activeItem__2Dk8T",
  cn = "menu_divider__1hw31";
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.menu_headerItem__37c0t {\n  font-family: "Roboto", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.55);\n  text-transform: uppercase;\n  line-height: 18px;\n  background-color: #E8E8E8; }\n  .menu_headerItem__37c0t > div {\n    padding: 15px 10px 10px 20px; }\n\na.menu_darkThemeLink__pphmS {\n  color: #f5f5f5 !important;\n  line-height: 20px; }\n\na.menu_brightThemeLink__1Xvzn {\n  color: #222 !important;\n  line-height: 20px; }\n\n.menu_menu__3ApNL {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  height: 100%;\n  line-height: 40px;\n  overflow-x: auto;\n  max-width: 100vw; }\n  .menu_menu__3ApNL .menu_menuItem__3QEsI, .menu_menu__3ApNL .menu_menuItem2__TKIaN {\n    white-space: nowrap;\n    color: rgba(0, 0, 0, 0.55);\n    text-decoration: none;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center; }\n    .menu_menu__3ApNL .menu_menuItem__3QEsI a, .menu_menu__3ApNL .menu_menuItem2__TKIaN a {\n      font-weight: 400; }\n    .menu_menu__3ApNL .menu_menuItem__3QEsI:active, .menu_menu__3ApNL .menu_menuItem2__TKIaN:active {\n      border-bottom: 2px solid #7e90ff;\n      font-weight: bold; }\n    .menu_menu__3ApNL .menu_menuItem__3QEsI > div, .menu_menu__3ApNL .menu_menuItem2__TKIaN > div {\n      padding-left: 20px;\n      padding-right: 20px; }\n  .menu_menu__3ApNL .menu_menuItem2__TKIaN {\n    white-space: nowrap; }\n  .menu_menu__3ApNL p {\n    padding: 0;\n    margin: 0; }\n  .menu_menu__3ApNL .menu_activeItem__2Dk8T a {\n    font-weight: bold; }\n  .menu_menu__3ApNL > .menu_menuItem__3QEsI, .menu_menu__3ApNL > .menu_menuItem2__TKIaN {\n    white-space: nowrap;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column; }\n    .menu_menu__3ApNL > .menu_menuItem__3QEsI > div > .menu_menuItem__3QEsI, .menu_menu__3ApNL > .menu_menuItem2__TKIaN > div > .menu_menuItem__3QEsI, .menu_menu__3ApNL > .menu_menuItem__3QEsI > div > .menu_menuItem2__TKIaN, .menu_menu__3ApNL > .menu_menuItem2__TKIaN > div > .menu_menuItem2__TKIaN {\n      padding: 0;\n      margin: 0;\n      padding-left: 20px; }\n  .menu_menu__3ApNL .menu_divider__1hw31 {\n    border: none;\n    border-bottom: solid 1px #D8D8D8;\n    height: 0;\n    padding: 0;\n    margin: 0;\n    background: none; }\n');
var dn = function t(n) {
    var r = n.style,
      i = n.data,
      a = void 0 === i ? [] : i,
      o = n.variant,
      s = void 0 === o ? "tree" : o,
      l = n.sticky,
      c = void 0 !== l && l,
      d = n.direction,
      u = void 0 === d ? "row" : d,
      p = n.stretch,
      m = void 0 !== p && p,
      f = n.theme,
      g = void 0 === f ? "bright" : f,
      _ = function (e) {
        var t = e.level;
        return "column" === u ? function () {
          switch (t) {
            case "2":
              return 0;
            case "3":
              return 22;
            default:
              return 0;
          }
        }() : 0;
      },
      y = function (t, n) {
        var r = t.title,
          i = t.type,
          a = void 0 === i ? "link" : i,
          o = t.icon,
          s = t.href,
          l = t.target,
          c = void 0 === l ? "_blank" : l,
          d = t.active,
          p = t.rounded,
          f = void 0 !== p && p,
          y = t.onClick;
        switch (a) {
          case "divider":
            return e.createElement("hr", {
              key: n,
              style: {
                width: m ? "100%" : ""
              },
              className: cn
            });
          case "header":
            return e.createElement("div", {
              key: n,
              style: {
                width: m ? "100%" : ""
              },
              className: tn
            }, e.createElement("div", null, r));
          case "url":
            return e.createElement("div", {
              key: n,
              style: {
                width: m ? "100%" : "",
                paddingLeft: _(t)
              }
            }, e.createElement("div", {
              style: {
                marginTop: f ? 6 : 0,
                borderBottom: "bright" === g && d ? "3px solid #3F51BF" : "dark" === g && d ? "3px solid #7e90ff" : "none"
              },
              className: "".concat(on, " ").concat(d && ln)
            }, e.createElement(Bl, {
              rounded: f,
              onClick: y,
              theme: g,
              padding: "column" === u ? "7px 15px" : "16px 14px"
            }, e.createElement("a", {
              href: s,
              className: "dark" === g ? nn : rn,
              target: c
            }, r))));
          default:
            return e.createElement("div", {
              key: n,
              style: {
                width: m ? "100%" : ""
              }
            }, e.createElement("div", {
              className: sn,
              style: {
                color: "dark" === g ? "#fff" : "rgba(0,0,0,.55)",
                width: m ? "100%" : "auto"
              },
              onClick: y
            }, e.createElement("div", null, o ? e.createElement(nd, {
              style: {
                alignItems: "center",
                marginTop: -2
              },
              color: "rgba(0, 0, 0, 0.55)",
              size: "small",
              icon: o,
              text: r
            }) : e.createElement("div", {
              style: {
                paddingLeft: _(t),
                paddingRight: "column" === u ? 40 : 0
              }
            }, r))), t.data ? h(t.data) : null);
        }
      },
      h = function (n) {
        return n.map && n.map(function (n, r) {
          return "popover" === s ? function (n, r, i) {
            var a = n.title,
              o = n.type,
              s = void 0 === o ? "link" : o,
              l = n.icon,
              c = n.onClick,
              d = n.active,
              p = void 0 !== d && d,
              f = n.href,
              g = n.target;
            switch (s) {
              case "divider":
                return e.createElement("hr", {
                  key: r,
                  style: {
                    width: m ? "100%" : ""
                  },
                  className: cn
                });
              case "header":
                return e.createElement("div", {
                  key: r,
                  style: {
                    width: m ? "100%" : ""
                  },
                  className: tn
                }, e.createElement("div", null, a));
              case "url":
                return e.createElement("div", {
                  key: r,
                  style: {
                    width: m ? "100%" : "",
                    paddingLeft: _(n)
                  }
                }, e.createElement("div", {
                  className: "".concat(on, " ").concat(p && ln)
                }, e.createElement("div", {
                  onClick: c
                }, e.createElement("a", {
                  href: f,
                  target: g
                }, a))));
              default:
                return e.createElement("div", {
                  key: r,
                  style: {
                    width: m ? "100%" : ""
                  }
                }, n.data ? e.createElement(K, {
                  stretch: !0,
                  direction: "row"
                }, e.createElement("div", {
                  className: "".concat(on, " ").concat(p ? ln : ""),
                  style: {
                    width: m ? "100%" : "auto"
                  },
                  onClick: c
                }, e.createElement("div", null, l ? e.createElement(nd, {
                  style: {
                    alignItems: "center",
                    marginTop: -2
                  },
                  color: "rgba(0, 0, 0, 0.55)",
                  size: "small",
                  icon: l,
                  text: a
                }) : e.createElement("div", {
                  style: {
                    paddingLeft: _(n),
                    paddingRight: "column" === u ? 40 : 0
                  }
                }, a), e.createElement(tc, {
                  slim: !0,
                  position: "bottom",
                  trigger: e.createElement(nd, {
                    icon: "more_vert",
                    color: p ? "#fff" : "rgba(0,0,0,.75)"
                  }),
                  content: e.createElement(t, {
                    direction: "column",
                    data: n.data
                  })
                })))) : e.createElement("div", {
                  className: "".concat(on, " ").concat(p ? ln : ""),
                  style: {
                    width: m ? "100%" : "auto"
                  },
                  onClick: c
                }, e.createElement("div", null, l ? e.createElement(nd, {
                  style: {
                    alignItems: "center",
                    marginTop: -2
                  },
                  color: "rgba(0, 0, 0, 0.55)",
                  size: "small",
                  icon: l,
                  text: a
                }) : e.createElement("div", {
                  style: {
                    paddingLeft: _(n),
                    paddingRight: "column" === u ? 40 : 0
                  }
                }, a))));
            }
          }(n, r) : y(n, r);
        });
      };
    return e.createElement("div", {
      style: r,
      className: an
    }, e.createElement(K, {
      gap: "8px",
      nowrap: !0,
      direction: u,
      style: {
        width: m ? "100%" : "auto",
        position: c ? "sticky" : "inherit",
        top: 0
      },
      justify: "space-around"
    }, h(a)));
  },
  un = "style_noticeContainer__1JXra",
  pn = "style_imageDiv__3UZsE";
function mn(t) {
  var n = t.image,
    r = t.text,
    i = void 0 === r ? "" : r,
    a = t.subtext,
    o = void 0 === a ? "" : a,
    s = t.handleClick,
    l = t.title;
  return e.createElement("div", {
    style: {
      cursor: s ? "pointer" : "inherit"
    },
    className: un,
    onClick: function (e) {
      return s ? s() : null;
    }
  }, e.createElement("div", {
    className: pn,
    title: l && l,
    style: {
      backgroundImage: "url(".concat(n, ")")
    }
  }), e.createElement("ul", null, e.createElement("li", null, e.createElement("strong", null, i)), e.createElement("li", null, o)));
}
y("/*\n@mixin desk-1050{\n    @media (max-width: 1050px){\n        @content;\n    }\n}\n*/\n.style_noticeContainer__1JXra {\n  display: flex;\n  background-color: #fff;\n  color: #222222;\n  width: 100%;\n  height: auto;\n  flex-direction: row;\n  align-items: center;\n  border: solid 1px #d4d4d4;\n  padding: 4px; }\n  .style_noticeContainer__1JXra:hover {\n    background-color: #e8e8e8;\n    color: #2e3b8c; }\n  .style_noticeContainer__1JXra .style_imageDiv__3UZsE {\n    min-width: 65px;\n    min-height: 65px;\n    border-radius: 50%;\n    margin: 5px;\n    background-size: cover; }\n  .style_noticeContainer__1JXra ul {\n    text-align: left;\n    padding: 0 !important;\n    margin: 0 5px; }\n    .style_noticeContainer__1JXra ul li {\n      margin: 2px 0; }\n      .style_noticeContainer__1JXra ul li:nth-child(1) {\n        font-size: 20px; }\n      .style_noticeContainer__1JXra ul li:nth-child(2) {\n        font-size: 15px; }\n");
var fn = "style_message__iwgjA",
  gn = "style_text__fwlp9",
  _n = "style_danger__tc6cI";
y(".style_message__iwgjA {\n  background-color: #607D8B;\n  color: #fff;\n  padding: 15px;\n  border-bottom: 1px solid #fff; }\n  .style_message__iwgjA .style_text__fwlp9 {\n    margin-right: 1ex; }\n  .style_message__iwgjA a {\n    color: #fff !important;\n    text-decoration: underline; }\n\n.style_danger__tc6cI {\n  background: #c62828; }\n");
var yn = o(function (n) {
  var r = n.message,
    i = void 0 === r ? {} : r,
    a = n.readOnly,
    o = n.mute,
    s = n.permanentHide,
    l = n.reset,
    c = i.level,
    d = void 0 === c ? "info" : c,
    u = i.linkText,
    p = i.linkUrl,
    m = i.text,
    f = i.slug,
    g = j(t(!0), 2),
    _ = g[0],
    y = g[1],
    h = function (e) {
      if (l && l(), "permanent" === e && s) s();else if ("permanent" === e && "undefined" != typeof window) {
        var t = window ? window.localStorage.getItem("ttMessages") : "",
          n = t ? t.split(",") : [];
        n.push(f), window && window.localStorage.setItem("ttMessages", n);
      } else o && o();
      y(!1);
    };
  return _ && !function () {
    if ("undefined" != typeof window) {
      var e = window ? window.localStorage.getItem("ttMessages") : "";
      return !!e && e.split(",").filter(function (e) {
        return e === f && !a;
      }).length > 0;
    }
    return !1;
  }() ? e.createElement("div", {
    className: "".concat(fn, " ").concat("danger" === d.toLowerCase() ? _n : "")
  }, e.createElement(Qt, {
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "15px"
  }, e.createElement(en, {
    cols: 11
  }, e.createElement(K, {
    direction: "row",
    align: "center",
    style: {
      height: "100%"
    }
  }, e.createElement(nd, {
    icon: "notifications",
    color: "#fff"
  }), " ", e.createElement("div", {
    className: gn
  }, m), e.createElement("a", {
    href: p
  }, u))), e.createElement(en, {
    cols: 1,
    alignX: "right"
  }, a ? null : e.createElement("div", {
    style: {
      maxWidth: 20
    }
  }, "danger" !== d.toLowerCase() ? e.createElement(tc, {
    trigger: e.createElement(nd, {
      icon: "clear",
      color: "#fff"
    }),
    content: e.createElement(dn, {
      stretch: !0,
      data: [{
        title: "Visa inte igen",
        onClick: function (e) {
          return h("permanent");
        }
      }, {
        title: "Dölj tillfälligt",
        onClick: function (e) {
          return h();
        }
      }]
    })
  }) : e.createElement(Bl, {
    padding: "5px",
    onClick: function (e) {
      return h();
    }
  }, e.createElement(nd, {
    icon: "clear",
    color: "#fff"
  })))))) : null;
}, hn);
function hn(e, t) {
  return !0;
}
var vn = "logo_small__3P-Ze",
  bn = "logo_medium__3iIvT",
  xn = "logo_large__3LO22",
  En = "logo_xlarge__2uuph",
  kn = "logo_title__1tUOc",
  Tn = "logo_menuContent__31E2T";
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n/*\n@mixin desk-1050{\n    @media (max-width: 1050px){\n        @content;\n    }\n}\n*/\n/* ---- Logo General --- */\n/* --- Logo Size --- */\n.logo_small__3P-Ze {\n  max-height: 36px; }\n\n.logo_medium__3iIvT {\n  max-height: 56px;\n  margin: 15px 5px 15px 20px; }\n\n.logo_large__3LO22 {\n  max-height: 76px; }\n\n.logo_xlarge__2uuph {\n  max-height: 160px; }\n\n/* --- Logo Wrapper --- */\n.logo_logo__xrSEB {\n  width: fit-content;\n  display: flex;\n  align-items: center; }\n  .logo_logo__xrSEB h3 {\n    font-family: Roboto;\n    font-size: 22px;\n    font-weight: 500;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 0.86;\n    letter-spacing: 0.2px;\n    color: #222222; }\n\n.logo_headingLarge__dYyU2 {\n  font-family: "Montserrat", sans-serif;\n  font-size: 42px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 52px;\n  color: green;\n  text-transform: uppercase; }\n\n.logo_title__1tUOc {\n  margin: 2px 10px 10px 10px; }\n\n.logo_headingMedium__3z23J {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  text-transform: uppercase; }\n\n.logo_testtest__25Tn- {\n  font-family: "Montserrat", sans-serif;\n  font-size: 72px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 93px;\n  color: blue;\n  font-size: 40px; }\n\n.logo_position-bottom__IDxFt {\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n\n.logo_position-right__E-gaZ {\n  display: flex;\n  flex-direction: row;\n  align-items: center; }\n\n.logo_position-right__E-gaZ img {\n  padding-right: 6px; }\n\n.logo_menuContent__31E2T {\n  width: 620px;\n  max-width: 800px; }\n  .logo_menuContent__31E2T ul {\n    list-style: none;\n    padding: 20px;\n    margin: 0; }\n  .logo_menuContent__31E2T i {\n    cursor: pointer; }\n  .logo_menuContent__31E2T a {\n    color: #222222 !important;\n    font-size: 1.2em;\n    font-weight: bolder; }\n  .logo_menuContent__31E2T [class*="flexWrapper"] {\n    align-content: space-between; }\n  .logo_menuContent__31E2T [class*="menuItem"] {\n    padding: 5px 20px; }\n');
var wn = "style_siteMenu__37WwW",
  An = "style_menu__3McWl",
  Cn = "style_menuVisible__3RAUn",
  Sn = "style_column__1jFe3";
y(".style_siteMenu__37WwW {\n  border-right: 1px solid rgba(0, 0, 0, 0.16);\n  margin-left: 0px;\n  margin-right: 0px;\n  padding-right: 15px; }\n\n.style_menu__3McWl {\n  background: #fff;\n  min-height: 100%;\n  min-width: 100%;\n  width: 100%;\n  height: auto;\n  position: fixed;\n  top: 0;\n  left: -110vw;\n  transition-property: left;\n  transition-duration: .4s;\n  transition-delay: 0s;\n  overflow-x: hidden; }\n  .style_menuVisible__3RAUn {\n    left: 0;\n    z-index: 10; }\n\n.style_column__1jFe3 {\n  position: absolute;\n  width: 100vw;\n  transition-property: left;\n  transition-duration: .4s;\n  transition-delay: 0s; }\n");
var Nn = function (n) {
    var r,
      i,
      a = n.siteMap,
      o = void 0 === a ? {} : a,
      s = n.context,
      l = n.theme,
      c = void 0 === l ? "bright" : l,
      d = n.transparent,
      u = void 0 !== d && d,
      p = j(t(!1), 2),
      m = p[0],
      f = p[1],
      g = j(t("string" == typeof s), 2),
      _ = g[0],
      y = g[1],
      h = function (e) {
        var t = [];
        return o && e.forEach(function (e) {
          t.push({
            title: e.fields.text,
            type: "url",
            href: e.fields.url,
            target: "external" === e.fields.target ? "_blank" : "_self"
          });
        }), t;
      },
      v = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = [];
        return 0 === e.length ? [] : (o && e.fields.link.forEach(function (e) {
          t.push({
            title: e.fields.text,
            type: "url",
            href: e.fields.url,
            target: "external" === e.fields.target ? "_blank" : "_self"
          });
        }), t);
      },
      b = o.fields && o.fields.menu;
    return e.createElement("div", {
      className: wn,
      style: {
        border: u && "none"
      }
    }, e.createElement(Vl, {
      inverted: !0
    }, e.createElement("div", {
      className: "".concat(An, " ").concat(m ? Cn : "")
    }, e.createElement(K, null, _ ? e.createElement(K, {
      direction: "row",
      align: "center"
    }, e.createElement(Bl, {
      onClick: function (e) {
        return y(!1);
      }
    }, e.createElement(nd, {
      icon: "arrow_back"
    })), e.createElement(Wc, {
      variant: "left"
    })) : e.createElement(K, {
      direction: "row",
      align: "center"
    }, e.createElement(Bl, {
      onClick: function (e) {
        f(!1), s && y(!0);
      }
    }, e.createElement(nd, {
      icon: "clear"
    })), e.createElement(Wc, {
      variant: "left"
    })), e.createElement(K, {
      direction: "row",
      nowrap: !0
    }, e.createElement("div", {
      className: Sn,
      style: {
        padding: 5,
        left: _ ? "-100vw" : 0
      }
    }, e.createElement(dn, {
      direction: "row",
      data: [{
        title: "Logga in",
        type: "url",
        href: "https://tt.se/logga-in/",
        target: "_self"
      }, {
        title: "Registrera",
        type: "url",
        href: "https://tt.se/ac/nytt-konto",
        target: "_self"
      }]
    }), e.createElement("hr", null), e.createElement(dn, {
      stretch: !0,
      direction: "column",
      data: (r = b, i = [], o && r && r.forEach(function (e) {
        e.fields && e.fields.link.forEach(function (e) {
          i.push({
            title: e.fields.text,
            type: "url",
            href: e.fields.url,
            target: "external" === e.fields.target ? "_blank" : "_self"
          });
        });
      }), i)
    }), e.createElement("hr", null), e.createElement(dn, {
      stretch: !0,
      direction: "column",
      data: o.fields && h(o.fields.link)
    })), s ? e.createElement("div", {
      className: Sn,
      style: {
        padding: 5,
        left: _ ? 0 : "100vw"
      }
    }, e.createElement(dn, {
      stretch: !0,
      direction: "column",
      data: v(b.filter(function (e) {
        return e.fields.title.toLowerCase() === s;
      })[0])
    }), e.createElement("hr", null), e.createElement(dn, {
      stretch: !0,
      padding: "0px",
      direction: "column",
      data: v(b.filter(function (e) {
        return e.fields.title.toLowerCase() === s;
      })[0] ? b.filter(function (e) {
        return e.fields.title.toLowerCase() === s;
      })[0].fields.menu[0] : [])
    })) : null)))), e.createElement(Vl, null, e.createElement(tc, {
      rounded: !0,
      theme: c,
      zonePadding: "15px",
      keepOpen: !0,
      slim: !0,
      trigger: o ? e.createElement(nd, {
        icon: "menu",
        color: c.toLowerCase && "bright" === c.toLowerCase() ? "#000" : "#fff"
      }) : null,
      content: e.createElement("div", {
        className: Tn
      }, e.createElement(Qt, {
        cssMode: "flex",
        hasChildBoxes: !0
      }, e.createElement(en, {
        cols: [6, 6, 6, 6],
        style: "display: flex"
      }, e.createElement(K, {
        gap: "15px",
        direction: "row",
        justify: "space-evenly"
      }, o && o.fields ? Object.values(o.fields.menu).map(function (t, n) {
        return e.createElement(mn, {
          key: n,
          text: t.fields.link[0].fields.text,
          subtext: t.fields.link[0].fields.subheader,
          image: t.fields.link[0].fields.image.fields.file.url,
          title: t.fields.link[0].fields.image.fields.title,
          handleClick: function (e) {
            window.location.href = t.fields.link[0].fields.url;
          }
        });
      }) : "Ingen data!")), e.createElement(en, {
        cols: [6, 6, 6, 6],
        style: "border: solid 1px #d4d4d4"
      }, e.createElement(dn, {
        stretch: !0,
        direction: "column",
        style: {
          marginTop: 15
        },
        data: o.fields && h(o.fields.link)
      }))))
    })));
  },
  On = "style_crumb__Rijm7",
  Rn = "style_link__2k2Up",
  In = "style_brightTheme__29TK3",
  Ln = "style_isLast__3GIAD",
  jn = "style_darkTheme__1eTl7",
  Dn = "style_divider__3nu4m";
y(".style_crumb__Rijm7 {\n  padding: 2px 1ex;\n  font-size: 14px;\n  line-height: 22px;\n  color: #333; }\n  .style_crumb__Rijm7.style_link__2k2Up {\n    cursor: pointer;\n    text-decoration: underline; }\n  .style_crumb__Rijm7.style_brightTheme__29TK3:hover {\n    background-color: #e8e8e8; }\n    .style_crumb__Rijm7.style_brightTheme__29TK3:hover.style_isLast__3GIAD:hover {\n      background-color: unset; }\n  .style_crumb__Rijm7.style_darkTheme__1eTl7:hover {\n    background-color: #292929; }\n    .style_crumb__Rijm7.style_darkTheme__1eTl7:hover.style_isLast__3GIAD:hover {\n      background-color: unset; }\n  .style_crumb__Rijm7:hover {\n    transition: background-color .4s ease-out;\n    -webkit-transition: background-color .4s ease-out;\n    -moz-transition: background-color .4s ease-out;\n    -o-transition: background-color .4s ease-out; }\n\n.style_divider__3nu4m {\n  font-size: 14px;\n  line-height: 22px;\n  color: #333; }\n");
var Fn = function (t) {
    var n = t.data,
      r = void 0 === n ? [] : n,
      i = t.theme,
      a = void 0 === i ? "bright" : i;
    return e.createElement(K, {
      direction: "row",
      align: "flex-start"
    }, r.map && r.map(function (t, n) {
      var i = t.text,
        o = t.onClick,
        s = n < r.length - 1;
      return e.createElement(K, {
        key: n,
        direction: "row",
        align: "center"
      }, e.createElement("div", {
        className: "".concat(On, " ").concat("bright" === a ? In : "dark" === a ? jn : "", " ").concat(s ? Rn : Ln),
        onClick: o || null,
        style: {
          color: "dark" !== a ? "#4f4f4f" : "#fff"
        }
      }, i), s ? e.createElement("div", {
        style: {
          color: "dark" !== a ? "#4f4f4f" : "#fff"
        },
        className: Dn
      }, e.createElement("div", {
        style: {
          marginTop: 2
        }
      }, e.createElement(nd, {
        icon: "chevron_right",
        color: "dark" === a ? "#fff" : "#4f4f4f"
      }))) : null);
    }));
  },
  Mn = e => e instanceof HTMLElement;
const Pn = "blur",
  Bn = "change",
  Hn = "input",
  zn = "onBlur",
  Un = "onChange",
  Wn = "onSubmit",
  Xn = "onTouched",
  Gn = "all",
  Vn = "max",
  Yn = "min",
  Kn = "maxLength",
  Zn = "minLength",
  qn = "pattern",
  Jn = "required",
  Qn = "validate";
var $n = e => null == e;
const er = e => "object" == typeof e;
var tr = e => !$n(e) && !Array.isArray(e) && er(e) && !(e instanceof Date),
  nr = e => /^\w*$/.test(e),
  rr = e => e.filter(Boolean),
  ir = e => rr(e.replace(/["|']/g, "").replace(/\[/g, ".").replace(/\]/g, "").split("."));
function ar(e, t, n) {
  let r = -1;
  const i = nr(t) ? [t] : ir(t),
    a = i.length,
    o = a - 1;
  for (; ++r < a;) {
    const t = i[r];
    let a = n;
    if (r !== o) {
      const n = e[t];
      a = tr(n) || Array.isArray(n) ? n : isNaN(+i[r + 1]) ? {} : [];
    }
    e[t] = a, e = e[t];
  }
  return e;
}
var or = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    for (const n in e) nr(n) ? t[n] = e[n] : ar(t, n, e[n]);
    return t;
  },
  sr = e => void 0 === e,
  lr = function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let t = arguments.length > 1 ? arguments[1] : undefined;
    let n = arguments.length > 2 ? arguments[2] : undefined;
    const r = rr(t.split(/[,[\].]+?/)).reduce((e, t) => $n(e) ? e : e[t], e);
    return sr(r) || r === e ? sr(e[t]) ? n : e[t] : r;
  },
  cr = (e, t) => {
    Mn(e) && e.removeEventListener && (e.removeEventListener(Hn, t), e.removeEventListener(Bn, t), e.removeEventListener(Pn, t));
  };
const dr = {
  isValid: !1,
  value: null
};
var ur = e => Array.isArray(e) ? e.reduce((e, t) => t && t.ref.checked ? {
    isValid: !0,
    value: t.ref.value
  } : e, dr) : dr,
  pr = e => "radio" === e.type,
  mr = e => "file" === e.type,
  fr = e => "checkbox" === e.type,
  gr = e => "select-multiple" === e.type;
const _r = {
    value: !1,
    isValid: !1
  },
  yr = {
    value: !0,
    isValid: !0
  };
var hr = e => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter(e => e && e.ref.checked).map(_ref => {
        let {
          ref: {
            value: e
          }
        } = _ref;
        return e;
      });
      return {
        value: t,
        isValid: !!t.length
      };
    }
    const {
      checked: t,
      value: n,
      attributes: r
    } = e[0].ref;
    return t ? r && !sr(r.value) ? sr(n) || "" === n ? yr : {
      value: n,
      isValid: !0
    } : yr : _r;
  }
  return _r;
};
function vr(e, t, n, r, i) {
  const a = e.current[t];
  if (a) {
    const {
      ref: {
        value: e,
        disabled: t
      },
      ref: n,
      valueAsNumber: s,
      valueAsDate: l,
      setValueAs: c
    } = a;
    if (t && r) return;
    return mr(n) ? n.files : pr(n) ? ur(a.options).value : gr(n) ? (o = n.options, [...o].filter(_ref2 => {
      let {
        selected: e
      } = _ref2;
      return e;
    }).map(_ref3 => {
      let {
        value: e
      } = _ref3;
      return e;
    })) : fr(n) ? hr(a.options).value : i ? e : s ? "" === e ? NaN : +e : l ? n.valueAsDate : c ? c(e) : e;
  }
  var o;
  if (n) return lr(n.current, t);
}
function br(e) {
  return !e || e instanceof HTMLElement && e.nodeType !== Node.DOCUMENT_NODE && br(e.parentNode);
}
var xr = e => tr(e) && !Object.keys(e).length,
  Er = e => "boolean" == typeof e;
function kr(e, t) {
  const n = nr(t) ? [t] : ir(t),
    r = 1 == n.length ? e : function (e, t) {
      const n = t.slice(0, -1).length;
      let r = 0;
      for (; r < n;) e = sr(e) ? r++ : e[t[r++]];
      return e;
    }(e, n),
    i = n[n.length - 1];
  let a;
  r && delete r[i];
  for (let t = 0; t < n.slice(0, -1).length; t++) {
    let r,
      i = -1;
    const o = n.slice(0, -(t + 1)),
      s = o.length - 1;
    for (t > 0 && (a = e); ++i < o.length;) {
      const t = o[i];
      r = r ? r[t] : e[t], s === i && (tr(r) && xr(r) || Array.isArray(r) && !r.filter(e => tr(e) && !xr(e) || Er(e)).length) && (a ? delete a[t] : delete e[t]), a = r;
    }
  }
  return e;
}
const Tr = (e, t) => e && e.ref === t;
var wr = e => $n(e) || !er(e);
function Ar(e, t) {
  if (wr(e) || wr(t)) return t;
  for (const n in t) {
    const r = e[n],
      i = t[n];
    try {
      e[n] = tr(r) && tr(i) || Array.isArray(r) && Array.isArray(i) ? Ar(r, i) : i;
    } catch (e) {}
  }
  return e;
}
function Cr(e, t, n) {
  if (wr(e) || wr(t) || e instanceof Date || t instanceof Date) return e === t;
  if (!d(e)) {
    const r = Object.keys(e),
      i = Object.keys(t);
    if (r.length !== i.length) return !1;
    for (const i of r) {
      const r = e[i];
      if (!n || "ref" !== i) {
        const e = t[i];
        if ((tr(r) || Array.isArray(r)) && (tr(e) || Array.isArray(e)) ? !Cr(r, e, n) : r !== e) return !1;
      }
    }
  }
  return !0;
}
function Sr(e, t, n, r, i) {
  let a = -1;
  for (; ++a < e.length;) {
    for (const r in e[a]) Array.isArray(e[a][r]) ? (!n[a] && (n[a] = {}), n[a][r] = [], Sr(e[a][r], lr(t[a] || {}, r, []), n[a][r], n[a], r)) : Cr(lr(t[a] || {}, r), e[a][r]) ? ar(n[a] || {}, r) : n[a] = Object.assign(Object.assign({}, n[a]), {
      [r]: !0
    });
    r && !n.length && delete r[i];
  }
  return n;
}
var Nr = (e, t, n) => Ar(Sr(e, t, n.slice(0, e.length)), Sr(t, e, n.slice(0, e.length))),
  Or = e => "string" == typeof e,
  Rr = (e, t, n, r, i) => {
    const a = {};
    for (const t in e.current) (sr(i) || (Or(i) ? t.startsWith(i) : Array.isArray(i) && i.find(e => t.startsWith(e)))) && (a[t] = vr(e, t, void 0, r));
    return n ? or(a) : Ar(t, or(a));
  },
  Ir = e => e instanceof RegExp,
  Lr = e => tr(e) && !Ir(e) ? e : {
    value: e,
    message: ""
  },
  jr = e => "function" == typeof e,
  Dr = e => Or(e) || d(e);
function Fr(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "validate";
  if (Dr(e) || Er(e) && !e) return {
    type: n,
    message: Dr(e) ? e : "",
    ref: t
  };
}
var Mr = (e, t, n, r, i) => t ? Object.assign(Object.assign({}, n[e]), {
    types: Object.assign(Object.assign({}, n[e] && n[e].types ? n[e].types : {}), {
      [r]: i || !0
    })
  }) : {},
  Pr = async (e, t, _ref4, p) => {
    let {
      ref: n,
      ref: {
        value: r
      },
      options: i,
      required: a,
      maxLength: o,
      minLength: s,
      min: l,
      max: c,
      pattern: d,
      validate: u
    } = _ref4;
    const m = n.name,
      f = {},
      g = pr(n),
      _ = fr(n),
      y = g || _,
      h = "" === r,
      v = Mr.bind(null, m, t, f),
      b = function (e, t, r) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Kn;
        let a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Zn;
        const o = e ? t : r;
        f[m] = Object.assign({
          type: e ? i : a,
          message: o,
          ref: n
        }, v(e ? i : a, o));
      };
    if (a && (!g && !_ && (h || $n(r)) || Er(r) && !r || _ && !hr(i).isValid || g && !ur(i).isValid)) {
      const {
        value: r,
        message: i
      } = Dr(a) ? {
        value: !!a,
        message: a
      } : Lr(a);
      if (r && (f[m] = Object.assign({
        type: Jn,
        message: i,
        ref: y ? ((e.current[m].options || [])[0] || {}).ref : n
      }, v(Jn, i)), !t)) return f;
    }
    if (!($n(l) && $n(c) || "" === r)) {
      let e, i;
      const a = Lr(c),
        o = Lr(l);
      if (isNaN(r)) {
        const t = n.valueAsDate || new Date(r);
        Or(a.value) && (e = t > new Date(a.value)), Or(o.value) && (i = t < new Date(o.value));
      } else {
        const t = n.valueAsNumber || parseFloat(r);
        $n(a.value) || (e = t > a.value), $n(o.value) || (i = t < o.value);
      }
      if ((e || i) && (b(!!e, a.message, o.message, Vn, Yn), !t)) return f;
    }
    if (Or(r) && !h && (o || s)) {
      const e = Lr(o),
        n = Lr(s),
        i = !$n(e.value) && r.length > e.value,
        a = !$n(n.value) && r.length < n.value;
      if ((i || a) && (b(i, e.message, n.message), !t)) return f;
    }
    if (Or(r) && d && !h) {
      const {
        value: e,
        message: i
      } = Lr(d);
      if (Ir(e) && !e.test(r) && (f[m] = Object.assign({
        type: qn,
        message: i,
        ref: n
      }, v(qn, i)), !t)) return f;
    }
    if (u) {
      const r = vr(e, m, p, !1, !0),
        a = y && i ? i[0].ref : n;
      if (jr(u)) {
        const e = Fr(await u(r), a);
        if (e && (f[m] = Object.assign(Object.assign({}, e), v(Qn, e.message)), !t)) return f;
      } else if (tr(u)) {
        let e = {};
        for (const [n, i] of Object.entries(u)) {
          if (!xr(e) && !t) break;
          const o = Fr(await i(r), a, n);
          o && (e = Object.assign(Object.assign({}, o), v(n, o.message)), t && (f[m] = e));
        }
        if (!xr(e) && (f[m] = Object.assign({
          ref: a
        }, e), !t)) return f;
      }
    }
    return f;
  };
const Br = function (e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  for (const r in t) {
    const i = e + (tr(t) ? `.${r}` : `[${r}]`);
    wr(t[r]) ? n.push(i) : Br(i, t[r], n);
  }
  return n;
};
var Hr = (e, t, n, r, i) => {
    let a;
    return n.add(t), xr(e) || (a = lr(e, t), (tr(a) || Array.isArray(a)) && Br(t, a).forEach(e => n.add(e))), sr(a) ? i ? r : lr(r, t) : a;
  },
  zr = _ref5 => {
    let {
      isOnBlur: e,
      isOnChange: t,
      isOnTouch: n,
      isTouched: r,
      isReValidateOnBlur: i,
      isReValidateOnChange: a,
      isBlurEvent: o,
      isSubmitted: s,
      isOnAll: l
    } = _ref5;
    return !l && (!s && n ? !(r || o) : (s ? i : e) ? !o : !(s ? a : t) || o);
  },
  Ur = e => e.substring(0, e.indexOf("["));
const Wr = (e, t) => RegExp(`^${t}([|.)\\d+`.replace(/\[/g, "\\[").replace(/\]/g, "\\]")).test(e);
var Xr = (e, t) => [...e].some(e => Wr(t, e));
var Gr = "undefined" != typeof window && "undefined" != typeof document;
function Vr(e) {
  var t;
  let n;
  if (wr(e) || Gr && (e instanceof File || Mn(e))) return e;
  if (!["Set", "Map", "Object", "Date", "Array"].includes(null === (t = e.constructor) || void 0 === t ? void 0 : t.name)) return e;
  if (e instanceof Date) return n = new Date(e.getTime()), n;
  if (e instanceof Set) {
    n = new Set();
    for (const t of e) n.add(t);
    return n;
  }
  if (e instanceof Map) {
    n = new Map();
    for (const t of e.keys()) n.set(t, Vr(e.get(t)));
    return n;
  }
  n = Array.isArray(e) ? [] : {};
  for (const t in e) n[t] = Vr(e[t]);
  return n;
}
var Yr = e => ({
    isOnSubmit: !e || e === Wn,
    isOnBlur: e === zn,
    isOnChange: e === Un,
    isOnAll: e === Gn,
    isOnTouch: e === Xn
  }),
  Kr = e => pr(e) || fr(e);
const Zr = "undefined" == typeof window,
  qr = Gr ? "Proxy" in window : "undefined" != typeof Proxy;
function Jr() {
  let {
    mode: e = Wn,
    reValidateMode: r = Un,
    resolver: a,
    context: o,
    defaultValues: s = {},
    shouldFocusError: d = !0,
    shouldUnregister: u = !0,
    criteriaMode: p
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const m = c({}),
    f = c({}),
    g = c({}),
    _ = c(new Set()),
    y = c({}),
    h = c({}),
    v = c({}),
    b = c({}),
    x = c(s),
    E = c(!1),
    k = c(!1),
    T = c(),
    w = c({}),
    A = c({}),
    C = c(o),
    S = c(a),
    N = c(new Set()),
    O = c(Yr(e)),
    {
      isOnSubmit: R,
      isOnTouch: I
    } = O.current,
    L = p === Gn,
    [j, D] = t({
      isDirty: !1,
      isValidating: !1,
      dirtyFields: {},
      isSubmitted: !1,
      submitCount: 0,
      touched: {},
      isSubmitting: !1,
      isSubmitSuccessful: !1,
      isValid: !R,
      errors: {}
    }),
    F = c({
      isDirty: !qr,
      dirtyFields: !qr,
      touched: !qr || I,
      isValidating: !qr,
      isSubmitting: !qr,
      isValid: !qr
    }),
    M = c(j),
    P = c(),
    {
      isOnBlur: B,
      isOnChange: H
    } = c(Yr(r)).current;
  C.current = o, S.current = a, M.current = j, w.current = u ? {} : xr(w.current) ? Vr(s) : w.current;
  const z = l(function () {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      E.current || (M.current = Object.assign(Object.assign({}, M.current), e), D(M.current));
    }, []),
    U = () => F.current.isValidating && z({
      isValidating: !0
    }),
    W = l(function (e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      let i = arguments.length > 4 ? arguments[4] : undefined;
      let a = n || (_ref6 => {
        let {
          errors: e,
          name: t,
          error: n,
          validFields: r,
          fieldsWithValidation: i
        } = _ref6;
        const a = sr(n),
          o = lr(e, t);
        return a && !!o || !a && !Cr(o, n, !0) || a && lr(i, t) && !lr(r, t);
      })({
        errors: M.current.errors,
        error: t,
        name: e,
        validFields: b.current,
        fieldsWithValidation: v.current
      });
      const o = lr(M.current.errors, e);
      t ? (kr(b.current, e), a = a || !o || !Cr(o, t, !0), ar(M.current.errors, e, t)) : ((lr(v.current, e) || S.current) && (ar(b.current, e, !0), a = a || o), kr(M.current.errors, e)), (a && !$n(n) || !xr(r) || F.current.isValidating) && z(Object.assign(Object.assign(Object.assign({}, r), S.current ? {
        isValid: !!i
      } : {}), {
        isValidating: !1
      }));
    }, []),
    X = l((e, t) => {
      const {
          ref: n,
          options: r
        } = m.current[e],
        i = Gr && Mn(n) && $n(t) ? "" : t;
      pr(n) ? (r || []).forEach(_ref7 => {
        let {
          ref: e
        } = _ref7;
        return e.checked = e.value === i;
      }) : mr(n) && !Or(i) ? n.files = i : gr(n) ? [...n.options].forEach(e => e.selected = i.includes(e.value)) : fr(n) && r ? r.length > 1 ? r.forEach(_ref8 => {
        let {
          ref: e
        } = _ref8;
        return e.checked = Array.isArray(i) ? !!i.find(t => t === e.value) : i === e.value;
      }) : r[0].ref.checked = !!i : n.value = i;
    }, []),
    G = l((e, t) => {
      if (F.current.isDirty) {
        const n = te();
        return e && t && ar(n, e, t), !Cr(n, x.current);
      }
      return !1;
    }, []),
    V = l(function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      if (F.current.isDirty || F.current.dirtyFields) {
        const n = !Cr(lr(x.current, e), vr(m, e, w)),
          r = lr(M.current.dirtyFields, e),
          i = M.current.isDirty;
        n ? ar(M.current.dirtyFields, e, !0) : kr(M.current.dirtyFields, e);
        const a = {
            isDirty: G(),
            dirtyFields: M.current.dirtyFields
          },
          o = F.current.isDirty && i !== a.isDirty || F.current.dirtyFields && r !== lr(M.current.dirtyFields, e);
        return o && t && z(a), o ? a : {};
      }
      return {};
    }, []),
    Y = l(async (e, t) => {
      if ("production" !== process.env.NODE_ENV && !m.current[e]) return console.warn("📋 Field is missing with `name` attribute: ", e), !1;
      const n = (await Pr(m, L, m.current[e], w))[e];
      return W(e, n, t), sr(n);
    }, [W, L]),
    K = l(async e => {
      const {
          errors: t
        } = await S.current(te(), C.current, L),
        n = M.current.isValid;
      if (Array.isArray(e)) {
        const n = e.map(e => {
          const n = lr(t, e);
          return n ? ar(M.current.errors, e, n) : kr(M.current.errors, e), !n;
        }).every(Boolean);
        return z({
          isValid: xr(t),
          isValidating: !1
        }), n;
      }
      {
        const r = lr(t, e);
        return W(e, r, n !== xr(t), {}, xr(t)), !r;
      }
    }, [W, L]),
    Z = l(async e => {
      const t = e || Object.keys(m.current);
      if (U(), S.current) return K(t);
      if (Array.isArray(t)) {
        !e && (M.current.errors = {});
        const n = await Promise.all(t.map(async e => await Y(e, null)));
        return z({
          isValidating: !1
        }), n.every(Boolean);
      }
      return await Y(t);
    }, [K, Y]),
    q = l((e, t, _ref9) => {
      let {
        shouldDirty: n,
        shouldValidate: r
      } = _ref9;
      const i = {};
      ar(i, e, t);
      for (const a of Br(e, t)) m.current[a] && (X(a, lr(i, a)), n && V(a), r && Z(a));
    }, [Z, X, V]),
    J = l((e, t, n) => {
      if (!u && !wr(t) && ar(w.current, e, Array.isArray(t) ? [...t] : Object.assign({}, t)), m.current[e]) X(e, t), n.shouldDirty && V(e), n.shouldValidate && Z(e);else if (!wr(t) && (q(e, t, n), N.current.has(e))) {
        const r = Ur(e) || e;
        ar(f.current, e, t), A.current[r]({
          [r]: lr(f.current, r)
        }), (F.current.isDirty || F.current.dirtyFields) && n.shouldDirty && (ar(M.current.dirtyFields, e, Nr(t, lr(x.current, e, []), lr(M.current.dirtyFields, e, []))), z({
          isDirty: !Cr(Object.assign(Object.assign({}, te()), {
            [e]: t
          }), x.current)
        }));
      }
      !u && ar(w.current, e, t);
    }, [V, X, q]),
    Q = e => k.current || _.current.has(e) || _.current.has((e.match(/\w+/) || [])[0]),
    $ = e => {
      let t = !0;
      if (!xr(y.current)) for (const n in y.current) e && y.current[n].size && !y.current[n].has(e) && !y.current[n].has(Ur(e)) || (h.current[n](), t = !1);
      return t;
    };
  function ee(e) {
    if (!u) {
      let t = Vr(e);
      for (const e of N.current) nr(e) && !t[e] && (t = Object.assign(Object.assign({}, t), {
        [e]: []
      }));
      return t;
    }
    return e;
  }
  function te(e) {
    if (Or(e)) return vr(m, e, w);
    if (Array.isArray(e)) {
      const t = {};
      for (const n of e) ar(t, n, vr(m, n, w));
      return t;
    }
    return ee(Rr(m, Vr(w.current), u));
  }
  T.current = T.current ? T.current : async _ref10 => {
    let {
      type: e,
      target: t
    } = _ref10;
    let n = t.name;
    const r = m.current[n];
    let i, a;
    if (r) {
      const o = e === Pn,
        s = zr(Object.assign({
          isBlurEvent: o,
          isReValidateOnChange: H,
          isReValidateOnBlur: B,
          isTouched: !!lr(M.current.touched, n),
          isSubmitted: M.current.isSubmitted
        }, O.current));
      let l = V(n, !1),
        c = !xr(l) || !o && Q(n);
      if (o && !lr(M.current.touched, n) && F.current.touched && (ar(M.current.touched, n, !0), l = Object.assign(Object.assign({}, l), {
        touched: M.current.touched
      })), !u && fr(t) && ar(w.current, n, vr(m, n)), s) return !o && $(n), (!xr(l) || c && xr(l)) && z(l);
      if (U(), S.current) {
        const {
            errors: e
          } = await S.current(te(), C.current, L),
          r = M.current.isValid;
        if (i = lr(e, n), fr(t) && !i && S.current) {
          const t = Ur(n),
            r = lr(e, t, {});
          r.type && r.message && (i = r), t && (r || lr(M.current.errors, t)) && (n = t);
        }
        a = xr(e), r !== a && (c = !0);
      } else i = (await Pr(m, L, r, w))[n];
      !o && $(n), W(n, i, c, l, a);
    }
  };
  const ne = l(async function () {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const t = xr(m.current) ? x.current : {},
        {
          errors: n
        } = (await S.current(Object.assign(Object.assign(Object.assign({}, t), te()), e), C.current, L)) || {},
        r = xr(n);
      M.current.isValid !== r && z({
        isValid: r
      });
    }, [L]),
    re = l((e, t) => {
      !function (e, t, n, r, i, a) {
        const {
            ref: o,
            ref: {
              name: s
            }
          } = n,
          l = e.current[s];
        if (!i) {
          const t = vr(e, s, r);
          !sr(t) && ar(r.current, s, t);
        }
        o.type && l ? pr(o) || fr(o) ? Array.isArray(l.options) && l.options.length ? (rr(l.options).forEach(function () {
          let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          let n = arguments.length > 1 ? arguments[1] : undefined;
          (br(e.ref) && Tr(e, e.ref) || a) && (cr(e.ref, t), kr(l.options, `[${n}]`));
        }), l.options && !rr(l.options).length && delete e.current[s]) : delete e.current[s] : (br(o) && Tr(l, o) || a) && (cr(o, t), delete e.current[s]) : delete e.current[s];
      }(m, T.current, e, w, u, t), u && (kr(b.current, e.ref.name), kr(v.current, e.ref.name));
    }, [u]),
    ie = l(e => {
      if (k.current) z();else {
        for (const t of _.current) if (t.startsWith(e)) {
          z();
          break;
        }
        $(e);
      }
    }, []),
    ae = l((e, t) => {
      e && (re(e, t), u && !rr(e.options || []).length && (kr(M.current.errors, e.ref.name), ar(M.current.dirtyFields, e.ref.name, !0), z({
        isDirty: G()
      }), F.current.isValid && S.current && ne(), ie(e.ref.name)));
    }, [ne, re]);
  const oe = l((e, t, n) => {
    const r = n ? y.current[n] : _.current;
    let i = Rr(m, Vr(w.current), u, !1, e);
    if (Or(e)) {
      const n = Ur(e) || e;
      return N.current.has(n) && (i = Object.assign(Object.assign({}, g.current), i)), Hr(i, e, r, sr(lr(x.current, e)) ? t : lr(x.current, e), !0);
    }
    const a = sr(t) ? x.current : t;
    return Array.isArray(e) ? e.reduce((e, t) => Object.assign(Object.assign({}, e), {
      [t]: Hr(i, t, r, a)
    }), {}) : (k.current = sr(n), or(!xr(i) && i || a));
  }, []);
  function se(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if ("production" !== process.env.NODE_ENV) {
      if (!e.name) return console.warn("📋 Field is missing `name` attribute", e, "https://react-hook-form.com/api#useForm");
      if (N.current.has(e.name.split(/\[\d+\]$/)[0]) && !RegExp(`^${e.name.split(/\[\d+\]$/)[0]}[\\d+].\\w+`.replace(/\[/g, "\\[").replace(/\]/g, "\\]")).test(e.name)) return console.warn('📋 `name` prop should be in object shape: name="test[index].name"', e, "https://react-hook-form.com/api#useFieldArray");
    }
    const {
        name: n,
        type: r,
        value: i
      } = e,
      a = Object.assign({
        ref: e
      }, t),
      o = m.current,
      s = Kr(e),
      l = Xr(N.current, n),
      c = t => Gr && (!Mn(e) || t === e);
    let d,
      p = o[n],
      f = !0;
    if (p && (s ? Array.isArray(p.options) && rr(p.options).find(e => i === e.ref.value && c(e.ref)) : c(p.ref))) return void (o[n] = Object.assign(Object.assign({}, p), t));
    p = r ? s ? Object.assign({
      options: [...rr(p && p.options || []), {
        ref: e
      }],
      ref: {
        type: r,
        name: n
      }
    }, t) : Object.assign({}, a) : a, o[n] = p;
    const g = sr(lr(w.current, n));
    xr(x.current) && g || (d = lr(g ? x.current : w.current, n), f = sr(d), f || l || X(n, d)), xr(t) || (ar(v.current, n, !0), !R && F.current.isValid && Pr(m, L, p, w).then(e => {
      const t = M.current.isValid;
      xr(e) ? ar(b.current, n, !0) : kr(b.current, n), t !== xr(e) && z();
    })), !u || l && f || !l && kr(M.current.dirtyFields, n), r && function (_ref11, t, n) {
      let {
        ref: e
      } = _ref11;
      Mn(e) && n && (e.addEventListener(t ? Bn : Hn, n), e.addEventListener(Pn, n));
    }(s && p.options ? p.options[p.options.length - 1] : p, s || "select-one" === e.type, T.current);
  }
  const le = l((e, t) => async n => {
    n && n.preventDefault && (n.preventDefault(), n.persist());
    let r = {},
      i = ee(Rr(m, Vr(w.current), u, !0));
    F.current.isSubmitting && z({
      isSubmitting: !0
    });
    try {
      if (S.current) {
        const {
          errors: e,
          values: t
        } = await S.current(i, C.current, L);
        M.current.errors = r = e, i = t;
      } else for (const e of Object.values(m.current)) if (e) {
        const {
            name: t
          } = e.ref,
          n = await Pr(m, L, e, w);
        n[t] ? (ar(r, t, n[t]), kr(b.current, t)) : lr(v.current, t) && (kr(M.current.errors, t), ar(b.current, t, !0));
      }
      xr(r) && Object.keys(M.current.errors).every(e => e in m.current) ? (z({
        errors: {},
        isSubmitting: !0
      }), await e(i, n)) : (M.current.errors = Object.assign(Object.assign({}, M.current.errors), r), t && (await t(M.current.errors, n)), d && ((e, t) => {
        for (const n in e) if (lr(t, n)) {
          const t = e[n];
          if (t) {
            if (t.ref.focus && sr(t.ref.focus())) break;
            if (t.options) {
              t.options[0].ref.focus();
              break;
            }
          }
        }
      })(m.current, M.current.errors));
    } finally {
      M.current.isSubmitting = !1, z({
        isSubmitted: !0,
        isSubmitting: !1,
        isSubmitSuccessful: xr(M.current.errors),
        submitCount: M.current.submitCount + 1
      });
    }
  }, [d, L]);
  n(() => {
    a && F.current.isValid && ne(), P.current = P.current || !Gr ? P.current : function (e, t) {
      const n = new MutationObserver(() => {
        for (const n of Object.values(e.current)) if (n && n.options) for (const e of n.options) e && e.ref && br(e.ref) && t(n);else n && br(n.ref) && t(n);
      });
      return n.observe(window.document, {
        childList: !0,
        subtree: !0
      }), n;
    }(m, ae);
  }, [ae, x.current]), n(() => () => {
    P.current && P.current.disconnect(), E.current = !0, "production" === process.env.NODE_ENV && Object.values(m.current).forEach(e => ae(e, !0));
  }, []), !a && F.current.isValid && (j.isValid = Cr(b.current, v.current) && xr(M.current.errors));
  const ce = {
      trigger: Z,
      setValue: l(function (e, t, n) {
        J(e, t, n || {}), Q(e) && z(), $(e);
      }, [J, Z]),
      getValues: l(te, []),
      register: l(function (e, t) {
        if (!Zr) if (Or(e)) se({
          name: e
        }, t);else {
          if (!tr(e) || !("name" in e)) return t => t && se(t, e);
          se(e, t);
        }
      }, [x.current]),
      unregister: l(function (e) {
        for (const t of Array.isArray(e) ? e : [e]) ae(m.current[t], !0);
      }, []),
      formState: qr ? new Proxy(j, {
        get: (e, t) => {
          if ("production" !== process.env.NODE_ENV && "isValid" === t && R && console.warn("📋 `formState.isValid` is applicable with `onTouched`, `onChange` or `onBlur` mode. https://react-hook-form.com/api#formState"), t in e) return F.current[t] = !0, e[t];
        }
      }) : j
    },
    de = i(() => Object.assign({
      isFormDirty: G,
      updateWatchedValue: ie,
      shouldUnregister: u,
      updateFormState: z,
      removeFieldEventListener: re,
      watchInternal: oe,
      mode: O.current,
      reValidateMode: {
        isReValidateOnBlur: B,
        isReValidateOnChange: H
      },
      validateResolver: a ? ne : void 0,
      fieldsRef: m,
      resetFieldArrayFunctionRef: A,
      useWatchFieldsRef: y,
      useWatchRenderFunctionsRef: h,
      fieldArrayDefaultValuesRef: f,
      validFieldsRef: b,
      fieldsWithValidationRef: v,
      fieldArrayNamesRef: N,
      readFormStateRef: F,
      formStateRef: M,
      defaultValuesRef: x,
      shallowFieldsStateRef: w,
      fieldArrayValuesRef: g
    }, ce), [x.current, ie, u, re, oe]);
  return Object.assign({
    watch: function (e, t) {
      return oe(e, t);
    },
    control: de,
    handleSubmit: le,
    reset: l(function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (Gr) for (const e of Object.values(m.current)) if (e) {
        const {
            ref: t,
            options: n
          } = e,
          r = Kr(t) && Array.isArray(n) ? n[0].ref : t;
        if (Mn(r)) try {
          r.closest("form").reset();
          break;
        } catch (e) {}
      }
      m.current = {}, x.current = Object.assign({}, e || x.current), e && $(""), Object.values(A.current).forEach(e => jr(e) && e()), w.current = u ? {} : Vr(e || x.current), (_ref12 => {
        let {
          errors: e,
          isDirty: t,
          isSubmitted: n,
          touched: r,
          isValid: i,
          submitCount: a,
          dirtyFields: o
        } = _ref12;
        i || (b.current = {}, v.current = {}), f.current = {}, _.current = new Set(), k.current = !1, z({
          submitCount: a ? M.current.submitCount : 0,
          isDirty: !!t && M.current.isDirty,
          isSubmitted: !!n && M.current.isSubmitted,
          isValid: !!i && M.current.isValid,
          dirtyFields: o ? M.current.dirtyFields : {},
          touched: r ? M.current.touched : {},
          errors: e ? M.current.errors : {},
          isSubmitting: !1,
          isSubmitSuccessful: !1
        });
      })(t);
    }, []),
    clearErrors: l(function (e) {
      e && (Array.isArray(e) ? e : [e]).forEach(e => m.current[e] && nr(e) ? delete M.current.errors[e] : kr(M.current.errors, e)), z({
        errors: e ? M.current.errors : {}
      });
    }, []),
    setError: l(function (e, t) {
      const n = (m.current[e] || {}).ref;
      ar(M.current.errors, e, Object.assign(Object.assign({}, t), {
        ref: n
      })), z({
        isValid: !1
      }), t.shouldFocus && n && n.focus && n.focus();
    }, []),
    errors: j.errors
  }, ce);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function Qr(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var i = 0;
    for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  }
  return n;
}
const $r = s(null);
$r.displayName = "RHFContext";
const ei = () => r($r);
var ti = () => {
  const e = "undefined" == typeof performance ? Date.now() : 1e3 * performance.now();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, t => {
    const n = (16 * Math.random() + e) % 16 | 0;
    return ("x" == t ? n : 3 & n | 8).toString(16);
  });
};
var ni = (e, t) => sr(t) ? [] : function (e, t) {
    let n = 0;
    const r = [...e];
    for (const e of t) r.splice(e - n, 1), n++;
    return rr(r).length ? r : [];
  }(e, (Array.isArray(t) ? t : [t]).sort((e, t) => e - t)),
  ri = (e, t, n) => Array.isArray(e) ? (sr(e[n]) && (e[n] = void 0), e.splice(n, 0, e.splice(t, 1)[0]), e) : [],
  ii = (e, t, n) => {
    const r = [e[n], e[t]];
    e[t] = r[0], e[n] = r[1];
  };
function ai(e, t) {
  return [...(Array.isArray(t) ? t : [t || void 0]), ...e];
}
function oi(e, t, n) {
  return [...e.slice(0, t), ...(Array.isArray(n) ? n : [n || void 0]), ...e.slice(t)];
}
var si = e => Array.isArray(e) ? Array(e.length).fill(void 0) : void 0,
  li = e => (Array.isArray(e) ? e : [e]).map(e => {
    if (tr(e)) {
      const t = {};
      for (const n in e) t[n] = !0;
      return t;
    }
    return !0;
  });
const ci = function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let t = arguments.length > 1 ? arguments[1] : undefined;
    let n = arguments.length > 2 ? arguments[2] : undefined;
    if ("production" !== process.env.NODE_ENV && !n) for (const n of e) {
      if ("object" != typeof n) {
        console.warn("📋 useFieldArray input's name should be in object shape instead of flat array. https://react-hook-form.com/api#useFieldArray");
        break;
      }
      if (t in n) {
        console.warn(`📋 useFieldArray fieldValues contain the keyName \`${t}\` which is reserved for use by useFieldArray. https://react-hook-form.com/api#useFieldArray`);
        break;
      }
    }
    return e.map(e => Object.assign({
      [t]: e[t] || ti()
    }, e));
  },
  di = _ref13 => {
    let {
      control: e,
      name: r,
      keyName: i = "id"
    } = _ref13;
    const a = ei();
    if ("production" !== process.env.NODE_ENV && !e && !a) throw new Error("📋 useFieldArray is missing `control` prop. https://react-hook-form.com/api#useFieldArray");
    const o = c(-1),
      s = c(!1),
      {
        isFormDirty: d,
        updateWatchedValue: u,
        resetFieldArrayFunctionRef: p,
        fieldArrayNamesRef: m,
        fieldsRef: f,
        defaultValuesRef: g,
        removeFieldEventListener: _,
        formStateRef: y,
        shallowFieldsStateRef: h,
        updateFormState: v,
        readFormStateRef: b,
        validFieldsRef: x,
        fieldsWithValidationRef: E,
        fieldArrayDefaultValuesRef: k,
        validateResolver: T,
        getValues: w,
        shouldUnregister: A,
        fieldArrayValuesRef: C
      } = e || a.control,
      S = e => lr(A ? e : h.current, r, []),
      N = Ur(r),
      O = c([...(lr(k.current, N) ? S(k.current) : S(g.current))]),
      [R, I] = t(ci(O.current, i));
    ar(C.current, r, R);
    const L = e => e.map(function () {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = i;
      return e[t], Qr(e, ["symbol" == typeof t ? t : t + ""]);
    });
    m.current.add(r);
    const j = l(() => lr(C.current, r, []), [r]),
      D = () => ci(lr(w(), r, j()).map((e, t) => Object.assign(Object.assign({}, j()[t]), e)), i, !0);
    m.current.add(r), N && !lr(k.current, N) && ar(k.current, N, Vr(lr(g.current, N)));
    const F = e => {
        if (I(e), ar(C.current, r, e), b.current.isValid && T) {
          const t = w();
          ar(t, r, e), T(t);
        }
      },
      M = () => {
        for (const e in f.current) Wr(e, r) && (_(f.current[e], !0), delete f.current[e]);
      },
      P = e => !rr(lr(e, r, [])).length && kr(e, r),
      B = e => {
        e && ar(y.current.dirtyFields, r, Nr(L(e), lr(g.current, r, []), lr(y.current.dirtyFields, r, [])));
      },
      H = function (e, t, n) {
        let i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        let a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
        let o = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
        if (lr(h.current, r)) {
          const n = e(lr(h.current, r), t.argA, t.argB);
          a && ar(h.current, r, n);
        }
        if (lr(k.current, r)) {
          const n = e(lr(k.current, r), t.argA, t.argB);
          a && ar(k.current, r, n);
        }
        if (Array.isArray(lr(y.current.errors, r))) {
          const n = e(lr(y.current.errors, r), t.argA, t.argB);
          a && ar(y.current.errors, r, n), P(y.current.errors);
        }
        if (b.current.touched && lr(y.current.touched, r)) {
          const n = e(lr(y.current.touched, r), t.argA, t.argB);
          a && ar(y.current.touched, r, n), P(y.current.touched);
        }
        (b.current.dirtyFields || b.current.isDirty) && (ar(y.current.dirtyFields, r, Nr(L(i), lr(g.current, r, []), lr(y.current.dirtyFields, r, []))), B(n), P(y.current.dirtyFields)), o && b.current.isValid && !T && (ar(x.current, r, e(lr(x.current, r, []), t.argA)), P(x.current), ar(E.current, r, e(lr(E.current, r, []), t.argA)), P(E.current)), !s.current && b.current.isDirty && v({
          isDirty: d(r, L(i))
        });
      },
      z = e => {
        const t = D(),
          n = ni(t, e);
        F(n), M(), H(ni, {
          argA: e,
          argC: e
        }, n, ni(t, e), !0, !0);
      };
    return n(() => {
      "production" !== process.env.NODE_ENV && (r || console.warn("📋 useFieldArray is missing `name` attribute. https://react-hook-form.com/api#useFieldArray"));
      const e = lr(k.current, r);
      if (e && R.length < e.length && ar(k.current, r, e.slice(1)), u(r), o.current > -1) for (const e in f.current) {
        const t = f.current[e];
        if (e.startsWith(`${r}[${o.current}]`) && t.ref.focus) {
          t.ref.focus();
          break;
        }
      }
      o.current = -1;
    }, [R, r]), n(() => {
      const e = p.current,
        t = m.current;
      return Ur(r) || (e[r] = e => {
        M(), !e && kr(k.current, r), kr(h.current, r), O.current = lr(e || g.current, r), s.current || I(ci(O.current, i));
      }), () => {
        s.current = !0, A && z(), M(), delete e[r], kr(C.current, r), t.delete(r);
      };
    }, []), {
      swap: l((e, t) => {
        const n = D();
        ii(n, e, t), M(), F([...n]), H(ii, {
          argA: e,
          argB: t,
          argC: e,
          argD: t
        }, void 0, n, !1);
      }, [r]),
      move: l((e, t) => {
        const n = D();
        ri(n, e, t), M(), F([...n]), H(ri, {
          argA: e,
          argB: t,
          argC: e,
          argD: t
        }, void 0, n, !1);
      }, [r]),
      prepend: l(function (e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        const n = si(e),
          r = ai(D(), ci(Array.isArray(e) ? e : [e], i));
        F(r), M(), H(ai, {
          argA: n,
          argC: li(e)
        }, r), o.current = t ? 0 : -1;
      }, [r]),
      append: l(function (e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        const n = Array.isArray(e) ? e : [e],
          a = [...D(), ...ci(n, i)];
        F(a), (b.current.dirtyFields || b.current.isDirty) && (B(a), v({
          isDirty: !0,
          dirtyFields: y.current.dirtyFields
        })), !A && ar(h.current, r, [...(lr(h.current, r) || []), ...Vr(n)]), o.current = t ? lr(C.current, r).length - 1 : -1;
      }, [r]),
      remove: l(z, [r]),
      insert: l(function (e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
        const r = si(t),
          a = D(),
          s = oi(a, e, ci(Array.isArray(t) ? t : [t], i));
        F(s), M(), H(oi, {
          argA: e,
          argB: r,
          argC: e,
          argD: li(t)
        }, s, oi(a, e)), o.current = n ? e : -1;
      }, [r]),
      fields: rr(R)
    };
  };
function ui(_ref14) {
  let {
    name: e,
    rules: r,
    defaultValue: i,
    control: a,
    onFocus: o
  } = _ref14;
  const s = ei();
  if ("production" !== process.env.NODE_ENV && !a && !s) throw new Error("📋 Controller is missing `control` prop. https://react-hook-form.com/api#Controller");
  const {
      defaultValuesRef: d,
      setValue: u,
      register: p,
      unregister: m,
      trigger: f,
      mode: g,
      reValidateMode: {
        isReValidateOnBlur: _,
        isReValidateOnChange: y
      },
      formState: h,
      formStateRef: {
        current: {
          isSubmitted: v,
          touched: b,
          errors: x
        }
      },
      updateFormState: E,
      readFormStateRef: k,
      fieldsRef: T,
      fieldArrayNamesRef: w,
      shallowFieldsStateRef: A
    } = a || s.control,
    C = !Xr(w.current, e),
    S = () => !sr(lr(A.current, e)) && C ? lr(A.current, e) : sr(i) ? lr(d.current, e) : i,
    [N, O] = t(S()),
    R = c(N),
    I = c({
      focus: () => null
    }),
    L = c(o || (() => {
      jr(I.current.focus) && I.current.focus(), "production" !== process.env.NODE_ENV && (jr(I.current.focus) || console.warn("📋 'ref' from Controller render prop must be attached to a React component or a DOM Element whose ref provides a 'focus()' method"));
    })),
    j = l(t => !zr(Object.assign({
      isBlurEvent: t,
      isReValidateOnBlur: _,
      isReValidateOnChange: y,
      isSubmitted: v,
      isTouched: !!lr(b, e)
    }, g)), [_, y, v, b, e, g]),
    D = l(_ref15 => {
      let [e] = _ref15;
      const t = (e => wr(e) || !tr(e.target) || tr(e.target) && !e.type ? e : sr(e.target.value) ? e.target.checked : e.target.value)(e);
      return O(t), R.current = t, t;
    }, []),
    F = l(t => {
      if ("production" !== process.env.NODE_ENV && !e) return console.warn("📋 Field is missing `name` prop. https://react-hook-form.com/api#Controller");
      T.current[e] ? T.current[e] = Object.assign({
        ref: T.current[e].ref
      }, r) : (p(Object.defineProperties({
        name: e,
        focus: L.current
      }, {
        value: {
          set(e) {
            O(e), R.current = e;
          },
          get: () => R.current
        }
      }), r), t = sr(lr(d.current, e))), t && C && O(S());
    }, [r, e, p]);
  n(() => () => m(e), [e]), n(() => {
    "production" !== process.env.NODE_ENV && (sr(N) && console.warn(`📋 ${e} is missing in the 'defaultValue' prop of either its Controller (https://react-hook-form.com/api#Controller) or useForm (https://react-hook-form.com/api#useForm)`), !C && sr(i) && console.warn("📋 Controller is missing `defaultValue` prop when using `useFieldArray`. https://react-hook-form.com/api#Controller")), F();
  }, [F]), n(() => {
    !T.current[e] && F(!0);
  });
  const M = l(() => {
    k.current.touched && !lr(b, e) && (ar(b, e, !0), E({
      touched: b
    })), j(!0) && f(e);
  }, [e, E, j, f, k]);
  return {
    field: {
      onChange: l(function () {
        for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
          t[_key] = arguments[_key];
        }
        return u(e, D(t), {
          shouldValidate: j(),
          shouldDirty: !0
        });
      }, [u, e, j]),
      onBlur: M,
      name: e,
      value: N,
      ref: I
    },
    meta: Object.defineProperties({
      invalid: !!lr(x, e)
    }, {
      isDirty: {
        get: () => !!lr(h.dirtyFields, e)
      },
      isTouched: {
        get: () => !!lr(h.touched, e)
      }
    })
  };
}
const pi = e => {
  const {
      rules: t,
      as: n,
      render: r,
      defaultValue: i,
      control: a,
      onFocus: o
    } = e,
    s = Qr(e, ["rules", "as", "render", "defaultValue", "control", "onFocus"]),
    {
      field: l,
      meta: c
    } = ui(e),
    m = Object.assign(Object.assign({}, s), l);
  return n ? d(n) ? u(n, m) : p(n, m) : r ? r(l, c) : null;
};
var mi = Object.freeze({
  __proto__: null,
  Controller: pi,
  FormProvider: e => {
    var {
        children: t
      } = e,
      n = Qr(e, ["children"]);
    return p($r.Provider, {
      value: Object.assign({}, n)
    }, t);
  },
  appendErrors: Mr,
  get: lr,
  transformToNestObject: or,
  useController: ui,
  useFieldArray: di,
  useForm: Jr,
  useFormContext: ei,
  useWatch: function (_ref16) {
    let {
      control: e,
      name: r,
      defaultValue: i
    } = _ref16;
    const a = ei();
    if ("production" !== process.env.NODE_ENV && !e && !a) throw new Error("📋 useWatch is missing `control` prop. https://react-hook-form.com/api#useWatch");
    const {
        useWatchFieldsRef: o,
        useWatchRenderFunctionsRef: s,
        watchInternal: l,
        defaultValuesRef: d
      } = e || a.control,
      u = t()[1],
      p = c(),
      m = c(i);
    return n(() => {
      "production" !== process.env.NODE_ENV && "" === r && console.warn("📋 useWatch is missing `name` attribute. https://react-hook-form.com/api#useWatch");
      const e = p.current = ti(),
        t = s.current,
        n = o.current;
      return n[e] = new Set(), t[e] = () => u({}), l(r, m.current, e), () => {
        delete n[e], delete t[e];
      };
    }, [r, s, o, l, m]), p.current ? l(r, m.current, p.current) : sr(i) ? Or(r) ? lr(d.current, r) : Array.isArray(r) ? r.reduce((e, t) => Object.assign(Object.assign({}, e), {
      [t]: lr(d.current, t)
    }), {}) : d.current : i;
  }
});
y("select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  /* Remove default arrow */\n  padding: 10px;\n  min-width: 320px;\n  font-size: 16px;\n  background-color: #f8f8f8;\n  border: none;\n  border-radius: 2px; }\n");
var fi = function (t) {
    var n = t.register,
      r = t.item,
      i = t.index,
      a = r.label,
      o = r.name,
      s = r.items,
      l = r.disabled,
      c = void 0 !== l && l,
      d = r.validation;
    return e.createElement("label", null, a ? e.createElement("h5", null, a) : null, e.createElement(K, {
      direction: "row"
    }, e.createElement("select", {
      name: o,
      disabled: c,
      tabIndex: i,
      ref: n(d)
    }, s.map(function (t, n) {
      return e.createElement("option", {
        key: n,
        value: t.value
      }, t.label);
    })), e.createElement(nd, {
      style: {
        marginLeft: -30,
        marginTop: 7
      },
      icon: "keyboard_arrow_down"
    })));
  },
  gi = {
    required: "Obligatorisk",
    minLength: "Fler tecken tack",
    maxLength: "Färre tecken tack"
  },
  _i = {
    form: "form_form__X6zjf",
    noLabel: "form_noLabel__10gOg",
    horizontal: "form_horizontal__1aael",
    errorBlock: "form_errorBlock__2cCMm",
    error: "form_error__1W4FQ",
    buttons: "form_buttons__2l5Gf"
  };
y(".form_form__X6zjf h5 {\n  margin-bottom: 10px;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.19;\n  letter-spacing: normal;\n  color: rgba(0, 0, 0, 0.87); }\n\n.form_form__X6zjf .form_noLabel__10gOg {\n  margin-top: -10px;\n  margin-bottom: -10px; }\n\n.form_horizontal__1aael {\n  flex-direction: row !important;\n  align-items: center !important;\n  margin-top: 0 !important; }\n\n.form_errorBlock__2cCMm input, .form_errorBlock__2cCMm input:focus, .form_errorBlock__2cCMm input[type=text], .form_errorBlock__2cCMm input[type=checkbox] {\n  border: solid 2px #c62828 !important;\n  background-color: rgba(198, 40, 40, 0.1) !important; }\n\n.form_error__1W4FQ {\n  margin-top: -4px;\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.58;\n  letter-spacing: normal;\n  color: #c62828; }\n\n.form_buttons__2l5Gf {\n  margin: 0px;\n  padding: 15px 0; }\n  .form_buttons__2l5Gf button {\n    margin-right: 10px; }\n");
var yi = function (t) {
    var n = t.register,
      r = t.errors,
      i = t.item,
      a = t.type,
      o = void 0 === a ? "text" : a,
      s = t.index,
      l = i.placeholder,
      c = i.name,
      d = i.label,
      u = i.disabled,
      p = void 0 !== u && u,
      m = i.defaultValue,
      f = void 0 === m ? "" : m,
      g = i.value,
      _ = i.validation;
    return e.createElement("div", null, e.createElement("label", null, d ? e.createElement("h5", null, d) : null, e.createElement("input", {
      className: _i.inputText,
      placeholder: l,
      defaultValue: g || f,
      disabled: p,
      name: c,
      ref: n(_ || {}),
      type: o,
      autoComplete: "off",
      tabIndex: s,
      lang: "sv-se"
    }), r[c] && e.createElement("div", {
      className: _i.error
    }, e.createElement("span", null, "" !== r[c].message ? r[c].message : gi[r[c].type]))));
  },
  hi = function (t) {
    var n = t.register,
      r = t.errors,
      i = t.item,
      a = t.index,
      o = Object.assign({}, i, {
        validation: Object.assign({}, i.validation, {
          pattern: {
            value: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/,
            message: "Felformaterad url"
          }
        }),
        placeholder: i.placeholder || "Din webbadress"
      });
    return e.createElement(yi, {
      register: n,
      errors: r,
      item: o,
      type: "url",
      index: a
    });
  },
  vi = function (t) {
    var n = t.register,
      r = t.errors,
      i = t.item,
      a = t.index,
      o = Object.assign({}, i, {
        validation: Object.assign({}, i.validation, {
          pattern: {
            value: /^(?:-)?\d+$/g,
            message: "Felformaterad siffra"
          }
        }),
        placeholder: i.placeholder || "Ditt nummer"
      });
    return e.createElement(yi, {
      register: n,
      errors: r,
      item: o,
      type: "number",
      index: a
    });
  },
  bi = function (t) {
    var n = t.register,
      r = t.errors,
      i = t.item,
      a = t.index,
      o = Object.assign({}, i, {
        validation: Object.assign({}, i.validation, {
          pattern: {
            value: /[0-2][0-9]:[0-9][0-9]/,
            message: "Felaktig tidpunkt (HH:mm)"
          }
        }),
        placeholder: i.placeholder || "Tidpunkt på dagen (HH:mm)"
      });
    return e.createElement(yi, {
      register: n,
      errors: r,
      item: o,
      type: "text",
      index: a
    });
  },
  xi = {
    container: "checkbox_container__1DE6C",
    checkmark: "checkbox_checkmark__2oO52",
    error: "checkbox_error__2tMng"
  };
y('/* The container */\n.checkbox_container__1DE6C {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  padding-right: 10px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  padding-top: 7px;\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.19;\n  letter-spacing: normal;\n  color: rgba(0, 0, 0, 0.87); }\n\n/* Hide the browser\'s default checkbox */\n.checkbox_container__1DE6C input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0; }\n\n/* Create a custom checkbox */\n.checkbox_checkmark__2oO52 {\n  position: absolute;\n  top: 7px;\n  left: 5px;\n  width: 15px;\n  height: 15px;\n  border-radius: 3px;\n  border: solid 2px rgba(0, 0, 0, 0.55); }\n\n/* On mouse-over, add a grey background color */\n.checkbox_container__1DE6C:hover input ~ .checkbox_checkmark__2oO52 {\n  background-color: #ccc; }\n\n/* When the checkbox is checked, add a blue background */\n.checkbox_container__1DE6C input:checked ~ .checkbox_checkmark__2oO52 {\n  background-color: #3f51bf; }\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkbox_checkmark__2oO52:after {\n  content: "";\n  position: absolute;\n  display: none; }\n\n/* Show the checkmark when checked */\n.checkbox_container__1DE6C input:checked ~ .checkbox_checkmark__2oO52:after {\n  display: block; }\n\n/* Style the checkmark/indicator */\n.checkbox_container__1DE6C .checkbox_checkmark__2oO52:after {\n  left: 3px;\n  top: -3px;\n  width: 5px;\n  height: 15px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg); }\n\n.checkbox_error__2tMng {\n  margin-top: 10px;\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.58;\n  letter-spacing: normal;\n  color: #c62828; }\n');
var Ei = function (t) {
    var n = t.register,
      r = t.errors,
      i = t.item,
      a = void 0 === i ? {} : i,
      o = t.checked,
      s = void 0 !== o && o,
      l = t.onChange,
      c = void 0 === l ? function (e) {
        return null;
      } : l,
      d = a.name;
    a.label;
    var u = a.value,
      p = void 0 === u || u,
      m = a.validation,
      f = a.direction,
      g = void 0 === f ? "column" : f,
      _ = a.items;
    return _ ? e.createElement("div", null, e.createElement("h5", null, a.label), e.createElement(K, {
      direction: g
    }, (_ || []).map(function (t, r) {
      return e.createElement("label", {
        key: r,
        className: xi.container
      }, t.label, e.createElement("input", {
        type: "checkbox",
        className: xi.checkbox,
        name: "".concat(a.name).concat(r),
        ref: n(m),
        defaultChecked: p
      }), e.createElement("span", {
        className: xi.checkmark
      }));
    })), r[d] && e.createElement("div", {
      className: xi.error
    }, e.createElement("span", null, "" !== r[d].message ? r[d].message : gi[r[d].type]))) : e.createElement("div", null, e.createElement("label", {
      className: xi.container
    }, e.createElement("input", {
      type: "checkbox",
      className: xi.checkbox,
      checked: s,
      onChange: c
    }), e.createElement("span", {
      className: xi.checkmark
    })));
  },
  ki = {
    container: "radio_container__1eeGr",
    label: "radio_label__2Sftc",
    checkmark: "radio_checkmark__3o40O",
    error: "radio_error__2ru3H"
  };
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n/* The container */\n.radio_container__1eeGr {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  padding-top: 7px;\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  font-size: 16px; }\n\n/* Hide the browser\'s default checkbox */\n.radio_container__1eeGr input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0; }\n\n.radio_label__2Sftc {\n  font-family: "Roboto", sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 27px; }\n\n/* Create a custom checkbox */\n.radio_checkmark__3o40O {\n  position: absolute;\n  top: 10px;\n  left: 5px;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  border: solid 2px rgba(0, 0, 0, 0.55); }\n\n/* On mouse-over, add a grey background color */\n.radio_container__1eeGr:hover input ~ .radio_checkmark__3o40O {\n  background-color: #ccc; }\n\n/* When the checkbox is checked, add a blue background */\n.radio_container__1eeGr input:checked ~ .radio_checkmark__3o40O {\n  background-color: #3f51bf; }\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.radio_checkmark__3o40O:after {\n  content: "";\n  position: absolute;\n  display: none; }\n\n/* Show the checkmark when checked */\n.radio_container__1eeGr input:checked ~ .radio_checkmark__3o40O:after {\n  display: block; }\n\n/* Style the checkmark/indicator */\n.radio_container__1eeGr .radio_checkmark__3o40O:after {\n  top: 3px;\n  left: 3px;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: white; }\n\n.radio_error__2ru3H {\n  margin-top: 10px;\n  font-family: Roboto;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.58;\n  letter-spacing: normal;\n  color: #c62828; }\n');
var Ti = function (n) {
    var r = n.register,
      i = n.errors,
      a = n.item,
      o = void 0 === a ? {} : a,
      s = n.checked,
      l = void 0 !== s && s,
      c = n.onChange,
      d = void 0 === c ? function (e) {
        return null;
      } : c,
      u = o.items,
      p = o.name;
    o.label;
    var f = o.validation,
      g = j(t([!0, !1]), 2),
      _ = g[0],
      y = g[1],
      h = j(t(0), 2),
      v = h[0],
      b = h[1];
    return u ? e.createElement("div", null, e.createElement("h5", {
      className: ki.label
    }, o.label), u.map(function (t, n) {
      return e.createElement("label", {
        key: n,
        className: ki.container
      }, t.label, e.createElement("input", {
        type: "radio",
        className: ki.checkbox,
        name: o.name,
        value: o.value,
        checked: n === v,
        onChange: function (e) {
          var t = _.map(function (e, t) {
            return t !== v;
          });
          y(t), b(n);
        },
        ref: r(f)
      }), e.createElement("span", {
        className: ki.checkmark
      }));
    }), o.items.map(function (t, n) {
      return e.createElement(m, {
        key: n
      }, !0 === _[n] ? (t.items || []).map(function (e, t) {
        return Oi(e, t, r, i);
      }) : null);
    }), i[p] && e.createElement("div", {
      className: ki.error
    }, e.createElement("span", null, "" !== i[p].message ? i[p].message : gi[i[p].type]))) : e.createElement("label", {
      className: ki.container
    }, "suck", e.createElement("input", {
      type: "radio",
      className: ki.checkbox,
      checked: l,
      onChange: d
    }), e.createElement("span", {
      className: ki.checkmark
    }));
  },
  wi = {
    groupContainer: "checkbox_groupContainer__28dTa"
  };
y("/* The container */\n.checkbox_groupContainer__28dTa label {\n  margin-bottom: 15px; }\n\n.checkbox_groupContainer__28dTa input {\n  width: 0;\n  visibility: hidden; }\n\n.checkbox_groupContainer__28dTa span {\n  cursor: pointer;\n  background-color: #fff;\n  border: solid 1px #3f51bf;\n  color: #3f51bf;\n  padding: 5px 15px;\n  border-radius: 3px;\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.57;\n  letter-spacing: 0.18px;\n  text-align: center;\n  -webkit-transition: background-color .2s ease-out;\n  -moz-transition: background-color .2s ease-out;\n  -o-transition: background-color .2s ease-out;\n  transition: background-color .2s ease-out; }\n  .checkbox_groupContainer__28dTa span:hover {\n    background-color: rgba(63, 81, 191, 0.1); }\n\n.checkbox_groupContainer__28dTa input:checked + span {\n  background-color: #3f51bf;\n  color: #fff; }\n  .checkbox_groupContainer__28dTa input:checked + span:hover {\n    background-color: #1D2559; }\n");
var Ai = function (t) {
  var n = t.register,
    r = t.errors,
    i = t.item,
    a = void 0 === i ? {} : i,
    o = a.name;
  a.label;
  var s = a.validation,
    l = a.direction,
    c = void 0 === l ? "column" : l,
    d = a.items;
  return e.createElement("div", {
    className: wi.groupContainer
  }, e.createElement("h5", null, a.label), e.createElement(K, {
    direction: c
  }, (d || []).map(function (t, r) {
    return e.createElement("label", {
      key: r,
      className: wi.container
    }, e.createElement("input", {
      type: "checkbox",
      className: wi.checkbox,
      name: "".concat(a.name).concat(r),
      ref: n(s),
      defaultChecked: t.value
    }), e.createElement("span", null, t.label));
  })), r[o] && e.createElement("div", {
    className: wi.error
  }, e.createElement("span", null, "" !== r[o].message ? r[o].message : gi[r[o].type])));
};
function Ci(e) {
  return function (e) {
    if (Array.isArray(e)) return I(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || L(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var Si = function (n) {
    var r = n.item,
      i = r.label,
      a = r.cta,
      o = r.template,
      s = r.items,
      l = Jr(),
      c = l.register,
      d = l.errors,
      u = j(t(0), 2),
      p = u[0],
      m = u[1],
      f = j(t(s), 2),
      g = f[0],
      _ = f[1],
      y = function (e) {
        return function () {
          _(function (t) {
            return Ci(t.filter(function (t) {
              return t !== e;
            }));
          }), m(function (e) {
            return e - 1;
          });
        };
      };
    return e.createElement(K, null, e.createElement("h5", null, i), g.map(function (t, n) {
      return e.createElement(K, {
        key: n,
        direction: "row"
      }, e.createElement(yi, {
        item: t,
        register: c,
        errors: d,
        type: o.type
      }), e.createElement(wd, {
        icon: "clear",
        text: "",
        level: "secondary",
        size: "small",
        handleClick: y(n)
      }));
    }), e.createElement(wd, {
      level: "secondary",
      size: "small",
      text: a,
      handleClick: function () {
        _(function (e) {
          return [].concat(Ci(e), [p]);
        }), m(function (e) {
          return e + 1;
        });
      }
    }));
  },
  Ni = function (t) {
    return e.createElement("hr", null);
  },
  Oi = function (t, n, r, i) {
    switch (t.type) {
      case "select":
        return e.createElement(fi, {
          key: n,
          item: t,
          register: r,
          errors: i,
          index: n
        });
      case "text":
        return e.createElement(yi, {
          key: n,
          item: t,
          register: r,
          errors: i,
          index: n
        });
      case "url":
        return e.createElement(hi, {
          key: n,
          item: t,
          register: r,
          errors: i,
          index: n
        });
      case "number":
        return e.createElement(vi, {
          key: n,
          item: t,
          register: r,
          errors: i,
          index: n
        });
      case "time":
        return e.createElement(bi, {
          key: n,
          item: t,
          register: r,
          errors: i,
          index: n
        });
      case "checkbox":
        return e.createElement(Ei, {
          key: n,
          item: t,
          register: r,
          errors: i,
          index: n
        });
      case "radio":
        return e.createElement(Ti, {
          key: n,
          item: t,
          register: r,
          errors: i,
          index: n
        });
      case "multibuttongroup":
        return e.createElement(Ai, {
          key: n,
          item: t,
          register: r,
          errors: i,
          index: n
        });
      case "fieldArrays":
        return e.createElement(Si, {
          key: n,
          item: t,
          register: r,
          errors: i,
          index: n
        });
      case "divider":
        return e.createElement(Ni, {
          key: n,
          index: n
        });
    }
  },
  Ri = {
    modalWrapper: "modal_modalWrapper__1Wy9o",
    optionalLabel: "modal_optionalLabel__3WoEb",
    modalClose: "modal_modalClose__13X2a",
    modalOverlay: "modal_modalOverlay__1XTDj",
    colorchange: "modal_colorchange__3bjZk",
    modalContent: "modal_modalContent__2zS9R",
    modalBody: "modal_modalBody__10A97",
    modalFooter: "modal_modalFooter__2M7_Z"
  };
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n@keyframes modal_colorchange__3bjZk {\n  0% {\n    background: rgba(0, 0, 0, 0); }\n  100% {\n    background: rgba(0, 0, 0, 0.5); } }\n\n@-webkit-keyframes modal_colorchange__3bjZk /* Safari and Chrome - necessary duplicate */ {\n  0% {\n    background: rgba(0, 0, 0, 0); }\n  100% {\n    background: rgba(0, 0, 0, 0.5); } }\n\n.modal_modalWrapper__1Wy9o {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  top: 20px;\n  left: 0;\n  right: 0;\n  z-index: 100; }\n  .modal_modalWrapper__1Wy9o button {\n    margin-left: 15px; }\n\n.modal_optionalLabel__3WoEb {\n  font-family: "Roboto", sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 27px;\n  padding: 14px; }\n\n.modal_modalClose__13X2a {\n  cursor: pointer; }\n\n.modal_modalOverlay__1XTDj {\n  z-index: 99;\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  animation: modal_colorchange__3bjZk .4s 1;\n  /* animation-name followed by duration in seconds*/\n  /* you could also use milliseconds (ms) or something like 2.5s */\n  -webkit-animation: modal_colorchange__3bjZk .4s 1;\n  /* Chrome and Safari */ }\n\n.modal_modalContent__2zS9R {\n  position: relative;\n  min-width: 450px;\n  max-width: 66%;\n  background: #fff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5); }\n\n.modal_modalBody__10A97 {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  padding: 20px;\n  max-height: 75vh;\n  overflow: auto; }\n\n.modal_modalFooter__2M7_Z {\n  padding: 20px;\n  text-align: right;\n  background-color: #f8f8f8; }\n\n.modal_modalFooter__2M7_Z > * > * {\n  margin-left: 10px; }\n');
var Ii = function (r) {
  var i = r.data,
    a = r.sidebar,
    o = r.visible,
    s = r.onChange,
    l = r.onSubmit,
    c = r.onCancel,
    d = r.width,
    u = void 0 === d ? "auto" : d,
    p = r.top,
    f = void 0 === p ? "inherit" : p,
    g = i.boxes,
    _ = Jr(),
    y = _.handleSubmit,
    h = _.getValues,
    v = _.register,
    b = _.errors,
    x = j(t(), 2),
    E = x[0],
    k = x[1];
  n(function () {
    k(h());
  }, []);
  var T = function (e) {
      l(h());
    },
    w = function (t) {
      return e.createElement("div", {
        style: {
          maxHeight: "70vh",
          overflowY: "auto",
          paddingBottom: 250
        }
      }, e.createElement(Qt, null, (g || []).map(function (t, n) {
        return e.createElement(en, {
          key: n,
          cols: t.cols
        }, t.items.map(function (e, t) {
          return Oi(e, t, v, b);
        }));
      })));
    },
    A = function (t) {
      return e.createElement("div", {
        style: {
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0
        },
        className: Ri.modalFooter
      }, e.createElement(K, {
        direction: "row",
        justify: "flex-end"
      }, e.createElement(wd, {
        level: "secondary",
        handleClick: c,
        text: "Avbryt"
      }), e.createElement(wd, {
        submit: !0,
        text: "Spara"
      })));
    };
  return a ? e.createElement(m, null, e.createElement("form", {
    style: {
      width: u,
      marginTop: f
    },
    className: _i.form,
    autoComplete: "off",
    onSubmit: y(T),
    onChange: function (e) {
      "checkbox" === e.target.type && (k(Object.assign({}, E, E[e.target.name] = e.target.checked)), s(e.target.name, e.target.checked, E));
    },
    onBlur: function (e) {
      console.log("change", e.target.value, "aaa", e.target.checked, h()), "text" === e.target.type && (k(Object.assign({}, E, E[e.target.name] = e.target.value)), s(e.target.name, e.target.value, E));
    }
  }, e.createElement(Ql, {
    visible: o,
    onClose: c,
    content: e.createElement("div", {
      style: {
        width: 400
      }
    }, e.createElement(w, null))
  }))) : e.createElement(m, null, e.createElement("form", {
    style: {
      width: u,
      marginTop: f
    },
    className: _i.form,
    autoComplete: "off",
    onSubmit: y(T)
  }, e.createElement(w, null), e.createElement(A, null)));
};
var Li = (e, t) => {
  const n = e.getItem(t);
  try {
    return n ? JSON.parse(n) : void 0;
  } catch (e) {
    return;
  }
};
var ji = e => void 0 === e;
var Di = s({
    store: {},
    updateStore: e => e
  }),
  Fi = _ref17 => {
    let {
      transform: e,
      externalStoreName: t,
      storageType: n,
      store: r
    } = _ref17;
    return e({
      externalStoreData: Li(n, t),
      currentStoreData: r
    });
  };
const Mi = "undefined" != typeof window,
  Pi = "production" !== process.env.NODE_ENV;
let Bi,
  Hi,
  zi,
  Ui = Mi && "undefined" != typeof sessionStorage ? window.sessionStorage : {
    getItem: e => e,
    setItem: e => e,
    clear: () => {},
    length: 0,
    key: e => e.toString(),
    removeItem: () => {}
  },
  Wi = [];
const Xi = _ref18 => {
  let {
    options: e,
    callback: t,
    updateStore: n
  } = _ref18;
  return r => {
    let i;
    const a = t ? t.name : "";
    if (Pi && function () {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      e && Mi && (window.__STATE_MACHINE_ACTION_NAME__ = e);
    }(a), t && (i = t(Bi(), r)), Hi(ji(i) ? Bi() : i), Ui.setItem(zi(), JSON.stringify(Bi())), ji(e) || e && !1 !== e.shouldReRenderApp) {
      let e = Bi();
      Array.isArray(Wi) && Wi.length && (e = Wi.reduce((e, t) => t(e) || e, e)), n(e);
    }
  };
};
var Gi = Object.freeze({
    __proto__: null,
    StateMachineContext: Di,
    StateMachineProvider: function (e) {
      const [n, r] = t(Bi()),
        a = i(() => ({
          store: n,
          updateStore: r
        }), [n]);
      return p(Di.Provider, Object.assign({
        value: a
      }, e));
    },
    createStore: function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        name: "__STATE_MACHINE__",
        middleWares: [],
        syncStores: void 0
      };
      const n = t ? t.name : "__STATE_MACHINE__",
        r = function (e, t) {
          const n = t || "__STATE_MACHINE__";
          let r = Li(e, n);
          return {
            set: e => {
              r = e;
            },
            get: () => r,
            getName: () => n
          };
        }(Ui, n);
      Pi && Mi && (window.STATE_MACHINE_NAME = n), zi = r.getName, Bi = r.get, Hi = r.set, Wi = t.middleWares, function (e, t, n, r) {
        "undefined" != typeof window && e && (window.STATE_MACHINE_DEBUG = e => t.setItem("___STATE_MACHINE_DEBUG__", e), window.STATE_MACHINE_RESET = () => t.clear(), window.STATE_MACHINE_GET_STORE = () => t.getItem(n()), window.STATE_MACHINE_SAVE_TO = e => window.localStorage.setItem(e, JSON.stringify(r())), window.STATE_MACHINE_LOAD = _ref19 => {
          let {
            storeName: e,
            data: r
          } = _ref19;
          return t.setItem(n() || "___STATE_MACHINE_DEBUG__", r || window.localStorage.getItem(e) || "");
        });
      }(Pi, Ui, zi, Bi), Hi(function (e, t, n) {
        let r = e;
        const i = t.syncStores;
        if (!i) return r;
        try {
          if (Array.isArray(i)) i.forEach(e => {
            r = Fi({
              transform: e.transform,
              externalStoreName: e.externalStoreName,
              storageType: n,
              store: r
            });
          });else {
            if (i.externalStoreName && "function" == typeof i.transform && "string" == typeof i.externalStoreName) return Fi({
              transform: i.transform,
              externalStoreName: i.externalStoreName,
              storageType: n,
              store: r
            });
            Object.entries(i).forEach(_ref20 => {
              let [e, t] = _ref20;
              const i = Li(n, e);
              t.forEach(e => {
                r = Object.assign(Object.assign({}, r), {
                  [e]: Object.assign(Object.assign({}, r[e]), i[e])
                });
              });
            });
          }
        } catch (e) {
          return r;
        }
        return r;
      }(Bi() || e, t, Ui));
    },
    setStorageType: function (e) {
      Ui = e;
    },
    useStateMachine: function (e, t) {
      const {
        store: n,
        updateStore: i
      } = r(Di);
      return e && Object.keys(e).length ? {
        actions: Object.entries(e).reduce((e, _ref21) => {
          let [n, r] = _ref21;
          return Object.assign(Object.assign({}, e), {
            [n]: l(Xi({
              options: t,
              callback: r,
              updateStore: i
            }), [])
          });
        }, {}),
        action: e => e,
        state: n
      } : {
        actions: {},
        action: l(e ? Xi({
          options: t,
          callback: e,
          updateStore: i
        }) : () => {}, []),
        state: n
      };
    }
  }),
  Vi = re(function (t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    var r = _ref22 => {
        let {
          duration: e = .3,
          delay: t = 0,
          overlay: n = 0
        } = _ref22;
        return e + t - n || 0;
      },
      i = e => void 0 === e;
    function a(e, t, n) {
      return i(t) && i(e) ? n || 0 : e && e >= 0 ? e : t || 0;
    }
    const o = .3,
      s = "linear",
      l = "normal",
      c = "none",
      d = "running",
      u = e.createContext({
        animationStates: {},
        register: e => {}
      });
    var p = e => 1e3 * (e || 0);
    function m(_ref23) {
      let {
        keyframes: e,
        animationName: t
      } = _ref23;
      return `@keyframes ${t} {${(e => {
        const t = e.length;
        return e.reduce((e, n, r) => {
          const i = 2 === t ? 100 * r : parseFloat((100 / (t - 1)).toFixed(2)) * r;
          if ("string" == typeof n) return `${e} ${i}% {${n}}`;
          const a = Object.keys(n);
          return a.length && isNaN(+a[0]) ? `${e} ${i}% {${a.reduce((e, t) => {
            return `${e} ${(r = t, r ? r.replace(/[A-Z]/g, e => `-${e.toLowerCase()}`) : "")}: ${n[t]};`;
            var r;
          }, "")}}` : `${e} ${Object.keys(n)[0]}% {${Object.values(n)[0]}}`;
        }, "");
      })(e)}}`;
    }
    function f(_ref24) {
      let {
        keyframes: e,
        animationName: t
      } = _ref24;
      let n,
        r = document.querySelector("style[data-id=rsi]");
      r || (r = document.createElement("style"), r.setAttribute("data-id", "rsi"), document.head.appendChild(r));
      try {
        n = r.sheet.cssRules.length;
      } catch (e) {
        n = 0;
      }
      try {
        r.sheet.insertRule(m({
          keyframes: e,
          animationName: t
        }), n);
      } catch (e) {
        console.error("react simple animate, error found during insert style ", e);
      }
      return {
        styleTag: r,
        index: n
      };
    }
    var g = (e, t) => {
        const n = Object.values(e.cssRules).findIndex(_ref25 => {
          let {
            name: e
          } = _ref25;
          return e === t;
        });
        n >= 0 && e.deleteRule(n);
      },
      _ = () => `RSI-${Math.random().toString(36).substr(2, 9)}`,
      y = e => e ? "paused" : d;
    n.Animate = function (t) {
      const {
          play: n,
          children: r,
          render: l,
          start: c,
          end: d,
          complete: m = "",
          onComplete: f,
          delay: g = 0,
          duration: _ = o,
          easeType: y = s,
          sequenceId: h,
          sequenceIndex: v
        } = t,
        b = e.useRef(),
        [x, E] = e.useState(c || {}),
        {
          register: k,
          animationStates: T = {}
        } = e.useContext(u),
        w = a(v, h);
      return e.useEffect(() => {
        (!i(v) && v >= 0 || h) && k(t);
      }, []), e.useEffect(() => {
        const e = T[w] || {};
        return E(Object.assign(Object.assign({}, n || e.play ? d : c), {
          transition: `all ${_}s ${y} ${parseFloat(e.delay || g)}s`
        })), n && (m || f) && (b.current = setTimeout(() => {
          m && E(m), f && f();
        }, p(parseFloat(e.delay || g) + _))), () => b.current && clearTimeout(b.current);
      }, [w, T, n, _, y, g, f, c, d, m]), l ? l({
        style: x
      }) : e.createElement("div", {
        style: x
      }, r);
    }, n.AnimateGroup = function (_ref26) {
      let {
        play: t,
        sequences: n = [],
        children: s
      } = _ref26;
      const [l, c] = e.useState({}),
        d = e.useRef({}),
        p = e.useCallback(e => {
          const {
            sequenceIndex: t,
            sequenceId: n
          } = e;
          i(n) && i(t) || (d.current[a(t, n)] = e);
        }, []);
      return e.useEffect(() => {
        const e = Array.isArray(n) && n.length ? n : Object.values(d.current),
          i = {};
        (t ? e : [...e].reverse()).reduce((e, _ref27, u) => {
          let {
            sequenceId: n,
            sequenceIndex: s,
            duration: l = o,
            delay: c,
            overlay: d
          } = _ref27;
          const p = a(s, n, u),
            m = r({
              duration: l,
              delay: c,
              overlay: d
            }) + e;
          return i[p] = {
            play: t,
            pause: !t,
            delay: 0 === u ? c || 0 : c ? e + c : e,
            controlled: !0
          }, m;
        }, 0), c(i);
      }, [t]), e.createElement(u.Provider, {
        value: {
          animationStates: l,
          register: p
        }
      }, s);
    }, n.AnimateKeyframes = function (t) {
      const {
        children: n,
        play: r = !1,
        pause: i = !1,
        render: d,
        duration: p = o,
        delay: m = 0,
        easeType: h = s,
        direction: v = l,
        fillMode: b = c,
        iterationCount: x = 1,
        sequenceIndex: E,
        keyframes: k,
        sequenceId: T
      } = t;
      let w;
      const A = e.useRef({
          forward: "",
          reverse: ""
        }),
        C = e.useRef(!1),
        S = e.useRef({
          forward: {
            sheet: {}
          },
          reverse: {
            sheet: {}
          }
        }),
        N = a(E, T),
        {
          register: O,
          animationStates: R = {}
        } = e.useContext(u),
        I = R[N] || {},
        [, L] = e.useState(!1);
      e.useEffect(() => {
        const e = S.current,
          n = A.current;
        A.current.forward = _();
        let i = f({
          animationName: A.current.forward,
          keyframes: k
        });
        return A.current.reverse = _(), S.current.forward = i.styleTag, i = f({
          animationName: A.current.reverse,
          keyframes: k.reverse()
        }), S.current.reverse = i.styleTag, O(t), r && L(!0), () => {
          g(e.forward.sheet, n.forward), g(e.reverse.sheet, n.reverse);
        };
      }, []), I.controlled && !C.current ? (w = I.pause, I.pause || (C.current = !0)) : w = i;
      const j = {
        animation: `${p}s ${h} ${I.delay || m}s ${x} ${v} ${b} ${y(w)} ${((I.controlled ? I.play : r) ? A.current.forward : A.current.reverse) || ""}`
      };
      return d ? d({
        style: j
      }) : e.createElement("div", {
        style: j || {}
      }, n);
    }, n.useAnimate = function (t) {
      const {
          start: n,
          end: r,
          complete: i,
          onComplete: a,
          delay: l = 0,
          duration: c = o,
          easeType: d = s
        } = t,
        u = e.useMemo(() => `all ${c}s ${d} ${l}s`, [c, d, l]),
        [m, f] = e.useState({
          isPlaying: !1,
          style: Object.assign(Object.assign({}, n), {
            transition: u
          })
        }),
        {
          isPlaying: g,
          style: _
        } = m,
        y = e.useRef();
      return e.useEffect(() => ((y.current || i) && g && (y.current = setTimeout(() => {
        a && a(), i && f(Object.assign(Object.assign({}, m), {
          style: i
        }));
      }, p(l + c))), () => y.current && clearTimeout(y.current)), [g]), {
        isPlaying: g,
        style: _,
        play: e.useCallback(e => {
          f(Object.assign(Object.assign({}, m), {
            style: Object.assign(Object.assign({}, e ? r : n), {
              transition: u
            }),
            isPlaying: e
          }));
        }, [])
      };
    }, n.useAnimateGroup = function (t) {
      const {
          sequences: n = []
        } = t,
        i = (a = n.length, Array.from({
          length: a
        }, () => null)).map((e, n) => t.sequences[n].start);
      var a;
      const [d, u] = e.useState(i),
        [p, m] = e.useState(!1),
        y = e.useRef([]),
        h = e.useRef([]),
        v = e.useRef();
      return e.useEffect(() => (n.forEach((_ref28, t) => {
        let {
          keyframes: e = !1
        } = _ref28;
        if (!Array.isArray(e)) return;
        y.current[t] || (y.current[t] = {}, h.current[t] = {}), y.current[t].forward = _();
        let n = f({
          animationName: y.current[t].forward,
          keyframes: e
        });
        h.current[t].forward = n.styleTag, y.current[t].reverse = _(), n = f({
          animationName: y.current[t].reverse,
          keyframes: e.reverse()
        }), h.current[t].reverse = n.styleTag;
      }), () => Object.values(y).forEach((_ref29, n) => {
        let {
          forward: e,
          reverse: t
        } = _ref29;
        h[n] && (g(h[n].sheet, e), g(h[n].sheet, t));
      })), []), v.current = v.current ? v.current : e => {
        let t = 0;
        const i = e ? y.current : [...y.current].reverse(),
          a = (e ? n : [...n].reverse()).map((n, a) => {
            const {
                duration: d = o,
                delay: u = 0,
                overlay: p,
                keyframes: m,
                iterationCount: f = 1,
                easeType: g = s,
                direction: _ = l,
                fillMode: y = c,
                end: h = {},
                start: v = {}
              } = n,
              b = 0 === a ? u : t,
              x = `all ${d}s ${g} ${b}s`;
            return t = r({
              duration: d,
              delay: u,
              overlay: p
            }) + t, m ? {
              animation: `${d}s ${g} ${b}s ${f} ${_} ${y} running ${e ? i[a].forward : i[a].reverse}`
            } : Object.assign(Object.assign({}, e ? h : v), {
              transition: x
            });
          });
        u(e ? a : [...a].reverse()), m(!p);
      }, {
        styles: d,
        play: v.current,
        isPlaying: p
      };
    }, n.useAnimateKeyframes = function (t) {
      const {
          duration: n = o,
          delay: r = 0,
          easeType: i = s,
          direction: a = l,
          fillMode: d = c,
          iterationCount: p = 1,
          keyframes: m
        } = t,
        h = e.useRef({
          forward: "",
          reverse: ""
        }),
        v = e.useRef({
          forward: {
            sheet: {}
          },
          reverse: {
            sheet: {}
          }
        }),
        {
          register: b
        } = e.useContext(u),
        [x, E] = e.useState(null),
        [k, T] = e.useState(!1),
        w = e.useRef();
      return e.useEffect(() => {
        const e = v.current,
          n = h.current;
        h.current.forward = _();
        let r = f({
          animationName: h.current.forward,
          keyframes: m
        });
        return v.current.forward = r.styleTag, h.current.reverse = _(), r = f({
          animationName: h.current.reverse,
          keyframes: m.reverse()
        }), v.current.reverse = r.styleTag, b(t), () => {
          g(e.forward.sheet, n.forward), g(e.reverse.sheet, n.reverse);
        };
      }, []), w.current = w.current ? w.current : e => E(e), {
        style: {
          animation: `${n}s ${i} ${r}s ${p} ${a} ${d} ${y(k)} ${null === x ? "" : x ? h.current.forward : h.current.reverse}`
        },
        play: w.current,
        pause: T,
        isPlaying: !!x
      };
    };
  }),
  Yi = ne(re(function (e) {
    e.exports = function (e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0;
  }));
function Ki(e) {
  var t = {};
  return function (n) {
    return void 0 === t[n] && (t[n] = e(n)), t[n];
  };
}
var Zi = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
  qi = Ki(function (e) {
    return Zi.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
  });
var Ji = function () {
  function e(e) {
    this.isSpeedy = void 0 === e.speedy ? "production" === process.env.NODE_ENV : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.before = null;
  }
  var t = e.prototype;
  return t.insert = function (e) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) == 0) {
      var t,
        n = function (e) {
          var t = document.createElement("style");
          return t.setAttribute("data-emotion", e.key), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t;
        }(this);
      t = 0 === this.tags.length ? this.before : this.tags[this.tags.length - 1].nextSibling, this.container.insertBefore(n, t), this.tags.push(n);
    }
    var r = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = function (e) {
        if (e.sheet) return e.sheet;
        for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
      }(r);
      try {
        var a = 105 === e.charCodeAt(1) && 64 === e.charCodeAt(0);
        i.insertRule(e, a ? 0 : i.cssRules.length);
      } catch (t) {
        "production" !== process.env.NODE_ENV && console.warn('There was a problem inserting the following rule: "' + e + '"', t);
      }
    } else r.appendChild(document.createTextNode(e));
    this.ctr++;
  }, t.flush = function () {
    this.tags.forEach(function (e) {
      return e.parentNode.removeChild(e);
    }), this.tags = [], this.ctr = 0;
  }, e;
}();
function Qi(e) {
  function t(e, r, l, c, p) {
    for (var m, f, g, _, b, E = 0, k = 0, T = 0, w = 0, A = 0, I = 0, j = g = m = 0, F = 0, M = 0, P = 0, B = 0, H = l.length, z = H - 1, U = "", W = "", X = "", G = ""; F < H;) {
      if (f = l.charCodeAt(F), F === z && 0 !== k + w + T + E && (0 !== k && (f = 47 === k ? 10 : 47), w = T = E = 0, H++, z++), 0 === k + w + T + E) {
        if (F === z && (0 < M && (U = U.replace(u, "")), 0 < U.trim().length)) {
          switch (f) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              U += l.charAt(F);
          }
          f = 59;
        }
        switch (f) {
          case 123:
            for (m = (U = U.trim()).charCodeAt(0), g = 1, B = ++F; F < H;) {
              switch (f = l.charCodeAt(F)) {
                case 123:
                  g++;
                  break;
                case 125:
                  g--;
                  break;
                case 47:
                  switch (f = l.charCodeAt(F + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (j = F + 1; j < z; ++j) switch (l.charCodeAt(j)) {
                          case 47:
                            if (42 === f && 42 === l.charCodeAt(j - 1) && F + 2 !== j) {
                              F = j + 1;
                              break e;
                            }
                            break;
                          case 10:
                            if (47 === f) {
                              F = j + 1;
                              break e;
                            }
                        }
                        F = j;
                      }
                  }
                  break;
                case 91:
                  f++;
                case 40:
                  f++;
                case 34:
                case 39:
                  for (; F++ < z && l.charCodeAt(F) !== f;);
              }
              if (0 === g) break;
              F++;
            }
            switch (g = l.substring(B, F), 0 === m && (m = (U = U.replace(d, "").trim()).charCodeAt(0)), m) {
              case 64:
                switch (0 < M && (U = U.replace(u, "")), f = U.charCodeAt(1)) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    M = r;
                    break;
                  default:
                    M = R;
                }
                if (B = (g = t(r, M, g, f, p + 1)).length, 0 < L && (b = s(3, g, M = n(R, U, P), r, S, C, B, f, p, c), U = M.join(""), void 0 !== b && 0 === (B = (g = b.trim()).length) && (f = 0, g = "")), 0 < B) switch (f) {
                  case 115:
                    U = U.replace(x, o);
                  case 100:
                  case 109:
                  case 45:
                    g = U + "{" + g + "}";
                    break;
                  case 107:
                    g = (U = U.replace(y, "$1 $2")) + "{" + g + "}", g = 1 === O || 2 === O && a("@" + g, 3) ? "@-webkit-" + g + "@" + g : "@" + g;
                    break;
                  default:
                    g = U + g, 112 === c && (W += g, g = "");
                } else g = "";
                break;
              default:
                g = t(r, n(r, U, P), g, c, p + 1);
            }
            X += g, g = P = M = j = m = 0, U = "", f = l.charCodeAt(++F);
            break;
          case 125:
          case 59:
            if (1 < (B = (U = (0 < M ? U.replace(u, "") : U).trim()).length)) switch (0 === j && (m = U.charCodeAt(0), 45 === m || 96 < m && 123 > m) && (B = (U = U.replace(" ", ":")).length), 0 < L && void 0 !== (b = s(1, U, r, e, S, C, W.length, c, p, c)) && 0 === (B = (U = b.trim()).length) && (U = "\0\0"), m = U.charCodeAt(0), f = U.charCodeAt(1), m) {
              case 0:
                break;
              case 64:
                if (105 === f || 99 === f) {
                  G += U + l.charAt(F);
                  break;
                }
              default:
                58 !== U.charCodeAt(B - 1) && (W += i(U, m, f, U.charCodeAt(2)));
            }
            P = M = j = m = 0, U = "", f = l.charCodeAt(++F);
        }
      }
      switch (f) {
        case 13:
        case 10:
          47 === k ? k = 0 : 0 === 1 + m && 107 !== c && 0 < U.length && (M = 1, U += "\0"), 0 < L * D && s(0, U, r, e, S, C, W.length, c, p, c), C = 1, S++;
          break;
        case 59:
        case 125:
          if (0 === k + w + T + E) {
            C++;
            break;
          }
        default:
          switch (C++, _ = l.charAt(F), f) {
            case 9:
            case 32:
              if (0 === w + E + k) switch (A) {
                case 44:
                case 58:
                case 9:
                case 32:
                  _ = "";
                  break;
                default:
                  32 !== f && (_ = " ");
              }
              break;
            case 0:
              _ = "\\0";
              break;
            case 12:
              _ = "\\f";
              break;
            case 11:
              _ = "\\v";
              break;
            case 38:
              0 === w + k + E && (M = P = 1, _ = "\f" + _);
              break;
            case 108:
              if (0 === w + k + E + N && 0 < j) switch (F - j) {
                case 2:
                  112 === A && 58 === l.charCodeAt(F - 3) && (N = A);
                case 8:
                  111 === I && (N = I);
              }
              break;
            case 58:
              0 === w + k + E && (j = F);
              break;
            case 44:
              0 === k + T + w + E && (M = 1, _ += "\r");
              break;
            case 34:
            case 39:
              0 === k && (w = w === f ? 0 : 0 === w ? f : w);
              break;
            case 91:
              0 === w + k + T && E++;
              break;
            case 93:
              0 === w + k + T && E--;
              break;
            case 41:
              0 === w + k + E && T--;
              break;
            case 40:
              if (0 === w + k + E) {
                if (0 === m) switch (2 * A + 3 * I) {
                  case 533:
                    break;
                  default:
                    m = 1;
                }
                T++;
              }
              break;
            case 64:
              0 === k + T + w + E + j + g && (g = 1);
              break;
            case 42:
            case 47:
              if (!(0 < w + E + T)) switch (k) {
                case 0:
                  switch (2 * f + 3 * l.charCodeAt(F + 1)) {
                    case 235:
                      k = 47;
                      break;
                    case 220:
                      B = F, k = 42;
                  }
                  break;
                case 42:
                  47 === f && 42 === A && B + 2 !== F && (33 === l.charCodeAt(B + 2) && (W += l.substring(B, F + 1)), _ = "", k = 0);
              }
          }
          0 === k && (U += _);
      }
      I = A, A = f, F++;
    }
    if (0 < (B = W.length)) {
      if (M = r, 0 < L && void 0 !== (b = s(2, W, M, e, S, C, B, c, p, c)) && 0 === (W = b).length) return G + W + X;
      if (W = M.join(",") + "{" + W + "}", 0 != O * N) {
        switch (2 !== O || a(W, 2) || (N = 0), N) {
          case 111:
            W = W.replace(v, ":-moz-$1") + W;
            break;
          case 112:
            W = W.replace(h, "::-webkit-input-$1") + W.replace(h, "::-moz-$1") + W.replace(h, ":-ms-input-$1") + W;
        }
        N = 0;
      }
    }
    return G + W + X;
  }
  function n(e, t, n) {
    var i = t.trim().split(g);
    t = i;
    var a = i.length,
      o = e.length;
    switch (o) {
      case 0:
      case 1:
        var s = 0;
        for (e = 0 === o ? "" : e[0] + " "; s < a; ++s) t[s] = r(e, t[s], n).trim();
        break;
      default:
        var l = s = 0;
        for (t = []; s < a; ++s) for (var c = 0; c < o; ++c) t[l++] = r(e[c] + " ", i[s], n).trim();
    }
    return t;
  }
  function r(e, t, n) {
    var r = t.charCodeAt(0);
    switch (33 > r && (r = (t = t.trim()).charCodeAt(0)), r) {
      case 38:
        return t.replace(_, "$1" + e.trim());
      case 58:
        return e.trim() + t.replace(_, "$1" + e.trim());
      default:
        if (0 < 1 * n && 0 < t.indexOf("\f")) return t.replace(_, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
    }
    return e + t;
  }
  function i(e, t, n, r) {
    var o = e + ";",
      s = 2 * t + 3 * n + 4 * r;
    if (944 === s) {
      e = o.indexOf(":", 9) + 1;
      var l = o.substring(e, o.length - 1).trim();
      return l = o.substring(0, e).trim() + l + ";", 1 === O || 2 === O && a(l, 1) ? "-webkit-" + l + l : l;
    }
    if (0 === O || 2 === O && !a(o, 1)) return o;
    switch (s) {
      case 1015:
        return 97 === o.charCodeAt(10) ? "-webkit-" + o + o : o;
      case 951:
        return 116 === o.charCodeAt(3) ? "-webkit-" + o + o : o;
      case 963:
        return 110 === o.charCodeAt(5) ? "-webkit-" + o + o : o;
      case 1009:
        if (100 !== o.charCodeAt(4)) break;
      case 969:
      case 942:
        return "-webkit-" + o + o;
      case 978:
        return "-webkit-" + o + "-moz-" + o + o;
      case 1019:
      case 983:
        return "-webkit-" + o + "-moz-" + o + "-ms-" + o + o;
      case 883:
        if (45 === o.charCodeAt(8)) return "-webkit-" + o + o;
        if (0 < o.indexOf("image-set(", 11)) return o.replace(A, "$1-webkit-$2") + o;
        break;
      case 932:
        if (45 === o.charCodeAt(4)) switch (o.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + o.replace("-grow", "") + "-webkit-" + o + "-ms-" + o.replace("grow", "positive") + o;
          case 115:
            return "-webkit-" + o + "-ms-" + o.replace("shrink", "negative") + o;
          case 98:
            return "-webkit-" + o + "-ms-" + o.replace("basis", "preferred-size") + o;
        }
        return "-webkit-" + o + "-ms-" + o + o;
      case 964:
        return "-webkit-" + o + "-ms-flex-" + o + o;
      case 1023:
        if (99 !== o.charCodeAt(8)) break;
        return "-webkit-box-pack" + (l = o.substring(o.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + o + "-ms-flex-pack" + l + o;
      case 1005:
        return m.test(o) ? o.replace(p, ":-webkit-") + o.replace(p, ":-moz-") + o : o;
      case 1e3:
        switch (t = (l = o.substring(13).trim()).indexOf("-") + 1, l.charCodeAt(0) + l.charCodeAt(t)) {
          case 226:
            l = o.replace(b, "tb");
            break;
          case 232:
            l = o.replace(b, "tb-rl");
            break;
          case 220:
            l = o.replace(b, "lr");
            break;
          default:
            return o;
        }
        return "-webkit-" + o + "-ms-" + l + o;
      case 1017:
        if (-1 === o.indexOf("sticky", 9)) break;
      case 975:
        switch (t = (o = e).length - 10, s = (l = (33 === o.charCodeAt(t) ? o.substring(0, t) : o).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | l.charCodeAt(7))) {
          case 203:
            if (111 > l.charCodeAt(8)) break;
          case 115:
            o = o.replace(l, "-webkit-" + l) + ";" + o;
            break;
          case 207:
          case 102:
            o = o.replace(l, "-webkit-" + (102 < s ? "inline-" : "") + "box") + ";" + o.replace(l, "-webkit-" + l) + ";" + o.replace(l, "-ms-" + l + "box") + ";" + o;
        }
        return o + ";";
      case 938:
        if (45 === o.charCodeAt(5)) switch (o.charCodeAt(6)) {
          case 105:
            return l = o.replace("-items", ""), "-webkit-" + o + "-webkit-box-" + l + "-ms-flex-" + l + o;
          case 115:
            return "-webkit-" + o + "-ms-flex-item-" + o.replace(k, "") + o;
          default:
            return "-webkit-" + o + "-ms-flex-line-pack" + o.replace("align-content", "").replace(k, "") + o;
        }
        break;
      case 973:
      case 989:
        if (45 !== o.charCodeAt(3) || 122 === o.charCodeAt(4)) break;
      case 931:
      case 953:
        if (!0 === w.test(e)) return 115 === (l = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? i(e.replace("stretch", "fill-available"), t, n, r).replace(":fill-available", ":stretch") : o.replace(l, "-webkit-" + l) + o.replace(l, "-moz-" + l.replace("fill-", "")) + o;
        break;
      case 962:
        if (o = "-webkit-" + o + (102 === o.charCodeAt(5) ? "-ms-" + o : "") + o, 211 === n + r && 105 === o.charCodeAt(13) && 0 < o.indexOf("transform", 10)) return o.substring(0, o.indexOf(";", 27) + 1).replace(f, "$1-webkit-$2") + o;
    }
    return o;
  }
  function a(e, t) {
    var n = e.indexOf(1 === t ? ":" : "{"),
      r = e.substring(0, 3 !== t ? n : 10);
    return n = e.substring(n + 1, e.length - 1), j(2 !== t ? r : r.replace(T, "$1"), n, t);
  }
  function o(e, t) {
    var n = i(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
    return n !== t + ";" ? n.replace(E, " or ($1)").substring(4) : "(" + t + ")";
  }
  function s(e, t, n, r, i, a, o, s, l, d) {
    for (var u, p = 0, m = t; p < L; ++p) switch (u = I[p].call(c, e, m, n, r, i, a, o, s, l, d)) {
      case void 0:
      case !1:
      case !0:
      case null:
        break;
      default:
        m = u;
    }
    if (m !== t) return m;
  }
  function l(e) {
    return void 0 !== (e = e.prefix) && (j = null, e ? "function" != typeof e ? O = 1 : (O = 2, j = e) : O = 0), l;
  }
  function c(e, n) {
    var r = e;
    if (33 > r.charCodeAt(0) && (r = r.trim()), r = [r], 0 < L) {
      var i = s(-1, n, r, r, S, C, 0, 0, 0, 0);
      void 0 !== i && "string" == typeof i && (n = i);
    }
    var a = t(R, r, n, 0, 0);
    return 0 < L && void 0 !== (i = s(-2, a, r, r, S, C, a.length, 0, 0, 0)) && (a = i), "", N = 0, C = S = 1, a;
  }
  var d = /^\0+/g,
    u = /[\0\r\f]/g,
    p = /: */g,
    m = /zoo|gra/,
    f = /([,: ])(transform)/g,
    g = /,\r+?/g,
    _ = /([\t\r\n ])*\f?&/g,
    y = /@(k\w+)\s*(\S*)\s*/,
    h = /::(place)/g,
    v = /:(read-only)/g,
    b = /[svh]\w+-[tblr]{2}/,
    x = /\(\s*(.*)\s*\)/g,
    E = /([\s\S]*?);/g,
    k = /-self|flex-/g,
    T = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
    w = /stretch|:\s*\w+\-(?:conte|avail)/,
    A = /([^-])(image-set\()/,
    C = 1,
    S = 1,
    N = 0,
    O = 1,
    R = [],
    I = [],
    L = 0,
    j = null,
    D = 0;
  return c.use = function e(t) {
    switch (t) {
      case void 0:
      case null:
        L = I.length = 0;
        break;
      default:
        if ("function" == typeof t) I[L++] = t;else if ("object" == typeof t) for (var n = 0, r = t.length; n < r; ++n) e(t[n]);else D = 0 | !!t;
    }
    return e;
  }, c.set = l, void 0 !== e && l(e), c;
}
var $i = function (e) {
  var t = new WeakMap();
  return function (n) {
    if (t.has(n)) return t.get(n);
    var r = e(n);
    return t.set(n, r), r;
  };
};
function ea(e) {
  e && ta.current.insert(e + "}");
}
var ta = {
    current: null
  },
  na = function (e, t, n, r, i, a, o, s, l, c) {
    switch (e) {
      case 1:
        switch (t.charCodeAt(0)) {
          case 64:
            return ta.current.insert(t + ";"), "";
          case 108:
            if (98 === t.charCodeAt(2)) return "";
        }
        break;
      case 2:
        if (0 === s) return t + "/*|*/";
        break;
      case 3:
        switch (s) {
          case 102:
          case 112:
            return ta.current.insert(n[0] + t), "";
          default:
            return t + (0 === c ? "/*|*/" : "");
        }
      case -2:
        t.split("/*|*/}").forEach(ea);
    }
  },
  ra = function (e, t) {
    if (1 === e && 108 === t.charCodeAt(0) && 98 === t.charCodeAt(2)) return "";
  },
  ia = "undefined" != typeof document,
  aa = {},
  oa = ia ? void 0 : $i(function () {
    var e = $i(function () {
        return {};
      }),
      t = {},
      n = {};
    return function (r) {
      return void 0 === r || !0 === r ? t : !1 === r ? n : e(r);
    };
  }),
  sa = function (e) {
    void 0 === e && (e = {});
    var t,
      n = e.key || "css";
    void 0 !== e.prefix && (t = {
      prefix: e.prefix
    });
    var r = new Qi(t);
    if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(n)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
    var i,
      a,
      o = {};
    if (ia) {
      i = e.container || document.head;
      var s = document.querySelectorAll("style[data-emotion-" + n + "]");
      Array.prototype.forEach.call(s, function (e) {
        e.getAttribute("data-emotion-" + n).split(" ").forEach(function (e) {
          o[e] = !0;
        }), e.parentNode !== i && i.appendChild(e);
      });
    }
    if (ia) r.use(e.stylisPlugins)(na), a = function (e, t, n, i) {
      var a = t.name;
      if (ta.current = n, "production" !== process.env.NODE_ENV && void 0 !== t.map) {
        var o = t.map;
        ta.current = {
          insert: function (e) {
            n.insert(e + o);
          }
        };
      }
      r(e, t.styles), i && (u.inserted[a] = !0);
    };else {
      r.use(ra);
      var l = aa;
      (e.stylisPlugins || void 0 !== e.prefix) && (r.use(e.stylisPlugins), l = oa(e.stylisPlugins || aa)(e.prefix));
      a = function (e, t, n, i) {
        var a = t.name,
          o = function (e, t) {
            var n = t.name;
            return void 0 === l[n] && (l[n] = r(e, t.styles)), l[n];
          }(e, t);
        return void 0 === u.compat ? (i && (u.inserted[a] = !0), "development" === process.env.NODE_ENV && void 0 !== t.map ? o + t.map : o) : i ? void (u.inserted[a] = o) : o;
      };
    }
    if ("production" !== process.env.NODE_ENV) {
      var c = /\/\*/g,
        d = /\*\//g;
      r.use(function (e, t) {
        switch (e) {
          case -1:
            for (; c.test(t);) {
              if (d.lastIndex = c.lastIndex, !d.test(t)) throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
              c.lastIndex = d.lastIndex;
            }
            c.lastIndex = 0;
        }
      }), r.use(function (e, t, n) {
        switch (e) {
          case -1:
            var r = t.match(/(:first|:nth|:nth-last)-child/g);
            r && !0 !== u.compat && r.forEach(function (e) {
              var n = new RegExp(e + ".*\\/\\* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason \\*\\/").test(t);
              e && !n && console.error('The pseudo class "' + e + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + e.split("-child")[0] + '-of-type".');
            });
        }
      });
    }
    var u = {
      key: n,
      sheet: new Ji({
        key: n,
        container: i,
        nonce: e.nonce,
        speedy: e.speedy
      }),
      nonce: e.nonce,
      inserted: o,
      registered: {},
      insert: a
    };
    return u;
  },
  la = "undefined" != typeof document;
function ca(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function (n) {
    void 0 !== e[n] ? t.push(e[n]) : r += n + " ";
  }), r;
}
var da = function (e, t, n) {
  var r = e.key + "-" + t.name;
  if ((!1 === n || !1 === la && void 0 !== e.compat) && void 0 === e.registered[r] && (e.registered[r] = t.styles), void 0 === e.inserted[t.name]) {
    var i = "",
      a = t;
    do {
      var o = e.insert("." + r, a, e.sheet, !0);
      la || void 0 === o || (i += o), a = a.next;
    } while (void 0 !== a);
    if (!la && 0 !== i.length) return i;
  }
};
var ua = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  },
  pa = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
  ma = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).",
  fa = /[A-Z]|^ms/g,
  ga = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
  _a = function (e) {
    return 45 === e.charCodeAt(1);
  },
  ya = function (e) {
    return null != e && "boolean" != typeof e;
  },
  ha = Ki(function (e) {
    return _a(e) ? e : e.replace(fa, "-$&").toLowerCase();
  }),
  va = function (e, t) {
    switch (e) {
      case "animation":
      case "animationName":
        if ("string" == typeof t) return t.replace(ga, function (e, t, n) {
          return Na = {
            name: t,
            styles: n,
            next: Na
          }, t;
        });
    }
    return 1 === ua[e] || _a(e) || "number" != typeof t || 0 === t ? t : t + "px";
  };
if ("production" !== process.env.NODE_ENV) {
  var ba = /(attr|calc|counters?|url)\(/,
    xa = ["normal", "none", "counter", "open-quote", "close-quote", "no-open-quote", "no-close-quote", "initial", "inherit", "unset"],
    Ea = va,
    ka = /^-ms-/,
    Ta = /-(.)/g,
    wa = {};
  va = function (e, t) {
    "content" === e && ("string" != typeof t || -1 === xa.indexOf(t) && !ba.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || '"' !== t.charAt(0) && "'" !== t.charAt(0))) && console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var n = Ea(e, t);
    return "" === n || _a(e) || -1 === e.indexOf("-") || void 0 !== wa[e] || (wa[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(ka, "ms-").replace(Ta, function (e, t) {
      return t.toUpperCase();
    }) + "?")), n;
  };
}
var Aa = !0;
function Ca(e, t, n, r) {
  if (null == n) return "";
  if (void 0 !== n.__emotion_styles) {
    if ("production" !== process.env.NODE_ENV && "NO_COMPONENT_SELECTOR" === n.toString()) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object":
      if (1 === n.anim) return Na = {
        name: n.name,
        styles: n.styles,
        next: Na
      }, n.name;
      if (void 0 !== n.styles) {
        var i = n.next;
        if (void 0 !== i) for (; void 0 !== i;) Na = {
          name: i.name,
          styles: i.styles,
          next: Na
        }, i = i.next;
        var a = n.styles + ";";
        return "production" !== process.env.NODE_ENV && void 0 !== n.map && (a += n.map), a;
      }
      return function (e, t, n) {
        var r = "";
        if (Array.isArray(n)) for (var i = 0; i < n.length; i++) r += Ca(e, t, n[i], !1);else for (var a in n) {
          var o = n[a];
          if ("object" != typeof o) null != t && void 0 !== t[o] ? r += a + "{" + t[o] + "}" : ya(o) && (r += ha(a) + ":" + va(a, o) + ";");else {
            if ("NO_COMPONENT_SELECTOR" === a && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
            if (!Array.isArray(o) || "string" != typeof o[0] || null != t && void 0 !== t[o[0]]) {
              var s = Ca(e, t, o, !1);
              switch (a) {
                case "animation":
                case "animationName":
                  r += ha(a) + ":" + s + ";";
                  break;
                default:
                  "production" !== process.env.NODE_ENV && "undefined" === a && console.error(ma), r += a + "{" + s + "}";
              }
            } else for (var l = 0; l < o.length; l++) ya(o[l]) && (r += ha(a) + ":" + va(a, o[l]) + ";");
          }
        }
        return r;
      }(e, t, n);
    case "function":
      if (void 0 !== e) {
        var o = Na,
          s = n(e);
        return Na = o, Ca(e, t, s, r);
      }
      "production" !== process.env.NODE_ENV && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    case "string":
      if ("production" !== process.env.NODE_ENV) {
        var l = [],
          c = n.replace(ga, function (e, t, n) {
            var r = "animation" + l.length;
            return l.push("const " + r + " = keyframes`" + n.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + r + "}";
          });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + c + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\ncss`" + c + "`");
      }
  }
  if (null == t) return n;
  var d = t[n];
  return "production" !== process.env.NODE_ENV && r && Aa && void 0 !== d && (console.error("Interpolating a className from css`` is not recommended and will cause problems with composition.\nInterpolating a className from css`` will be completely unsupported in a future major version of Emotion"), Aa = !1), void 0 === d || r ? n : d;
}
var Sa,
  Na,
  Oa = /label:\s*([^\s;\n{]+)\s*;/g;
"production" !== process.env.NODE_ENV && (Sa = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//);
var Ra = function (e, t, n) {
    if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
    var r = !0,
      i = "";
    Na = void 0;
    var a,
      o = e[0];
    null == o || void 0 === o.raw ? (r = !1, i += Ca(n, t, o, !1)) : ("production" !== process.env.NODE_ENV && void 0 === o[0] && console.error(pa), i += o[0]);
    for (var s = 1; s < e.length; s++) i += Ca(n, t, e[s], 46 === i.charCodeAt(i.length - 1)), r && ("production" !== process.env.NODE_ENV && void 0 === o[s] && console.error(pa), i += o[s]);
    "production" !== process.env.NODE_ENV && (i = i.replace(Sa, function (e) {
      return a = e, "";
    })), Oa.lastIndex = 0;
    for (var l, c = ""; null !== (l = Oa.exec(i));) c += "-" + l[1];
    var d = function (e) {
      for (var t, n = 0, r = 0, i = e.length; i >= 4; ++r, i -= 4) t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(r) | (255 & e.charCodeAt(++r)) << 8 | (255 & e.charCodeAt(++r)) << 16 | (255 & e.charCodeAt(++r)) << 24)) + (59797 * (t >>> 16) << 16), n = 1540483477 * (65535 & (t ^= t >>> 24)) + (59797 * (t >>> 16) << 16) ^ 1540483477 * (65535 & n) + (59797 * (n >>> 16) << 16);
      switch (i) {
        case 3:
          n ^= (255 & e.charCodeAt(r + 2)) << 16;
        case 2:
          n ^= (255 & e.charCodeAt(r + 1)) << 8;
        case 1:
          n = 1540483477 * (65535 & (n ^= 255 & e.charCodeAt(r))) + (59797 * (n >>> 16) << 16);
      }
      return (((n = 1540483477 * (65535 & (n ^= n >>> 13)) + (59797 * (n >>> 16) << 16)) ^ n >>> 15) >>> 0).toString(36);
    }(i) + c;
    return "production" !== process.env.NODE_ENV ? {
      name: d,
      styles: i,
      map: a,
      next: Na,
      toString: function () {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    } : {
      name: d,
      styles: i,
      next: Na
    };
  },
  Ia = "undefined" != typeof document,
  La = Object.prototype.hasOwnProperty,
  ja = s("undefined" != typeof HTMLElement ? sa() : null),
  Da = s({});
ja.Provider;
var Fa = function (e) {
  return f(function (t, n) {
    return p(ja.Consumer, null, function (r) {
      return e(t, r, n);
    });
  });
};
if (!Ia) {
  var Ma = function (e) {
    var t, n;
    function r(t, n, r) {
      var i;
      return (i = e.call(this, t, n, r) || this).state = {
        value: sa()
      }, i;
    }
    return n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, $(t, n), r.prototype.render = function () {
      return p(ja.Provider, this.state, this.props.children(this.state.value));
    }, r;
  }(a);
  Fa = function (e) {
    return function (t) {
      return p(ja.Consumer, null, function (n) {
        return null === n ? p(Ma, null, function (n) {
          return e(t, n);
        }) : e(t, n);
      });
    };
  };
}
var Pa = function (e, t, n, r) {
    var i = null === n ? t.css : t.css(n);
    "string" == typeof i && void 0 !== e.registered[i] && (i = e.registered[i]);
    var a = t.__EMOTION_TYPE_PLEASE_DO_NOT_USE__,
      o = [i],
      s = "";
    "string" == typeof t.className ? s = ca(e.registered, o, t.className) : null != t.className && (s = t.className + " ");
    var l = Ra(o);
    if ("production" !== process.env.NODE_ENV && -1 === l.name.indexOf("-")) {
      var c = t.__EMOTION_LABEL_PLEASE_DO_NOT_USE__;
      c && (l = Ra([l, "label:" + c + ";"]));
    }
    var d = da(e, l, "string" == typeof a);
    s += e.key + "-" + l.name;
    var u = {};
    for (var f in t) !La.call(t, f) || "css" === f || "__EMOTION_TYPE_PLEASE_DO_NOT_USE__" === f || "production" !== process.env.NODE_ENV && "__EMOTION_LABEL_PLEASE_DO_NOT_USE__" === f || (u[f] = t[f]);
    u.ref = r, u.className = s;
    var g = p(a, u);
    if (!Ia && void 0 !== d) {
      for (var _, y = l.name, h = l.next; void 0 !== h;) y += " " + h.name, h = h.next;
      return p(m, null, p("style", ((_ = {})["data-emotion-" + e.key] = y, _.dangerouslySetInnerHTML = {
        __html: d
      }, _.nonce = e.sheet.nonce, _)), g);
    }
    return g;
  },
  Ba = Fa(function (e, t, n) {
    return "function" == typeof e.css ? p(Da.Consumer, null, function (r) {
      return Pa(t, e, r, n);
    }) : Pa(t, e, null, n);
  });
"production" !== process.env.NODE_ENV && (Ba.displayName = "EmotionCssPropInternal");
var Ha = function e(t) {
  for (var n = t.length, r = 0, i = ""; r < n; r++) {
    var a = t[r];
    if (null != a) {
      var o = void 0;
      switch (typeof a) {
        case "boolean":
          break;
        case "object":
          if (Array.isArray(a)) o = e(a);else for (var s in o = "", a) a[s] && s && (o && (o += " "), o += s);
          break;
        default:
          o = a;
      }
      o && (i && (i += " "), i += o);
    }
  }
  return i;
};
function za(e, t, n) {
  var r = [],
    i = ca(e, r, n);
  return r.length < 2 ? n : i + t(r);
}
Fa(function (e, t) {
  return p(Da.Consumer, null, function (n) {
    var r,
      i = "",
      a = "",
      o = !1,
      s = function () {
        if (o && "production" !== process.env.NODE_ENV) throw new Error("css can only be used during render");
        for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
        var s = Ra(n, t.registered);
        if (Ia) da(t, s, !1);else {
          var l = da(t, s, !1);
          void 0 !== l && (i += l);
        }
        return Ia || (a += " " + s.name), t.key + "-" + s.name;
      },
      l = {
        css: s,
        cx: function () {
          if (o && "production" !== process.env.NODE_ENV) throw new Error("cx can only be used during render");
          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
          return za(t.registered, s, Ha(n));
        },
        theme: n
      },
      c = e.children(l);
    return o = !0, Ia || 0 === i.length ? c : p(m, null, p("style", ((r = {})["data-emotion-" + t.key] = a.substring(1), r.dangerouslySetInnerHTML = {
      __html: i
    }, r.nonce = t.sheet.nonce, r)), c);
  });
});
var Ua = qi,
  Wa = function (e) {
    return "theme" !== e && "innerRef" !== e;
  },
  Xa = function (e) {
    return "string" == typeof e && e.charCodeAt(0) > 96 ? Ua : Wa;
  };
function Ga(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Va(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ga(n, !0).forEach(function (t) {
      Yi(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ga(n).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
var Ya = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
  Ka = "undefined" != typeof document,
  Za = function e(t, n) {
    if ("production" !== process.env.NODE_ENV && void 0 === t) throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
    var r, i, a;
    void 0 !== n && (r = n.label, a = n.target, i = t.__emotion_forwardProp && n.shouldForwardProp ? function (e) {
      return t.__emotion_forwardProp(e) && n.shouldForwardProp(e);
    } : n.shouldForwardProp);
    var o = t.__emotion_real === t,
      s = o && t.__emotion_base || t;
    "function" != typeof i && o && (i = t.__emotion_forwardProp);
    var l = i || Xa(s),
      c = !l("as");
    return function () {
      var d = arguments,
        u = o && void 0 !== t.__emotion_styles ? t.__emotion_styles.slice(0) : [];
      if (void 0 !== r && u.push("label:" + r + ";"), null == d[0] || void 0 === d[0].raw) u.push.apply(u, d);else {
        "production" !== process.env.NODE_ENV && void 0 === d[0][0] && console.error(Ya), u.push(d[0][0]);
        for (var f = d.length, g = 1; g < f; g++) "production" !== process.env.NODE_ENV && void 0 === d[0][g] && console.error(Ya), u.push(d[g], d[0][g]);
      }
      var _ = Fa(function (e, t, n) {
        return p(Da.Consumer, null, function (o) {
          var d = c && e.as || s,
            f = "",
            g = [],
            _ = e;
          if (null == e.theme) {
            for (var y in _ = {}, e) _[y] = e[y];
            _.theme = o;
          }
          "string" == typeof e.className ? f = ca(t.registered, g, e.className) : null != e.className && (f = e.className + " ");
          var h = Ra(u.concat(g), t.registered, _),
            v = da(t, h, "string" == typeof d);
          f += t.key + "-" + h.name, void 0 !== a && (f += " " + a);
          var b = c && void 0 === i ? Xa(d) : l,
            x = {};
          for (var E in e) c && "as" === E || b(E) && (x[E] = e[E]);
          x.className = f, x.ref = n || e.innerRef, "production" !== process.env.NODE_ENV && e.innerRef && console.error("`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead" + (void 0 === r ? "" : " in the usage of `" + r + "`"));
          var k = p(d, x);
          if (!Ka && void 0 !== v) {
            for (var T, w = h.name, A = h.next; void 0 !== A;) w += " " + A.name, A = A.next;
            return p(m, null, p("style", ((T = {})["data-emotion-" + t.key] = w, T.dangerouslySetInnerHTML = {
              __html: v
            }, T.nonce = t.sheet.nonce, T)), k);
          }
          return k;
        });
      });
      return _.displayName = void 0 !== r ? r : "Styled(" + ("string" == typeof s ? s : s.displayName || s.name || "Component") + ")", _.defaultProps = t.defaultProps, _.__emotion_real = _, _.__emotion_base = s, _.__emotion_styles = u, _.__emotion_forwardProp = i, Object.defineProperty(_, "toString", {
        value: function () {
          return void 0 === a && "production" !== process.env.NODE_ENV ? "NO_COMPONENT_SELECTOR" : "." + a;
        }
      }), _.withComponent = function (t, r) {
        return e(t, void 0 !== r ? Va({}, n || {}, {}, r) : n).apply(void 0, u);
      }, _;
    };
  }.bind();
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"].forEach(function (e) {
  Za[e] = Za(e);
});
var qa = Object.freeze({
    __proto__: null,
    default: Za
  }),
  Ja = Array.isArray,
  Qa = "object" == typeof te && te && te.Object === Object && te,
  $a = "object" == typeof self && self && self.Object === Object && self,
  eo = Qa || $a || Function("return this")(),
  to = eo.Symbol,
  no = Object.prototype,
  ro = no.hasOwnProperty,
  io = no.toString,
  ao = to ? to.toStringTag : void 0;
var oo = function (e) {
    var t = ro.call(e, ao),
      n = e[ao];
    try {
      e[ao] = void 0;
      var r = !0;
    } catch (e) {}
    var i = io.call(e);
    return r && (t ? e[ao] = n : delete e[ao]), i;
  },
  so = Object.prototype.toString;
var lo = function (e) {
    return so.call(e);
  },
  co = to ? to.toStringTag : void 0;
var uo = function (e) {
  return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : co && co in Object(e) ? oo(e) : lo(e);
};
var po = function (e) {
  return null != e && "object" == typeof e;
};
var mo = function (e) {
    return "symbol" == typeof e || po(e) && "[object Symbol]" == uo(e);
  },
  fo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  go = /^\w*$/;
var _o = function (e, t) {
  if (Ja(e)) return !1;
  var n = typeof e;
  return !("number" != n && "symbol" != n && "boolean" != n && null != e && !mo(e)) || go.test(e) || !fo.test(e) || null != t && e in Object(t);
};
var yo = function (e) {
  var t = typeof e;
  return null != e && ("object" == t || "function" == t);
};
var ho,
  vo = function (e) {
    if (!yo(e)) return !1;
    var t = uo(e);
    return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
  },
  bo = eo["__core-js_shared__"],
  xo = (ho = /[^.]+$/.exec(bo && bo.keys && bo.keys.IE_PROTO || "")) ? "Symbol(src)_1." + ho : "";
var Eo = function (e) {
    return !!xo && xo in e;
  },
  ko = Function.prototype.toString;
var To = function (e) {
    if (null != e) {
      try {
        return ko.call(e);
      } catch (e) {}
      try {
        return e + "";
      } catch (e) {}
    }
    return "";
  },
  wo = /^\[object .+?Constructor\]$/,
  Ao = Function.prototype,
  Co = Object.prototype,
  So = Ao.toString,
  No = Co.hasOwnProperty,
  Oo = RegExp("^" + So.call(No).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
var Ro = function (e) {
  return !(!yo(e) || Eo(e)) && (vo(e) ? Oo : wo).test(To(e));
};
var Io = function (e, t) {
  return null == e ? void 0 : e[t];
};
var Lo = function (e, t) {
    var n = Io(e, t);
    return Ro(n) ? n : void 0;
  },
  jo = Lo(Object, "create");
var Do = function () {
  this.__data__ = jo ? jo(null) : {}, this.size = 0;
};
var Fo = function (e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  },
  Mo = Object.prototype.hasOwnProperty;
var Po = function (e) {
    var t = this.__data__;
    if (jo) {
      var n = t[e];
      return "__lodash_hash_undefined__" === n ? void 0 : n;
    }
    return Mo.call(t, e) ? t[e] : void 0;
  },
  Bo = Object.prototype.hasOwnProperty;
var Ho = function (e) {
  var t = this.__data__;
  return jo ? void 0 !== t[e] : Bo.call(t, e);
};
var zo = function (e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = jo && void 0 === t ? "__lodash_hash_undefined__" : t, this;
};
function Uo(e) {
  var t = -1,
    n = null == e ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Uo.prototype.clear = Do, Uo.prototype.delete = Fo, Uo.prototype.get = Po, Uo.prototype.has = Ho, Uo.prototype.set = zo;
var Wo = Uo;
var Xo = function () {
  this.__data__ = [], this.size = 0;
};
var Go = function (e, t) {
  return e === t || e != e && t != t;
};
var Vo = function (e, t) {
    for (var n = e.length; n--;) if (Go(e[n][0], t)) return n;
    return -1;
  },
  Yo = Array.prototype.splice;
var Ko = function (e) {
  var t = this.__data__,
    n = Vo(t, e);
  return !(n < 0) && (n == t.length - 1 ? t.pop() : Yo.call(t, n, 1), --this.size, !0);
};
var Zo = function (e) {
  var t = this.__data__,
    n = Vo(t, e);
  return n < 0 ? void 0 : t[n][1];
};
var qo = function (e) {
  return Vo(this.__data__, e) > -1;
};
var Jo = function (e, t) {
  var n = this.__data__,
    r = Vo(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
};
function Qo(e) {
  var t = -1,
    n = null == e ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Qo.prototype.clear = Xo, Qo.prototype.delete = Ko, Qo.prototype.get = Zo, Qo.prototype.has = qo, Qo.prototype.set = Jo;
var $o = Qo,
  es = Lo(eo, "Map");
var ts = function () {
  this.size = 0, this.__data__ = {
    hash: new Wo(),
    map: new (es || $o)(),
    string: new Wo()
  };
};
var ns = function (e) {
  var t = typeof e;
  return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
};
var rs = function (e, t) {
  var n = e.__data__;
  return ns(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
};
var is = function (e) {
  var t = rs(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
};
var as = function (e) {
  return rs(this, e).get(e);
};
var os = function (e) {
  return rs(this, e).has(e);
};
var ss = function (e, t) {
  var n = rs(this, e),
    r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
};
function ls(e) {
  var t = -1,
    n = null == e ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ls.prototype.clear = ts, ls.prototype.delete = is, ls.prototype.get = as, ls.prototype.has = os, ls.prototype.set = ss;
var cs = ls;
function ds(e, t) {
  if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");
  var n = function () {
    var r = arguments,
      i = t ? t.apply(this, r) : r[0],
      a = n.cache;
    if (a.has(i)) return a.get(i);
    var o = e.apply(this, r);
    return n.cache = a.set(i, o) || a, o;
  };
  return n.cache = new (ds.Cache || cs)(), n;
}
ds.Cache = cs;
var us = ds;
var ps = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
  ms = /\\(\\)?/g,
  fs = function (e) {
    var t = us(e, function (e) {
        return 500 === n.size && n.clear(), e;
      }),
      n = t.cache;
    return t;
  }(function (e) {
    var t = [];
    return 46 === e.charCodeAt(0) && t.push(""), e.replace(ps, function (e, n, r, i) {
      t.push(r ? i.replace(ms, "$1") : n || e);
    }), t;
  });
var gs = function (e, t) {
    for (var n = -1, r = null == e ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
    return i;
  },
  _s = to ? to.prototype : void 0,
  ys = _s ? _s.toString : void 0;
var hs = function e(t) {
  if ("string" == typeof t) return t;
  if (Ja(t)) return gs(t, e) + "";
  if (mo(t)) return ys ? ys.call(t) : "";
  var n = t + "";
  return "0" == n && 1 / t == -Infinity ? "-0" : n;
};
var vs = function (e) {
  return null == e ? "" : hs(e);
};
var bs = function (e, t) {
  return Ja(e) ? e : _o(e, t) ? [e] : fs(vs(e));
};
var xs = function (e) {
  if ("string" == typeof e || mo(e)) return e;
  var t = e + "";
  return "0" == t && 1 / e == -Infinity ? "-0" : t;
};
var Es = function (e, t) {
  for (var n = 0, r = (t = bs(t, e)).length; null != e && n < r;) e = e[xs(t[n++])];
  return n && n == r ? e : void 0;
};
var ks = function (e, t, n) {
  var r = null == e ? void 0 : Es(e, t);
  return void 0 === r ? n : r;
};
var Ts = function (e) {
    return void 0 === e;
  },
  ws = ie(Gi),
  As = ie(qa),
  Cs = ie(mi),
  Ss = re(function (t, n) {
    function r(e) {
      return e && "object" == typeof e && "default" in e ? e.default : e;
    }
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    var i = r(As),
      a = r(ks),
      o = r(Ts),
      s = r(yo),
      l = function () {
        return (l = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          return e;
        }).apply(this, arguments);
      };
    function c(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }
    var d = "#0e101c",
      u = "#bf1650",
      p = "#516391",
      m = "#1e2a4a",
      f = "#ec5990",
      g = "#191d3a",
      _ = "#1bda2b",
      y = {
        fontSize: 14,
        lineHeight: "22px"
      },
      h = i.button(v || (v = c(["\n  appearance: none;\n  margin: 0;\n  border: 0;\n  color: white;\n  padding: 5px !important;\n  border-radius: 0 !important;\n  background: ", ";\n  transition: 0.2s all;\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  appearance: none;\n  margin: 0;\n  border: 0;\n  color: white;\n  padding: 5px !important;\n  border-radius: 0 !important;\n  background: ", ";\n  transition: 0.2s all;\n\n  &:hover {\n    background: ", ";\n  }\n"])), function (e) {
        return e.hideBackground ? "" : m + " !important";
      }, p);
    h.defaultProps = {
      type: "button"
    };
    var v,
      b,
      x,
      E,
      k = i(h)(b || (b = c(["\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0 4px 0 auto;\n  background: none !important;\n  display: flex;\n  width: 25px;\n  height: 25px;\n  justify-content: center;\n  line-height: 14px !important;\n  border-radius: 50% !important;\n  padding: 0 !important;\n  transition: 0.2s all;\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:active {\n    background: black;\n  }\n"], ["\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0 4px 0 auto;\n  background: none !important;\n  display: flex;\n  width: 25px;\n  height: 25px;\n  justify-content: center;\n  line-height: 14px !important;\n  border-radius: 50% !important;\n  padding: 0 !important;\n  transition: 0.2s all;\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:active {\n    background: black;\n  }\n"])), p),
      T = i.input(x || (x = c(["\n  &::placeholder {\n    color: #b3b3b3;\n  }\n\n  &:focus::placeholder {\n    color: white;\n  }\n"], ["\n  &::placeholder {\n    color: #b3b3b3;\n  }\n\n  &:focus::placeholder {\n    color: white;\n  }\n"]))),
      w = i.table(E || (E = c(["\n  transition: 0.3s all;\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  transition: 0.3s all;\n\n  &:hover {\n    background: ", ";\n  }\n"])), d),
      A = function (t) {
        var n = t.setVisible,
          r = t.control;
        return e.createElement("header", {
          style: {
            display: "flex",
            alignItems: "center",
            paddingLeft: 10
          }
        }, e.createElement("p", {
          style: l({
            margin: 0,
            padding: 0,
            fontWeight: 600
          }, y)
        }, e.createElement("span", {
          style: {
            transition: "0.5s all",
            color: r.readFormStateRef.current.isValid && r.formStateRef.current.isValid ? _ : f
          }
        }, "■"), " ", "RHF DevTools"), e.createElement(k, {
          title: "Close dev panel",
          onClick: function () {
            return n(!1);
          }
        }, "✕"));
      },
      C = function (t) {
        var n = t.refObject,
          r = t.hasError,
          i = t.isDirty,
          c = t.fieldsValues,
          d = t.readFormStateRef,
          m = t.isNative,
          v = t.errorMessage,
          b = t.errorType,
          x = t.type,
          E = t.isTouched,
          k = t.name,
          T = t.collapseAll,
          A = t.index,
          C = e.useState(!1),
          S = C[0],
          N = C[1];
        e.useEffect(function () {
          N(!T);
        }, [T]);
        var O = c ? a(c, k) : "";
        if (!o(O)) if (s(O)) try {
          O = e.createElement("pre", {
            style: {
              margin: 0
            }
          }, e.createElement("code", {
            style: {
              fontSize: 12
            }
          }, JSON.stringify(O, null, 2)));
        } catch (t) {
          O = e.createElement("span", null, "[Nested Object]");
        } else "string" != typeof O && (O = String(O));
        return e.createElement(Vi.Animate, {
          play: !0,
          start: {
            opacity: 0,
            transform: "translateY(10px)"
          },
          end: {
            opacity: 1
          },
          easeType: "ease-in",
          delay: .1 * A
        }, e.createElement(w, {
          style: {
            padding: "10px 10px 10px",
            width: "100%",
            transition: ".3s all",
            borderLeft: "2px solid " + (r ? u : g)
          }
        }, e.createElement("thead", null, e.createElement("tr", null, e.createElement("td", {
          valign: "top",
          style: {
            width: 100,
            lineHeight: "22px"
          }
        }, e.createElement(h, {
          onClick: function () {
            return N(!S);
          },
          title: "Toggle field table",
          style: {
            border: "1px solid " + p,
            borderRadius: 2,
            padding: "3px 5px",
            display: "inline-block",
            fontSize: 10,
            lineHeight: "12px",
            width: 20,
            textAlign: "center",
            marginRight: 10
          }
        }, S ? "+" : "-"), e.createElement(h, {
          onClick: function () {
            n.scrollIntoView && n.scrollIntoView({
              behavior: "smooth"
            });
          },
          title: "Scroll into view",
          style: l({
            border: "1px solid " + p,
            borderRadius: 2,
            padding: "3px 5px",
            display: "inline-block",
            fontSize: 10,
            lineHeight: "12px",
            textAlign: "center",
            marginRight: 10
          }, m ? {} : {
            cursor: "not-allowed",
            background: p
          })
        }, m ? "Native" : "Custom")), e.createElement("td", {
          style: {
            display: "block",
            maxWidth: 100
          }
        }, e.createElement("p", {
          style: l({
            margin: 0,
            padding: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }, y),
          title: k
        }, k)))), !S && e.createElement("tbody", null, x && e.createElement("tr", null, e.createElement("td", {
          align: "right",
          style: l({
            paddingRight: 5,
            fontWeight: 500,
            verticalAlign: "top"
          }, y)
        }, "Type:"), e.createElement("td", {
          style: l({
            display: "block",
            maxWidth: 100
          }, y)
        }, x)), b && e.createElement("tr", null, e.createElement("td", {
          align: "right",
          style: l({
            paddingRight: 5,
            fontWeight: 500,
            verticalAlign: "top"
          }, y)
        }, "ERROR Type:"), e.createElement("td", {
          style: l({
            display: "block",
            maxWidth: 100
          }, y)
        }, b)), v && e.createElement("tr", null, e.createElement("td", {
          align: "right",
          style: l({
            paddingRight: 5,
            fontWeight: 500,
            verticalAlign: "top"
          }, y)
        }, "MESSAGE:"), e.createElement("td", {
          style: l({
            display: "block",
            maxWidth: 100
          }, y)
        }, v.trim())), !o(O) && e.createElement("tr", null, e.createElement("td", {
          align: "right",
          style: l({
            paddingRight: 5,
            fontWeight: 500,
            verticalAlign: "top"
          }, y)
        }, "Value:"), e.createElement("td", {
          "data-testid": k + "-field-value",
          style: l({
            display: "block",
            maxWidth: 100
          }, y)
        }, O)), d.current.touched && e.createElement("tr", null, e.createElement("td", {
          align: "right",
          style: l({
            paddingRight: 5,
            fontWeight: 500,
            verticalAlign: "top"
          }, y)
        }, "Touched:"), e.createElement("td", null, e.createElement("code", {
          style: l(l({
            color: E ? _ : f
          }, y), {
            fontSize: 12
          })
        }, E ? "true" : "false"))), d.current.dirtyFields && e.createElement("tr", null, e.createElement("td", {
          align: "right",
          style: l({
            paddingRight: 5,
            fontWeight: 500,
            verticalAlign: "top"
          }, y)
        }, "Dirty:"), e.createElement("td", null, e.createElement("code", {
          style: l(l({
            color: i ? _ : f
          }, y), {
            fontSize: 12
          })
        }, i ? "true" : "false"))))));
      },
      S = function (t) {
        var n = t.formState,
          r = t.showFormState,
          i = t.setShowFormState,
          a = t.readFormStateRef;
        return e.createElement("div", {
          style: {
            alignSelf: "end"
          }
        }, r && e.createElement("table", {
          style: {
            padding: 10,
            display: "block",
            background: "black",
            borderTop: "1px solid " + f
          }
        }, e.createElement("tbody", null, e.createElement("tr", null, e.createElement("td", {
          align: "right",
          style: l({
            width: 90
          }, y)
        }, "Valid:"), e.createElement("td", {
          style: l({
            color: a.current.isValid && n.isValid ? _ : f
          }, y)
        }, a.current.isValid && n.isValid ? "true" : "false")), e.createElement("tr", null, e.createElement("td", {
          align: "right",
          style: l({}, y)
        }, "Submitted:"), e.createElement("td", {
          style: l({
            color: n.isSubmitted ? _ : f
          }, y)
        }, n.isSubmitted ? "true" : "false")), e.createElement("tr", null, e.createElement("td", {
          align: "right",
          style: l({}, y)
        }, "Count:"), e.createElement("td", {
          style: l({
            color: n.submitCount ? _ : f
          }, y)
        }, n.submitCount)), e.createElement("tr", null, e.createElement("td", {
          align: "right",
          style: l({}, y)
        }, "Submitting:"), e.createElement("td", {
          style: l({
            color: n.isSubmitting ? _ : f
          }, y)
        }, n.isSubmitting ? "true" : "false")))), e.createElement(h, {
          style: {
            margin: 0,
            width: "100%",
            padding: "8px 10px",
            textTransform: "none",
            fontSize: 12,
            lineHeight: "14px"
          },
          title: "Toggle form state panel",
          onClick: function () {
            i(!r);
          }
        }, e.createElement("span", {
          style: {
            transition: "0.5s all",
            color: a.current.isValid && n.isValid ? _ : f
          }
        }, "■"), " ", "Form State: ", r ? "OFF" : "ON"));
      };
    function N(e, t) {
      return l(l({}, e), {
        visible: t
      });
    }
    function O(e, t) {
      return l(l({}, e), {
        isCollapse: t
      });
    }
    var R = function (t) {
        var n = t.control,
          r = n.fieldsRef,
          i = n.getValues,
          o = n.readFormStateRef,
          s = n.formStateRef,
          l = ws.useStateMachine(O),
          c = l.state,
          p = l.action,
          m = e.useState({})[1],
          f = e.useState(!1),
          g = f[0],
          _ = f[1],
          y = i(),
          v = Cs.useForm(),
          b = v.register,
          x = (0, v.watch)("search", "");
        return e.useEffect(function () {
          m({});
        }, []), e.createElement("div", {
          style: {
            display: "grid",
            gridTemplateRows: "56px auto",
            height: "calc(100vh - 40px)"
          }
        }, e.createElement("div", {
          style: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "28px 28px"
          }
        }, e.createElement(h, {
          style: {
            borderRight: "1px solid " + d,
            textTransform: "none",
            fontSize: 11,
            lineHeight: 1
          },
          title: "Update values and state the form",
          onClick: function () {
            return m({});
          }
        }, "♺ UPDATE"), e.createElement(h, {
          style: {
            borderRight: "1px solid " + d,
            textTransform: "none",
            fontSize: 11,
            lineHeight: 1
          },
          title: "Toggle entire fields",
          onClick: function () {
            p(!c.isCollapse);
          }
        }, c.isCollapse ? "[-] COLLAPSE" : "[+] EXPAND"), e.createElement(T, {
          style: {
            display: "inline-block",
            borderRadius: 0,
            width: "100%",
            margin: 0,
            padding: "5px 10px",
            WebkitAppearance: "none",
            appearance: "none",
            fontSize: 14,
            border: 0,
            color: "white",
            gridColumnStart: 1,
            gridColumnEnd: 4,
            background: "black"
          },
          name: "search",
          ref: b,
          placeholder: "Filter name...",
          type: "search"
        })), e.createElement("div", {
          style: {
            overflow: "auto"
          }
        }, Object.entries(r.current).filter(function (e) {
          var t = e[0];
          return (t && t.toLowerCase && t.toLowerCase().includes(x) || !t && !x || "" === x) && t;
        }).map(function (t, n) {
          var r = t[0],
            i = t[1],
            l = a(s.current.errors, r),
            d = a(l, "message", void 0),
            p = a(l, "type", void 0),
            m = a(i, "ref.type", void 0),
            f = !!a(s.current.touched, r),
            g = i.ref.type,
            _ = !!a(s.current.dirtyFields, r),
            h = !!l,
            v = a(i, "ref");
          return e.createElement("section", {
            key: "" + r + n,
            style: {
              borderBottom: "1px dashed " + u,
              margin: 0
            }
          }, e.createElement(C, {
            refObject: v,
            index: n,
            collapseAll: c.isCollapse,
            name: r,
            isTouched: f,
            type: m,
            hasError: h,
            isNative: g,
            errorMessage: d,
            errorType: p,
            readFormStateRef: o,
            isDirty: _,
            fieldsValues: y
          }));
        })), e.createElement(S, {
          readFormStateRef: o,
          formState: s.current,
          showFormState: g,
          setShowFormState: _
        }));
      },
      I = function (t) {
        var n = t.style,
          r = t.setVisible;
        return e.createElement("svg", {
          fill: "white",
          viewBox: "0 0 100 100",
          style: l({
            height: 14,
            padding: 3,
            borderRadius: 2,
            background: f
          }, n),
          onClick: function () {
            r(!0);
          },
          "aria-label": "React Hook Form Logo"
        }, e.createElement("path", {
          d: "M73.56,13.32H58.14a8.54,8.54,0,0,0-16.27,0H26.44a11,11,0,0,0-11,11V81.63a11,11,0,0,0,11,11H73.56a11,11,0,0,0,11-11V24.32A11,11,0,0,0,73.56,13.32Zm-30.92,2a1,1,0,0,0,1-.79,6.54,6.54,0,0,1,12.78,0,1,1,0,0,0,1,.79h5.38v6.55a3,3,0,0,1-3,3H40.25a3,3,0,0,1-3-3V15.32ZM82.56,81.63a9,9,0,0,1-9,9H26.44a9,9,0,0,1-9-9V24.32a9,9,0,0,1,9-9h8.81v6.55a5,5,0,0,0,5,5h19.5a5,5,0,0,0,5-5V15.32h8.81a9,9,0,0,1,9,9Z"
        }), e.createElement("path", {
          style: {
            transform: "translateX(-25px)"
          },
          d: "M71.6,45.92H54a1,1,0,0,0,0,2H71.6a1,1,0,0,0,0-2Z"
        }), e.createElement("path", {
          d: "M71.6,45.92H54a1,1,0,0,0,0,2H71.6a1,1,0,0,0,0-2Z"
        }), e.createElement("path", {
          style: {
            transform: "translateX(-25px)"
          },
          d: "M71.1,69.49H53.45a1,1,0,1,0,0,2H71.1a1,1,0,0,0,0-2Z"
        }), e.createElement("path", {
          d: "M71.1,69.49H53.45a1,1,0,1,0,0,2H71.1a1,1,0,0,0,0-2Z"
        }));
      },
      L = function (t) {
        var n = t.visible;
        return e.createElement(Vi.Animate, {
          play: n,
          duration: .1,
          start: {
            transform: "translateX(8px)"
          },
          end: {
            transform: "translateX(0)"
          },
          delay: .3
        }, e.createElement("div", {
          style: {
            position: "relative"
          }
        }, e.createElement("div", {
          style: {
            position: "fixed",
            height: "100vh",
            width: 250,
            zIndex: 99998,
            background: "black",
            top: 7,
            right: 7,
            boxShadow: "rgba(15, 15, 29, 0.4) -3px 3px 6px 0px"
          }
        }), e.createElement("span", {
          style: {
            width: 0,
            height: 0,
            position: "fixed",
            zIndex: 99998,
            borderTop: "10px solid transparent",
            borderBottom: "10px solid transparent",
            borderRight: "10px solid black",
            right: 247,
            top: -3
          }
        }), e.createElement("span", {
          style: {
            width: 0,
            height: 0,
            position: "fixed",
            zIndex: 99998,
            borderTop: "10px solid transparent",
            borderBottom: "10px solid transparent",
            borderRight: "10px solid " + g,
            right: 247,
            top: 37
          }
        }), e.createElement("span", {
          style: {
            width: 10,
            height: 21,
            position: "fixed",
            zIndex: 99998,
            right: 247,
            top: 47,
            background: g
          }
        }), e.createElement("span", {
          style: {
            width: 0,
            height: 0,
            position: "fixed",
            zIndex: 99998,
            borderTop: "10px solid transparent",
            borderBottom: "10px solid transparent",
            borderLeft: "10px solid " + g,
            right: 247,
            top: 55
          }
        })));
      },
      j = function (t) {
        var n = t.control,
          r = ws.useStateMachine(N),
          i = r.state,
          a = r.action;
        return e.createElement(e.Fragment, null, e.createElement(Vi.Animate, {
          play: !i.visible,
          duration: .2,
          start: {
            position: "fixed",
            top: 0,
            right: 0,
            transform: "translateX(0)",
            zIndex: 99999
          },
          end: {
            top: 0,
            right: 0,
            position: "fixed",
            transform: "translateX(280px)",
            zIndex: 99999
          }
        }, e.createElement("div", {
          style: {
            position: "fixed",
            height: "100vh",
            width: 250,
            zIndex: 99999,
            background: g,
            top: 0,
            right: 0,
            display: "grid",
            textAlign: "left",
            color: "white",
            fontSize: 14,
            gridTemplateRows: "40px auto",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
          }
        }, e.createElement(A, {
          setVisible: a,
          control: n
        }), e.createElement(R, {
          control: n
        })), e.createElement(L, {
          visible: i.visible
        })), !i.visible && e.createElement(h, {
          title: "Show dev panel",
          hideBackground: !0,
          style: {
            position: "fixed",
            zIndex: 99999,
            top: 3,
            right: 3,
            padding: 3,
            margin: 0,
            background: "none"
          }
        }, e.createElement(I, {
          setVisible: a
        })));
      };
    "undefined" != typeof window && ws.setStorageType(window.localStorage), ws.createStore({
      visible: !0,
      isCollapse: !1,
      filterName: ""
    }, {
      name: "__REACT_HOOK_FORM_DEVTOOLS__"
    });
    n.DevTool = function (t) {
      var n = t.control;
      return e.createElement(ws.StateMachineProvider, null, e.createElement(j, {
        control: n
      }));
    };
  }),
  Ns = re(function (e) {
    "production" === process.env.NODE_ENV ? e.exports = {
      DevTool: () => null
    } : e.exports = Ss;
  }),
  Os = {
    email: {
      pattern: {
        value: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
        message: "Fel format på e-postadress"
      }
    },
    tel: {
      pattern: {
        value: /^([+]46)\s*(7[0236])\s*(\d{4})\s*(\d{3})$/,
        message: "Fel format på telefonnummer"
      }
    },
    number: {
      pattern: {
        value: /^(?:-)?\d+$/,
        message: "Fel format på siffran"
      }
    },
    url: {
      pattern: {
        value: /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/,
        message: "Fel format på urlen"
      }
    }
  },
  Rs = function (e, t, n) {
    return ("string" == typeof t ? t.replace(/\[(\d+)]/g, ".$1") : (t || []).join(".")).split(".").filter(Boolean).every(function (t) {
      return void 0 !== (e = e[t]);
    }) ? e : n;
  },
  Is = function (t) {
    var n = t.addText,
      r = t.allowEmpty,
      i = void 0 !== r && r,
      a = t.errors,
      o = t.control,
      s = t.register,
      l = t.onRemoveField,
      c = t.getValues,
      d = t.children;
    if (!d.props) return !1;
    var u = d.props.children ? d.props.children : d,
      p = di({
        control: o,
        name: d.props.name
      }),
      m = p.fields,
      f = p.append,
      g = p.remove;
    return o && s ? e.createElement("div", null, e.createElement(K, null, m.map(function (t, n) {
      return e.createElement(K, {
        direction: "row",
        nowrap: !0,
        align: "center",
        key: t.id
      }, (u && u.map ? u : [u]).map(function (r, i) {
        return e.createElement("div", {
          key: "".concat(t.id, "-").concat(i)
        }, e.createElement("label", {
          className: "".concat(Rs(a, "".concat(d.props.name, "[").concat(n, "].").concat(r.props.name), void 0) && _i.errorBlock)
        }, e.createElement(pi, {
          key: "".concat(t.id, "-").concat(i),
          as: r,
          name: "".concat(d.props.name, "[").concat(n, "].").concat(r.props.name),
          control: o,
          defaultValue: t && t[r.props.name] || r.props.defaultValue,
          rules: Object.assign({}, r.props.validation, Os[r.props.type])
        })), Rs(a, "".concat(d.props.name, "[").concat(n, "].").concat(r.props.name), void 0) && e.createElement("div", {
          className: _i.error
        }, e.createElement("span", null, Rs(a, "".concat(d.props.name, "[").concat(n, "].").concat(r.props.name), void 0).message)));
      }), (i || m.length > 1) && e.createElement(Bl, {
        onClick: function () {
          g(n), setTimeout(function () {
            l(c());
          }, 10);
        }
      }, e.createElement(nd, {
        icon: "close"
      })));
    })), e.createElement(Bl, {
      onClick: function () {
        f();
      }
    }, e.createElement(nd, {
      icon: "add_circle",
      text: n || "Lägg till rad"
    }))) : e.createElement("h4", null, "FieldArray must be wrapped by Form");
  },
  Ls = function (t) {
    var r = t.children,
      i = t.mode,
      a = void 0 === i ? "onSubmit" : i,
      o = t.submit,
      s = t.cancel,
      l = t.onSubmit,
      c = t.onChange,
      d = t.onFocus,
      u = t.onBlur,
      p = t.onCancel,
      m = t.onRemoveField,
      f = t.dev,
      g = t.defaultValues,
      _ = t.isDirty,
      y = Jr({
        mode: a,
        defaultValues: g
      }),
      h = y.handleSubmit,
      v = y.register,
      b = y.errors,
      x = y.getValues,
      E = y.setValue,
      k = y.reset,
      T = y.control,
      w = y.formState;
    n(function () {
      _ && _(w.isDirty);
    }, [w.isDirty]), n(function () {
      k(g);
    }, [g]);
    var A = function t(n) {
        return n ? e.createElement(e.Fragment, null, (n.map ? n : [n]).map(function (n, r) {
          return "input" === n.type && "color" === n.props.type ? e.createElement(e.Fragment, {
            key: "".concat(n.props.name, "-").concat(r)
          }, e.createElement("label", {
            className: "".concat(Rs(b, n.props.name, void 0) && _i.errorBlock, " ").concat(!C(n.props.type) && _i.horizontal)
          }, n.props.label, e.createElement(tc, {
            trigger: e.createElement(K, {
              direction: "row",
              align: "center"
            }, e.createElement("div", {
              style: {
                height: 38,
                width: 38,
                border: "solid 1px #dbdbdb",
                borderRight: "none",
                background: x()[n.props.name] || "#bada55"
              }
            }), e.createElement("input", Z({}, Object.assign({}, n.props, C(n.props.type) ? {
              type: "text"
            } : {}), {
              style: {
                background: x()[n.props.name]
              },
              ref: v(Object.assign({}, n.props.validation, Os[n.props.type]))
            })))
          }, e.createElement(wf, {
            onChange: function (e) {
              E(n.props.name, e, {
                shouldValidate: !0,
                shouldDirty: !0
              }), console.log("get vals", x()[n.props.name]);
            }
          })), !C(n.props.type) && n.props.label), Rs(b, n.props.name, void 0) && e.createElement("div", {
            className: _i.error
          }, e.createElement("span", null, Rs(b, n.props.name, void 0).message))) : "input" === n.type && "hidden" === n.props.type ? e.createElement("input", Z({
            key: n.key || "".concat(n.props.name, "-").concat(r)
          }, n.props, {
            ref: v(Object.assign({}, n.props.validation, Os[n.props.type]))
          })) : "input" === n.type ? e.createElement(e.Fragment, {
            key: "".concat(n.props.name, "-").concat(r)
          }, e.createElement(K, {
            direction: "row",
            align: "center"
          }, e.createElement("label", {
            className: "".concat(Rs(b, n.props.name, void 0) && _i.errorBlock, " ").concat(!C(n.props.type) && _i.horizontal, " ").concat(!n.props.label && _i.noLabel)
          }, C(n.props.type) && n.props.label, e.createElement("input", Z({}, n.props, {
            ref: v(Object.assign({}, n.props.validation, Os[n.props.type]))
          })), !C(n.props.type) && n.props.label), n.props.more && e.createElement(tc, {
            keepOpen: !0,
            trigger: e.createElement(nd, {
              icon: "more_vert"
            })
          }, n.props.more)), Rs(b, n.props.name) && e.createElement("div", {
            className: _i.error
          }, e.createElement("span", null, Rs(b, n.props.name, void 0).message))) : "select" === n.type ? e.createElement(e.Fragment, {
            key: "".concat(n.props.name, "-").concat(r)
          }, e.createElement(K, {
            direction: "row",
            align: "center"
          }, e.createElement("label", null, n.props.label || "", e.createElement("select", Z({}, n.props, {
            ref: v(n.props.validation || {})
          }), (n.props.children.map ? n.props.children : [n.props.children]).map(function (t, n) {
            return e.createElement("option", {
              value: t.props.value,
              key: t.key || "".concat(t.props.name, "-").concat(n)
            }, t.props.children);
          }))), n.props.more && e.createElement(tc, {
            keepOpen: !0,
            trigger: e.createElement(nd, {
              icon: "more_vert"
            })
          }, n.props.more)), Rs(b, n.props.name, void 0) && e.createElement("div", {
            className: _i.error
          }, e.createElement("span", null, Rs(b, n.props.name, void 0).message))) : "textarea" === n.type ? e.createElement(e.Fragment, {
            key: "".concat(n.props.name, "-").concat(r)
          }, e.createElement("label", null, n.props.label || "", e.createElement("textarea", Z({}, Object.assign({}, n.props, C(n.props.type) ? {
            type: "text"
          } : {}), {
            ref: v(n.props.validation || {})
          }))), b[n.props.name] && e.createElement("div", {
            className: _i.error
          }, e.createElement("span", null, b[n.props.name].message))) : n.type && n.key && "fieldarray" === n.key.substr(0, 10).toLowerCase() ? e.createElement(Is, {
            key: n.key || "fieldarray-".concat(r),
            onRemoveField: m,
            getValues: x,
            addText: n.props.addText,
            children: n,
            control: T,
            register: v,
            allowEmpty: n.props.allowEmpty,
            errors: b
          }) : n.type && n.key && "list" === n.key.substr(0, 4).toLowerCase() ? e.createElement(K, Z({}, n.props, {
            key: n.key || "list-".concat(r)
          }), t(n.props.children)) : "hr" === n.type ? e.createElement("hr", {
            key: n.key || "hr-".concat(r)
          }) : "h4" === n.type ? e.createElement("h4", {
            key: n.key || "h4-".concat(r)
          }, n.props.children) : "h5" === n.type ? e.createElement("h5", {
            key: n.key || "h5-".concat(r)
          }, n.props.children) : "fieldset" === n.type ? e.createElement("fieldset", {
            key: n.key || "fieldset-".concat(r)
          }, t(n.props.children)) : "legend" === n.type ? e.createElement("legend", {
            key: n.key || "legend-".concat(r)
          }, n.props.children) : Array.isArray(n) ? t(n) : void 0;
        })) : null;
      },
      C = function (e) {
        return "radio" !== e && "checkbox" !== e;
      };
    return e.createElement("form", {
      className: _i.form,
      autoComplete: "off",
      onSubmit: h(function (e, t) {
        return l ? l(e) : null;
      }),
      onChange: function (e) {
        return c && 0 === Object.keys(b).length ? c(x()) : null;
      },
      onBlur: function (e) {
        setTimeout(function () {
          return u ? 0 === Object.keys(b).length ? u(x()) : u({
            errors: b
          }) : null;
        }, 10);
      },
      onFocus: function (e) {
        return d ? d(e) : null;
      }
    }, r && r.key && "grid" === r.key.substr(0, 4).toLowerCase() ? e.createElement(Qt, null, r.props.children.map(function (n, r) {
      return e.createElement(en, Z({}, n.props, {
        key: t.key || r
      }), A(n.props.children));
    })) : r ? A(r) : e.createElement("div", null, "null"), e.createElement("div", {
      className: _i.buttons
    }, o && e.createElement(wd, {
      disabled: Object.keys(b).length > 0,
      submit: !0,
      text: o
    }), s && e.createElement(wd, {
      text: s,
      level: "secondary",
      handleClick: function (e) {
        return p ? p() : k({});
      }
    })), f && e.createElement(Ns.DevTool, {
      control: T
    }));
  },
  js = function (t) {
    var n = t.data,
      r = t.mode,
      i = t.submit,
      a = t.cancel,
      o = t.onSubmit,
      s = t.onCancel,
      l = t.onBlur,
      c = t.trigger,
      d = t.onChange,
      u = t.onFocus,
      p = t.onReset,
      m = t.onRemoveField,
      f = t.control,
      g = t.children,
      _ = t.defaultValues,
      y = t.isDirty;
    return n ? e.createElement(Ii, {
      data: n
    }) : e.createElement(Ls, {
      mode: r,
      submit: i,
      cancel: a,
      onSubmit: o,
      onChange: d,
      onFocus: u,
      onBlur: l,
      trigger: c,
      onCancel: s,
      onReset: p,
      onRemoveField: m,
      dev: f,
      defaultValues: _,
      isDirty: y
    }, g);
  },
  Ds = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  };
var Fs = function (e, t) {
    var n,
      r,
      i,
      a,
      o,
      s,
      l = !1;
    t || (t = {}), n = t.debug || !1;
    try {
      if (i = function () {
        var e = document.getSelection();
        if (!e.rangeCount) return function () {};
        for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++) n.push(e.getRangeAt(r));
        switch (t.tagName.toUpperCase()) {
          case "INPUT":
          case "TEXTAREA":
            t.blur();
            break;
          default:
            t = null;
        }
        return e.removeAllRanges(), function () {
          "Caret" === e.type && e.removeAllRanges(), e.rangeCount || n.forEach(function (t) {
            e.addRange(t);
          }), t && t.focus();
        };
      }(), a = document.createRange(), o = document.getSelection(), (s = document.createElement("span")).textContent = e, s.style.all = "unset", s.style.position = "fixed", s.style.top = 0, s.style.clip = "rect(0, 0, 0, 0)", s.style.whiteSpace = "pre", s.style.webkitUserSelect = "text", s.style.MozUserSelect = "text", s.style.msUserSelect = "text", s.style.userSelect = "text", s.addEventListener("copy", function (r) {
        if (r.stopPropagation(), t.format) if (r.preventDefault(), void 0 === r.clipboardData) {
          n && console.warn("unable to use e.clipboardData"), n && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var i = Ds[t.format] || Ds.default;
          window.clipboardData.setData(i, e);
        } else r.clipboardData.clearData(), r.clipboardData.setData(t.format, e);
        t.onCopy && (r.preventDefault(), t.onCopy(r.clipboardData));
      }), document.body.appendChild(s), a.selectNodeContents(s), o.addRange(a), !document.execCommand("copy")) throw new Error("copy command was unsuccessful");
      l = !0;
    } catch (i) {
      n && console.error("unable to copy using execCommand: ", i), n && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), l = !0;
      } catch (i) {
        n && console.error("unable to copy using clipboardData: ", i), n && console.error("falling back to prompt"), r = function (e) {
          var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
          return e.replace(/#{\s*key\s*}/g, t);
        }("message" in t ? t.message : "Copy to clipboard: #{key}, Enter"), window.prompt(r, e);
      }
    } finally {
      o && ("function" == typeof o.removeRange ? o.removeRange(a) : o.removeAllRanges()), s && document.body.removeChild(s), i();
    }
    return l;
  },
  Ms = re(function (t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.CopyToClipboard = void 0;
    var r = a(e),
      i = a(Fs);
    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function o(e) {
      return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function s(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function l(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = function (e, t) {
          if (null == e) return {};
          var n,
            r,
            i = {},
            a = Object.keys(e);
          for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
          return i;
        }(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
      }
      return i;
    }
    function c(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function d(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    function u(e, t) {
      return !t || "object" !== o(t) && "function" != typeof t ? m(e) : t;
    }
    function p(e) {
      return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function m(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function f(e, t) {
      return (f = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function g(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    var _ = function (e) {
      function t() {
        var e, n;
        c(this, t);
        for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++) o[s] = arguments[s];
        return g(m(n = u(this, (e = p(t)).call.apply(e, [this].concat(o)))), "onClick", function (e) {
          var t = n.props,
            a = t.text,
            o = t.onCopy,
            s = t.children,
            l = t.options,
            c = r.default.Children.only(s),
            d = (0, i.default)(a, l);
          o && o(a, d), c && c.props && "function" == typeof c.props.onClick && c.props.onClick(e);
        }), n;
      }
      var n, a, o;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && f(e, t);
      }(t, e), n = t, (a = [{
        key: "render",
        value: function () {
          var e = this.props;
          e.text, e.onCopy, e.options;
          var t = e.children,
            n = l(e, ["text", "onCopy", "options", "children"]),
            i = r.default.Children.only(t);
          return r.default.cloneElement(i, function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? s(n, !0).forEach(function (t) {
                g(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(n).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }({}, n, {
            onClick: this.onClick
          }));
        }
      }]) && d(n.prototype, a), o && d(n, o), t;
    }(r.default.PureComponent);
    n.CopyToClipboard = _, g(_, "defaultProps", {
      onCopy: void 0,
      options: void 0
    });
  }).CopyToClipboard;
Ms.CopyToClipboard = Ms;
var Ps = Ms,
  Bs = function (n) {
    var r = n.text,
      i = n.onCopy,
      a = n.isButton,
      o = n.ctaText,
      s = n.hideText,
      l = void 0 !== s && s,
      c = j(t(""), 2),
      d = c[0],
      u = c[1];
    return e.createElement("div", null, l || !a ? null : e.createElement("h4", {
      style: {
        overflowWrap: "break-word",
        width: 500
      }
    }, r), e.createElement(Ps, {
      text: r,
      onCopy: function () {
        i ? i() : u(!0);
      }
    }, e.createElement("div", null, a ? e.createElement(wd, {
      submit: !0,
      handleClick: function (e) {
        return e.preventDefault;
      },
      text: o || "Kopiera"
    }) : e.createElement(Bl, {
      padding: "2px"
    }, o))), d ? e.createElement("div", {
      style: {
        padding: 15
      }
    }, e.createElement(Ap, {
      text: "Kopierad"
    })) : null);
  },
  Hs = "style_avatar__1kSJB",
  zs = "style_settingsWrapper__9bxAd",
  Us = "style_settingsHeader__1Kma2",
  Ws = "style_settingsContent__1WNx4",
  Xs = "style_settingsLinks__1jps9";
y(".style_avatar__1kSJB {\n  background-color: #5B8C79;\n  color: #fff;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  text-transform: uppercase; }\n\n.style_settingsWrapper__9bxAd {\n  min-width: 450px; }\n\n.style_settingsHeader__1Kma2 {\n  padding: 16px;\n  border-bottom: solid 1px #dcdcdc;\n  text-align: center; }\n  .style_settingsHeader__1Kma2 h5 {\n    font-size: 16px;\n    font-weight: bold;\n    margin: 0;\n    padding: 0; }\n\n.style_settingsContent__1WNx4 {\n  padding: 16px; }\n  .style_settingsContent__1WNx4 h5 {\n    margin: 16px 0 8px 0;\n    padding: 0;\n    font-size: 16px;\n    color: rgba(0, 0, 0, 0.54); }\n  .style_settingsContent__1WNx4 div {\n    color: rgba(0, 0, 0, 0.87); }\n\n.style_settingsLinks__1jps9 {\n  padding: 16px 0;\n  margin: 0;\n  list-style: none; }\n  .style_settingsLinks__1jps9 li {\n    text-align: center;\n    padding: 0;\n    border-top: solid 1px #e8e8e8; }\n    .style_settingsLinks__1jps9 li a {\n      color: #3f51bf;\n      text-decoration: none; }\n  .style_settingsLinks__1jps9 .style_settingsLinkDanger__5P1kc a {\n    color: #ff5252; }\n");
var Gs = function (t) {
    var n = t.loggedInAs,
      r = void 0 === n ? {} : n,
      i = t.loginAsModal,
      a = t.logOutAs,
      o = t.logout,
      s = t.profile,
      l = t.customerId,
      c = t.links,
      d = s.admin;
    return e.createElement("div", {
      className: zs
    }, e.createElement("div", {
      className: Us
    }, e.createElement("h5", null, "Inloggad som")), e.createElement("div", {
      className: Ws
    }, e.createElement("h5", null, "Användare"), e.createElement("div", null, r && r.name ? r.name : s.sub), e.createElement("h5", null, "Namn"), e.createElement("div", null, r && r.name ? r.name : s.name), e.createElement("h5", null, "E-post"), e.createElement("div", null, r && r.email ? r.email : s.email), l ? e.createElement("div", null, " ", e.createElement("h5", null, "Kundnummer"), e.createElement("div", null, l)) : null), e.createElement("ul", {
      className: Xs
    }, c.map(function (t, n) {
      return e.createElement("li", {
        key: "avatar-link-".concat(n)
      }, e.createElement(Bl, {
        stretch: !0
      }, t));
    }), d && r && !r.name && e.createElement("li", null, e.createElement(wd, {
      style: {
        width: 420
      },
      handleClick: function () {
        i();
      },
      text: "Logga in som",
      stretch: !0
    })), d && r && r.name && e.createElement("li", null, e.createElement(wd, {
      handleClick: function () {
        a();
      },
      style: {
        width: 420
      },
      text: "Logga ut ".concat(r.name, " "),
      stretch: !0
    })), r && !r.name && e.createElement("li", null, e.createElement(Bl, {
      stretch: !0
    }, e.createElement("a", {
      onClick: function (e) {
        o();
      }
    }, "Logga ut")))));
  },
  Vs = function (t) {
    var n = t.profile,
      r = t.loggedInAs,
      i = n.sub,
      a = n.givenName,
      o = n.familyName,
      s = a && o ? "".concat(a[0]).concat(o[0]) : i.substr(0, 2);
    return e.createElement(K, {
      direction: "row",
      align: "center"
    }, r && r.name ? e.createElement("div", {
      style: {
        backgroundColor: "#ff5252"
      },
      className: Hs
    }, r.name.substr(0, 2)) : null, e.createElement("div", {
      className: Hs
    }, s));
  },
  Ys = function (t) {
    var n,
      r = t.loggedInAs,
      i = void 0 === r ? {} : r,
      a = t.profile,
      o = t.loginAsModal,
      s = t.logout,
      l = t.theme,
      c = void 0 === l ? "bright" : l,
      d = t.logOutAs,
      u = t.links,
      p = void 0 === u ? [] : u;
    return a && a.sub ? e.createElement(tc, {
      rounded: (n = i, void 0 === n.email),
      trigger: e.createElement(Vs, {
        theme: c,
        loggedInAs: i,
        profile: a
      }),
      content: e.createElement(Gs, {
        loggedInAs: i,
        profile: a,
        logout: s,
        logOutAs: d,
        loginAsModal: o,
        links: p
      }),
      theme: c
    }) : null;
  },
  Ks = function (t) {
    var n = t.toggleFilter,
      r = t.icon,
      i = t.iconSize,
      a = void 0 === i ? "small" : i,
      o = t.text,
      s = t.counter,
      l = t.active,
      c = t.filterName,
      d = t.onClick;
    return e.createElement("div", {
      style: {
        border: "".concat(l && s > 0 ? "solid 1px #2e3b8c" : "solid 1px #bababa"),
        background: "".concat(l || s && s > 0 ? "#2e3b8c" : "#fff"),
        color: "".concat(l || s && s > 0 ? "#fff" : "#828282"),
        fontWeight: "bold",
        width: "fit-content",
        fontSize: 14,
        height: 22,
        borderRadius: 11,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingLeft: 8,
        paddingRight: 8,
        cursor: "pointer",
        margin: 8,
        flexWrap: "nowrap",
        whiteSpace: "nowrap"
      },
      onClick: function (e) {
        d ? d() : n(c);
      }
    }, e.createElement(K, {
      justify: "space-around",
      nowrap: !0,
      direction: "row",
      align: "center"
    }, e.createElement("div", null, o, " ", s ? "".concat(s) : ""), r && e.createElement(nd, {
      style: {
        marginLeft: 6
      },
      icon: r,
      size: a,
      color: l ? "#fff" : "#181818"
    })));
  },
  Zs = "expandable_expandable__1hsNW",
  qs = "expandable_headerArea__2vniF",
  Js = "expandable_expandableHeader__3RcuP",
  Qs = "expandable_expandableContent__1Qh4L";
y(".expandable_expandable__1hsNW {\n  min-width: 100%;\n  width: 100%;\n  border: solid 1px #d3d3d3; }\n  .expandable_expandable__1hsNW .expandable_headerArea__2vniF {\n    cursor: pointer; }\n  .expandable_expandableHeader__3RcuP {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #e5e3e5;\n    white-space: nowrap;\n    -webkit-transition: background-color .4s ease-out;\n    -moz-transition: background-color .4s ease-out;\n    -o-transition: background-color .4s ease-out; }\n    .expandable_expandableHeader__3RcuP:hover {\n      background-color: #e8e8e8; }\n    .expandable_expandableHeader__3RcuP h5 {\n      color: rgba(0, 0, 0, 0.87);\n      font-size: 16px;\n      font-weight: 500;\n      margin: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      width: 100%; }\n  .expandable_expandableContent__1Qh4L {\n    padding: 10px;\n    height: 0;\n    overflow: hidden;\n    position: relative;\n    height: auto;\n    -webkit-transition: all .3s ease-out; }\n");
var $s = function (n) {
    var r = n.title,
      i = n.content,
      a = n.isOpen,
      o = void 0 !== a && a,
      s = n.header,
      l = n.children,
      c = n.right,
      d = j(t(o), 2),
      u = d[0],
      p = d[1],
      m = j(t(o), 2),
      f = m[0],
      g = m[1];
    return e.createElement("div", {
      className: Zs
    }, e.createElement("section", {
      className: qs,
      onClick: function () {
        f ? g(!f) : p(!u), setTimeout(function () {
          f ? p(!u) : g(!f);
        }, 100);
      }
    }, s, e.createElement("div", {
      className: Js
    }, e.createElement(Bl, null, e.createElement(nd, {
      icon: "arrow_drop_up",
      rotate: u ? "180deg" : "90deg"
    })), e.createElement("h5", null, r), c && e.createElement(K, {
      justify: "flex-end",
      direction: "row",
      style: {
        width: "100%"
      }
    }, c))), u && e.createElement("div", {
      className: Qs,
      style: {
        maxHeight: f ? 2e3 : 0
      }
    }, i || l));
  },
  el = "style-module_filter__32x7y",
  tl = "style-module_filterHeader__AG7JJ",
  nl = "style-module_filterVisible__qtTSs",
  rl = "style-module_filterViewer__17qPm",
  il = "style-module_expandableWrapper__1RxNB",
  al = "style-module_mediaType__2pxi_",
  ol = "style-module_overlay__3k8Jm",
  sl = "style-module_overlayVisible__2n4Ew";
y(".style-module_filter__32x7y {\n  width: 266px;\n  min-height: 100vh;\n  position: sticky;\n  top: 0px;\n  margin-left: -266px;\n  background: #f3f3f3;\n  z-index: 2;\n  transition-property: margin-left;\n  transition-duration: .3s;\n  transition-delay: 0s; }\n  .style-module_filterHeader__AG7JJ {\n    background-color: #ffffff;\n    color: #222222;\n    font-size: 14px;\n    border: solid 1px #d3d3d3;\n    margin: 7px 7px 0 7px;\n    padding: 10px; }\n  .style-module_filterVisible__qtTSs {\n    margin-left: 15px;\n    min-width: 266px;\n    color: #222222; }\n  .style-module_filterViewer__17qPm {\n    padding: 1px 5px;\n    margin-right: 5px;\n    margin-top: 5px;\n    color: #3F51BF;\n    border: solid 1px #3F51BF;\n    border-radius: 3px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    max-width: 100%;\n    overflow: hidden; }\n  @media only screen and (max-width: 1080px) {\n    .style-module_filter__32x7y {\n      background: #ffffff;\n      min-height: 100%;\n      height: auto;\n      position: fixed;\n      top: 0;\n      overflow-x: hidden;\n      position: fixed;\n      left: -110vw;\n      transition-property: left;\n      transition-duration: .4s;\n      transition-delay: 0s; }\n      .style-module_filterVisible__qtTSs {\n        left: 0;\n        position: fixed; } }\n  .style-module_filter__32x7y label {\n    margin-top: 0 !important; }\n  @media only screen and (max-width: 1080px) {\n    .style-module_filter__32x7y {\n      position: fixed;\n      z-index: 200;\n      width: 366px;\n      max-width: 75vw;\n      margin-left: 0;\n      bottom: 0; } }\n  .style-module_filter__32x7y .style-module_expandableWrapper__1RxNB {\n    max-height: calc(100vh - 130px);\n    overflow-y: auto; }\n    .style-module_filter__32x7y .style-module_expandableWrapper__1RxNB h5 {\n      color: rgba(0, 0, 0, 0.87); }\n    .style-module_filter__32x7y .style-module_expandableWrapper__1RxNB label {\n      color: #222222; }\n    .style-module_filter__32x7y .style-module_expandableWrapper__1RxNB div.style-module_mediaType__2pxi_,\n    .style-module_filter__32x7y .style-module_expandableWrapper__1RxNB div.style-module_photographers__2LjYj {\n      margin: 7px 9px 7px 7px;\n      background: #ffffff; }\n    .style-module_filter__32x7y .style-module_expandableWrapper__1RxNB div.style-module_formats__c3-G6 {\n      margin: 7px;\n      background: #ffffff; }\n    .style-module_filter__32x7y .style-module_expandableWrapper__1RxNB div.style-module_modelReleased__1fwyO,\n    .style-module_filter__32x7y .style-module_expandableWrapper__1RxNB div.style-module_suppliers__2wWgo {\n      background: #ffffff;\n      margin: 7px 7px 0 7px; }\n\n.style-module_overlay__3k8Jm {\n  display: none;\n  position: fixed;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: -1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0; }\n  @media only screen and (max-width: 1080px) {\n    .style-module_overlay__3k8Jm {\n      transition-duration: .4s;\n      transition-delay: 0s; }\n      .style-module_overlayVisible__2n4Ew {\n        z-index: 150;\n        transition-property: opacity;\n        opacity: 1;\n        display: block; } }\n  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) {\n    .style-module_overlay__3k8Jm {\n      overflow-x: hidden; } }\n\n.style-module_filterActions__2gTry {\n  position: sticky;\n  top: 0;\n  background-color: #ffffff;\n  padding-bottom: 10px;\n  color: #222222; }\n  .style-module_filterActionsDDLs__3lecv {\n    margin-left: 15px;\n    overflow-x: auto; }\n    .style-module_filterActionsDDLs__3lecv::-webkit-scrollbar-thumb {\n      background-color: #ffffff; }\n    .style-module_filterActionsDDLs__3lecv::-webkit-scrollbar-track-piece {\n      background-color: #ffffff; }\n    @media only screen and (min-width: 375px) and (max-width: 667px) {\n      .style-module_filterActionsDDLs__3lecv {\n        width: 92vw; } }\n  @media only screen and (min-width: 375px) and (max-width: 667px) {\n    .style-module_filterActions__2gTry {\n      margin-top: 85px;\n      position: relative; } }\n\n.style-module_alternativeSearchWrapper__2fQjA {\n  transition: opacity .2s ease-out;\n  opacity: 0; }\n  .style-module_alternativeSearchWrapperVisible__1LvVn {\n    opacity: 1; }\n");
var ll = function (t) {
    var n = t.isVisible,
      r = t.filters,
      i = void 0 === r ? [] : r,
      a = t.toggleFilter,
      o = t.clearAll,
      s = t.children;
    return e.createElement("div", null, e.createElement("div", {
      className: "".concat(ol, " ").concat(n ? sl : ""),
      onClick: function (e) {
        return a(!1);
      }
    }), e.createElement("div", {
      className: "".concat(el, " ").concat(n ? nl : "")
    }, e.createElement(_l, {
      filters: i,
      toggleFilter: a,
      isVisible: n,
      clearAll: o
    }), e.createElement("div", {
      className: il
    }, s)));
  },
  cl = function (t) {
    t.query;
    var n = t.title,
      r = void 0 === n ? "" : n,
      i = t.isOpen,
      a = void 0 !== i && i,
      o = t.counterBadge,
      s = t.children;
    return e.createElement("div", {
      className: al
    }, e.createElement($s, {
      title: r,
      isOpen: a,
      right: o && e.createElement(Ap, {
        text: "".concat(o),
        type: "flash",
        style: {
          borderRadius: "50%",
          marginBottom: 0,
          marginRight: 10
        }
      }),
      content: s
    }));
  },
  dl = function (t) {
    var n = t.name,
      r = t.items,
      i = void 0 === r ? [] : r;
    return e.createElement(K, {
      style: {
        padding: "0 15px"
      }
    }, i.map(function (t, r) {
      var i = t.text,
        a = t.value,
        o = t.onChange,
        s = t.checked,
        l = void 0 !== s && s,
        c = t.disabled,
        d = void 0 !== c && c;
      return e.createElement("label", {
        className: ki.container,
        key: r,
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }
      }, i, e.createElement("input", {
        type: "radio",
        name: n,
        className: ki.checkbox,
        checked: l,
        disabled: d,
        value: a,
        onChange: o
      }), e.createElement("span", {
        className: ki.checkmark
      }));
    }));
  },
  ul = function (t) {
    var n = t.items,
      r = t.search,
      i = t.selected,
      a = t.onClick;
    return e.createElement(e.Fragment, null, n.filter(function (e) {
      return "" !== e.key;
    }).map(function (t, n) {
      return "" === r || -1 !== t.key.indexOf(r) ? e.createElement(K, {
        key: n,
        direction: "row",
        align: "center",
        nowrap: !0,
        justify: "space-between",
        style: {
          width: "100%"
        }
      }, e.createElement("div", {
        style: {
          cursor: "pointer",
          color: "#222",
          fontSize: "16px",
          lineHeight: "32px",
          width: "100%",
          margin: "auto -10px",
          padding: "5px 5px 5px 26px",
          backgroundColor: t.key === i ? "#d8d8d8" : "inherit"
        },
        onClick: function () {
          return a(t.value);
        }
      }, t.key)) : null;
    }));
  },
  pl = function (t) {
    var n = t.items,
      r = t.search,
      i = t.selected,
      a = t.onClick,
      o = Array.isArray(i) ? i : [i];
    return e.createElement(e.Fragment, null, n.filter(function (e) {
      return "" !== e.key;
    }).map(function (t, n) {
      return "" === r || -1 !== t.key.indexOf(r) ? e.createElement(K, {
        key: n,
        direction: "row",
        align: "center",
        nowrap: !0,
        justify: "space-between",
        style: {
          width: "100%"
        }
      }, e.createElement("div", {
        style: {
          cursor: "pointer",
          color: "#222",
          fontSize: "16px",
          lineHeight: "32px",
          width: "100%",
          margin: "auto -10px",
          padding: "5px 5px 5px 26px"
        }
      }, e.createElement("label", {
        className: xi.container
      }, t.key, e.createElement("input", {
        type: "checkbox",
        checked: (o || []).filter(function (e) {
          return t.key === e || t.value === e;
        }).length > 0,
        onChange: function (e) {
          return a({
            event: e.target,
            value: t.value
          });
        },
        className: xi.checkbox
      }), e.createElement("span", {
        className: xi.checkmark
      })))) : null;
    }));
  },
  ml = function (n) {
    var r = n.select,
      i = n.multi,
      a = void 0 !== i && i,
      o = n.searchFilter,
      s = n.selected,
      l = n.items,
      c = n.onChange,
      d = n.onClick,
      u = j(t(""), 2),
      p = u[0],
      m = u[1];
    return r ? e.createElement("div", null, e.createElement("select", {
      onChange: c,
      value: s,
      style: {
        minWidth: "fit-content"
      }
    }, l.map(function (t, n) {
      return e.createElement("option", {
        key: n,
        value: t.key
      }, t.key);
    }))) : e.createElement("div", null, o && e.createElement("input", {
      type: "text",
      onChange: function (e) {
        m(e.target.value);
      }
    }), e.createElement(K, {
      nowrap: !0
    }, a ? e.createElement(pl, {
      items: l,
      search: p,
      selected: s,
      onClick: d
    }) : e.createElement(ul, {
      items: l,
      search: p,
      selected: s,
      onClick: d
    })));
  },
  fl = function (t) {
    var n = t.date,
      r = t.onChange;
    return e.createElement(Xp, {
      date: n,
      onChange: r
    });
  };
var gl = function (t) {
    var n = t.text,
      r = t.handleClick;
    return e.createElement("div", {
      className: rl,
      onClick: r
    }, n, " ", e.createElement(nd, {
      icon: "close",
      size: "small",
      color: "#3f51bf"
    }));
  },
  _l = function (r) {
    var i = r.isVisible,
      a = r.toggleFilter,
      o = r.clearAll,
      s = r.filters,
      l = void 0 === s ? [] : s,
      c = r.filterCounter,
      d = r.totalHits,
      u = void 0 === d ? 0 : d,
      p = function () {
        if ("undefined" == typeof navigator) return !1;
        var e = j(t(!1), 2),
          r = e[0],
          i = e[1];
        return n(function () {
          i(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
        }, []), {
          isMobile: r
        };
      }().isMobile,
      m = c || function (e) {
        var t = 0;
        return e.forEach(function (e) {
          Array.isArray(e.text) ? e.text.forEach(function () {
            t += 1;
          }) : t += 1;
        }), t;
      }(l);
    return e.createElement("div", null, i && p && e.createElement(Bl, {
      padding: "10px",
      style: {
        position: "inherit",
        background: "#fff",
        left: "calc(75vw - 1px)",
        top: 82
      },
      onClick: a(!i)
    }, e.createElement(nd, {
      icon: "close"
    })), e.createElement(K, {
      direction: "row",
      align: "center",
      justify: "space-between",
      style: {
        backgroundColor: "#fff",
        width: "auto"
      }
    }, e.createElement("div", {
      style: {
        width: i ? "50%" : "auto",
        display: "flex",
        cursor: a ? "pointer" : "default",
        padding: 10,
        margin: 5,
        background: "#000",
        border: "none",
        borderRadius: "3px"
      },
      onClick: function (e) {
        a && a(!i);
      }
    }, e.createElement(nd, {
      icon: "tune",
      color: "#fff"
    }), (!p || p && 0 === m || p && i) && e.createElement("div", {
      style: {
        color: "#fff",
        marginLeft: 10
      }
    }, "Filter"), i && a && e.createElement(e.Fragment, null, e.createElement(nd, {
      style: {
        marginLeft: 25
      },
      color: "#fff",
      icon: "chevron_left"
    }))), m > 0 && e.createElement(e.Fragment, null, i && e.createElement("a", {
      style: {
        fontSize: 14,
        cursor: "pointer"
      },
      onClick: o
    }, "Rensa alla"), e.createElement(Ap, {
      text: "".concat(m),
      type: "flash",
      style: {
        margin: "0px 10px 0 0",
        borderRadius: "50%"
      }
    }))), i && e.createElement("div", {
      className: tl
    }, e.createElement(K, {
      direction: "row",
      align: "center",
      justify: "flex-start"
    }, e.createElement("div", null, m > 0 ? m : "Inga", " filter valda"), e.createElement(Vl, {
      inverted: !0
    }, e.createElement("div", null, ", ", u, " träffar"))), e.createElement(K, {
      direction: "row",
      align: "center"
    }, l.map(function (t, n) {
      var r = t.text,
        i = t.onClick;
      return Array.isArray(t.text) ? t.text.map(function (t, r) {
        return e.createElement(gl, {
          key: "".concat(n, "_").concat(r),
          text: t,
          handleClick: function (e) {
            return i(t);
          }
        });
      }) : e.createElement(gl, {
        key: n,
        text: r,
        handleClick: function (e) {
          return i(r);
        }
      });
    })), p && e.createElement(K, {
      style: {
        padding: 10,
        marginTop: 10
      },
      direction: "row",
      justify: "center"
    }, e.createElement(wd, {
      text: "Visa resultat",
      handleClick: function () {
        return a(!i);
      }
    }))));
  },
  yl = "style_toast__2gMmo",
  hl = "style_toastVisible__2bTyK",
  vl = "style_topRight__2HVnj",
  bl = "style_bottomCenter__3H-_W";
y(".style_toast__2gMmo {\n  background-color: #f00;\n  color: #fff;\n  padding: 15px;\n  border-radius: 3px;\n  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.14);\n  position: fixed;\n  z-indeX: 100000;\n  min-width: 200px;\n  -webkit-transition: background-color 1s ease-out;\n  -moz-transition: background-color 1s ease-out;\n  -o-transition: background-color 1s ease-out; }\n  .style_toastVisible__2bTyK {\n    background-color: rgba(25, 25, 25, 0.84); }\n\n.style_topRight__2HVnj {\n  right: 15px;\n  top: 87px; }\n\n.style_bottomCenter__3H-_W {\n  margin-left: calc(50vw - 100px);\n  bottom: 40px; }\n");
var xl = function (t) {
    var n = t.message,
      r = void 0 === n ? "Hej!" : n,
      i = t.visible,
      a = t.level,
      o = void 0 === a ? "info" : a,
      s = t.reset,
      l = t.ttninjs,
      c = t.position,
      d = void 0 === c ? "topRight" : c;
    return e.createElement("div", {
      style: {
        backgroundcolor: "info" === o ? "rgba(25, 25, 25, 0)" : "red"
      },
      className: "".concat(yl, " ").concat(i ? hl : "", " ").concat("topRight" === d ? vl : bl)
    }, e.createElement(K, null, e.createElement("span", {
      onClick: function (e) {
        return s ? s() : null;
      }
    }, e.createElement(nd, {
      icon: "clear",
      color: "#fff",
      style: {
        cursor: "pointer"
      }
    })), l ? e.createElement(vp, {
      density: "story",
      ttninjs: l
    }) : e.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: r
      }
    })));
  },
  El = re(function (e) {
    !function (t, n) {
      var r = function (e, t, n) {
        var r, i;
        if (function () {
          var t,
            n = {
              lazyClass: "lazyload",
              loadedClass: "lazyloaded",
              loadingClass: "lazyloading",
              preloadClass: "lazypreload",
              errorClass: "lazyerror",
              autosizesClass: "lazyautosizes",
              fastLoadedClass: "ls-is-cached",
              iframeLoadMode: 0,
              srcAttr: "data-src",
              srcsetAttr: "data-srcset",
              sizesAttr: "data-sizes",
              minSize: 40,
              customMedia: {},
              init: !0,
              expFactor: 1.5,
              hFac: .8,
              loadMode: 2,
              loadHidden: !0,
              ricTimeout: 0,
              throttleDelay: 125
            };
          for (t in i = e.lazySizesConfig || e.lazysizesConfig || {}, n) t in i || (i[t] = n[t]);
        }(), !t || !t.getElementsByClassName) return {
          init: function () {},
          cfg: i,
          noSupport: !0
        };
        var a = t.documentElement,
          o = e.HTMLPictureElement,
          s = "addEventListener",
          l = "getAttribute",
          c = e[s].bind(e),
          d = e.setTimeout,
          u = e.requestAnimationFrame || d,
          p = e.requestIdleCallback,
          m = /^picture$/i,
          f = ["load", "error", "lazyincluded", "_lazyloaded"],
          g = {},
          _ = Array.prototype.forEach,
          y = function (e, t) {
            return g[t] || (g[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), g[t].test(e[l]("class") || "") && g[t];
          },
          h = function (e, t) {
            y(e, t) || e.setAttribute("class", (e[l]("class") || "").trim() + " " + t);
          },
          v = function (e, t) {
            var n;
            (n = y(e, t)) && e.setAttribute("class", (e[l]("class") || "").replace(n, " "));
          },
          b = function (e, t, n) {
            var r = n ? s : "removeEventListener";
            n && b(e, t), f.forEach(function (n) {
              e[r](n, t);
            });
          },
          x = function (e, n, i, a, o) {
            var s = t.createEvent("Event");
            return i || (i = {}), i.instance = r, s.initEvent(n, !a, !o), s.detail = i, e.dispatchEvent(s), s;
          },
          E = function (t, n) {
            var r;
            !o && (r = e.picturefill || i.pf) ? (n && n.src && !t[l]("srcset") && t.setAttribute("srcset", n.src), r({
              reevaluate: !0,
              elements: [t]
            })) : n && n.src && (t.src = n.src);
          },
          k = function (e, t) {
            return (getComputedStyle(e, null) || {})[t];
          },
          T = function (e, t, n) {
            for (n = n || e.offsetWidth; n < i.minSize && t && !e._lazysizesWidth;) n = t.offsetWidth, t = t.parentNode;
            return n;
          },
          w = (he = [], ve = [], be = he, xe = function () {
            var e = be;
            for (be = he.length ? ve : he, _e = !0, ye = !1; e.length;) e.shift()();
            _e = !1;
          }, Ee = function (e, n) {
            _e && !n ? e.apply(this, arguments) : (be.push(e), ye || (ye = !0, (t.hidden ? d : u)(xe)));
          }, Ee._lsFlush = xe, Ee),
          A = function (e, t) {
            return t ? function () {
              w(e);
            } : function () {
              var t = this,
                n = arguments;
              w(function () {
                e.apply(t, n);
              });
            };
          },
          C = function (e) {
            var t,
              r = 0,
              a = i.throttleDelay,
              o = i.ricTimeout,
              s = function () {
                t = !1, r = n.now(), e();
              },
              l = p && o > 49 ? function () {
                p(s, {
                  timeout: o
                }), o !== i.ricTimeout && (o = i.ricTimeout);
              } : A(function () {
                d(s);
              }, !0);
            return function (e) {
              var i;
              (e = !0 === e) && (o = 33), t || (t = !0, (i = a - (n.now() - r)) < 0 && (i = 0), e || i < 9 ? l() : d(l, i));
            };
          },
          S = function (e) {
            var t,
              r,
              i = 99,
              a = function () {
                t = null, e();
              },
              o = function () {
                var e = n.now() - r;
                e < i ? d(o, i - e) : (p || a)(a);
              };
            return function () {
              r = n.now(), t || (t = d(o, i));
            };
          },
          N = (K = /^img$/i, Z = /^iframe$/i, q = "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent), J = 0, Q = 0, $ = 0, ee = -1, te = function (e) {
            $--, (!e || $ < 0 || !e.target) && ($ = 0);
          }, ne = function (e) {
            return null == Y && (Y = "hidden" == k(t.body, "visibility")), Y || !("hidden" == k(e.parentNode, "visibility") && "hidden" == k(e, "visibility"));
          }, re = function (e, n) {
            var r,
              i = e,
              o = ne(e);
            for (W -= n, V += n, X -= n, G += n; o && (i = i.offsetParent) && i != t.body && i != a;) (o = (k(i, "opacity") || 1) > 0) && "visible" != k(i, "overflow") && (r = i.getBoundingClientRect(), o = G > r.left && X < r.right && V > r.top - 1 && W < r.bottom + 1);
            return o;
          }, ie = function () {
            var e,
              n,
              o,
              s,
              c,
              d,
              u,
              p,
              m,
              f,
              g,
              _,
              y = r.elements;
            if ((B = i.loadMode) && $ < 8 && (e = y.length)) {
              for (n = 0, ee++; n < e; n++) if (y[n] && !y[n]._lazyRace) if (!q || r.prematureUnveil && r.prematureUnveil(y[n])) pe(y[n]);else if ((p = y[n][l]("data-expand")) && (d = 1 * p) || (d = Q), f || (f = !i.expand || i.expand < 1 ? a.clientHeight > 500 && a.clientWidth > 500 ? 500 : 370 : i.expand, r._defEx = f, g = f * i.expFactor, _ = i.hFac, Y = null, Q < g && $ < 1 && ee > 2 && B > 2 && !t.hidden ? (Q = g, ee = 0) : Q = B > 1 && ee > 1 && $ < 6 ? f : J), m !== d && (z = innerWidth + d * _, U = innerHeight + d, u = -1 * d, m = d), o = y[n].getBoundingClientRect(), (V = o.bottom) >= u && (W = o.top) <= U && (G = o.right) >= u * _ && (X = o.left) <= z && (V || G || X || W) && (i.loadHidden || ne(y[n])) && (M && $ < 3 && !p && (B < 3 || ee < 4) || re(y[n], d))) {
                if (pe(y[n]), c = !0, $ > 9) break;
              } else !c && M && !s && $ < 4 && ee < 4 && B > 2 && (F[0] || i.preloadAfterLoad) && (F[0] || !p && (V || G || X || W || "auto" != y[n][l](i.sizesAttr))) && (s = F[0] || y[n]);
              s && !c && pe(s);
            }
          }, ae = C(ie), oe = function (e) {
            var t = e.target;
            t._lazyCache ? delete t._lazyCache : (te(e), h(t, i.loadedClass), v(t, i.loadingClass), b(t, le), x(t, "lazyloaded"));
          }, se = A(oe), le = function (e) {
            se({
              target: e.target
            });
          }, ce = function (e, t) {
            var n = e.getAttribute("data-load-mode") || i.iframeLoadMode;
            0 == n ? e.contentWindow.location.replace(t) : 1 == n && (e.src = t);
          }, de = function (e) {
            var t,
              n = e[l](i.srcsetAttr);
            (t = i.customMedia[e[l]("data-media") || e[l]("media")]) && e.setAttribute("media", t), n && e.setAttribute("srcset", n);
          }, ue = A(function (e, t, n, r, a) {
            var o, s, c, u, p, f;
            (p = x(e, "lazybeforeunveil", t)).defaultPrevented || (r && (n ? h(e, i.autosizesClass) : e.setAttribute("sizes", r)), s = e[l](i.srcsetAttr), o = e[l](i.srcAttr), a && (u = (c = e.parentNode) && m.test(c.nodeName || "")), f = t.firesLoad || "src" in e && (s || o || u), p = {
              target: e
            }, h(e, i.loadingClass), f && (clearTimeout(P), P = d(te, 2500), b(e, le, !0)), u && _.call(c.getElementsByTagName("source"), de), s ? e.setAttribute("srcset", s) : o && !u && (Z.test(e.nodeName) ? ce(e, o) : e.src = o), a && (s || u) && E(e, {
              src: o
            })), e._lazyRace && delete e._lazyRace, v(e, i.lazyClass), w(function () {
              var t = e.complete && e.naturalWidth > 1;
              f && !t || (t && h(e, i.fastLoadedClass), oe(p), e._lazyCache = !0, d(function () {
                "_lazyCache" in e && delete e._lazyCache;
              }, 9)), "lazy" == e.loading && $--;
            }, !0);
          }), pe = function (e) {
            if (!e._lazyRace) {
              var t,
                n = K.test(e.nodeName),
                r = n && (e[l](i.sizesAttr) || e[l]("sizes")),
                a = "auto" == r;
              (!a && M || !n || !e[l]("src") && !e.srcset || e.complete || y(e, i.errorClass) || !y(e, i.lazyClass)) && (t = x(e, "lazyunveilread").detail, a && O.updateElem(e, !0, e.offsetWidth), e._lazyRace = !0, $++, ue(e, t, a, r, n));
            }
          }, me = S(function () {
            i.loadMode = 3, ae();
          }), fe = function () {
            3 == i.loadMode && (i.loadMode = 2), me();
          }, ge = function () {
            M || (n.now() - H < 999 ? d(ge, 999) : (M = !0, i.loadMode = 3, ae(), c("scroll", fe, !0)));
          }, {
            _: function () {
              H = n.now(), r.elements = t.getElementsByClassName(i.lazyClass), F = t.getElementsByClassName(i.lazyClass + " " + i.preloadClass), c("scroll", ae, !0), c("resize", ae, !0), c("pageshow", function (e) {
                if (e.persisted) {
                  var n = t.querySelectorAll("." + i.loadingClass);
                  n.length && n.forEach && u(function () {
                    n.forEach(function (e) {
                      e.complete && pe(e);
                    });
                  });
                }
              }), e.MutationObserver ? new MutationObserver(ae).observe(a, {
                childList: !0,
                subtree: !0,
                attributes: !0
              }) : (a[s]("DOMNodeInserted", ae, !0), a[s]("DOMAttrModified", ae, !0), setInterval(ae, 999)), c("hashchange", ae, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function (e) {
                t[s](e, ae, !0);
              }), /d$|^c/.test(t.readyState) ? ge() : (c("load", ge), t[s]("DOMContentLoaded", ae), d(ge, 2e4)), r.elements.length ? (ie(), w._lsFlush()) : ae();
            },
            checkElems: ae,
            unveil: pe,
            _aLSL: fe
          }),
          O = (L = A(function (e, t, n, r) {
            var i, a, o;
            if (e._lazysizesWidth = r, r += "px", e.setAttribute("sizes", r), m.test(t.nodeName || "")) for (a = 0, o = (i = t.getElementsByTagName("source")).length; a < o; a++) i[a].setAttribute("sizes", r);
            n.detail.dataAttr || E(e, n.detail);
          }), j = function (e, t, n) {
            var r,
              i = e.parentNode;
            i && (n = T(e, i, n), (r = x(e, "lazybeforesizes", {
              width: n,
              dataAttr: !!t
            })).defaultPrevented || (n = r.detail.width) && n !== e._lazysizesWidth && L(e, i, r, n));
          }, D = S(function () {
            var e,
              t = I.length;
            if (t) for (e = 0; e < t; e++) j(I[e]);
          }), {
            _: function () {
              I = t.getElementsByClassName(i.autosizesClass), c("resize", D);
            },
            checkElems: D,
            updateElem: j
          }),
          R = function () {
            !R.i && t.getElementsByClassName && (R.i = !0, O._(), N._());
          };
        var I, L, j, D;
        var F, M, P, B, H, z, U, W, X, G, V, Y, K, Z, q, J, Q, $, ee, te, ne, re, ie, ae, oe, se, le, ce, de, ue, pe, me, fe, ge;
        var _e, ye, he, ve, be, xe, Ee;
        return d(function () {
          i.init && R();
        }), r = {
          cfg: i,
          autoSizer: O,
          loader: N,
          init: R,
          uP: E,
          aC: h,
          rC: v,
          hC: y,
          fire: x,
          gW: T,
          rAF: w
        };
      }(t, t.document, Date);
      t.lazySizes = r, e.exports && (e.exports = r);
    }("undefined" != typeof window ? window : {});
  });
re(function (e) {
  !function (t, n) {
    if (t) {
      var r = function () {
        n(t.lazySizes), t.removeEventListener("lazyunveilread", r, !0);
      };
      n = n.bind(null, t, t.document), e.exports ? n(El) : t.lazySizes ? r() : t.addEventListener("lazyunveilread", r, !0);
    }
  }("undefined" != typeof window ? window : 0, function (e, t, n) {
    var r = function () {
      var i,
        a,
        o,
        s,
        l,
        c,
        d,
        u = n.cfg,
        p = {
          "data-bgset": 1,
          "data-include": 1,
          "data-poster": 1,
          "data-bg": 1,
          "data-script": 1
        },
        m = "(\\s|^)(" + u.loadedClass,
        f = t.documentElement,
        g = function (e) {
          n.rAF(function () {
            n.rC(e, u.loadedClass), u.unloadedClass && n.rC(e, u.unloadedClass), n.aC(e, u.lazyClass), ("none" == e.style.display || e.parentNode && "none" == e.parentNode.style.display) && setTimeout(function () {
              n.loader.unveil(e);
            }, 0);
          });
        },
        _ = function (e) {
          var t, n, r, i;
          for (t = 0, n = e.length; t < n; t++) (i = (r = e[t]).target).getAttribute(r.attributeName) && ("source" == i.localName && i.parentNode && (i = i.parentNode.querySelector("img")), i && m.test(i.className) && g(i));
        };
      u.unloadedClass && (m += "|" + u.unloadedClass), m += "|" + u.loadingClass + ")(\\s|$)", m = new RegExp(m), p[u.srcAttr] = 1, p[u.srcsetAttr] = 1, e.MutationObserver ? (o = new MutationObserver(_), i = function () {
        s || (s = !0, o.observe(f, {
          subtree: !0,
          attributes: !0,
          attributeFilter: Object.keys(p)
        }));
      }, a = function () {
        s && (s = !1, o.disconnect());
      }) : (f.addEventListener("DOMAttrModified", (c = [], d = function () {
        _(c), c = [], l = !1;
      }, function (e) {
        s && p[e.attrName] && e.newValue && (c.push({
          target: e.target,
          attributeName: e.attrName
        }), l || (setTimeout(d), l = !0));
      }), !0), i = function () {
        s = !0;
      }, a = function () {
        s = !1;
      }), addEventListener("lazybeforeunveil", a, !0), addEventListener("lazybeforeunveil", i), addEventListener("lazybeforesizes", a, !0), addEventListener("lazybeforesizes", i), i(), removeEventListener("lazybeforeunveil", r);
    };
    addEventListener("lazybeforeunveil", r);
  });
});
var kl = {
  wrapper: "style_wrapper__1p4Yv",
  lazyload: "style_lazyload__1zZfh",
  lazyloading: "style_lazyloading__2gZjs",
  lazyloaded: "style_lazyloaded__IehUi",
  fadein: "style_fadein__2UIEz",
  lazyerror: "style_lazyerror__16IP1"
};
y("@keyframes style_fadein__2UIEz {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n/* Firefox < 16 */\n@-moz-keyframes style_fadein__2UIEz {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n/* Safari, Chrome and Opera > 12.1 */\n@-webkit-keyframes style_fadein__2UIEz {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n/* Internet Explorer */\n@-ms-keyframes style_fadein__2UIEz {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n/* Opera < 12.1 */\n@-o-keyframes style_fadein__2UIEz {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.style_wrapper__1p4Yv {\n  min-height: 76px;\n  max-height: 76px;\n  min-width: 76px;\n  max-width: 76px;\n  height: 76px;\n  width: 76px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  alignt-items: center;\n  background-color: #efefef; }\n\n/* fade image in after load */\n.style_lazyload__1zZfh,\n.style_lazyloading__2gZjs {\n  opacity: 0; }\n\n.style_lazyloaded__IehUi {\n  -webkit-animation: style_fadein__2UIEz 2s;\n  /* Safari, Chrome and Opera > 12.1 */\n  -moz-animation: style_fadein__2UIEz 2s;\n  /* Firefox < 16 */\n  -ms-animation: style_fadein__2UIEz 2s;\n  /* Internet Explorer */\n  -o-animation: style_fadein__2UIEz 2s;\n  /* Opera < 12.1 */\n  animation: style_fadein__2UIEz 2s; }\n\n.style_lazyerror__16IP1 {\n  opacity: 1;\n  background-color: red; }\n"), El.cfg.loadMode = 1, El.cfg.lazyClass = kl.lazyload, El.cfg.loadedClass = kl.lazyloaded, El.cfg.errorClass = kl.lazyeror;
var Tl = function (t) {
    var r = t.src;
    return n(function () {
      document.addEventListener("lazybeforeunveil", function (e) {});
    }, []), e.createElement("div", {
      className: kl.wrapper
    }, e.createElement("img", {
      "data-src": r,
      className: kl.lazyload,
      style: {
        height: 76
      },
      alt: ""
    }));
  },
  wl = {
    articleContainer: "style_articleContainer__1Z8-4",
    blockquoteMarker: "style_blockquoteMarker__IVj1R",
    unorderedList: "style_unorderedList__4_UM7"
  };
y("article.style_articleContainer__1Z8-4 {\n  margin: 0 auto;\n  padding: 30px 25px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  max-width: 650px; }\n\narticle.style_articleContainer__1Z8-4 .style_blockquoteMarker__IVj1R {\n  font-family: Montserrat medium;\n  color: #5b8c79;\n  display: flex;\n  align-self: center;\n  font-size: 92px;\n  margin: 25px; }\n\narticle.style_articleContainer__1Z8-4 blockquote {\n  font-size: 26px;\n  line-height: 35px;\n  letter-spacing: 0;\n  color: #222222; }\n\narticle.style_articleContainer__1Z8-4 .style_unorderedList__4_UM7 {\n  font-size: 20px;\n  color: #222222; }\n\narticle.style_articleContainer__1Z8-4 hr {\n  border: none;\n  border-bottom: solid 1px #D8D8D8;\n  width: 100%; }\n\narticle.style_articleContainer__1Z8-4 strong {\n  color: #000; }\n\n/* MQ 768px max */\n@media screen and (max-width: 768px) {\n  article.style_articleContainer__1Z8-4 h3 {\n    font-size: 20px; }\n  article.style_articleContainer__1Z8-4 p {\n    font-size: 18px;\n    margin: 9px 0; }\n  article.style_articleContainer__1Z8-4 .style_unorderedList__4_UM7 {\n    font-size: 18px; }\n  article.style_articleContainer__1Z8-4 .style_blockquoteMarker__IVj1R {\n    font-size: 72px;\n    margin: 10px 0 0; }\n  article.style_articleContainer__1Z8-4 blockquote {\n    font-size: 22px;\n    margin: 20px;\n    text-align: center; } }\n\n@media screen and (max-width: 350px) {\n  article.style_articleContainer__1Z8-4 p {\n    font-size: 16px; }\n  article.style_articleContainer__1Z8-4 .style_unorderedList__4_UM7 {\n    font-size: 16px; }\n  article.style_articleContainer__1Z8-4 blockquote {\n    font-size: 18px;\n    margin: 0; }\n  article.style_articleContainer__1Z8-4 .style_blockquoteMarker__IVj1R {\n    font-size: 52px;\n    margin: 0; } }\n");
var Al = function (t) {
    var n = t.article;
    return n ? e.createElement("article", {
      className: wl.articleContainer
    }, n.content.map(function (t) {
      switch (t.nodeType) {
        case "heading-1":
          return n = t.content[0].value, e.createElement("h1", null, n);
        case "heading-2":
          return function (t) {
            return e.createElement("h2", null, t);
          }(t.content[0].value);
        case "heading-3":
          return function (t) {
            return e.createElement("h3", null, t);
          }(t.content[0].value);
        case "paragraph":
          return function (t, n) {
            return e.createElement("p", {
              key: n
            }, e.createElement("span", {
              key: n
            }, t.map(function (t, n) {
              return "hyperlink" === t.nodeType ? e.createElement("a", {
                key: n,
                href: t.data.uri
              }, t.content[0].value) : t.marks.length > 0 && "bold" === t.marks[0].type ? e.createElement("span", {
                key: n
              }, e.createElement("strong", null, t.value)) : t.marks.length > 0 && "italics" === t.marks[0].type ? e.createElement("span", {
                key: n
              }, e.createElement("em", null, t.value)) : t.value;
            })));
          }(t.content);
        case "hr":
          return e.createElement("hr", null);
        case "unordered-list":
          return function (t) {
            return e.createElement("ul", {
              className: wl.unorderedList
            }, t.map(function (t, n) {
              return e.createElement("li", {
                key: n
              }, t.content[0].content[0].value);
            }));
          }(t.content);
        case "embedded-asset-block":
          return function (t) {
            var n = t.title ? t.title : "";
            return e.createElement("img", {
              alt: n,
              src: t.file.url,
              style: {
                maxWidth: "100%"
              }
            });
          }(t.data.target.fields);
        case "blockquote":
          return function (t) {
            return e.createElement(e.Fragment, null, e.createElement("div", {
              className: wl.blockquoteMarker
            }, '"'), e.createElement("blockquote", {
              className: wl.blockquote
            }, t.map(function (t, n) {
              return e.createElement("div", {
                key: n
              }, t.content[0].value);
            })));
          }(t.content);
      }
      var n;
    })) : null;
  },
  Cl = "tabs_tabWrapper__2MApS",
  Sl = "tabs_tab__zwqux",
  Nl = "tabs_activeTab__3nrDP",
  Ol = "tabs_tabContent__VuaUH",
  Rl = "tabs_stretch__13JzR";
y(".tabs_tabWrapper__2MApS {\n  margin-bottom: 20px; }\n\n.tabs_tab__zwqux {\n  padding: 20px 100px 30px 20px;\n  border: solid 1px #ececec;\n  background-color: #f8f8f8;\n  font-weight: 700;\n  cursor: pointer; }\n\n.tabs_activeTab__3nrDP {\n  cursor: unset;\n  border-top: solid 4px #3d50c1;\n  border-bottom: none;\n  background-color: #fff;\n  margin-bottom: -2px; }\n\n.tabs_tabContent__VuaUH {\n  border: solid 1px #ececec;\n  padding: 20px;\n  background-color: #fff; }\n\n.tabs_stretch__13JzR {\n  width: 100%; }\n");
var Il = function (r) {
    var i = r.data,
      a = void 0 === i ? [] : i,
      o = r.headers,
      s = void 0 === o ? [] : o,
      l = r.active,
      c = void 0 === l ? 0 : l,
      d = r.children,
      u = void 0 === d ? [] : d,
      p = r.stretch,
      m = void 0 !== p && p,
      f = j(t(c), 2),
      g = f[0],
      _ = f[1];
    return n(function () {
      _(c);
    }, [c]), e.createElement("div", {
      className: "".concat(Cl, " ").concat(m ? Rl : "")
    }, e.createElement(K, {
      direction: "row"
    }, a.map && a.map(function (t, n) {
      return e.createElement("div", {
        onClick: function (e) {
          _(t.name);
        },
        key: n,
        className: "".concat(Sl, " ").concat(g === n ? Nl : "")
      }, t.tab);
    }), s.map && s.map(function (t, n) {
      return e.createElement("div", {
        onClick: function (e) {
          _(n), t.ref && t.ref.current.click();
        },
        key: n,
        className: "".concat(Sl, " ").concat(g === n ? Nl : "")
      }, t);
    })), u.map && u.map(function (t, n) {
      return g === n ? e.createElement("div", {
        key: n,
        className: Ol
      }, t) : null;
    }));
  },
  Ll = "style_zoneWrapper__rf4iJ",
  jl = "style_zoneWrapperDark__2_uGJ",
  Dl = "style_zoneWrapperBright__1V-AI",
  Fl = "style_isStatic__uDjWZ";
function Ml(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Pl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ml(Object(n), !0).forEach(function (t) {
      X(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ml(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.style_zoneWrapper__rf4iJ {\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  padding: 14px;\n  width: fit-content;\n  -webkit-transition: background-color .4s ease-out;\n  -moz-transition: background-color .4s ease-out;\n  -o-transition: background-color .4s ease-out; }\n  .style_zoneWrapper__rf4iJ > div {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    flex-direction: column; }\n  .style_zoneWrapper__rf4iJ:hover {\n    background-color: #E8E8E8; }\n    .style_zoneWrapper__rf4iJ:hover a:hover {\n      color: #2E3B8C !important; }\n  .style_zoneWrapperDark__2_uGJ:hover {\n    background-color: #292929; }\n    .style_zoneWrapperDark__2_uGJ:hover a:hover {\n      color: #7E90FF !important; }\n  .style_zoneWrapperBright__1V-AI:hover {\n    background-color: #E8E8E8; }\n    .style_zoneWrapperBright__1V-AI:hover a:hover {\n      color: #7E90FF !important; }\n\n.style_isStatic__uDjWZ {\n  cursor: default; }\n  .style_isStatic__uDjWZ:hover {\n    background-color: rgba(0, 0, 0, 0); }\n');
var Bl = function (t) {
    var n = t.children,
      r = t.isStatic,
      i = void 0 !== r && r,
      a = t.padding,
      o = t.onClick,
      s = t.theme,
      l = void 0 === s ? "bright" : s,
      c = t.rounded,
      d = t.stretch,
      u = t.style;
    return e.createElement("div", {
      style: Pl(Pl({}, u), {}, {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: a && !c ? a : 10,
        width: d ? "auto" : "none",
        borderRadius: c ? "50%" : "0"
      }),
      className: "".concat(Ll, " ").concat(l.toLowerCase && "dark" === l.toLowerCase() ? jl : l.toLowerCase && "bright" === l.toLowerCase() ? Dl : "", " ").concat(i ? Fl : ""),
      onClick: o || null
    }, e.createElement("div", null, n));
  },
  Hl = "style_hoverWrapper__n7jg8";
function zl(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ul(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? zl(Object(n), !0).forEach(function (t) {
      X(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zl(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.style_hoverWrapper__n7jg8 {\n  position: fixed;\n  background-color: #434242;\n  color: #fff;\n  padding: 8px;\n  font-size: 14px;\n  z-index: 10001;\n  min-width: 120px;\n  text-align: center; }\n');
var Wl = function (r) {
    var i = r.children,
      a = r.bubble,
      o = r.style,
      s = j(t(!1), 2),
      l = s[0],
      d = s[1],
      u = j(t(), 2),
      p = u[0],
      m = u[1],
      f = j(t(), 2),
      g = f[0],
      _ = f[1],
      y = c(null),
      h = c(null),
      v = function () {
        var e = j(t({
            width: void 0,
            height: void 0
          }), 2),
          r = e[0],
          i = e[1];
        return n(function () {
          if ("undefined" != typeof window) {
            var e = function () {
              i({
                width: window.innerWidth,
                height: window.innerHeight
              });
            };
            return window.addEventListener("resize", e), e(), function () {
              return window.removeEventListener("resize", e);
            };
          }
        }, []), r;
      }();
    return e.createElement(e.Fragment, null, e.createElement("div", {
      onMouseEnter: function (e) {
        if (y) {
          var t = y.current.getBoundingClientRect();
          m(t.bottom + 10), _(t.left - 16 - t.width / 2), d(!0), setTimeout(function () {
            var e = h.current.getBoundingClientRect();
            e.right > v.width && _(t.right - e.width), e.left < 0 && _(t.left);
          }, 1);
        }
      },
      onMouseLeave: function (e) {
        return d(!1);
      },
      onClick: function (e) {
        return d(!1);
      },
      ref: y
    }, i), e.createElement("div", {
      ref: h,
      style: Ul(Ul({}, o), {}, {
        display: l ? "block" : "none",
        top: p,
        left: g
      }),
      className: "".concat(Hl)
    }, a));
  },
  Xl = "style_responsive__1TpBi",
  Gl = "style_inverted__jiFs0";
y("@media only screen and (max-width: 667px) {\n  .style_responsive__1TpBi {\n    display: none !important; } }\n\n@media only screen and (min-width: 668px) {\n  .style_inverted__jiFs0 {\n    display: none; } }\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {\n  .style_inverted__jiFs0 {\n    display: block; } }\n");
var Vl = function (t) {
    var n = t.inverted,
      r = t.style;
    return e.createElement("div", {
      style: r,
      className: n ? Gl : Xl
    }, t.children);
  },
  Yl = "sidebar_sidebar__2069T",
  Kl = "sidebar_sidebarVisible__2HBCy",
  Zl = "sidebar_noHeader__1P3Zo",
  ql = "sidebar_sidebarRight__1l2sS",
  Jl = "sidebar_sidebarRightVisible__fBwPE";
y(".sidebar_sidebar__2069T {\n  width: 0;\n  max-height: calc(100vh - 120px);\n  margin-right: 0;\n  overflow-x: hidden;\n  position: relative;\n  opacity: 0; }\n  .sidebar_sidebarVisible__2HBCy {\n    opacity: 1;\n    width: 400px; }\n  .sidebar_sidebar__2069T.sidebar_noHeader__1P3Zo {\n    min-height: calc(100vh - 105px);\n    max-height: calc(100vh - 105px); }\n\n.sidebar_sidebarRight__1l2sS {\n  width: 0;\n  min-height: calc(100vh - 73px);\n  max-height: calc(100vh - 73px);\n  margin-right: 0;\n  overflow-x: hidden;\n  position: relative;\n  opacity: 0; }\n  .sidebar_sidebarRightVisible__fBwPE {\n    opacity: 1; }\n  .sidebar_sidebarRight__1l2sS.sidebar_noHeader__1P3Zo {\n    min-height: calc(100vh - 73px);\n    max-height: calc(100vh - 73px); }\n");
var Ql = function (t) {
    var n = t.visible,
      r = void 0 !== n && n,
      i = t.position,
      a = void 0 === i ? "left" : i,
      o = t.width,
      s = void 0 === o ? 320 : o,
      l = t.sticky,
      c = t.content,
      d = t.style,
      u = void 0 === d ? {} : d,
      p = t.noHeader,
      m = t.headerOnClose,
      f = t.headerTitle,
      g = l ? {
        position: "sticky",
        top: l,
        zIndex: 2
      } : {},
      _ = Object.assign({}, u, g);
    return e.createElement("div", {
      style: _
    }, "left" === a ? e.createElement("div", {
      style: {
        width: s,
        overflow: "auto"
      },
      className: "".concat(Yl, " ").concat(p ? Zl : "", "  ").concat(r ? Kl : "")
    }, f ? e.createElement(C, {
      noLogo: !0,
      level: "secondary",
      left: e.createElement("h5", {
        style: {
          padding: 0,
          margin: 0,
          marginTop: -40
        }
      }, f),
      right: e.createElement("div", {
        onClick: function (e) {
          m();
        }
      }, e.createElement(Bl, null, e.createElement(nd, {
        icon: "clear"
      })))
    }) : null, e.createElement("div", null, c)) : e.createElement("div", {
      style: {
        position: "sticky",
        top: 0,
        width: s,
        overflow: "auto"
      },
      className: "".concat(ql, " ").concat(r ? Jl : "")
    }, e.createElement("div", null, c)));
  },
  $l = {
    popoverOverlay: "popover_popoverOverlay__3AR6_",
    popoverWrapper: "popover_popoverWrapper__2VUbX",
    popoverTrigger: "popover_popoverTrigger__1y6C1",
    popoverContent: "popover_popoverContent__2ZLX1",
    "popoverContent-right": "popover_popoverContent-right__2p7mj"
  };
function ec(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
y(".popover_popoverOverlay__3AR6_ {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.2);\n  position: absolute; }\n\n.popover_popoverWrapper__2VUbX {\n  width: auto;\n  margin: 0; }\n\n.popover_popoverTrigger__1y6C1 {\n  padding: 0 !important; }\n\n.popover_popoverContent__2ZLX1 {\n  position: absolute;\n  background: #fff;\n  width: fit-content;\n  padding: 0;\n  margin-top: 0;\n  margin-right: 20px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n  z-index: 100; }\n\n.popover_popoverContent-right__2p7mj {\n  right: 0;\n  max-width: 300px; }\n");
var tc = function (t) {
    ee(r, a);
    var n = ec(r);
    function r(t) {
      var i;
      return q(this, r), (i = n.call(this, t)).state = {
        visible: !1,
        outside: !1
      }, i.wrapperRef = e.createRef(), i.triggerRef = e.createRef(), i.contentRef = e.createRef(), i.setPosition = i.setPosition.bind(oe(i)), i.handleClickOutside = i.handleClickOutside.bind(oe(i)), i;
    }
    return Q(r, [{
      key: "setPosition",
      value: function () {
        var e = this.contentRef.current.getBoundingClientRect().right > window.innerWidth;
        this.setState({
          outside: e
        });
      }
    }, {
      key: "handleClickOutside",
      value: function (e) {
        this.wrapperRef.current && !this.wrapperRef.current.contains(e.target) && this.setState({
          visible: !1,
          outside: !1
        });
      }
    }, {
      key: "componentDidMount",
      value: function () {
        document.addEventListener("mousedown", this.handleClickOutside);
      }
    }, {
      key: "componentDidUpdate",
      value: function () {
        this.state.visible || this.setState({
          outside: !1
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        document.removeEventListener("mousedown", this.handleClickOutside);
      }
    }, {
      key: "shouldComponentUpdate",
      value: function (e, t) {
        return e.children !== this.props.children || t.visible !== this.state.visible || t.outside !== this.state.outside || e.content !== this.props.content;
      }
    }, {
      key: "render",
      value: function () {
        var t = this,
          n = this.props,
          r = n.overlay,
          i = void 0 !== r && r,
          a = n.trigger,
          o = n.content,
          s = n.slim,
          l = n.keepOpen,
          c = void 0 !== l && l,
          d = n.children,
          u = n.zonePadding,
          p = n.theme,
          m = void 0 === p ? "bright" : p,
          f = n.rounded,
          g = void 0 !== f && f,
          _ = this.state,
          y = _.visible,
          h = _.outside;
        return e.createElement("div", {
          ref: this.wrapperRef,
          className: $l.popoverWrapper,
          onClick: function () {
            return c ? null : t.setState({
              visible: !y
            });
          }
        }, e.createElement("div", {
          className: $l.popoverTrigger,
          ref: this.triggerRef,
          onClick: function () {
            setTimeout(function () {
              t.setState({
                visible: !y
              }), t.setPosition();
            }, 1);
          }
        }, s ? e.createElement(Bl, {
          theme: m,
          rounded: g,
          padding: 0
        }, a) : e.createElement(Bl, {
          theme: m,
          rounded: g,
          padding: u
        }, a)), e.createElement("div", null, i ? e.createElement("div", {
          className: $l.popoverOverlay,
          onClick: function () {
            return t.setState({
              visible: !1
            });
          }
        }) : null, e.createElement("div", {
          ref: this.contentRef,
          className: "".concat($l.popoverContent, " ").concat($l["popoverContent-bottom"]),
          style: {
            position: "absolute",
            display: y ? "inherit" : "none",
            right: h ? 0 : "auto"
          }
        }, o || d)));
      }
    }]), r;
  }(),
  nc = "dashboard_columnHeader__3n88D",
  rc = "dashboard_heading__1RZP0",
  ic = "dashboard_subHeading__3MRuN",
  ac = "dashboard_subHeader__2i0wq",
  oc = "dashboard_sunday__LIiaR",
  sc = "dashboard_resultList__1moXs",
  lc = "dashboard_resultListActive__3-DEY",
  cc = "dashboard_resultListHidden__Ksmki",
  dc = "dashboard_title__1YAjR",
  uc = "dashboard_cards__3ITmp";
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.dashboard_columnHeader__3n88D {\n  padding: 15px;\n  margin: 0; }\n\n.dashboard_heading__1RZP0 {\n  font-family: Roboto;\n  font-size: 22px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.06;\n  letter-spacing: normal;\n  color: rgba(0, 0, 0, 0.87); }\n\n.dashboard_subHeading__3MRuN {\n  font-size: 12px;\n  line-height: 10px; }\n\n.dashboard_subHeader__2i0wq {\n  font-family: "Roboto", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.55);\n  text-transform: uppercase;\n  line-height: 18px;\n  position: sticky;\n  top: 0;\n  padding: 4px 10px;\n  background-color: #f1f1f1; }\n\n.dashboard_sunday__LIiaR {\n  color: #FF5252; }\n\n.dashboard_hiddenColumn__2gdoY {\n  display: none; }\n\n.dashboard_resultList__1moXs {\n  white-space: normal;\n  background-color: #f1f1f1;\n  border: 1px solid #e5e3e5;\n  margin-right: 14px;\n  display: inline-block;\n  min-width: 300px;\n  max-width: 300px;\n  width: 300px; }\n  .dashboard_resultListActive__3-DEY {\n    border-top: solid 4px #3f51bf; }\n  .dashboard_resultListHidden__Ksmki {\n    display: none; }\n  .dashboard_resultList__1moXs .dashboard_title__1YAjR {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between; }\n    .dashboard_resultList__1moXs .dashboard_title__1YAjR ul {\n      list-style: none;\n      padding: 0;\n      margin: 0; }\n      .dashboard_resultList__1moXs .dashboard_title__1YAjR ul li {\n        padding: 15px; }\n        .dashboard_resultList__1moXs .dashboard_title__1YAjR ul li:hover {\n          background-color: #e8e8e8; }\n    .dashboard_resultList__1moXs .dashboard_title__1YAjR a {\n      float: right;\n      color: orange;\n      font-weight: lighter;\n      text-decoration: none; }\n  .dashboard_resultList__1moXs .dashboard_cards__3ITmp {\n    height: calc(100vh - 220px);\n    overflow-y: auto;\n    overflow-x: hidden; }\n');
var pc = function (t) {
  var n = t.items,
    r = void 0 === n ? [] : n,
    i = t.mode,
    a = void 0 === i ? "dashboard" : i,
    o = t.active,
    s = t.column,
    l = t.menu,
    c = t.subTitle,
    d = t.title,
    u = t.keyboard,
    p = t.headerIcons,
    m = t.maxColumns,
    f = t.onClickColumn,
    g = t.handleClickBottom,
    _ = t.handleDragStart,
    y = t.handleDropEnd,
    h = t.sortable,
    v = void 0 !== h && h,
    b = t.splice,
    x = t.noLoadMore,
    E = t.density,
    k = t.searching;
  return e.createElement("div", {
    className: "\n        ".concat(sc, "\n        ").concat(u && o[0] === s ? lc : m > 0 && (b && s < b[0] || b && s >= b[1] || s > m) ? cc : "", "\n      "),
    onDrop: function (e) {
      return y(e, s);
    },
    draggable: v,
    onDragOver: function (e) {
      return v && _(e, s);
    }
  }, e.createElement("div", {
    onClick: r.length > 0 ? f : null,
    className: dc,
    style: {
      display: "flex",
      cursor: v ? "move" : "auto"
    }
  }, e.createElement(K, {
    justify: "space-between",
    nowrap: !0,
    align: "center",
    stretch: !0,
    style: {
      width: "100%"
    },
    direction: "row"
  }, e.createElement("div", {
    className: nc
  }, e.createElement("div", {
    className: "".concat(ic, " ").concat(c && "sön" === c.toLowerCase() && oc)
  }, c), e.createElement("div", {
    className: "".concat(rc, " ").concat(c && "sön" === c.toLowerCase() && oc)
  }, d)), e.createElement("div", {
    style: {
      display: "flex"
    }
  }, "dashboard" === a ? e.createElement(Bl, {
    isStatic: !0,
    padding: "0"
  }, e.createElement(K, {
    direction: "row",
    justify: "space-between"
  }, (p || []).map(function (t, n) {
    return e.createElement("div", {
      key: n,
      style: {
        marginLeft: 10
      }
    }, e.createElement(nd, {
      size: "small",
      color: "#607d8b",
      icon: t
    }));
  }))) : null, "dashboard" === a && l ? e.createElement(tc, {
    rounded: !0,
    position: "left",
    trigger: e.createElement(nd, {
      icon: "more_vert"
    }),
    content: e.createElement(dn, {
      stretch: !0,
      data: l,
      direction: "column"
    })
  }) : null))), k ? e.createElement(id, null) : e.createElement("div", {
    className: uc
  }, (r || []).map(function (t, n) {
    return "subheader" === t.type ? e.createElement("div", {
      className: ac,
      key: t.id || n
    }, t.title) : e.createElement(vp, {
      admin: t.admin,
      key: t.id || n,
      cardNr: n,
      hint: t.hint,
      ttninjs: t,
      activeCard: o && o[0] === s && o[1] === n,
      onClickCard: t.onClickCard,
      density: E
    });
  }), !x && e.createElement(Bl, {
    isStatic: !0
  }, e.createElement(wd, {
    stretch: !0,
    level: "secondary",
    handleClick: g,
    text: "Ladda fler"
  }))));
};
function mc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
var fc = require("react-hotkeys").HotKeys,
  gc = function (t) {
    ee(r, a);
    var n = mc(r);
    function r(t) {
      var i;
      return q(this, r), (i = n.call(this, t)).state = {
        dragColumn: null,
        dropColumn: null,
        dragging: !1
      }, i.focusRef = e.createRef(), i.handleDragStart = i.handleDragStart.bind(oe(i)), i.handleDropEnd = i.handleDropEnd.bind(oe(i)), i.handleClickColumn = i.handleClickColumn.bind(oe(i)), i.spaceHandler = i.spaceHandler.bind(oe(i)), i.arrowDownHandler = i.arrowDownHandler.bind(oe(i)), i.arrowUpHandler = i.arrowUpHandler.bind(oe(i)), i.arrowLeftHandler = i.arrowLeftHandler.bind(oe(i)), i.arrowRightHandler = i.arrowRightHandler.bind(oe(i)), i.shiftArrowLeftHandler = i.shiftArrowLeftHandler.bind(oe(i)), i.shiftArrowRightHandler = i.shiftArrowRightHandler.bind(oe(i)), i.handlers = {
        ON_SPACE: i.spaceHandler,
        ARROW_UP: i.arrowUpHandler,
        ARROW_DOWN: i.arrowDownHandler,
        ARROW_LEFT: i.arrowLeftHandler,
        ARROW_RIGHT: i.arrowRightHandler,
        SHIFT_ARROW_LEFT: i.shiftArrowLeftHandler,
        SHIFT_ARROW_RIGHT: i.shiftArrowRightHandler
      }, i.keyMap = {
        ON_SPACE: "Space",
        ARROW_UP: "ArrowUp",
        ARROW_DOWN: "ArrowDown",
        ARROW_LEFT: "ArrowLeft",
        ARROW_RIGHT: "ArrowRight",
        SHIFT_ARROW_LEFT: "shift+ArrowLeft",
        SHIFT_ARROW_RIGHT: "shift+ArrowRight"
      }, i;
    }
    return Q(r, [{
      key: "spaceHandler",
      value: function (e) {
        var t = this.props.onSpace;
        e.preventDefault(), t && t([this.state.activeColumn, this.state.activeRow]);
      }
    }, {
      key: "arrowUpHandler",
      value: function (e) {
        var t = this.props.onArrowUp;
        void 0 !== t && t();
      }
    }, {
      key: "arrowDownHandler",
      value: function (e) {
        var t = this.props.onArrowDown;
        void 0 !== t && t();
      }
    }, {
      key: "arrowRightHandler",
      value: function (e) {
        var t = this.props.onArrowRight;
        void 0 !== t && t();
      }
    }, {
      key: "arrowLeftHandler",
      value: function (e) {
        var t = this.props.onArrowLeft;
        void 0 !== t && t();
      }
    }, {
      key: "shiftArrowLeftHandler",
      value: function (e) {
        var t = this.props,
          n = t.moveList,
          r = t.active,
          i = t.onArrowLeft;
        if (r[0] <= 0) return !1;
        n(r[0], r[0] - 1), void 0 !== i && i();
      }
    }, {
      key: "shiftArrowRightHandler",
      value: function (e) {
        var t = this.props,
          n = t.moveList,
          r = t.active,
          i = t.items,
          a = t.onArrowRight;
        if (r[0] > i.length - 2) return !1;
        n(r[0], r[0] + 1), void 0 !== a && a();
      }
    }, {
      key: "handleDragStart",
      value: function (e, t) {
        e.preventDefault(), this.state.dragging || this.setState({
          dragging: !0,
          dragColumn: t
        });
      }
    }, {
      key: "handleDropEnd",
      value: function (e, t) {
        var n = this.props.moveList;
        e.preventDefault(), this.setState({
          dragging: !1,
          dropColumn: t
        }), n && n(this.state.dragColumn, t);
      }
    }, {
      key: "handleClickColumn",
      value: function (e) {
        (0, this.props.onClickColumn)(e);
      }
    }, {
      key: "render",
      value: function () {
        var t = this,
          n = this.props,
          r = n.items,
          i = void 0 === r ? [] : r,
          a = n.keyboard,
          o = void 0 !== a && a,
          s = n.onBottomClick,
          l = n.onSpace,
          c = n.onSpace2,
          d = n.maxColumns,
          u = void 0 === d ? -1 : d,
          p = n.active,
          m = n.mode,
          f = n.splice,
          g = n.noLoadMore,
          _ = n.searching,
          y = n.density;
        return e.createElement(fc, {
          ref: this.focusRef,
          keyMap: this.keyMap,
          handlers: this.handlers
        }, e.createElement(K, {
          direction: "row",
          nowrap: !0
        }, i.map(function (n, r) {
          return e.createElement(pc, {
            key: r,
            subTitle: n.subTitle,
            title: n.title,
            headerIcons: n.headerIcons,
            items: n.data,
            hilite: n.hilite,
            column: r,
            keyboard: o,
            menu: n.menu,
            onSpace: l,
            onSpace2: c,
            maxColumns: parseInt(u, 10),
            onClickColumn: function (e) {
              return t.handleClickColumn(r);
            },
            handleClickBottom: function (e) {
              return s(r);
            },
            active: p,
            mode: m,
            splice: f,
            noLoadMore: g,
            density: y,
            searching: _
          });
        })));
      }
    }]), r;
  }(),
  _c = "styles_overlay__2L8ud",
  yc = "styles_overlayTargetTop__tcnG4",
  hc = "styles_overlayTargetBottom___apJK",
  vc = "styles_tourContainer__OkUsl",
  bc = "styles_currentSlide__QfXFd",
  xc = "styles_guide__3HRtz",
  Ec = "styles_guideInfo__1zD2H",
  kc = "styles_headline__3xCFJ",
  Tc = "styles_guideDots__2fapW",
  wc = "styles_guideChoices__3QE67",
  Ac = "styles_skip__3rhPS",
  Cc = "styles_guideImage__1-bCE",
  Sc = "styles_guideImageNavigation__1mIlg",
  Nc = "styles_guideImageLeft__1yqmP",
  Oc = "styles_guideImageRight__EbdaS",
  Rc = "styles_guideNoImage__2JMd7";
y("section.styles_overlay__2L8ud {\n  color: #222;\n  z-index: 99999;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.5); }\n  section.styles_overlayTargetTop__tcnG4 {\n    align-items: flex-start;\n    padding-top: 10px; }\n  section.styles_overlayTargetBottom___apJK {\n    align-items: flex-end; }\n    section.styles_overlayTargetBottom___apJK .styles_tourContainer__OkUsl {\n      padding-bottom: 10px; }\n\nsection.styles_tourContainer__OkUsl {\n  width: 80%;\n  height: auto;\n  padding: 0;\n  /*     DEFAULT (WITH IMAGE) TOUR STYLES */ }\n  @media screen and (max-width: 1300px) {\n    section.styles_tourContainer__OkUsl {\n      width: 90%; } }\n  @media screen and (max-width: 768px) {\n    section.styles_tourContainer__OkUsl {\n      width: 70%; } }\n  section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd {\n    /* NO-IMAGE-STYLES */ }\n    section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz {\n      display: flex;\n      flex-direction: row;\n      text-align: left;\n      font-family: Roboto, sans-serif;\n      background-color: #f8f8f8;\n      width: 100%; }\n      @media screen and (max-width: 768px) {\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz {\n          flex-direction: column-reverse;\n          width: 85%; } }\n      @media screen and (max-height: 600px) {\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz {\n          flex-direction: row; } }\n\n@media screen and (max-width: 500px) and (max-height: 600px) {\n  section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz {\n    flex-direction: column-reverse; } }\n      section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        padding: 0;\n        width: 33.3%;\n        word-break: break-word; }\n        @media screen and (max-width: 768px) {\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H {\n            width: 100%;\n            padding: 0 0 10px 0; } }\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H h2.styles_headline__3xCFJ {\n          margin-top: 20px;\n          margin-bottom: 0;\n          max-width: 95%;\n          padding: 0 32px; }\n          @media screen and (max-width: 1300px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H h2.styles_headline__3xCFJ {\n              margin-top: 10px;\n              font-size: 32px; } }\n          @media screen and (max-height: 500px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H h2.styles_headline__3xCFJ {\n              padding: 10px; } }\n          @media screen and (max-width: 1000px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H h2.styles_headline__3xCFJ {\n              font-size: 28px;\n              padding: 0 20px; } }\n          @media screen and (max-width: 768px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H h2.styles_headline__3xCFJ {\n              margin-top: 0;\n              font-size: 18px; } }\n          @media screen and (max-width: 768px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H h2.styles_headline__3xCFJ {\n              margin-top: -5px; } }\n\n@media screen and (max-width: 768px) and (max-height: 500px) {\n  section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H h2.styles_headline__3xCFJ {\n    padding: 20px 20px 10px; } }\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H div.styles_guideDots__2fapW {\n          width: 11px;\n          margin-right: 8px;\n          margin-top: 20px;\n          height: 11px;\n          border-radius: 50%;\n          z-index: 10;\n          cursor: pointer; }\n          @media screen and (max-width: 768px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H div.styles_guideDots__2fapW {\n              position: relative;\n              bottom: 30px;\n              margin-top: 0; } }\n          @media screen and (max-height: 500px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H div.styles_guideDots__2fapW {\n              display: none; } }\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H ul {\n          color: #222222;\n          list-style-type: none;\n          text-align: left;\n          padding: 0 0 0 32px;\n          max-width: 90%;\n          word-break: break-word; }\n          @media screen and (max-width: 1000px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H ul {\n              padding: 0 20px; } }\n          @media screen and (max-width: 768px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H ul {\n              padding: 0 0 0 20px;\n              margin-bottom: 2px; } }\n          @media screen and (max-width: 400px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H ul {\n              margin-top: 0; } }\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H ul li {\n            margin-top: 0;\n            margin-bottom: 20px;\n            font-weight: normal;\n            line-height: 27px;\n            max-width: 100%;\n            font-size: 16px;\n            padding: 0 20px 0 0; }\n            @media screen and (max-width: 1200px) {\n              section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H ul li {\n                line-height: 23px; } }\n            @media screen and (max-width: 1000px) {\n              section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H ul li {\n                margin-bottom: 10px;\n                font-size: 14px; } }\n            @media screen and (max-width: 768px) {\n              section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H ul li {\n                margin-top: -3px; } }\n            @media screen and (max-width: 400px) {\n              section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H ul li {\n                margin-bottom: 0;\n                max-width: 100%;\n                line-height: 22px; } }\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H div.styles_guideChoices__3QE67 {\n          width: 90%;\n          display: flex;\n          flex-direction: row;\n          align-items: baseline;\n          justify-content: space-between;\n          padding: 20px; }\n          @media screen and (max-width: 768px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H div.styles_guideChoices__3QE67 {\n              padding: 0 20px;\n              margin: -2px; } }\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H div.styles_guideChoices__3QE67 p.styles_skip__3rhPS {\n            font-size: 16px;\n            margin: 0;\n            cursor: pointer;\n            width: fit-content;\n            text-decoration: underline; }\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H div.styles_guideChoices__3QE67 label {\n            font-size: 16px;\n            display: flex;\n            flex-direction: row-reverse;\n            align-items: center; }\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H div.styles_guideChoices__3QE67 label input {\n              cursor: pointer;\n              border-radius: 3px;\n              width: 20px;\n              height: 20px;\n              border: 2px solid rgba(0, 0, 0, 0.55); }\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz div.styles_guideInfo__1zD2H strong {\n          color: #000000;\n          font-weight: bolder; }\n      section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz .styles_guideImage__1-bCE {\n        width: 66.7%;\n        position: relative;\n        user-select: none; }\n        @media screen and (max-width: 768px) {\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz .styles_guideImage__1-bCE {\n            width: 100%; } }\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz .styles_guideImage__1-bCE div.styles_guideImageNavigation__1mIlg {\n          position: absolute;\n          top: 0;\n          display: flex;\n          width: 100%;\n          height: 100%;\n          align-items: center;\n          user-select: none; }\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz .styles_guideImage__1-bCE div.styles_guideImageNavigation__1mIlg .styles_guideImageLeft__1yqmP, section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz .styles_guideImage__1-bCE div.styles_guideImageNavigation__1mIlg .styles_guideImageRight__EbdaS {\n            padding: 5px 10px;\n            background-color: rgba(0, 0, 0, 0.5);\n            user-select: none;\n            cursor: pointer; }\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz .styles_guideImage__1-bCE img {\n          min-width: 100%;\n          min-height: 100%;\n          max-width: 100%;\n          max-height: 100%; }\n          @media screen and (max-width: 400px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guide__3HRtz .styles_guideImage__1-bCE img {\n              margin-top: -35px; } }\n    section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 {\n      display: flex;\n      flex-direction: row;\n      text-align: left;\n      font-family: Roboto, sans-serif;\n      background-color: #f8f8f8;\n      width: 100%; }\n      @media screen and (max-width: 768px) {\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 {\n          flex-direction: column-reverse; } }\n      @media screen and (max-height: 600px) {\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 {\n          flex-direction: row; } }\n\n@media screen and (max-width: 500px) and (max-height: 600px) {\n  section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 {\n    flex-direction: column-reverse; } }\n      section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 h2.styles_headline__3xCFJ {\n        margin-top: 20px;\n        margin-bottom: 0;\n        max-width: 40%;\n        padding: 0 32px; }\n        @media screen and (max-height: 500px) {\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 h2.styles_headline__3xCFJ {\n            padding: 10px; } }\n        @media screen and (max-width: 1000px) {\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 h2.styles_headline__3xCFJ {\n            font-size: 28px;\n            padding: 0 20px; } }\n        @media screen and (max-width: 768px) {\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 h2.styles_headline__3xCFJ {\n            margin-top: 0;\n            font-size: 18px; } }\n        @media screen and (max-width: 768px) {\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 h2.styles_headline__3xCFJ {\n            margin-top: -5px; } }\n\n@media screen and (max-width: 768px) and (max-height: 500px) {\n  section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 h2.styles_headline__3xCFJ {\n    padding: 20px 20px 10px; } }\n      section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        padding: 0;\n        width: 100%;\n        word-break: break-word; }\n        @media screen and (max-width: 768px) {\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H {\n            padding: 0 0 10px 0; } }\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H div.styles_guideDots__2fapW {\n          width: 11px;\n          margin-right: 8px;\n          margin-top: 20px;\n          height: 11px;\n          border-radius: 50%;\n          z-index: 10;\n          cursor: pointer; }\n          @media screen and (max-width: 768px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H div.styles_guideDots__2fapW {\n              position: relative;\n              top: 11px;\n              margin-top: 0; } }\n          @media screen and (max-height: 500px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H div.styles_guideDots__2fapW {\n              display: none; } }\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H ul {\n          color: #222222;\n          list-style-type: none;\n          text-align: left;\n          padding: 0 32px;\n          max-width: 90%;\n          word-break: break-word; }\n          @media screen and (max-width: 1000px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H ul {\n              padding: 0 20px; } }\n          @media screen and (max-width: 768px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H ul {\n              padding: 0 20px;\n              margin-bottom: 2px; } }\n          @media screen and (max-width: 400px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H ul {\n              margin-top: 0; } }\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H ul li {\n            margin-top: 0;\n            margin-bottom: 20px;\n            font-weight: normal;\n            line-height: 27px;\n            max-width: 100%;\n            font-size: 16px; }\n            @media screen and (max-width: 1000px) {\n              section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H ul li {\n                margin-bottom: 10px;\n                font-size: 14px; } }\n            @media screen and (max-width: 768px) {\n              section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H ul li {\n                margin-top: -3px; } }\n            @media screen and (max-width: 400px) {\n              section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H ul li {\n                margin-bottom: 0;\n                max-width: 100%;\n                line-height: 22px; } }\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H div.styles_guideChoices__3QE67 {\n          width: 90%;\n          display: flex;\n          flex-direction: row;\n          align-items: baseline;\n          justify-content: space-between;\n          padding: 20px; }\n          @media screen and (max-width: 600px) {\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H div.styles_guideChoices__3QE67 {\n              padding: 0 20px;\n              margin: -2px; } }\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H div.styles_guideChoices__3QE67 p.styles_skip__3rhPS {\n            font-size: 16px;\n            margin: 0;\n            cursor: pointer;\n            width: fit-content;\n            text-decoration: underline; }\n          section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H div.styles_guideChoices__3QE67 label {\n            font-size: 16px;\n            display: flex;\n            flex-direction: row-reverse;\n            align-items: center; }\n            section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H div.styles_guideChoices__3QE67 label input {\n              cursor: pointer;\n              border-radius: 3px;\n              width: 20px;\n              height: 20px;\n              border: 2px solid rgba(0, 0, 0, 0.55); }\n        section.styles_tourContainer__OkUsl section.styles_currentSlide__QfXFd section.styles_guideNoImage__2JMd7 .styles_guideInfo__1zD2H strong {\n          color: #000000;\n          font-weight: bolder; }\n");
var Ic = function (r) {
  var i = r.steps,
    a = void 0 === i ? [] : i,
    o = r.storageString,
    s = r.skipText,
    l = void 0 === s ? "Hoppa över" : s,
    c = r.closingText,
    d = void 0 === c ? "Avsluta" : c,
    u = r.checkText,
    p = void 0 === u ? "Visa igen" : u,
    m = j(t(0), 2),
    f = m[0],
    g = m[1],
    _ = j(t(!0), 2),
    y = _[0],
    h = _[1],
    v = j(t(!0), 2),
    b = v[0],
    x = v[1],
    E = j(t(y), 2),
    k = E[0],
    T = E[1],
    w = "bottom" === a[f].position ? hc : "top" === a[f].position ? yc : "";
  n(function () {
    var e = window.localStorage.getItem(o),
      t = window.sessionStorage.getItem("showduringsession", !0);
    null === e || "true" === e ? (window.localStorage.setItem(o, !0), e = !0) : e = !1, h(e), null === t || "true" === t ? (window.sessionStorage.setItem("showduringsession", !0), t = !0) : t = !1, T(t);
  }, [f]);
  var A,
    C = function (t) {
      var n = t.children;
      return e.createElement(e.Fragment, null, e.createElement("section", {
        className: "".concat(_c, " ").concat(w)
      }, n));
    },
    S = function (e) {
      g(e);
    },
    N = function () {
      window.sessionStorage.setItem("showduringsession", !1), T(!1), b || window.localStorage.setItem(o, !1);
    };
  return y && k ? e.createElement(C, null, e.createElement("section", {
    className: vc
  }, (A = a.filter(function (e, t) {
    return t === f;
  }), e.createElement("section", {
    className: bc
  }, A.map(function (t, n) {
    return e.createElement(K, {
      key: t.headline,
      direction: "row",
      justify: "center"
    }, e.createElement("section", {
      className: t.image ? xc : Rc,
      style: {
        width: !t.image && t.size ? "fit-content" : "100%"
      }
    }, e.createElement("div", {
      className: Ec
    }, e.createElement(K, {
      direction: "column",
      justify: "space-between"
    }, function (t) {
      return e.createElement(e.Fragment, null, e.createElement(K, {
        direction: "row",
        justify: "center",
        style: {
          width: "100%"
        }
      }, a.map(function (n, r) {
        return e.createElement("div", {
          className: Tc,
          key: n.headline && n.headline[0] + r,
          style: {
            backgroundColor: r === f ? "#3f51bf" : "#dfdcdc"
          },
          onClick: function () {
            t(r), g(r);
          }
        });
      })));
    }(S), t.headline && e.createElement("h2", {
      className: kc
    }, t.headline), t.body && e.createElement("ul", null, t.body.map(function (t, n) {
      return e.createElement("li", {
        key: t[0] + n
      }, t);
    }))), e.createElement(K, {
      direction: "column",
      justify: "center"
    }, e.createElement(K, {
      direction: "row",
      justify: "center",
      style: {
        width: "100%"
      }
    }, e.createElement(wd, {
      size: "medium",
      level: "primary",
      text: t.buttonText ? t.buttonText : f === a.length - 1 ? d : "Nästa",
      handleClick: f === a.length - 1 ? function () {
        return N();
      } : function () {
        return S(f + 1);
      }
    })), e.createElement("div", {
      className: wc
    }, e.createElement(K, {
      direction: "row",
      align: "baseline",
      justify: "space-between",
      style: {
        width: "100%"
      }
    }, e.createElement("p", {
      className: Ac,
      onClick: N
    }, l), o && e.createElement("label", {
      htmlFor: "noshow"
    }, p, e.createElement("input", {
      type: "checkbox",
      name: "noshow",
      checked: b,
      onChange: function (e) {
        x(!b);
      }
    })))))), t.image && e.createElement("div", {
      className: Cc
    }, e.createElement("img", {
      src: t.image
    }), function (t) {
      var n = 0 === f,
        r = f === a.length - 1;
      return e.createElement("div", {
        className: Sc
      }, e.createElement(K, {
        direction: "row",
        justify: n ? "flex-end" : f === r ? "flex-start" : "space-between",
        style: {
          width: "100%",
          height: "100%"
        }
      }, !n && e.createElement("div", {
        className: Nc,
        onClick: function () {
          t(f - 1), g(f - 1);
        }
      }, e.createElement(nd, {
        icon: "arrow_back",
        size: "large",
        color: "#fff"
      })), !r && e.createElement("div", {
        className: Oc,
        onClick: function () {
          t(f + 1), g(f + 1);
        }
      }, e.createElement(nd, {
        icon: "arrow_forward",
        size: "large",
        color: "#fff"
      }))));
    }(S))));
  }))))) : null;
};
function Lc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
var jc = function (t) {
    ee(r, a);
    var n = Lc(r);
    function r(e) {
      var t;
      return q(this, r), (t = n.call(this, e)).state = {
        visible: !0
      }, t.setContentRef = t.setContentRef.bind(oe(t)), t.handleClickOutside = t.handleClickOutside.bind(oe(t)), t;
    }
    return Q(r, [{
      key: "setContentRef",
      value: function (e) {
        this.contentRef = e;
      }
    }, {
      key: "handleClickOutside",
      value: function (e) {
        var t = this.props.reset;
        this.contentRef && !this.contentRef.contains(e.target) && this.state.visible && (this.setState({
          visible: !1
        }), t());
      }
    }, {
      key: "componentWillReceiveProps",
      value: function (e) {
        this.setState({
          visible: !0
        });
      }
    }, {
      key: "componentDidMount",
      value: function () {
        console.log("init modal"), document.addEventListener("mousedown", this.handleClickOutside);
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        document.removeEventListener("mousedown", this.handleClickOutside);
      }
    }, {
      key: "render",
      value: function () {
        var t = this,
          n = this.props,
          r = n.reset,
          i = n.heading,
          a = n.content,
          o = n.children,
          s = n.footer,
          l = n.isVisible;
        return e.createElement("div", {
          style: {
            display: l ? "block" : "none"
          }
        }, e.createElement("div", {
          className: Ri.modalOverlay
        }), e.createElement("div", {
          className: Ri.modalWrapper
        }, e.createElement("div", {
          ref: this.setContentRef,
          className: "".concat(Ri.modalContent)
        }, e.createElement("div", {
          className: Ri.modalHeader
        }, e.createElement(K, {
          direction: "row",
          align: "center",
          justify: "space-between"
        }, e.createElement("div", {
          className: Ri.optionalLabel
        }, i), e.createElement("div", {
          className: Ri.modalClose,
          onClick: function (e) {
            t.setState({
              visible: !1
            }), r();
          }
        }, e.createElement(Bl, null, e.createElement(nd, {
          icon: "clear"
        }))))), e.createElement("div", {
          className: Ri.modalBody
        }, a || o), s ? e.createElement("div", {
          className: Ri.modalFooter
        }, s) : null)));
      }
    }]), r;
  }(),
  Dc = function (t) {
    var n = t.profile,
      r = t.loginAsModal,
      i = t.loggedInAs,
      a = t.logout,
      o = t.logOutAs,
      s = t.children;
    return n ? e.cloneElement(s, {
      profile: n,
      loginAsModal: r,
      loggedInAs: i,
      logout: a,
      logOutAs: o
    }) : s;
  },
  Fc = function (t) {
    var n = t.ttninjs,
      r = t.children;
    return n ? e.cloneElement(r, {
      ttninjs: n
    }) : r;
  };
function Mc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Pc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Mc(Object(n), !0).forEach(function (t) {
      X(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mc(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
var Bc = function (t) {
    var n = t.data,
      r = t.siteMap,
      i = t.footer,
      a = t.messages,
      o = t.children;
    return n || r ? o ? e.cloneElement(o, Pc(Pc({}, t), {}, {
      item: n,
      siteMap: r
    })) : null : a ? o ? e.cloneElement(e.createElement("div", null), Pc(Pc({}, t), {}, {
      item: n,
      messages: a
    }), o) : null : i ? o ? e.cloneElement(o, Pc(Pc({}, t), {}, {
      item: n,
      footerData: i
    })) : null : o || null;
  },
  Hc = function (t) {
    var n = t.data,
      r = t.children;
    return n ? e.cloneElement(r, {
      data: n
    }) : r;
  },
  zc = function (t) {
    var n = t.data,
      r = void 0 === n ? [] : n;
    return e.createElement("div", {
      className: "".concat(B.props, " ").concat(B.ttroot)
    }, e.createElement("table", null, e.createElement("thead", null, e.createElement("th", null, "Name"), e.createElement("th", null, "Type"), e.createElement("th", null, "Default"), e.createElement("th", null, "Description")), r.map(function (t) {
      return e.createElement("tbody", null, e.createElement("td", null, e.createElement("strong", null, t.name)), e.createElement("td", null, t.dataType && e.createElement("code", null, t.dataType)), e.createElement("td", null, t.defVal && e.createElement("code", null, t.defVal)), e.createElement("td", null, t.descr));
    })));
  };
function Uc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
var Wc = function (t) {
    ee(r, a);
    var n = Uc(r);
    function r(e) {
      var t;
      return q(this, r), (t = n.call(this, e)).state = {
        menuOpen: !1
      }, t;
    }
    return Q(r, [{
      key: "render",
      value: function () {
        var t,
          n,
          r = this.props,
          i = r.context,
          a = r.color,
          o = void 0 === a ? "black" : a,
          s = r.size,
          l = void 0 === s ? "medium" : s,
          c = r.title,
          d = r.variant,
          u = "https://s3-eu-west-1.amazonaws.com/ttnewsagency-designsystem/";
        switch (l) {
          case "small":
            t = vn;
            break;
          case "large":
            t = xn;
            break;
          case "xlarge":
            t = En;
            break;
          default:
            t = bn;
        }
        switch (d) {
          case "left":
            n = "".concat(u, "TTlogo_left_").concat(o, ".png");
            break;
          case "top":
            n = "".concat(u, "TTlogo_top_").concat(o, ".png");
            break;
          default:
            n = "".concat(u, "TTlogo_").concat(o, ".png");
        }
        return e.createElement(K, {
          direction: "row",
          align: "center",
          nowrap: !0
        }, e.createElement("img", {
          className: t,
          src: n
        }), e.createElement("div", null, e.createElement("h3", {
          className: kn,
          style: {
            margin: 0,
            color: o,
            textTransform: "capitalize",
            marginLeft: "10px"
          }
        }, c || i)));
      }
    }]), r;
  }(),
  Xc = "leaflet_leafletContainer__2irQH",
  Gc = "leaflet_higher__3XzZd",
  Vc = "leaflet_lower__1N59_",
  Yc = "leaflet_leafletFlexContainer__jWiEJ",
  Kc = "leaflet_flexHigher__3cnzb",
  Zc = "leaflet_flexLower__3YAHN";
y('/*\n@mixin desk-1050{\n    @media (max-width: 1050px){\n        @content;\n    }\n}\n*/\n/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.leaflet_leafletContainer__2irQH {\n  font-family: "Roboto", sans-serif;\n  margin: 0 19px;\n  border-radius: 4px;\n  box-shadow: -1px 1px 6px -1px #969496;\n  overflow: hidden;\n  width: 280px;\n  height: auto;\n  box-sizing: border-box; }\n  @media all and (max-width: 1275px) {\n    .leaflet_leafletContainer__2irQH {\n      margin: 0 12px; } }\n  @media all and (max-width: 1130px) {\n    .leaflet_leafletContainer__2irQH {\n      width: 227px; } }\n  @media all and (max-width: 1050px) {\n    .leaflet_leafletContainer__2irQH {\n      margin: 28px 6px; } }\n  @media all and (max-width: 1000px) {\n    .leaflet_leafletContainer__2irQH {\n      width: 325px;\n      margin: 28px 18px; } }\n  @media all and (max-width: 820px) {\n    .leaflet_leafletContainer__2irQH {\n      width: 325px; } }\n  @media all and (max-width: 775px) {\n    .leaflet_leafletContainer__2irQH {\n      width: 300px; } }\n  @media all and (max-width: 725px) {\n    .leaflet_leafletContainer__2irQH {\n      width: 280px; } }\n  @media all and (max-width: 685px) {\n    .leaflet_leafletContainer__2irQH {\n      width: 270px; } }\n  @media all and (max-width: 650px) {\n    .leaflet_leafletContainer__2irQH {\n      width: 100%;\n      height: auto; } }\n  .leaflet_leafletContainer__2irQH .leaflet_higher__3XzZd {\n    height: 140px;\n    background-size: cover; }\n    @media all and (max-width: 1130px) {\n      .leaflet_leafletContainer__2irQH .leaflet_higher__3XzZd {\n        height: 115px; } }\n    @media all and (max-width: 1000px) {\n      .leaflet_leafletContainer__2irQH .leaflet_higher__3XzZd {\n        height: 144px; } }\n    @media all and (max-width: 725px) {\n      .leaflet_leafletContainer__2irQH .leaflet_higher__3XzZd {\n        height: 120px; } }\n  .leaflet_leafletContainer__2irQH .leaflet_lower__1N59_ {\n    text-align: left;\n    font-weight: lighter;\n    height: 220px;\n    display: flex;\n    flex-direction: column;\n    padding: 12px 18px; }\n    .leaflet_leafletContainer__2irQH .leaflet_lower__1N59_ h4 {\n      font-size: 24px;\n      padding: 0;\n      margin: 0; }\n      @media all and (max-width: 1275px) {\n        .leaflet_leafletContainer__2irQH .leaflet_lower__1N59_ h4 {\n          font-size: 20px; } }\n      @media all and (max-width: 900px) {\n        .leaflet_leafletContainer__2irQH .leaflet_lower__1N59_ h4 {\n          font-size: 24px; } }\n      @media all and (max-width: 520px) {\n        .leaflet_leafletContainer__2irQH .leaflet_lower__1N59_ h4 {\n          font-size: 20px; } }\n    .leaflet_leafletContainer__2irQH .leaflet_lower__1N59_ ul {\n      padding: 0;\n      width: 100%;\n      margin: 0; }\n      @media all and (max-width: 1100px) {\n        .leaflet_leafletContainer__2irQH .leaflet_lower__1N59_ ul {\n          width: 90%; } }\n      .leaflet_leafletContainer__2irQH .leaflet_lower__1N59_ ul li {\n        font-size: 15px;\n        width: 100%;\n        line-height: 1.33; }\n        @media all and (max-width: 900px) {\n          .leaflet_leafletContainer__2irQH .leaflet_lower__1N59_ ul li {\n            line-height: 1.33; } }\n      .leaflet_leafletContainer__2irQH .leaflet_lower__1N59_ ul div > p {\n        font-size: 16px !important; }\n    .leaflet_leafletContainer__2irQH .leaflet_lower__1N59_ span {\n      color: #417505; }\n  @media all and (max-width: 500px) {\n    .leaflet_leafletContainer__2irQH [class*="material-icons"] {\n      position: relative;\n      left: 10px;\n      bottom: 5px; } }\n\n.leaflet_leafletFlexContainer__jWiEJ {\n  font-family: "Roboto", sans-serif;\n  display: flex;\n  margin: 0 19px;\n  border-radius: 4px;\n  box-shadow: -1px 1px 6px -1px #969496;\n  overflow: hidden;\n  width: 597px;\n  height: auto; }\n  @media all and (max-width: 1024px) {\n    .leaflet_leafletFlexContainer__jWiEJ {\n      width: 95%;\n      height: 300px; } }\n  @media all and (max-width: 1000px) {\n    .leaflet_leafletFlexContainer__jWiEJ {\n      height: 375px;\n      margin: 25px 0; } }\n  @media all and (max-width: 650px) {\n    .leaflet_leafletFlexContainer__jWiEJ {\n      flex-direction: column !important; } }\n  .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexHigher__3cnzb {\n    height: 100%;\n    width: 215px;\n    background-size: cover; }\n    @media all and (max-width: 1300px) {\n      .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexHigher__3cnzb {\n        width: 200px; } }\n    @media all and (max-width: 1024px) {\n      .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexHigher__3cnzb {\n        height: 300px; } }\n    @media all and (max-width: 1000px) {\n      .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexHigher__3cnzb {\n        height: 400px;\n        width: 300px; } }\n    @media all and (max-width: 650px) {\n      .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexHigher__3cnzb {\n        width: 100%;\n        height: 250px; } }\n  .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexLower__3YAHN {\n    width: 90%;\n    text-align: left;\n    font-weight: lighter;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 0; }\n    .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexLower__3YAHN h4 {\n      font-size: 24px;\n      margin: 0;\n      padding: 30px 35px 0; }\n      @media all and (max-width: 1200px) {\n        .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexLower__3YAHN h4 {\n          font-size: 20px; } }\n      @media all and (max-width: 1000px) {\n        .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexLower__3YAHN h4 {\n          font-size: 24px; } }\n      @media all and (max-width: 650px) {\n        .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexLower__3YAHN h4 {\n          font-size: 20px; } }\n    .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexLower__3YAHN ul {\n      padding: 15px 0 0 35px;\n      width: 85%;\n      margin-top: 0; }\n      @media all and (max-width: 1200px) {\n        .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexLower__3YAHN ul div {\n          font-size: 15px; } }\n      @media all and (max-width: 1000px) {\n        .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexLower__3YAHN ul div {\n          line-height: 1.6; } }\n      @media all and (max-width: 650px) {\n        .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexLower__3YAHN ul div {\n          font-size: 16px; } }\n    .leaflet_leafletFlexContainer__jWiEJ .leaflet_flexLower__3YAHN span {\n      color: #417505; }\n  .leaflet_leafletFlexContainer__jWiEJ [class*="material-icons"] {\n    padding: 0px 30px 25px 0; }\n    @media all and (max-width: 500px) {\n      .leaflet_leafletFlexContainer__jWiEJ [class*="material-icons"] {\n        padding: 15px 5px; } }\n');
var qc = require("react-markdown");
function Jc(t, n) {
  var r = t.image,
    i = t.title,
    a = t.listItems,
    o = t.text,
    s = t.cta,
    l = t.flex;
  n = "dark" === t.mode ? "#000" : "#fff";
  var c = "dark" === t.mode ? "#f5f5f5" : "#222222";
  return e.createElement("div", {
    onClick: function (e) {
      s && (window.location.href = s.fields ? s.fields.url : s.url);
    },
    className: l ? Yc : Xc,
    style: {
      backgroundColor: "".concat(n),
      cursor: s ? "pointer" : "auto",
      boxShadow: s ? "-1px 1px 6px -1px #969496" : "none"
    }
  }, r ? e.createElement("div", {
    title: i,
    className: l ? Kc : Gc,
    style: {
      backgroundImage: "url(".concat(r, ")"),
      backgroundColor: s && s.fields ? s.fields.color : "#DFDEDC",
      backgroundPosition: "center"
    }
  }) : null, e.createElement("div", {
    className: l ? Zc : Vc,
    style: {
      color: "".concat(c)
    }
  }, e.createElement("h4", null, t.header), e.createElement("ul", {
    style: {
      listStyleType: "none",
      height: t.image || 1 !== a.length ? "95%" : "100%"
    }
  }, a.length > 0 ? a.map(function (t, n) {
    return e.createElement("li", {
      style: {
        fontSize: s ? "15px" : "10px"
      },
      key: n
    }, e.createElement("span", null, "✓"), " ", t);
  }) : e.createElement("div", null, e.createElement(qc, {
    source: o
  }))), s && l ? e.createElement(nd, {
    icon: "arrow_forward",
    style: {
      alignSelf: "flex-end"
    }
  }) : null), s && !l ? e.createElement(nd, {
    icon: "arrow_forward",
    style: {
      flexDirection: "row",
      alignSelf: "flex-end",
      position: "relative",
      left: "80%",
      marginBottom: "20px",
      marginLeft: "10px"
    }
  }) : null);
}
Jc.defaultProps = {
  listItems: [],
  color: "#000",
  mode: "light",
  image: "https://picsum.photos/300"
};
function Qc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $c(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Qc(Object(n), !0).forEach(function (t) {
      X(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Qc(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function ed(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
y('@import url("https://fonts.googleapis.com/icon?family=Material+Icons");\n');
var td = function (e) {
    switch (e) {
      case "small":
        return "18px";
      case "large":
        return "36px";
      case "xlarge":
        return "76px";
      default:
        return "24px";
    }
  },
  nd = function (t) {
    ee(r, a);
    var n = ed(r);
    function r() {
      return q(this, r), n.apply(this, arguments);
    }
    return Q(r, [{
      key: "shouldComponentUpdate",
      value: function () {
        return !0;
      }
    }, {
      key: "render",
      value: function () {
        var t = this.props,
          n = t.icon,
          r = t.text,
          i = t.nowrap,
          a = t.rotate,
          o = void 0 === a ? "0deg" : a,
          s = t.className,
          l = void 0 === s ? "" : s,
          c = t.style,
          d = t.color,
          u = void 0 === d ? "rgba(0,0,0,.87)" : d,
          p = t.size,
          m = void 0 === p ? "medium" : p,
          f = t.direction,
          g = void 0 === f ? "row" : f;
        return e.createElement("div", {
          style: $c({
            whiteSpace: "".concat(i ? "nowrap" : "normal"),
            color: u || "#000"
          }, c),
          className: l
        }, e.createElement(K, {
          direction: g,
          align: "center"
        }, e.createElement("i", {
          className: "material-icons",
          style: {
            transform: "rotate(".concat(o, ")"),
            color: u,
            fontSize: "row" === g ? td(m) : 20
          }
        }, n), r ? e.createElement("div", {
          style: "row" === g ? {
            marginTop: "2px",
            marginLeft: "6px",
            fontWeight: "500"
          } : {
            color: "#4f4f4f",
            marginTop: "-7px",
            fontWeight: "500",
            fontSize: 12
          }
        }, r) : null));
      }
    }]), r;
  }(),
  rd = "spinner_spinner__3CqBT";
y("@-webkit-keyframes spinner_rotation__1fZG7 {\n  from {\n    -webkit-transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(359deg); } }\n\n.spinner_spinner__3CqBT {\n  display: flex;\n  justify-content: center;\n  padding: 20px; }\n  .spinner_spinner__3CqBT > div {\n    -webkit-animation: spinner_rotation__1fZG7 1s infinite linear; }\n");
var id = function (t) {
  return e.createElement("div", {
    className: rd
  }, e.createElement(nd, {
    color: "#ddd",
    icon: "donut_small"
  }));
};
function ad(e) {
  var t, n, r;
  return e.match && e.match(/^rgb/) ? (t = (e = e.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/))[1], n = e[2], r = e[3]) : e.slice && (t = (e = +("0x" + e.slice(1).replace(e.length < 5 && /./g, "$&$&"))) >> 16, n = e >> 8 & 255, r = 255 & e), Math.sqrt(t * t * .299 + n * n * .587 + r * r * .114) > 127.5 ? "light" : "dark";
}
var od = {
  leafletHero: "style_leafletHero__1H3A5",
  leafletHeroHeadline: "style_leafletHeroHeadline__3ON64",
  leafletHeroSubHeadline: "style_leafletHeroSubHeadline__w7eqi",
  cardsContainer: "style_cardsContainer__3xvGo",
  flexCardsContainer: "style_flexCardsContainer__1gUsp",
  articleInfo: "style_articleInfo__30jFl",
  articleText: "style_articleText__PL_gJ",
  articleTextHeadlines: "style_articleTextHeadlines__1t4I1",
  articleImage: "style_articleImage__2J3iG",
  articleOnlyText: "style_articleOnlyText__mjY1L",
  articleOnlyTextHeadlines: "style_articleOnlyTextHeadlines__2ILh9",
  TopHero: "style_TopHero__2vxlv",
  imageDiv: "style_imageDiv__2oohR",
  formHeroWrapper: "style_formHeroWrapper__1ROYN",
  formHeroImage: "style_formHeroImage__1fYYS",
  formHeroText: "style_formHeroText__U0NZA",
  respContainer: "style_respContainer__Lyay5",
  respIframe: "style_respIframe__7jK2R",
  formHeroSplitWrapper: "style_formHeroSplitWrapper__2Xdod",
  formHeroLeft: "style_formHeroLeft__1lvPf",
  formHeroRight: "style_formHeroRight__3zpM6"
};
function sd(t) {
  var n = t.json,
    r = void 0 === n ? {} : n,
    i = t.headline,
    a = t.subHeadline,
    o = t.backgroundColor,
    s = void 0 === o ? "#000" : o,
    l = t.cta,
    c = t.level,
    d = t.image,
    u = r.headline || i,
    p = r.subHeadline || a,
    m = r.image ? r.image.fields.file.url : d,
    f = r.image && r.image.fields && r.image.fields.title ? r.image.fields.title : "",
    g = r.backgroundColor || s,
    _ = r.cta || l,
    y = r.ctaVariant || c,
    h = function () {
      return "Big" === y || "primary" === y || "" === y || !y;
    };
  return e.createElement("section", {
    className: od.TopHero,
    title: f,
    style: {
      alignItems: h() ? "center" : "flex-start",
      backgroundImage: "url(".concat(m || "", ")"),
      backgroundColor: g,
      padding: h() ? "120px 0 200px" : "150px 100px 190px"
    }
  }, e.createElement("h1", {
    style: {
      color: "dark" === ad(g) ? "#f5f5f5" : "#222222"
    }
  }, u), e.createElement("h3", {
    style: {
      textAlign: h() ? "center" : "left",
      color: "dark" === ad(g) ? "#f5f5f5" : "#222222"
    }
  }, p), e.createElement(K, {
    direction: "row",
    justify: h() ? "center" : "flex-start",
    style: {
      maxWidth: 1200
    }
  }, (_ || []).map(function (t, n) {
    var r = t.fields || t,
      i = r.image,
      a = r.subheader,
      o = r.level,
      s = void 0 === o ? "primary" : o,
      l = r.text,
      c = r.url,
      d = r.handleClick,
      u = i && i.fields && i.fields.title;
    return h() ? e.createElement(mn, {
      style: {
        margin: "0 5px"
      },
      key: n,
      text: l,
      subtext: a,
      image: i && i.fields && i.fields.file ? i.fields.file.url : i,
      title: u,
      handleClick: d || function (e) {
        window.location.href = c;
      }
    }) : e.createElement(wd, {
      key: n,
      text: l,
      size: "large",
      level: s,
      style: {
        marginRight: 15,
        marginBottom: 15
      },
      handleClick: d || function (e) {
        window.location.href = c;
      }
    });
  })));
}
function ld(t) {
  var n = t.json,
    r = void 0 === n ? {} : n,
    i = t.headline,
    a = void 0 === i ? "" : i,
    o = t.subHeadline,
    s = t.image,
    l = t.cta,
    c = void 0 === l ? [] : l,
    d = t.backgroundColor,
    u = void 0 === d ? "#fff" : d,
    p = r.headline || a,
    m = r.subHeadline || o,
    f = r.image && r.image.fields ? r.image.fields.file.url : s,
    g = r.image && r.image.fields && r.image.fields.title ? r.image.fields.title : "",
    _ = r.backgroundColor || u,
    y = r.cta || c;
  return e.createElement(Qt, {
    breakpoints: [0, 500, 768, 2e3],
    colspan: 12,
    cssMode: "flex",
    right: ["", "25px", "0"],
    left: ["0", "25px"]
  }, e.createElement(en, {
    tag: "section",
    className: od.articleInfo,
    cols: 12
  }, e.createElement(en, {
    tag: "section",
    className: f ? od.articleText : od.articleOnlyText,
    cols: f ? [12, 12, 8, 8] : [12]
  }, e.createElement(en, {
    tag: "div",
    className: f ? od.articleTextHeadlines : od.articleOnlyTextHeadlines,
    cols: f ? [12, 12, 8] : [12]
  }, e.createElement("a", {
    id: p.toLowerCase().replace(/ /gi, "_")
  }), e.createElement("h2", {
    style: {
      color: "dark" === ad(_) ? "#f5f5f5" : "#222222"
    }
  }, p), e.createElement("p", {
    style: {
      color: "dark" === ad(_) ? "#f5f5f5" : "#222222"
    }
  }, m)), y.map(function (t, n) {
    return e.createElement(wd, {
      key: n,
      size: "large",
      text: t.fields ? t.fields.text : t.text,
      handleClick: t.fields && t.fields.url ? function () {
        window.location.href = t.fields.url;
      } : null
    });
  })), f ? e.createElement(en, {
    cols: [12, 12, 4],
    tag: "div",
    className: od.articleImage,
    style: _
  }, e.createElement("img", {
    src: f || null,
    alt: g
  })) : ""));
}
function cd(t) {
  var n = t.json,
    r = void 0 === n ? {} : n,
    i = t.headline,
    a = t.subHeadline,
    o = t.cta,
    s = t.leaflet,
    l = t.backgroundColor,
    c = void 0 === l ? "#fff" : l,
    d = r.headline || i,
    u = r.subHeadline || a,
    p = r.leaflet ? r.leaflet : s,
    m = r.backgroundColor || c,
    f = r.cta || o;
  return e.createElement("section", {
    className: od.leafletHero
  }, e.createElement("a", {
    id: (d || "").toLowerCase().replace(/ /gi, "_")
  }), d ? e.createElement("h2", {
    className: od.leafletHeroHeadline,
    style: {
      margin: "0",
      color: "dark" === ad(m) ? "#f5f5f5" : "#222222"
    }
  }, d) : "", u ? e.createElement("p", {
    className: od.leafletHeroSubHeadline
  }, u) : "", e.createElement(K, {
    direction: "row",
    align: "stretch",
    justify: "center"
  }, p ? p.map(function (t, n) {
    var r = t.fields || t,
      i = r.headline,
      a = r.text,
      o = r.image,
      s = r.listItems,
      l = r.cta,
      c = o && o.fields && o.fields.title ? o.fields.title : "";
    return e.createElement(Jc, {
      flex: p.length <= 2,
      key: n,
      header: i,
      listItems: s,
      text: a,
      image: o && o.fields ? o.fields.file.url : o,
      title: c && c,
      cta: l
    });
  }) : null), (f || []).map(function (t, n) {
    return e.createElement(wd, {
      key: n,
      size: "large",
      text: t.fields ? t.fields.text : t.text,
      handleClick: function (e) {
        window.location.href = t.fields ? t.fields.url : t.url;
      }
    });
  }));
}
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n/*\n@mixin desk-1050{\n    @media (max-width: 1050px){\n        @content;\n    }\n}\n*/\n.style_leafletHero__1H3A5 {\n  padding: 50px; }\n  @media all and (max-width: 1275px) {\n    .style_leafletHero__1H3A5 {\n      padding: 20px 25px 0 25px; } }\n  @media all and (max-width: 650px) {\n    .style_leafletHero__1H3A5 {\n      padding: 10px 25px 0 25px; } }\n  @media all and (max-width: 1380px) {\n    .style_leafletHero__1H3A5 [class*="flexWrapper"] {\n      flex-wrap: nowrap !important; } }\n  @media all and (max-width: 1000px) {\n    .style_leafletHero__1H3A5 [class*="flexWrapper"] {\n      flex-wrap: wrap !important; } }\n  .style_leafletHero__1H3A5 .style_leafletHeroHeadline__3ON64 {\n    font-family: "Montserrat", sans-serif;\n    color: #222222;\n    font-size: 48px;\n    line-height: normal;\n    text-align: center;\n    padding: 28px 20px 20px; }\n    @media all and (max-width: 768px) {\n      .style_leafletHero__1H3A5 .style_leafletHeroHeadline__3ON64 {\n        margin-bottom: 0 !important;\n        line-height: 36px;\n        font-size: 32px; } }\n    @media all and (max-width: 600px) {\n      .style_leafletHero__1H3A5 .style_leafletHeroHeadline__3ON64 {\n        font-size: 24px; } }\n    @media all and (max-width: 500px) {\n      .style_leafletHero__1H3A5 .style_leafletHeroHeadline__3ON64 {\n        padding-left: 0;\n        padding-right: 0;\n        padding-bottom: 10px;\n        text-align: left; } }\n  .style_leafletHero__1H3A5 .style_leafletHeroSubHeadline__w7eqi {\n    text-align: center;\n    padding: 0 25px;\n    font-family: "Roboto", sans-serif;\n    margin-top: 0;\n    margin-bottom: 42px;\n    margin-left: auto;\n    margin-right: auto; }\n    @media all and (max-width: 1000px) {\n      .style_leafletHero__1H3A5 .style_leafletHeroSubHeadline__w7eqi {\n        margin-bottom: 28px; } }\n    @media all and (max-width: 768px) {\n      .style_leafletHero__1H3A5 .style_leafletHeroSubHeadline__w7eqi {\n        font-size: 16px; } }\n    @media all and (max-width: 500px) {\n      .style_leafletHero__1H3A5 .style_leafletHeroSubHeadline__w7eqi {\n        padding-left: 0;\n        padding-right: 0;\n        padding-bottom: 10px;\n        text-align: left; } }\n  .style_leafletHero__1H3A5 .style_cardsContainer__3xvGo {\n    display: grid;\n    grid-template-columns: auto auto auto auto;\n    grid-template-rows: auto;\n    justify-content: center; }\n    @media all and (max-width: 1100px) {\n      .style_leafletHero__1H3A5 .style_cardsContainer__3xvGo {\n        grid-template-columns: auto auto; } }\n    @media all and (max-width: 650px) {\n      .style_leafletHero__1H3A5 .style_cardsContainer__3xvGo {\n        grid-template-columns: auto; } }\n  .style_leafletHero__1H3A5 .style_flexCardsContainer__1gUsp {\n    display: grid;\n    justify-content: center;\n    grid-template-columns: auto auto; }\n    @media all and (max-width: 960px) {\n      .style_leafletHero__1H3A5 .style_flexCardsContainer__1gUsp {\n        grid-template-columns: auto; } }\n\n.style_articleInfo__30jFl {\n  width: 1440px;\n  color: #222222;\n  display: flex;\n  padding: 85px 0 30px 100px;\n  height: auto;\n  margin-right: 0;\n  align-content: center;\n  justify-self: center;\n  overflow: visible;\n  justify-content: center;\n  justify-items: center; }\n  @media all and (max-width: 1200px) {\n    .style_articleInfo__30jFl {\n      padding: 40px 0 25px 80px; } }\n  @media all and (max-width: 900px) {\n    .style_articleInfo__30jFl {\n      padding: 30px 25px 25px 25px; } }\n  @media all and (max-width: 500px) {\n    .style_articleInfo__30jFl {\n      padding: 20px 25px; } }\n  .style_articleInfo__30jFl .style_articleText__PL_gJ {\n    background-color: unset;\n    position: relative;\n    top: 75px;\n    text-align: left;\n    display: flex;\n    flex-direction: column; }\n    @media all and (max-width: 768px) {\n      .style_articleInfo__30jFl .style_articleText__PL_gJ {\n        top: 0;\n        text-align: left;\n        justify-content: center;\n        justify-self: center; } }\n    .style_articleInfo__30jFl .style_articleText__PL_gJ .style_articleTextHeadlines__1t4I1 {\n      height: auto;\n      background-color: #fff;\n      padding: 0px;\n      width: auto;\n      position: relative;\n      z-index: 1; }\n      .style_articleInfo__30jFl .style_articleText__PL_gJ .style_articleTextHeadlines__1t4I1 h2 {\n        background-color: #fff;\n        font-family: "Montserrat", sans-serif;\n        font-size: 48px;\n        line-height: 52px;\n        margin-bottom: 0px;\n        padding: 0px 28px 0px 0px; }\n        @media all and (max-width: 900px) {\n          .style_articleInfo__30jFl .style_articleText__PL_gJ .style_articleTextHeadlines__1t4I1 h2 {\n            line-height: 33px;\n            margin-right: initial;\n            font-size: 32px; } }\n      .style_articleInfo__30jFl .style_articleText__PL_gJ .style_articleTextHeadlines__1t4I1 h4 {\n        line-height: 36px;\n        font-weight: 400;\n        font-family: "Roboto", sans-serif;\n        font-size: 20px;\n        margin-top: 0px; }\n        @media all and (max-width: 900px) {\n          .style_articleInfo__30jFl .style_articleText__PL_gJ .style_articleTextHeadlines__1t4I1 h4 {\n            line-height: 24px;\n            font-size: 16px; } }\n      .style_articleInfo__30jFl .style_articleText__PL_gJ .style_articleTextHeadlines__1t4I1 p {\n        background-color: #fff;\n        padding: 0px 28px 0px 0px; }\n        @media all and (max-width: 500px) {\n          .style_articleInfo__30jFl .style_articleText__PL_gJ .style_articleTextHeadlines__1t4I1 p {\n            font-size: 16px; } }\n  .style_articleInfo__30jFl .style_articleImage__2J3iG img {\n    width: 1200px;\n    position: relative;\n    height: auto;\n    right: 100%; }\n    @media all and (max-width: 1200px) {\n      .style_articleInfo__30jFl .style_articleImage__2J3iG img {\n        width: 900px; } }\n    @media all and (max-width: 767px) {\n      .style_articleInfo__30jFl .style_articleImage__2J3iG img {\n        padding-top: 28px;\n        width: 100%;\n        right: 0; } }\n  .style_articleInfo__30jFl .style_articleOnlyText__mjY1L {\n    background-color: unset;\n    width: 100%;\n    padding: 0 25px; }\n    .style_articleInfo__30jFl .style_articleOnlyText__mjY1L .style_articleOnlyTextHeadlines__2ILh9 {\n      background-color: #fff; }\n      .style_articleInfo__30jFl .style_articleOnlyText__mjY1L .style_articleOnlyTextHeadlines__2ILh9 h1 {\n        font-size: 72px;\n        line-height: normal;\n        font-stretch: normal;\n        letter-spacing: normal;\n        font-weight: 600;\n        width: 100%; }\n        @media all and (max-width: 1024px) {\n          .style_articleInfo__30jFl .style_articleOnlyText__mjY1L .style_articleOnlyTextHeadlines__2ILh9 h1 {\n            font-size: 52px;\n            line-height: 65px; } }\n        @media all and (max-width: 500px) {\n          .style_articleInfo__30jFl .style_articleOnlyText__mjY1L .style_articleOnlyTextHeadlines__2ILh9 h1 {\n            font-size: 24px;\n            width: 90%; } }\n      .style_articleInfo__30jFl .style_articleOnlyText__mjY1L .style_articleOnlyTextHeadlines__2ILh9 p {\n        font-size: 20px;\n        line-height: 1.4;\n        width: 50%; }\n        @media all and (max-width: 1024px) {\n          .style_articleInfo__30jFl .style_articleOnlyText__mjY1L .style_articleOnlyTextHeadlines__2ILh9 p {\n            width: 100%; } }\n        @media all and (max-width: 500px) {\n          .style_articleInfo__30jFl .style_articleOnlyText__mjY1L .style_articleOnlyTextHeadlines__2ILh9 p {\n            font-size: 16px;\n            width: 90%; } }\n\n.style_TopHero__2vxlv {\n  margin-top: -72px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-size: cover;\n  background-position: center; }\n  @media all and (max-width: 768px) {\n    .style_TopHero__2vxlv {\n      padding: 100px 50px !important; } }\n  @media all and (max-width: 500px) {\n    .style_TopHero__2vxlv {\n      padding: 100px 25px !important;\n      align-items: flex-start !important; } }\n  .style_TopHero__2vxlv h1 {\n    font-size: 72px;\n    line-height: 90px;\n    margin-bottom: 0;\n    margin-top: 50px; }\n    @media all and (max-width: 1200px) {\n      .style_TopHero__2vxlv h1 {\n        font-size: 52px; } }\n    @media all and (max-width: 700px) {\n      .style_TopHero__2vxlv h1 {\n        font-size: 42px;\n        padding: 0; } }\n    @media all and (max-width: 600px) {\n      .style_TopHero__2vxlv h1 {\n        font-size: 28px;\n        line-height: 36px; } }\n  .style_TopHero__2vxlv h3 {\n    font-family: "Roboto", sans-serif;\n    text-align: left;\n    font-weight: 500;\n    margin-top: 24px;\n    margin-bottom: 30px;\n    padding-top: 0;\n    width: 65%;\n    padding-bottom: 0;\n    padding-right: 28px;\n    font-size: 20px;\n    line-height: 27px;\n    color: #f5f5f5; }\n    @media all and (max-width: 700px) {\n      .style_TopHero__2vxlv h3 {\n        font-size: 18px;\n        padding: 0;\n        line-height: 1.56em;\n        text-align: left; } }\n    @media all and (max-width: 500px) {\n      .style_TopHero__2vxlv h3 {\n        font-size: 16px;\n        text-align: left !important;\n        width: auto; } }\n  .style_TopHero__2vxlv [class*="flexWrapper"] {\n    width: 100%; }\n    .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] {\n      font-family: "Roboto", sans-serif;\n      width: 320px;\n      margin: 10px;\n      padding: 20px;\n      border-radius: 4px; }\n      @media all and (max-width: 1280px) {\n        .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] {\n          width: 300px; } }\n      @media all and (max-width: 1100px) {\n        .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] .style_imageDiv__2oohR {\n          width: 75px;\n          height: 75px; } }\n      @media all and (max-width: 1090px) {\n        .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] {\n          margin: 5px;\n          padding: 10px; } }\n      @media all and (max-width: 1000px) {\n        .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] {\n          width: 290px;\n          height: 100px;\n          margin: 5px;\n          padding: 5px; } }\n      @media all and (max-width: 950px) {\n        .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] {\n          width: 285px;\n          margin: 3px;\n          padding: 1px; } }\n      @media all and (max-width: 900px) {\n        .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] {\n          width: 320px;\n          margin: 10px;\n          padding: 0 20px; } }\n      .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] ul {\n        width: 100%;\n        line-height: 27px;\n        list-style-type: none; }\n        .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] ul li:nth-child(1) {\n          font-size: 24px; }\n          @media all and (max-width: 1280px) {\n            .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] ul li:nth-child(1) {\n              font-size: 20px; } }\n          @media all and (max-width: 900px) {\n            .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] ul li:nth-child(1) {\n              font-size: 24px; } }\n          @media all and (max-width: 640px) {\n            .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] ul li:nth-child(1) {\n              font-size: 20px; } }\n        .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] ul li:nth-child(2) {\n          font-size: 15px; }\n          @media all and (max-width: 1000px) {\n            .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] ul li:nth-child(2) {\n              font-size: 14px; } }\n          @media all and (max-width: 900px) {\n            .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] ul li:nth-child(2) {\n              font-size: 15px; } }\n      @media all and (max-width: 700px) {\n        .style_TopHero__2vxlv [class*="flexWrapper"] [class*="noticeContainer"] [class*="imageDiv"] {\n          height: 57px;\n          width: 57px; } }\n\n.style_formHeroWrapper__1ROYN {\n  max-width: 1440px;\n  justify-self: center;\n  flex-direction: column;\n  padding: 80px;\n  align-content: flex-start;\n  justify-content: center;\n  overflow: hidden; }\n  @media all and (max-width: 950px) {\n    .style_formHeroWrapper__1ROYN {\n      padding: 60px; } }\n  @media all and (max-width: 800px) {\n    .style_formHeroWrapper__1ROYN {\n      padding: 100px 25px 40px 25px; } }\n  @media all and (max-width: 650px) {\n    .style_formHeroWrapper__1ROYN {\n      flex-direction: row;\n      padding: 15px; } }\n  @media all and (max-width: 500px) {\n    .style_formHeroWrapper__1ROYN .style_formHeroImage__1fYYS {\n      width: auto;\n      margin-left: -15px;\n      margin-right: -30px; } }\n  .style_formHeroWrapper__1ROYN .style_formHeroImage__1fYYS img {\n    width: 600px;\n    height: 700px;\n    background-size: cover; }\n    @media all and (max-width: 1440px) {\n      .style_formHeroWrapper__1ROYN .style_formHeroImage__1fYYS img {\n        width: 550px;\n        height: 700px; } }\n    @media all and (max-width: 1250px) {\n      .style_formHeroWrapper__1ROYN .style_formHeroImage__1fYYS img {\n        width: 480px; } }\n    @media all and (max-width: 1080px) {\n      .style_formHeroWrapper__1ROYN .style_formHeroImage__1fYYS img {\n        width: 410px;\n        height: 650px; } }\n    @media all and (max-width: 980px) {\n      .style_formHeroWrapper__1ROYN .style_formHeroImage__1fYYS img {\n        width: 375px;\n        height: 600px; } }\n    @media all and (max-width: 900px) {\n      .style_formHeroWrapper__1ROYN .style_formHeroImage__1fYYS img {\n        width: 350px;\n        height: 575px; } }\n    @media all and (max-width: 850px) {\n      .style_formHeroWrapper__1ROYN .style_formHeroImage__1fYYS img {\n        width: 325px; } }\n    @media all and (max-width: 800px) {\n      .style_formHeroWrapper__1ROYN .style_formHeroImage__1fYYS img {\n        width: 100%;\n        margin-left: -15px;\n        margin-right: -15px;\n        height: 100%; } }\n  .style_formHeroWrapper__1ROYN .style_formHeroText__U0NZA {\n    text-align: left;\n    padding: 0 25px;\n    align-self: center; }\n    @media all and (max-width: 650px) {\n      .style_formHeroWrapper__1ROYN .style_formHeroText__U0NZA {\n        padding: 25px; } }\n    .style_formHeroWrapper__1ROYN .style_formHeroText__U0NZA h2 {\n      font-size: 48px;\n      font-weight: 600;\n      line-height: 52px;\n      font-family: "Montserrat", sans-serif; }\n      @media all and (max-width: 950px) {\n        .style_formHeroWrapper__1ROYN .style_formHeroText__U0NZA h2 {\n          font-size: 32px;\n          line-height: 1.38;\n          text-align: center; } }\n      @media all and (max-width: 950px) {\n        .style_formHeroWrapper__1ROYN .style_formHeroText__U0NZA h2 {\n          text-align: left; } }\n      @media all and (max-width: 700px) {\n        .style_formHeroWrapper__1ROYN .style_formHeroText__U0NZA h2 {\n          font-size: 24px; } }\n    @media all and (max-width: 700px) {\n      .style_formHeroWrapper__1ROYN .style_formHeroText__U0NZA p {\n        font-size: 16px; } }\n  .style_formHeroWrapper__1ROYN img {\n    max-width: 100%; }\n  .style_formHeroWrapper__1ROYN .style_respContainer__Lyay5 {\n    position: relative;\n    overflow: hidden;\n    padding-top: 56.25%; }\n  .style_formHeroWrapper__1ROYN .style_respIframe__7jK2R {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0; }\n\n.style_formHeroSplitWrapper__2Xdod {\n  padding: 100px 20px;\n  flex-direction: column;\n  height: auto; }\n  @media all and (max-width: 950px) {\n    .style_formHeroSplitWrapper__2Xdod {\n      padding: 60px 20px; } }\n  @media all and (max-width: 800px) {\n    .style_formHeroSplitWrapper__2Xdod {\n      padding: 40px 0; } }\n  .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf img {\n    width: 600px;\n    height: 700px; }\n    @media all and (max-width: 1440px) {\n      .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf img {\n        width: 550px;\n        height: 700px; } }\n    @media all and (max-width: 1250px) {\n      .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf img {\n        width: 490px; } }\n    @media all and (max-width: 1080px) {\n      .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf img {\n        width: 410px;\n        height: 650px; } }\n    @media all and (max-width: 980px) {\n      .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf img {\n        width: 375px;\n        height: 600px; } }\n    @media all and (max-width: 900px) {\n      .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf img {\n        width: 350px;\n        height: 575px; } }\n    @media all and (max-width: 800px) {\n      .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf img {\n        width: 100%;\n        height: 400px; } }\n  .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf h1 {\n    line-height: 52px;\n    font-size: 32px; }\n    @media all and (max-width: 800px) {\n      .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf h1 {\n        line-height: 27px;\n        padding: 0 20px; } }\n    @media all and (max-width: 700px) {\n      .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf h1 {\n        font-size: 24px; } }\n  .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf h4 {\n    line-height: 36px;\n    font-size: 20px; }\n    @media all and (max-width: 800px) {\n      .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf h4 {\n        line-height: 27px;\n        padding: 0 20px; } }\n    @media all and (max-width: 700px) {\n      .style_formHeroSplitWrapper__2Xdod .style_formHeroLeft__1lvPf h4 {\n        font-size: 16px; } }\n  .style_formHeroSplitWrapper__2Xdod .style_formHeroRight__3zpM6 {\n    justify-self: center; }\n    .style_formHeroSplitWrapper__2Xdod .style_formHeroRight__3zpM6 iframe {\n      border: 3px solid darkgrey; }\n      @media all and (max-width: 1100px) {\n        .style_formHeroSplitWrapper__2Xdod .style_formHeroRight__3zpM6 iframe {\n          width: 430px; } }\n      @media all and (max-width: 850px) {\n        .style_formHeroSplitWrapper__2Xdod .style_formHeroRight__3zpM6 iframe {\n          width: 330px; } }\n      @media all and (max-width: 799px) {\n        .style_formHeroSplitWrapper__2Xdod .style_formHeroRight__3zpM6 iframe {\n          width: 500px; } }\n      @media all and (max-width: 600px) {\n        .style_formHeroSplitWrapper__2Xdod .style_formHeroRight__3zpM6 iframe {\n          width: 400px; } }\n      @media all and (max-width: 420px) {\n        .style_formHeroSplitWrapper__2Xdod .style_formHeroRight__3zpM6 iframe {\n          width: 350px; } }\n');
var dd = require("react-markdown");
function ud(t) {
  var n = t.json,
    r = void 0 === n ? {} : n,
    i = t.headline,
    a = t.subHeadline,
    o = t.formUrl,
    s = t.formProportions,
    l = t.image,
    c = t.formherolayout,
    d = r.headline || i || "",
    u = r.subHeadline || a,
    p = r.formUrl ? r.formUrl : o,
    m = r.formProportions ? r.formProportions : s,
    f = r.formherolayout ? r.formherolayout : c,
    g = l || r.image,
    _ = r.image && r.image.fields && r.image.fields.title,
    y = p;
  return e.createElement(Qt, {
    breakpoints: [0, 750, 1440],
    colspan: [12],
    cssMode: "flex",
    left: "0",
    right: "0"
  }, 1 !== f && f ? 2 === f ? e.createElement(en, {
    className: od.formHeroWrapper,
    cols: 12
  }, e.createElement(en, {
    cols: [12, 12, 6, 6],
    className: g ? od.formHeroImage : od.formHeroForm
  }, g && g.fields ? e.createElement("img", {
    src: g.fields.file.url,
    alt: _
  }) : y ? e.createElement("iframe", {
    className: od.theIframe,
    src: y.content[0].content[0].value,
    scrolling: "no",
    allowtransparency: "true",
    width: "500px",
    height: "750px",
    type: "text/html"
  }) : null), e.createElement(en, {
    cols: [12, 12, 6, 6],
    className: od.formHeroText
  }, e.createElement("a", {
    id: d.toLowerCase().replace(/ /gi, "_")
  }), e.createElement("h2", null, d), e.createElement("h4", null, e.createElement(dd, {
    source: u
  })))) : 3 === f ? e.createElement(en, {
    className: od.formHeroSplitWrapper,
    cols: 12
  }, e.createElement(en, {
    cols: [12, 12, 6],
    className: od.formHeroLeft
  }, g && g.fields && e.createElement("img", {
    src: g.fields.file.url,
    alt: _
  }), e.createElement("a", {
    id: d.toLowerCase().replace(/ /gi, "_")
  }), e.createElement("h2", null, d), e.createElement("h4", null, e.createElement(dd, {
    source: u
  }))), e.createElement(en, {
    cols: [12, 12, 6],
    className: od.formHeroRight
  }, e.createElement("iframe", {
    className: "".concat(od.theIframe, " lazyload"),
    src: y.content[0].content[0].value,
    scrolling: "no",
    allowtransparency: "true",
    type: "text/html"
  }))) : null : e.createElement(en, {
    className: od.formHeroWrapper,
    cols: 12
  }, e.createElement(en, {
    cols: [12, 12, 6],
    className: od.formHeroText
  }, e.createElement("a", {
    id: d.toLowerCase().replace(/ /gi, "_")
  }), e.createElement("h2", null, d), e.createElement("h4", null, e.createElement(dd, {
    source: u
  }))), e.createElement(en, {
    cols: [12, 12, 6],
    className: g ? od.formHeroImage : od.formHeroForm
  }, e.createElement("div", {
    className: od.respContainer,
    style: {
      paddingTop: "".concat(m, "%") || "65%"
    }
  }, e.createElement("iframe", {
    className: od.respIframe,
    src: y,
    allowtransparency: "true"
  })))));
}
function pd(t) {
  var n = t.json,
    r = void 0 === n ? {} : n,
    i = t.backgroundColor,
    a = void 0 === i ? "#d8d8d8" : i,
    o = t.cta,
    s = r.backgroundColor || a,
    l = r.cta ? r.cta[0].fields : o;
  return e.createElement("section", {
    style: {
      height: 496,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: s
    }
  }, e.createElement(K, {
    direction: "row",
    justify: "center",
    align: "center"
  }, e.createElement(Op, {
    value: "",
    width: 600,
    handleSubmit: function (e) {
      "" !== e.trim() && (window.location.href = "".concat(l.url).concat(e));
    },
    selected: "kreativt"
  })));
}
var md = function t(n) {
  var r = n.type,
    i = n.item,
    a = n.headline,
    o = n.subHeadline,
    s = n.image,
    l = n.leaflet,
    c = n.cta,
    d = n.level,
    u = n.backgroundColor,
    p = n.index,
    m = void 0 === p ? 0 : p;
  if (!(r || i && i.fields)) return null;
  switch (r || i.fields.heroType) {
    case "superhero":
      return i ? e.createElement(sd, {
        key: m,
        json: i ? i.fields : {}
      }) : e.createElement(sd, {
        key: m,
        headline: a,
        subHeadline: o,
        image: s,
        cta: c,
        level: d,
        backgroundColor: u
      });
    case "normalhero":
      return i ? e.createElement(ld, {
        key: m,
        json: i ? i.fields : {}
      }) : e.createElement(ld, {
        key: m,
        headline: a,
        subHeadline: o,
        image: s,
        cta: c,
        backgroundColor: u
      });
    case "leaflethero":
      return i ? e.createElement(cd, {
        key: m,
        json: i ? i.fields : {}
      }) : e.createElement(cd, {
        key: m,
        headline: a,
        subHeadline: o,
        leaflet: l,
        cta: c,
        backgroundColor: u
      });
    case "formhero":
      return i ? e.createElement(ud, {
        key: m,
        json: i ? i.fields : {}
      }) : e.createElement(ud, {
        key: m,
        headline: a,
        image: s,
        subHeadline: o,
        formUrl: "https://go.pardot.com/l/858403/2020-06-15/4c56m",
        formherolayout: 1
      });
    case "searchhero":
      return i ? e.createElement(pd, {
        key: m,
        json: i ? i.fields : {}
      }) : e.createElement(pd, {
        key: m,
        headline: a,
        subHeadline: o,
        leaflet: l,
        cta: c,
        backgroundColor: u
      });
    default:
      return e.createElement(Qt, {
        left: "0px",
        right: "0px",
        top: "0px",
        bottom: "0px"
      }, i && i.fields.block.map(function (n, r) {
        return e.createElement(en, {
          cols: [12, 12, 6, 6]
        }, t(n.heroType));
      }));
  }
};
function fd(t) {
  return e.createElement("div", null, md(t));
}
var gd = "style_small__1PlH1",
  _d = "style_medium__2bGXy",
  yd = "style_large__UrO_9",
  hd = "style_primaryButton__2CcIN",
  vd = "style_disabledButton__1F_fB",
  bd = "style_secondaryButton__1zs_n",
  xd = "style_dangerButton__2q-EX";
function Ed(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ed(Object(n), !0).forEach(function (t) {
      X(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ed(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function Td(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\nbutton {\n  width: auto;\n  border-radius: 3px;\n  text-align: center;\n  margin: 0; }\n  button:hover {\n    cursor: pointer;\n    -webkit-transition: background-color .4s ease-out;\n    -moz-transition: background-color .4s ease-out;\n    -o-transition: background-color .4s ease-out;\n    transition: background-color .4s ease-out; }\n  button.style_small__1PlH1 {\n    padding: 4px 20px; }\n  button.style_medium__2bGXy {\n    padding: 7px 20px; }\n  button.style_large__UrO_9 {\n    padding: 12px 40px !important; }\n\n/* Button */\n.style_primaryButton__2CcIN {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  background-color: #3f51bf;\n  color: #fff;\n  border: solid 1px #3f51bf; }\n  .style_primaryButton__2CcIN:hover {\n    background-color: #2e3b8c; }\n  .style_primaryButton__2CcIN:active {\n    background-color: #1D2559; }\n  .style_primaryButton__2CcIN.style_disabledButton__1F_fB {\n    background-color: rgba(63, 81, 191, 0.4);\n    color: rgba(255, 255, 255, 0.7);\n    border: solid 1px rgba(63, 81, 191, 0.4);\n    cursor: auto !important; }\n    .style_primaryButton__2CcIN.style_disabledButton__1F_fB:focus {\n      outline: none; }\n\n.style_secondaryButton__1zs_n {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  background-color: #fff;\n  color: #222;\n  border: solid 1px #979797; }\n  .style_secondaryButton__1zs_n:hover {\n    background-color: #e8e8e8; }\n  .style_secondaryButton__1zs_n:active {\n    background-color: rgba(63, 81, 191, 0.3); }\n  .style_secondaryButton__1zs_n.style_disabledButton__1F_fB {\n    background-color: rgba(255, 255, 255, 0.9);\n    color: rgba(0, 0, 1, 0.4);\n    border: solid 1px rgba(0, 0, 0, 0.25);\n    cursor: auto !important; }\n    .style_secondaryButton__1zs_n.style_disabledButton__1F_fB:focus {\n      outline: none; }\n\n.style_dangerButton__2q-EX {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  background-color: #c62828;\n  color: #fff;\n  border: solid 1px #c62828; }\n  .style_dangerButton__2q-EX:hover {\n    background-color: #661414; }\n  .style_dangerButton__2q-EX:active {\n    background-color: #4d0f0f; }\n  .style_dangerButton__2q-EX.style_disabledButton__1F_fB {\n    background-color: #e8a9a9;\n    color: rgba(255, 255, 255, 0.7);\n    border: solid 1px #e8a9a9;\n    cursor: auto !important; }\n    .style_dangerButton__2q-EX.style_disabledButton__1F_fB:focus {\n      outline: none; }\n\n[class*="grid_shady__"] .style_primaryButton__2CcIN {\n  background-color: #fff;\n  color: rgba(0, 0, 0, 0.75); }\n');
var wd = function (t) {
  ee(r, a);
  var n = Td(r);
  function r() {
    return q(this, r), n.apply(this, arguments);
  }
  return Q(r, [{
    key: "sizeClz",
    value: function (e) {
      switch (e) {
        case "small":
          return gd;
        case "large":
          return yd;
        default:
          return _d;
      }
    }
  }, {
    key: "levelClz",
    value: function (e) {
      switch (e) {
        case "secondary":
          return bd;
        case "danger":
          return xd;
        default:
          return hd;
      }
    }
  }, {
    key: "render",
    value: function () {
      var t = this.props,
        n = t.handleClick,
        r = t.text,
        i = void 0 === r ? "button" : r,
        a = t.level,
        o = void 0 === a ? "primary" : a,
        s = t.size,
        l = void 0 === s ? "medium" : s,
        c = t.icon,
        d = t.disabled,
        u = void 0 !== d && d,
        p = t.style,
        m = t.stretch,
        f = void 0 !== m && m,
        g = t.submit,
        _ = void 0 !== g && g;
      return e.createElement("button", {
        type: _ ? "submit" : "button",
        className: "".concat(this.sizeClz(l), " ").concat(u ? vd : "", " ").concat(this.levelClz(o)),
        onClick: n,
        style: kd({
          width: f ? "100%" : "auto"
        }, p)
      }, e.createElement(K, {
        direction: "row",
        align: "center",
        justify: "center"
      }, c ? e.createElement(nd, {
        style: {
          marginRight: 6
        },
        icon: c,
        color: "secondary" !== o ? "#fff" : "rgba(0, 0, 0, 0.87)",
        size: l
      }) : " ", i));
    }
  }]), r;
}();
function Ad(e) {
  if (null === e || !0 === e || !1 === e) return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Cd(e, t) {
  if (t.length < e) throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Sd(e) {
  Cd(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || "object" == typeof e && "[object Date]" === t ? new Date(e.getTime()) : "number" == typeof e || "[object Number]" === t ? new Date(e) : ("string" != typeof e && "[object String]" !== t || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}
function Nd(e, t) {
  Cd(2, arguments);
  var n = Sd(e),
    r = Ad(t);
  return isNaN(r) ? new Date(NaN) : r ? (n.setDate(n.getDate() + r), n) : n;
}
function Od(e, t) {
  Cd(2, arguments);
  var n = Sd(e),
    r = Ad(t);
  if (isNaN(r)) return new Date(NaN);
  if (!r) return n;
  var i = n.getDate(),
    a = new Date(n.getTime());
  a.setMonth(n.getMonth() + r + 1, 0);
  var o = a.getDate();
  return i >= o ? a : (n.setFullYear(a.getFullYear(), a.getMonth(), i), n);
}
function Rd(e, t) {
  Cd(2, arguments);
  var n = Sd(e).getTime(),
    r = Ad(t);
  return new Date(n + r);
}
function Id(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Ld(e) {
  Cd(1, arguments);
  var t = Sd(e);
  return t.setHours(0, 0, 0, 0), t;
}
function jd(e) {
  Cd(1, arguments);
  var t = Sd(e);
  return !isNaN(t);
}
function Dd(e, t) {
  Cd(2, arguments);
  var n = Ld(e),
    r = Ld(t);
  return n.getTime() === r.getTime();
}
function Fd(e) {
  Cd(1, arguments);
  var t = Sd(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
var Md = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
function Pd(e) {
  return function (t) {
    var n = t || {},
      r = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
var Bd = {
    date: Pd({
      formats: {
        full: "EEEE, MMMM do, y",
        long: "MMMM do, y",
        medium: "MMM d, y",
        short: "MM/dd/yyyy"
      },
      defaultWidth: "full"
    }),
    time: Pd({
      formats: {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      },
      defaultWidth: "full"
    }),
    dateTime: Pd({
      formats: {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: "{{date}}, {{time}}",
        short: "{{date}}, {{time}}"
      },
      defaultWidth: "full"
    })
  },
  Hd = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  };
function zd(e) {
  return function (t, n) {
    var r,
      i = n || {};
    if ("formatting" === (i.context ? String(i.context) : "standalone") && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth,
        o = i.width ? String(i.width) : a;
      r = e.formattingValues[o] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth,
        l = i.width ? String(i.width) : e.defaultWidth;
      r = e.values[l] || e.values[s];
    }
    return r[e.argumentCallback ? e.argumentCallback(t) : t];
  };
}
function Ud(e) {
  return function (t, n) {
    var r = String(t),
      i = n || {},
      a = r.match(e.matchPattern);
    if (!a) return null;
    var o = a[0],
      s = r.match(e.parsePattern);
    if (!s) return null;
    var l = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    return {
      value: l = i.valueCallback ? i.valueCallback(l) : l,
      rest: r.slice(o.length)
    };
  };
}
function Wd(e) {
  return function (t, n) {
    var r = String(t),
      i = n || {},
      a = i.width,
      o = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth],
      s = r.match(o);
    if (!s) return null;
    var l,
      c = s[0],
      d = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth];
    return l = "[object Array]" === Object.prototype.toString.call(d) ? function (e, t) {
      for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
    }(d, function (e) {
      return e.test(c);
    }) : function (e, t) {
      for (var n in e) if (e.hasOwnProperty(n) && t(e[n])) return n;
    }(d, function (e) {
      return e.test(c);
    }), l = e.valueCallback ? e.valueCallback(l) : l, {
      value: l = i.valueCallback ? i.valueCallback(l) : l,
      rest: r.slice(c.length)
    };
  };
}
var Xd = {
  code: "en-US",
  formatDistance: function (e, t, n) {
    var r;
    return n = n || {}, r = "string" == typeof Md[e] ? Md[e] : 1 === t ? Md[e].one : Md[e].other.replace("{{count}}", t), n.addSuffix ? n.comparison > 0 ? "in " + r : r + " ago" : r;
  },
  formatLong: Bd,
  formatRelative: function (e, t, n, r) {
    return Hd[e];
  },
  localize: {
    ordinalNumber: function (e, t) {
      var n = Number(e),
        r = n % 100;
      if (r > 20 || r < 10) switch (r % 10) {
        case 1:
          return n + "st";
        case 2:
          return n + "nd";
        case 3:
          return n + "rd";
      }
      return n + "th";
    },
    era: zd({
      values: {
        narrow: ["B", "A"],
        abbreviated: ["BC", "AD"],
        wide: ["Before Christ", "Anno Domini"]
      },
      defaultWidth: "wide"
    }),
    quarter: zd({
      values: {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
      },
      defaultWidth: "wide",
      argumentCallback: function (e) {
        return Number(e) - 1;
      }
    }),
    month: zd({
      values: {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      },
      defaultWidth: "wide"
    }),
    day: zd({
      values: {
        narrow: ["S", "M", "T", "W", "T", "F", "S"],
        short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      },
      defaultWidth: "wide"
    }),
    dayPeriod: zd({
      values: {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        }
      },
      defaultWidth: "wide",
      formattingValues: {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        }
      },
      defaultFormattingWidth: "wide"
    })
  },
  match: {
    ordinalNumber: Ud({
      matchPattern: /^(\d+)(th|st|nd|rd)?/i,
      parsePattern: /\d+/i,
      valueCallback: function (e) {
        return parseInt(e, 10);
      }
    }),
    era: Wd({
      matchPatterns: {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        any: [/^b/i, /^(a|c)/i]
      },
      defaultParseWidth: "any"
    }),
    quarter: Wd({
      matchPatterns: {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        any: [/1/i, /2/i, /3/i, /4/i]
      },
      defaultParseWidth: "any",
      valueCallback: function (e) {
        return e + 1;
      }
    }),
    month: Wd({
      matchPatterns: {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      },
      defaultParseWidth: "any"
    }),
    day: Wd({
      matchPatterns: {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      },
      defaultParseWidth: "any"
    }),
    dayPeriod: Wd({
      matchPatterns: {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      },
      defaultMatchWidth: "any",
      parsePatterns: {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      },
      defaultParseWidth: "any"
    })
  },
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Gd(e, t) {
  Cd(2, arguments);
  var n = Ad(t);
  return Rd(e, -n);
}
function Vd(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t;) r = "0" + r;
  return n + r;
}
var Yd = function (e, t) {
    var n = e.getUTCFullYear(),
      r = n > 0 ? n : 1 - n;
    return Vd("yy" === t ? r % 100 : r, t.length);
  },
  Kd = function (e, t) {
    var n = e.getUTCMonth();
    return "M" === t ? String(n + 1) : Vd(n + 1, 2);
  },
  Zd = function (e, t) {
    return Vd(e.getUTCDate(), t.length);
  },
  qd = function (e, t) {
    return Vd(e.getUTCHours() % 12 || 12, t.length);
  },
  Jd = function (e, t) {
    return Vd(e.getUTCHours(), t.length);
  },
  Qd = function (e, t) {
    return Vd(e.getUTCMinutes(), t.length);
  },
  $d = function (e, t) {
    return Vd(e.getUTCSeconds(), t.length);
  },
  eu = function (e, t) {
    var n = t.length,
      r = e.getUTCMilliseconds();
    return Vd(Math.floor(r * Math.pow(10, n - 3)), t.length);
  };
function tu(e) {
  Cd(1, arguments);
  var t = 1,
    n = Sd(e),
    r = n.getUTCDay(),
    i = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function nu(e) {
  Cd(1, arguments);
  var t = Sd(e),
    n = t.getUTCFullYear(),
    r = new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = tu(r),
    a = new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = tu(a);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function ru(e) {
  Cd(1, arguments);
  var t = nu(e),
    n = new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = tu(n);
  return r;
}
function iu(e, t) {
  Cd(1, arguments);
  var n = t || {},
    r = n.locale,
    i = r && r.options && r.options.weekStartsOn,
    a = null == i ? 0 : Ad(i),
    o = null == n.weekStartsOn ? a : Ad(n.weekStartsOn);
  if (!(o >= 0 && o <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var s = Sd(e),
    l = s.getUTCDay(),
    c = (l < o ? 7 : 0) + l - o;
  return s.setUTCDate(s.getUTCDate() - c), s.setUTCHours(0, 0, 0, 0), s;
}
function au(e, t) {
  Cd(1, arguments);
  var n = Sd(e, t),
    r = n.getUTCFullYear(),
    i = t || {},
    a = i.locale,
    o = a && a.options && a.options.firstWeekContainsDate,
    s = null == o ? 1 : Ad(o),
    l = null == i.firstWeekContainsDate ? s : Ad(i.firstWeekContainsDate);
  if (!(l >= 1 && l <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var c = new Date(0);
  c.setUTCFullYear(r + 1, 0, l), c.setUTCHours(0, 0, 0, 0);
  var d = iu(c, t),
    u = new Date(0);
  u.setUTCFullYear(r, 0, l), u.setUTCHours(0, 0, 0, 0);
  var p = iu(u, t);
  return n.getTime() >= d.getTime() ? r + 1 : n.getTime() >= p.getTime() ? r : r - 1;
}
function ou(e, t) {
  Cd(1, arguments);
  var n = t || {},
    r = n.locale,
    i = r && r.options && r.options.firstWeekContainsDate,
    a = null == i ? 1 : Ad(i),
    o = null == n.firstWeekContainsDate ? a : Ad(n.firstWeekContainsDate),
    s = au(e, t),
    l = new Date(0);
  l.setUTCFullYear(s, 0, o), l.setUTCHours(0, 0, 0, 0);
  var c = iu(l, t);
  return c;
}
var su = "midnight",
  lu = "noon",
  cu = "morning",
  du = "afternoon",
  uu = "evening",
  pu = "night",
  mu = {
    G: function (e, t, n) {
      var r = e.getUTCFullYear() > 0 ? 1 : 0;
      switch (t) {
        case "G":
        case "GG":
        case "GGG":
          return n.era(r, {
            width: "abbreviated"
          });
        case "GGGGG":
          return n.era(r, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return n.era(r, {
            width: "wide"
          });
      }
    },
    y: function (e, t, n) {
      if ("yo" === t) {
        var r = e.getUTCFullYear(),
          i = r > 0 ? r : 1 - r;
        return n.ordinalNumber(i, {
          unit: "year"
        });
      }
      return Yd(e, t);
    },
    Y: function (e, t, n, r) {
      var i = au(e, r),
        a = i > 0 ? i : 1 - i;
      return "YY" === t ? Vd(a % 100, 2) : "Yo" === t ? n.ordinalNumber(a, {
        unit: "year"
      }) : Vd(a, t.length);
    },
    R: function (e, t) {
      return Vd(nu(e), t.length);
    },
    u: function (e, t) {
      return Vd(e.getUTCFullYear(), t.length);
    },
    Q: function (e, t, n) {
      var r = Math.ceil((e.getUTCMonth() + 1) / 3);
      switch (t) {
        case "Q":
          return String(r);
        case "QQ":
          return Vd(r, 2);
        case "Qo":
          return n.ordinalNumber(r, {
            unit: "quarter"
          });
        case "QQQ":
          return n.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return n.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return n.quarter(r, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    q: function (e, t, n) {
      var r = Math.ceil((e.getUTCMonth() + 1) / 3);
      switch (t) {
        case "q":
          return String(r);
        case "qq":
          return Vd(r, 2);
        case "qo":
          return n.ordinalNumber(r, {
            unit: "quarter"
          });
        case "qqq":
          return n.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return n.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return n.quarter(r, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    M: function (e, t, n) {
      var r = e.getUTCMonth();
      switch (t) {
        case "M":
        case "MM":
          return Kd(e, t);
        case "Mo":
          return n.ordinalNumber(r + 1, {
            unit: "month"
          });
        case "MMM":
          return n.month(r, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return n.month(r, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return n.month(r, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    L: function (e, t, n) {
      var r = e.getUTCMonth();
      switch (t) {
        case "L":
          return String(r + 1);
        case "LL":
          return Vd(r + 1, 2);
        case "Lo":
          return n.ordinalNumber(r + 1, {
            unit: "month"
          });
        case "LLL":
          return n.month(r, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return n.month(r, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return n.month(r, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    w: function (e, t, n, r) {
      var i = function (e, t) {
        Cd(1, arguments);
        var n = Sd(e),
          r = iu(n, t).getTime() - ou(n, t).getTime();
        return Math.round(r / 6048e5) + 1;
      }(e, r);
      return "wo" === t ? n.ordinalNumber(i, {
        unit: "week"
      }) : Vd(i, t.length);
    },
    I: function (e, t, n) {
      var r = function (e) {
        Cd(1, arguments);
        var t = Sd(e),
          n = tu(t).getTime() - ru(t).getTime();
        return Math.round(n / 6048e5) + 1;
      }(e);
      return "Io" === t ? n.ordinalNumber(r, {
        unit: "week"
      }) : Vd(r, t.length);
    },
    d: function (e, t, n) {
      return "do" === t ? n.ordinalNumber(e.getUTCDate(), {
        unit: "date"
      }) : Zd(e, t);
    },
    D: function (e, t, n) {
      var r = function (e) {
        Cd(1, arguments);
        var t = Sd(e),
          n = t.getTime();
        t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
        var r = t.getTime(),
          i = n - r;
        return Math.floor(i / 864e5) + 1;
      }(e);
      return "Do" === t ? n.ordinalNumber(r, {
        unit: "dayOfYear"
      }) : Vd(r, t.length);
    },
    E: function (e, t, n) {
      var r = e.getUTCDay();
      switch (t) {
        case "E":
        case "EE":
        case "EEE":
          return n.day(r, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return n.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return n.day(r, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return n.day(r, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    e: function (e, t, n, r) {
      var i = e.getUTCDay(),
        a = (i - r.weekStartsOn + 8) % 7 || 7;
      switch (t) {
        case "e":
          return String(a);
        case "ee":
          return Vd(a, 2);
        case "eo":
          return n.ordinalNumber(a, {
            unit: "day"
          });
        case "eee":
          return n.day(i, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return n.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return n.day(i, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return n.day(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    c: function (e, t, n, r) {
      var i = e.getUTCDay(),
        a = (i - r.weekStartsOn + 8) % 7 || 7;
      switch (t) {
        case "c":
          return String(a);
        case "cc":
          return Vd(a, t.length);
        case "co":
          return n.ordinalNumber(a, {
            unit: "day"
          });
        case "ccc":
          return n.day(i, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return n.day(i, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return n.day(i, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return n.day(i, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    i: function (e, t, n) {
      var r = e.getUTCDay(),
        i = 0 === r ? 7 : r;
      switch (t) {
        case "i":
          return String(i);
        case "ii":
          return Vd(i, t.length);
        case "io":
          return n.ordinalNumber(i, {
            unit: "day"
          });
        case "iii":
          return n.day(r, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return n.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return n.day(r, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return n.day(r, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    a: function (e, t, n) {
      var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (t) {
        case "a":
        case "aa":
          return n.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return n.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return n.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    b: function (e, t, n) {
      var r,
        i = e.getUTCHours();
      switch (r = 12 === i ? lu : 0 === i ? su : i / 12 >= 1 ? "pm" : "am", t) {
        case "b":
        case "bb":
          return n.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return n.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return n.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    B: function (e, t, n) {
      var r,
        i = e.getUTCHours();
      switch (r = i >= 17 ? uu : i >= 12 ? du : i >= 4 ? cu : pu, t) {
        case "B":
        case "BB":
        case "BBB":
          return n.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return n.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return n.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    h: function (e, t, n) {
      if ("ho" === t) {
        var r = e.getUTCHours() % 12;
        return 0 === r && (r = 12), n.ordinalNumber(r, {
          unit: "hour"
        });
      }
      return qd(e, t);
    },
    H: function (e, t, n) {
      return "Ho" === t ? n.ordinalNumber(e.getUTCHours(), {
        unit: "hour"
      }) : Jd(e, t);
    },
    K: function (e, t, n) {
      var r = e.getUTCHours() % 12;
      return "Ko" === t ? n.ordinalNumber(r, {
        unit: "hour"
      }) : Vd(r, t.length);
    },
    k: function (e, t, n) {
      var r = e.getUTCHours();
      return 0 === r && (r = 24), "ko" === t ? n.ordinalNumber(r, {
        unit: "hour"
      }) : Vd(r, t.length);
    },
    m: function (e, t, n) {
      return "mo" === t ? n.ordinalNumber(e.getUTCMinutes(), {
        unit: "minute"
      }) : Qd(e, t);
    },
    s: function (e, t, n) {
      return "so" === t ? n.ordinalNumber(e.getUTCSeconds(), {
        unit: "second"
      }) : $d(e, t);
    },
    S: function (e, t) {
      return eu(e, t);
    },
    X: function (e, t, n, r) {
      var i = (r._originalDate || e).getTimezoneOffset();
      if (0 === i) return "Z";
      switch (t) {
        case "X":
          return gu(i);
        case "XXXX":
        case "XX":
          return _u(i);
        case "XXXXX":
        case "XXX":
        default:
          return _u(i, ":");
      }
    },
    x: function (e, t, n, r) {
      var i = (r._originalDate || e).getTimezoneOffset();
      switch (t) {
        case "x":
          return gu(i);
        case "xxxx":
        case "xx":
          return _u(i);
        case "xxxxx":
        case "xxx":
        default:
          return _u(i, ":");
      }
    },
    O: function (e, t, n, r) {
      var i = (r._originalDate || e).getTimezoneOffset();
      switch (t) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + fu(i, ":");
        case "OOOO":
        default:
          return "GMT" + _u(i, ":");
      }
    },
    z: function (e, t, n, r) {
      var i = (r._originalDate || e).getTimezoneOffset();
      switch (t) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + fu(i, ":");
        case "zzzz":
        default:
          return "GMT" + _u(i, ":");
      }
    },
    t: function (e, t, n, r) {
      var i = r._originalDate || e;
      return Vd(Math.floor(i.getTime() / 1e3), t.length);
    },
    T: function (e, t, n, r) {
      return Vd((r._originalDate || e).getTime(), t.length);
    }
  };
function fu(e, t) {
  var n = e > 0 ? "-" : "+",
    r = Math.abs(e),
    i = Math.floor(r / 60),
    a = r % 60;
  if (0 === a) return n + String(i);
  var o = t || "";
  return n + String(i) + o + Vd(a, 2);
}
function gu(e, t) {
  return e % 60 == 0 ? (e > 0 ? "-" : "+") + Vd(Math.abs(e) / 60, 2) : _u(e, t);
}
function _u(e, t) {
  var n = t || "",
    r = e > 0 ? "-" : "+",
    i = Math.abs(e);
  return r + Vd(Math.floor(i / 60), 2) + n + Vd(i % 60, 2);
}
function yu(e, t) {
  switch (e) {
    case "P":
      return t.date({
        width: "short"
      });
    case "PP":
      return t.date({
        width: "medium"
      });
    case "PPP":
      return t.date({
        width: "long"
      });
    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}
function hu(e, t) {
  switch (e) {
    case "p":
      return t.time({
        width: "short"
      });
    case "pp":
      return t.time({
        width: "medium"
      });
    case "ppp":
      return t.time({
        width: "long"
      });
    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}
var vu = {
    p: hu,
    P: function (e, t) {
      var n,
        r = e.match(/(P+)(p+)?/),
        i = r[1],
        a = r[2];
      if (!a) return yu(e, t);
      switch (i) {
        case "P":
          n = t.dateTime({
            width: "short"
          });
          break;
        case "PP":
          n = t.dateTime({
            width: "medium"
          });
          break;
        case "PPP":
          n = t.dateTime({
            width: "long"
          });
          break;
        case "PPPP":
        default:
          n = t.dateTime({
            width: "full"
          });
      }
      return n.replace("{{date}}", yu(i, t)).replace("{{time}}", hu(a, t));
    }
  },
  bu = ["D", "DD"],
  xu = ["YY", "YYYY"];
function Eu(e) {
  return -1 !== bu.indexOf(e);
}
function ku(e) {
  return -1 !== xu.indexOf(e);
}
function Tu(e, t, n) {
  if ("YYYY" === e) throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://git.io/fxCyr"));
  if ("YY" === e) throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://git.io/fxCyr"));
  if ("D" === e) throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://git.io/fxCyr"));
  if ("DD" === e) throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://git.io/fxCyr"));
}
var wu = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  Au = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  Cu = /^'([^]*?)'?$/,
  Su = /''/g,
  Nu = /[a-zA-Z]/;
function Ou(e, t, n) {
  Cd(2, arguments);
  var r = String(t),
    i = n || {},
    a = i.locale || Xd,
    o = a.options && a.options.firstWeekContainsDate,
    s = null == o ? 1 : Ad(o),
    l = null == i.firstWeekContainsDate ? s : Ad(i.firstWeekContainsDate);
  if (!(l >= 1 && l <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var c = a.options && a.options.weekStartsOn,
    d = null == c ? 0 : Ad(c),
    u = null == i.weekStartsOn ? d : Ad(i.weekStartsOn);
  if (!(u >= 0 && u <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!a.localize) throw new RangeError("locale must contain localize property");
  if (!a.formatLong) throw new RangeError("locale must contain formatLong property");
  var p = Sd(e);
  if (!jd(p)) throw new RangeError("Invalid time value");
  var m = Id(p),
    f = Gd(p, m),
    g = {
      firstWeekContainsDate: l,
      weekStartsOn: u,
      locale: a,
      _originalDate: p
    },
    _ = r.match(Au).map(function (e) {
      var t = e[0];
      return "p" === t || "P" === t ? (0, vu[t])(e, a.formatLong, g) : e;
    }).join("").match(wu).map(function (n) {
      if ("''" === n) return "'";
      var r = n[0];
      if ("'" === r) return Ru(n);
      var o = mu[r];
      if (o) return !i.useAdditionalWeekYearTokens && ku(n) && Tu(n, t, e), !i.useAdditionalDayOfYearTokens && Eu(n) && Tu(n, t, e), o(f, n, a.localize, g);
      if (r.match(Nu)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + r + "`");
      return n;
    }).join("");
  return _;
}
function Ru(e) {
  return e.match(Cu)[1].replace(Su, "'");
}
function Iu(e, t) {
  Cd(2, arguments);
  var n = Sd(e),
    r = Sd(t);
  return n.getTime() === r.getTime();
}
function Lu(e) {
  return Cd(1, arguments), Dd(e, Date.now());
}
var ju = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
  },
  Du = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/,
  Fu = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/,
  Mu = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Pu(e, t) {
  Cd(1, arguments);
  var n = t || {},
    r = null == n.additionalDigits ? 2 : Ad(n.additionalDigits);
  if (2 !== r && 1 !== r && 0 !== r) throw new RangeError("additionalDigits must be 0, 1 or 2");
  if ("string" != typeof e && "[object String]" !== Object.prototype.toString.call(e)) return new Date(NaN);
  var i,
    a = Bu(e);
  if (a.date) {
    var o = Hu(a.date, r);
    i = zu(o.restDateString, o.year);
  }
  if (isNaN(i) || !i) return new Date(NaN);
  var s,
    l = i.getTime(),
    c = 0;
  if (a.time && (c = Wu(a.time), isNaN(c) || null === c)) return new Date(NaN);
  if (!a.timezone) {
    var d = new Date(l + c),
      u = new Date(0);
    return u.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), u.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()), u;
  }
  return s = Gu(a.timezone), isNaN(s) ? new Date(NaN) : new Date(l + c + s);
}
function Bu(e) {
  var t,
    n = {},
    r = e.split(ju.dateTimeDelimiter);
  if (r.length > 2) return n;
  if (/:/.test(r[0]) ? (n.date = null, t = r[0]) : (n.date = r[0], t = r[1], ju.timeZoneDelimiter.test(n.date) && (n.date = e.split(ju.timeZoneDelimiter)[0], t = e.substr(n.date.length, e.length))), t) {
    var i = ju.timezone.exec(t);
    i ? (n.time = t.replace(i[1], ""), n.timezone = i[1]) : n.time = t;
  }
  return n;
}
function Hu(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"),
    r = e.match(n);
  if (!r) return {
    year: null
  };
  var i = r[1] && parseInt(r[1]),
    a = r[2] && parseInt(r[2]);
  return {
    year: null == a ? i : 100 * a,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function zu(e, t) {
  if (null === t) return null;
  var n = e.match(Du);
  if (!n) return null;
  var r = !!n[4],
    i = Uu(n[1]),
    a = Uu(n[2]) - 1,
    o = Uu(n[3]),
    s = Uu(n[4]),
    l = Uu(n[5]) - 1;
  if (r) return function (e, t, n) {
    return t >= 1 && t <= 53 && n >= 0 && n <= 6;
  }(0, s, l) ? function (e, t, n) {
    var r = new Date(0);
    r.setUTCFullYear(e, 0, 4);
    var i = r.getUTCDay() || 7,
      a = 7 * (t - 1) + n + 1 - i;
    return r.setUTCDate(r.getUTCDate() + a), r;
  }(t, s, l) : new Date(NaN);
  var c = new Date(0);
  return function (e, t, n) {
    return t >= 0 && t <= 11 && n >= 1 && n <= (Vu[t] || (Yu(e) ? 29 : 28));
  }(t, a, o) && function (e, t) {
    return t >= 1 && t <= (Yu(e) ? 366 : 365);
  }(t, i) ? (c.setUTCFullYear(t, a, Math.max(i, o)), c) : new Date(NaN);
}
function Uu(e) {
  return e ? parseInt(e) : 1;
}
function Wu(e) {
  var t = e.match(Fu);
  if (!t) return null;
  var n = Xu(t[1]),
    r = Xu(t[2]),
    i = Xu(t[3]);
  return function (e, t, n) {
    if (24 === e) return 0 === t && 0 === n;
    return n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
  }(n, r, i) ? 36e5 * n + 6e4 * r + 1e3 * i : NaN;
}
function Xu(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function Gu(e) {
  if ("Z" === e) return 0;
  var t = e.match(Mu);
  if (!t) return 0;
  var n = "+" === t[1] ? -1 : 1,
    r = parseInt(t[2]),
    i = t[3] && parseInt(t[3]) || 0;
  return function (e, t) {
    return t >= 0 && t <= 59;
  }(0, i) ? n * (36e5 * r + 6e4 * i) : NaN;
}
var Vu = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Yu(e) {
  return e % 400 == 0 || e % 4 == 0 && e % 100;
}
var Ku = {
  textcard: "card_textcard__2i_rO",
  imagecard: "card_imagecard__Nt4BM",
  text: "card_text__tiGOd",
  slugMeta: "card_slugMeta__8PrXi",
  sector: "card_sector__1ShlR",
  prio1: "card_prio1__2Pz9x",
  prio2: "card_prio2__2PNEV",
  prio3: "card_prio3__y2Sbz",
  hint: "card_hint__38jCV",
  card: "card_card__31XA6",
  noTTNinjsCard: "card_noTTNinjsCard__R-x8z",
  headline: "card_headline__3GT0i",
  body: "card_body__1eDBR",
  compactCard: "card_compactCard__uFsEH",
  compactCardActive: "card_compactCardActive__3h0Uw",
  header: "card_header__3q9Bc",
  defaultCard: "card_defaultCard__2JWKd",
  storyCard: "card_storyCard__2jXt9",
  urgencyCard: "card_urgencyCard__3aUI6",
  infoCard: "card_infoCard___CYtD",
  pressCard: "card_pressCard__2UfL2",
  wrapper: "card_wrapper__xDUIo",
  pictureCard: "card_pictureCard__SLNkz",
  container: "card_container__145za",
  infoText: "card_infoText__1mLmC",
  datetime: "card_datetime__20AFQ",
  picture: "card_picture__Iv2Sx",
  headlineText: "card_headlineText__VSxU0",
  bodyText: "card_bodyText__1JizP",
  cardActive: "card_cardActive__3tNfX",
  thumb: "card_thumb__1QWNv",
  time: "card_time__2jTIx",
  urgency: "card_urgency__16DwP",
  subjects: "card_subjects__2VEU4",
  subject: "card_subject__2ERTZ",
  canceled: "card_canceled__2wwbt"
};
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.card_textcard__2i_rO, .card_imagecard__Nt4BM .card_text__tiGOd {\n  padding: 10px;\n  min-width: 250px;\n  max-width: 280px; }\n\n.card_slugMeta__8PrXi {\n  border-bottom: solid 2px rgba(0, 0, 0, 0.55); }\n\n.card_sector__1ShlR {\n  color: #4f4f4f;\n  text-transform: uppercase;\n  font-size: 12px; }\n\n.card_prio1__2Pz9x {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 10px;\n  width: 10px;\n  border: solid 3px #fff;\n  border-radius: 50%;\n  background: #C62828; }\n\n.card_prio2__2PNEV {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 10px;\n  width: 10px;\n  border: solid 3px #fff;\n  border-radius: 50%;\n  background: #FFB74D; }\n\n.card_prio3__y2Sbz {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 10px;\n  width: 10px;\n  border: solid 3px #fff;\n  border-radius: 50%;\n  background: #ffed00; }\n\n.card_hint__38jCV {\n  font-family: "Roboto", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.55);\n  text-transform: uppercase;\n  line-height: 18px; }\n\n.card_card__31XA6.card_noTTNinjsCard__R-x8z {\n  padding: 12px 15px;\n  min-width: 250px;\n  max-width: 250px;\n  min-height: 130px;\n  width: 250px;\n  margin-right: 20px;\n  margin-bottom: 20px !important;\n  background-color: #fff; }\n  .card_card__31XA6.card_noTTNinjsCard__R-x8z:hover {\n    background-color: #E8E8E8 !important;\n    -webkit-transition: background-color .4s ease-out;\n    -moz-transition: background-color .4s ease-out;\n    -o-transition: background-color .4s ease-out; }\n  .card_card__31XA6.card_noTTNinjsCard__R-x8z .card_headline__3GT0i {\n    font-family: Roboto;\n    font-size: 16px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    margin: 0;\n    padding: 0 10px;\n    line-height: 1.25;\n    letter-spacing: normal;\n    color: #222222; }\n  .card_card__31XA6.card_noTTNinjsCard__R-x8z .card_body__1eDBR {\n    padding: 0 10px 20px 0;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.43;\n    letter-spacing: normal;\n    color: #4f4f4f;\n    display: flex;\n    flex-direction: column;\n    overflow: auto; }\n    .card_card__31XA6.card_noTTNinjsCard__R-x8z .card_body__1eDBR img {\n      max-width: 100%; }\n\n.card_compactCard__uFsEH {\n  border-radius: 2px;\n  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.14);\n  background-color: #ffffff;\n  margin: 1px;\n  padding: 12px 15px;\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  cursor: pointer;\n  min-width: 250px;\n  max-width: 280px; }\n  .card_compactCard__uFsEH:focus {\n    outline: none; }\n  .card_compactCard__uFsEH:hover {\n    background-color: #E8E8E8;\n    -webkit-transition: background-color .4s ease-out;\n    -moz-transition: background-color .4s ease-out;\n    -o-transition: background-color .4s ease-out; }\n  .card_compactCard__uFsEH:active {\n    background: #9E9E9E; }\n  .card_compactCardActive__3h0Uw {\n    background: #E6E9FF; }\n  .card_compactCard__uFsEH .card_header__3q9Bc {\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.43;\n    letter-spacing: normal;\n    color: #222222;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    margin-bottom: 5px; }\n  .card_compactCard__uFsEH h5 {\n    margin: 0; }\n\n.card_defaultCard__2JWKd {\n  margin: 3px 3px 8px 3px; }\n\n.card_textcard__2i_rO.card_defaultCard__2JWKd .card_header__3q9Bc {\n  font-family: Roboto;\n  font-size: 14px;\n  padding: 0 0 4px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: normal;\n  color: #222;\n  white-space: inherit !important;\n  width: 100%;\n  margin-bottom: 0; }\n\n.card_textcard__2i_rO.card_defaultCard__2JWKd .card_body__1eDBR {\n  margin-bottom: 8px;\n  padding: 8px 12px 0 0;\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n  color: #4f4f4f;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden; }\n\n.card_storyCard__2jXt9.card_textcard__2i_rO {\n  background-color: #dae6e1; }\n  .card_storyCard__2jXt9.card_textcard__2i_rO .card_header__3q9Bc {\n    background-color: #5b8c79;\n    margin: -10px; }\n    .card_storyCard__2jXt9.card_textcard__2i_rO .card_header__3q9Bc > div:first-of-type {\n      padding: 10px;\n      font-family: Roboto;\n      font-size: 22px;\n      font-weight: bold;\n      font-stretch: normal;\n      font-style: normal;\n      line-height: 1.27;\n      letter-spacing: normal;\n      color: #f5f5f5; }\n\n.card_card__31XA6.card_urgencyCard__3aUI6 {\n  background-color: #fff9c1; }\n\n.card_infoCard___CYtD {\n  background-color: #FFF0F0; }\n\n.card_pressCard__2UfL2 {\n  background-color: #E6E9FF; }\n\ndiv.card_wrapper__xDUIo {\n  display: flex;\n  border: solid 1px #d5d5d5;\n  justify-content: center;\n  align-items: flex-start;\n  flex-grow: 1;\n  min-height: 270px;\n  margin-top: 10px;\n  cursor: pointer;\n  max-width: 380px; }\n  div.card_wrapper__xDUIo div.card_pictureCard__SLNkz {\n    overflow: hidden; }\n    div.card_wrapper__xDUIo div.card_pictureCard__SLNkz div {\n      width: 100%;\n      display: flex;\n      justify-content: center; }\n      div.card_wrapper__xDUIo div.card_pictureCard__SLNkz div div.card_container__145za {\n        background-color: #fff;\n        width: fit-content;\n        min-width: 100%;\n        margin: 0; }\n        div.card_wrapper__xDUIo div.card_pictureCard__SLNkz div div.card_container__145za div.card_infoText__1mLmC {\n          margin-top: 15px;\n          padding: 0 13px;\n          max-width: 180px; }\n          div.card_wrapper__xDUIo div.card_pictureCard__SLNkz div div.card_container__145za div.card_infoText__1mLmC p {\n            font-size: 14px;\n            margin: 0;\n            max-width: 90%; }\n          div.card_wrapper__xDUIo div.card_pictureCard__SLNkz div div.card_container__145za div.card_infoText__1mLmC p.card_headline__3GT0i {\n            letter-spacing: 0.2px;\n            font-weight: 500;\n            color: #222222;\n            line-height: 21px;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden; }\n          div.card_wrapper__xDUIo div.card_pictureCard__SLNkz div div.card_container__145za div.card_infoText__1mLmC p.card_datetime__20AFQ {\n            letter-spacing: 0.2px;\n            color: #4f4f4f;\n            padding-bottom: 8px; }\n        div.card_wrapper__xDUIo div.card_pictureCard__SLNkz div div.card_container__145za img.card_picture__Iv2Sx {\n          height: 235px;\n          object-fit: contain;\n          max-width: 100%;\n          min-width: 100%;\n          display: block;\n          object-position: top; }\n\n.card_card__31XA6 {\n  display: flex;\n  align-items: baseline;\n  min-width: 280px;\n  max-width: 280px;\n  border-radius: 2px;\n  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.14);\n  background-color: #ffffff;\n  margin: 3px 3px 8px 3px;\n  padding: 0px;\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  cursor: pointer; }\n  .card_card__31XA6 .card_header__3q9Bc {\n    padding: 12px 0 8px 0;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.25;\n    letter-spacing: normal;\n    color: #222222;\n    display: flex;\n    justify-content: space-between; }\n  .card_card__31XA6 .card_headline__3GT0i {\n    padding: 7px 15px 10px;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.33;\n    letter-spacing: normal;\n    color: #4f4f4f; }\n    .card_card__31XA6 .card_headline__3GT0i .card_headlineText__VSxU0 {\n      font-size: 16px; }\n  .card_card__31XA6 .card_body__1eDBR {\n    padding: 0;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.43;\n    letter-spacing: normal;\n    color: #4f4f4f;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden; }\n    .card_card__31XA6 .card_body__1eDBR .card_bodyText__1JizP {\n      padding: 0 15px 10px; }\n  .card_card__31XA6:focus {\n    outline: none; }\n  .card_card__31XA6:hover {\n    background-color: #E8E8E8;\n    -webkit-transition: background-color .4s ease-out;\n    -moz-transition: background-color .4s ease-out;\n    -o-transition: background-color .4s ease-out; }\n  .card_card__31XA6:active {\n    background: #9E9E9E; }\n  .card_cardActive__3tNfX {\n    background: #E6E9FF; }\n  .card_card__31XA6 .card_thumb__1QWNv {\n    width: 100%; }\n  .card_card__31XA6 .card_headlineText__VSxU0 {\n    padding: 0 15px 8px; }\n  .card_card__31XA6 .card_headline__3GT0i {\n    margin-bottom: 5px; }\n\n.card_time__2jTIx {\n  font-family: "Roboto", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 18px;\n  display: flex;\n  text-transform: uppercase; }\n\n.card_hint__38jCV {\n  display: flex;\n  flex-direction: row;\n  text-align: right; }\n  .card_hint__38jCV > div {\n    margin-left: 10px; }\n\n.card_picture__Iv2Sx {\n  width: 100%;\n  object-fit: contain; }\n\n.card_urgency__16DwP {\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background-color: red;\n  margin: 4px; }\n\n.card_subjects__2VEU4 {\n  padding: 7px 1em 7px 15px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%; }\n  .card_subjects__2VEU4 :last-child {\n    border-bottom: none; }\n\n.card_subject__2ERTZ {\n  font-family: "Roboto", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 18px;\n  padding: 2px 0;\n  color: rgba(0, 0, 0, 0.55);\n  white-space: normal;\n  overflow-wrap: anywhere; }\n\n.card_canceled__2wwbt {\n  text-decoration: line-through; }\n\n@media only screen and (max-width: 667px) {\n  div.card_wrapper__xDUIo {\n    max-width: 300px; }\n    div.card_wrapper__xDUIo img.card_picture__Iv2Sx {\n      height: auto !important; } }\n');
var Zu = function (e) {
    return {
      INR: {
        text: "Inrikes",
        color: "#417505"
      },
      UTR: {
        text: "Utrikes",
        color: "#ff5252"
      },
      SPT: {
        text: "Sport",
        color: "#2e3b8c"
      },
      EKO: {
        text: "Ekonomi",
        color: "#661414"
      },
      KLT: {
        text: "Kultur & nöje",
        color: "#fb8c00"
      },
      PRM: {
        text: "Pressmeddelande",
        color: "#4f4f4f"
      },
      undefined: {
        text: "",
        color: "#fff"
      }
    };
  },
  qu = {
    lessThanXSeconds: {
      singular: "mindre än en sekund",
      plural: "mindre än {{count}} sekunder"
    },
    xSeconds: {
      singular: "en sekund",
      plural: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
      singular: "mindre än en minut",
      plural: "mindre än {{count}} minuter"
    },
    xMinutes: {
      singular: "en minut",
      plural: "{{count}} minuter"
    },
    aboutXHours: {
      singular: "ungefär en timme",
      plural: "ungefär {{count}} timmar"
    },
    xHours: {
      singular: "en timme",
      plural: "{{count}} timmar"
    },
    xDays: {
      singular: "en dag",
      plural: "{{count}} dagar"
    },
    aboutXWeeks: {
      singular: "ungefär en vecka",
      plural: "ungefär {{count}} vecka"
    },
    xWeeks: {
      singular: "en vecka",
      plural: "{{count}} vecka"
    },
    aboutXMonths: {
      singular: "ungefär en månad",
      plural: "ungefär {{count}} månader"
    },
    xMonths: {
      singular: "en månad",
      plural: "{{count}} månader"
    },
    aboutXYears: {
      singular: "ungefär ett år",
      plural: "ungefär {{count}} år"
    },
    xYears: {
      singular: "ett år",
      plural: "{{count}} år"
    },
    overXYears: {
      singular: "över ett år",
      plural: "över {{count}} år"
    },
    almostXYears: {
      singular: "nästan ett år",
      plural: "nästan {{count}} år"
    }
  },
  Ju = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"];
var Qu = {
    date: Pd({
      formats: {
        full: "EEEE d MMMM y",
        long: "d MMMM y",
        medium: "d MMM y",
        short: "y-MM-dd"
      },
      defaultWidth: "full"
    }),
    time: Pd({
      formats: {
        full: "'kl'. HH:mm:ss zzzz",
        long: "HH:mm:ss z",
        medium: "HH:mm:ss",
        short: "HH:mm"
      },
      defaultWidth: "full"
    }),
    dateTime: Pd({
      formats: {
        full: "{{date}} 'kl.' {{time}}",
        long: "{{date}} 'kl.' {{time}}",
        medium: "{{date}} {{time}}",
        short: "{{date}} {{time}}"
      },
      defaultWidth: "full"
    })
  },
  $u = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'igår kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
  };
var ep = {
    code: "sv",
    formatDistance: function (e, t, n) {
      n = n || {
        onlyNumeric: !1
      };
      var r,
        i = qu[e];
      return r = "string" == typeof i ? i : 0 === t || t > 1 ? n.onlyNumeric ? i.plural.replace("{{count}}", t) : i.plural.replace("{{count}}", t < 13 ? Ju[t] : t) : i.singular, n.addSuffix ? n.comparison > 0 ? "om " + r : r + " sedan" : r;
    },
    formatLong: Qu,
    formatRelative: function (e, t, n, r) {
      return $u[e];
    },
    localize: {
      ordinalNumber: function (e) {
        var t = Number(e),
          n = t % 100;
        if (n > 20 || n < 10) switch (n % 10) {
          case 1:
          case 2:
            return t + ":a";
        }
        return t + ":e";
      },
      era: zd({
        values: {
          narrow: ["f.Kr.", "e.Kr."],
          abbreviated: ["f.Kr.", "e.Kr."],
          wide: ["före Kristus", "efter Kristus"]
        },
        defaultWidth: "wide"
      }),
      quarter: zd({
        values: {
          narrow: ["1", "2", "3", "4"],
          abbreviated: ["Q1", "Q2", "Q3", "Q4"],
          wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
        },
        defaultWidth: "wide",
        argumentCallback: function (e) {
          return Number(e) - 1;
        }
      }),
      month: zd({
        values: {
          narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
          abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
          wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
        },
        defaultWidth: "wide"
      }),
      day: zd({
        values: {
          narrow: ["S", "M", "T", "O", "T", "F", "L"],
          short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
          abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
          wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
        },
        defaultWidth: "wide"
      }),
      dayPeriod: zd({
        values: {
          narrow: {
            am: "fm",
            pm: "em",
            midnight: "midnatt",
            noon: "middag",
            morning: "morg.",
            afternoon: "efterm.",
            evening: "kväll",
            night: "natt"
          },
          abbreviated: {
            am: "f.m.",
            pm: "e.m.",
            midnight: "midnatt",
            noon: "middag",
            morning: "morgon",
            afternoon: "efterm.",
            evening: "kväll",
            night: "natt"
          },
          wide: {
            am: "förmiddag",
            pm: "eftermiddag",
            midnight: "midnatt",
            noon: "middag",
            morning: "morgon",
            afternoon: "eftermiddag",
            evening: "kväll",
            night: "natt"
          }
        },
        defaultWidth: "wide",
        formattingValues: {
          narrow: {
            am: "fm",
            pm: "em",
            midnight: "midnatt",
            noon: "middag",
            morning: "på morg.",
            afternoon: "på efterm.",
            evening: "på kvällen",
            night: "på natten"
          },
          abbreviated: {
            am: "fm",
            pm: "em",
            midnight: "midnatt",
            noon: "middag",
            morning: "på morg.",
            afternoon: "på efterm.",
            evening: "på kvällen",
            night: "på natten"
          },
          wide: {
            am: "fm",
            pm: "em",
            midnight: "midnatt",
            noon: "middag",
            morning: "på morgonen",
            afternoon: "på eftermiddagen",
            evening: "på kvällen",
            night: "på natten"
          }
        },
        defaultFormattingWidth: "wide"
      })
    },
    match: {
      ordinalNumber: Ud({
        matchPattern: /^(\d+)(:a|:e)?/i,
        parsePattern: /\d+/i,
        valueCallback: function (e) {
          return parseInt(e, 10);
        }
      }),
      era: Wd({
        matchPatterns: {
          narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
          abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
          wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
          any: [/^f/i, /^[ev]/i]
        },
        defaultParseWidth: "any"
      }),
      quarter: Wd({
        matchPatterns: {
          narrow: /^[1234]/i,
          abbreviated: /^q[1234]/i,
          wide: /^[1234](:a|:e)? kvartalet/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
          any: [/1/i, /2/i, /3/i, /4/i]
        },
        defaultParseWidth: "any",
        valueCallback: function (e) {
          return e + 1;
        }
      }),
      month: Wd({
        matchPatterns: {
          narrow: /^[jfmasond]/i,
          abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec)\.?/i,
          wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
          narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
          any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
        },
        defaultParseWidth: "any"
      }),
      day: Wd({
        matchPatterns: {
          narrow: /^[smtofl]/i,
          short: /^(sö|må|ti|on|to|fr|lö)/i,
          abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
          wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
          any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
        },
        defaultParseWidth: "any"
      }),
      dayPeriod: Wd({
        matchPatterns: {
          any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
        },
        defaultMatchWidth: "any",
        parsePatterns: {
          any: {
            am: /^f/i,
            pm: /^e/i,
            midnight: /^midn/i,
            noon: /^midd/i,
            morning: /morgon/i,
            afternoon: /eftermiddag/i,
            evening: /kväll/i,
            night: /natt/i
          }
        },
        defaultParseWidth: "any"
      })
    },
    options: {
      weekStartsOn: 1,
      firstWeekContainsDate: 4
    }
  },
  tp = function (e, t, n, r) {
    return "".concat(Ou(e, "HH:mm", {
      locale: ep
    }), " • ").concat(n(r)[t] ? "".concat(n(r)[t].text) : "".concat(t));
  },
  np = function (e) {
    return "".concat(Ou(e, "dd MMM yyyy - HH:mm", {
      locale: ep
    }));
  },
  rp = function (t) {
    var r = t.ttninjs,
      i = t.nameInput,
      a = t.time,
      o = t.activeCard,
      s = t.cardNr,
      l = t.onClickCard,
      c = t.replaced,
      d = t.isToday,
      u = t.checkBadge,
      p = t.prio,
      m = t.getTTHint,
      f = t.admin,
      g = void 0 !== f && f,
      _ = r.urgency,
      y = r.headline,
      h = r.slug,
      v = r.description_text,
      b = r.sector,
      x = new Date(a),
      E = "".concat({
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[b] ? {
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[b].text : b);
    return n(function () {
      o && i.current.focus();
    }, [o]), e.createElement("div", {
      ref: i,
      tabIndex: "0",
      style: {
        opacity: c ? "0.3" : "1"
      },
      className: "".concat(1 === _ ? Ku.urgencyCard : "", " ").concat(Ku.compactCard, " ").concat(Ku.defaultCard, " ").concat(Ku.textcard, " ").concat(o ? Ku.cardActive : ""),
      onClick: function (e) {
        return l ? l(e, s) : null;
      },
      "data-testid": "default"
    }, e.createElement("div", {
      style: {
        margin: "-10px -10px 10px -10px"
      }
    }, u(r)), e.createElement(K, null, e.createElement("div", {
      className: Ku.header,
      style: {
        fontSize: 14
      }
    }, e.createElement(Qt, {
      top: "0",
      right: "0",
      bottom: "0",
      left: "0"
    }, e.createElement(en, {
      cols: 11
    }, "".concat(y)), e.createElement(en, {
      cols: 1
    }, e.createElement("div", {
      className: p()
    })))), e.createElement("div", {
      className: Ku.body
    }, v), e.createElement("div", {
      style: {
        width: "100%",
        borderTop: "solid 1px #e3e5e3"
      }
    }), e.createElement("div", {
      className: Ku.footer,
      style: {
        width: "100%"
      }
    }, e.createElement(Qt, {
      top: "0",
      right: "0",
      bottom: "0styles.card",
      left: "0"
    }, e.createElement(en, {
      cols: 12
    }, e.createElement(K, {
      nowrap: !0,
      direction: "row",
      align: "center",
      justify: "space-between",
      style: {
        width: "100%",
        paddingTop: "10px"
      }
    }, a && e.createElement("div", {
      className: Ku.time
    }, d(x) ? e.createElement("div", null, tp(x, b, Zu, g)) : e.createElement("div", null, e.createElement("div", null, np(x)), e.createElement("div", null, E))), e.createElement("div", {
      className: Ku.hint,
      style: {
        justifyContent: "flex-end",
        textTransform: h ? "none" : "uppercase"
      }
    }, m())))))));
  },
  ip = function (t) {
    var r = t.ttninjs,
      i = t.nameInput,
      a = t.time,
      o = t.isToday,
      s = t.checkBadge,
      l = t.activeCard,
      c = t.cardNr,
      d = t.replaced,
      u = void 0 !== d && d,
      p = t.getTTHint,
      m = t.onClickCard,
      f = t.admin,
      g = void 0 !== f && f,
      _ = t.sectorBeautifier,
      y = r.urgency,
      h = r.headline,
      v = r.sector,
      b = new Date(a),
      x = _(g)[v] ? "".concat(_(g)[v].text) : "".concat(v);
    return n(function () {
      l && i.current.focus();
    }, [l]), e.createElement("div", {
      ref: i,
      tabIndex: "0",
      style: {
        opacity: u ? "0.3" : "1"
      },
      className: "".concat(1 === y ? Ku.urgencyCard : "", " ").concat(Ku.compactCard, " ").concat(Ku.textcard, " ").concat(l ? Ku.cardActive : ""),
      onClick: function (e) {
        return m ? m(e, c) : null;
      },
      "data-testid": "compact"
    }, e.createElement(Qt, {
      gutter: "0",
      top: "0",
      right: "0",
      bottom: "0",
      left: "0"
    }, e.createElement(en, {
      cols: 12
    }, e.createElement("div", {
      style: {
        margin: "-10px -10px 10px -10px"
      }
    }, s(r)), e.createElement("div", {
      className: Ku.header
    }, "".concat(h))), e.createElement(en, null, e.createElement(K, {
      nowrap: !0,
      direction: "row",
      align: "center",
      justify: "space-between",
      style: {
        width: "100%"
      }
    }, e.createElement("div", {
      className: Ku.time
    }, o(b) ? e.createElement("div", null, tp(b, v, _, g)) : e.createElement("div", null, e.createElement("div", null, np(b)), e.createElement("div", null, x))), e.createElement("div", {
      className: Ku.hint,
      style: {
        justifyContent: "flex-end",
        textTransform: "none"
      }
    }, p())))));
  },
  ap = function (t) {
    var r = t.ttninjs,
      i = t.nameInput,
      a = t.time,
      o = t.activeCard,
      s = t.cardNr,
      l = t.onClickCard,
      c = t.sectorBeautifier,
      d = t.isToday,
      u = t.prio,
      p = t.replaced,
      m = t.checkBadge,
      f = t.getTTHint,
      g = t.admin,
      _ = void 0 !== g && g,
      y = t.getThumb,
      h = r.urgency,
      v = r.headline,
      b = r.associations,
      x = r.sector,
      E = r.slug,
      k = r.description_text,
      T = new Date(a);
    n(function () {
      o && i.current.focus();
    }, [o]);
    var w = c(_)[x] ? "".concat(c(_)[x].text) : "".concat(x);
    return e.createElement("div", {
      ref: i,
      tabIndex: "0",
      style: {
        opacity: p ? "0.3" : "1"
      },
      className: "".concat(1 === h ? Ku.urgencyCard : "", " ").concat(Ku.card, " ").concat(Ku.textcard, " ").concat(o ? Ku.cardActive : ""),
      onClick: function (e) {
        return l ? l(e, s) : null;
      }
    }, e.createElement(K, {
      justify: "space-between",
      style: {
        width: "100%"
      }
    }, m(r), e.createElement("div", {
      className: Ku.headline
    }, e.createElement("div", {
      className: Ku.header
    }, e.createElement(Qt, {
      left: "0px",
      right: "0px",
      top: "0px",
      bottom: "0px"
    }, e.createElement(en, {
      cols: 8
    }, v, e.createElement("div", {
      className: Ku.body
    }, k)), e.createElement(en, {
      cols: 4
    }, b ? e.createElement(Tl, {
      src: y(b)
    }) : e.createElement(Wc, null), e.createElement("div", {
      className: u()
    }))))), e.createElement("div", {
      className: Ku.footer,
      style: {
        width: "100%"
      }
    }, e.createElement(Qt, {
      top: "0",
      right: "10px",
      bottom: "10px",
      left: "10px"
    }, e.createElement(en, {
      cols: 12
    }, e.createElement(K, {
      direction: "row",
      align: "flex-end",
      nowrap: !0,
      justify: "space-between",
      style: {
        width: "100%"
      }
    }, e.createElement("div", {
      className: Ku.time
    }, d(T) ? e.createElement("div", null, tp(T, x, c, _)) : e.createElement("div", null, e.createElement("div", null, np(T)), e.createElement("div", null, w))), e.createElement("div", {
      className: Ku.hint,
      style: {
        justifyContent: "flex-end",
        textTransform: E ? "none" : "uppercase"
      }
    }, f())))))));
  },
  op = function (t) {
    if (1 === t.urgency) return e.createElement(Ap, {
      type: "flash",
      text: "TT-FLASH",
      stretch: !0
    });
    if ("PRM" === t.sector) {
      var n = "Pressmeddelande från ".concat(t.copyrightholder);
      return e.createElement(Ap, {
        type: "PRM",
        text: n,
        stretch: !0
      });
    }
    return "";
  },
  sp = function (t) {
    var r = c(null);
    n(function () {
      t.props.activeCard && r.current.focus();
    }, []);
    var i = function (e) {
        return !!e && Lu(e);
      },
      a = t.props,
      o = a.ttninjs,
      s = void 0 === o ? {} : o,
      l = a.cardNr,
      d = void 0 === l ? 0 : l,
      u = a.activeCard,
      p = void 0 === u ? 0 : u,
      m = a.onClickCard,
      f = a.replacedby,
      g = a.density,
      _ = void 0 === g ? "default" : g,
      y = s.datetime,
      h = s.webprio,
      v = y || undefined,
      b = function () {
        return "event" === s.type ? e.createElement(nd, {
          icon: "calendar_today",
          size: "small"
        }) : e.createElement("div", {
          dangerouslySetInnerHTML: (t = s.slug, n = t, ["UV", "KORR", "OMS", "RÄ"].forEach(function (e) {
            var t = e.split(/["/\\*|()+-]/);
            e && "" !== e && t.forEach(function (e) {
              var t = new RegExp(e.trim(), "g");
              n && "" !== e.trim() && (n = n.replace(t, "<span class='".concat(Ku.slugMeta, "'>").concat(e, "</span>")));
            });
          }), {
            __html: n
          })
        });
        var t, n;
      },
      x = function () {
        switch (h) {
          case 1:
            return Ku.prio1;
          case 2:
            return Ku.prio2;
          case 3:
            return Ku.prio3;
        }
      },
      E = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = e[Object.keys(e)[0]],
          n = t && t.renditions ? t.renditions : {},
          r = Object.keys(n).filter(function (e) {
            return "Normal" === n[e].variant && "Thumbnail" === n[e].usage;
          }),
          i = n[r];
        return i ? i.href : null;
      };
    return "compact" === _ ? e.createElement(ip, {
      ttninjs: s,
      nameInput: r,
      time: v,
      activeCard: p,
      cardNr: d,
      onClickCard: m,
      sectorBeautifier: Zu,
      isToday: i,
      replaced: void 0 !== f,
      checkBadge: op,
      getTTHint: b
    }) : "default" === _ ? e.createElement(rp, {
      ttninjs: s,
      nameInput: r,
      time: v,
      activeCard: p,
      cardNr: d,
      onClickCard: m,
      sectorBeautifier: Zu,
      isToday: i,
      prio: x,
      checkBadge: op,
      getTTHint: b
    }) : e.createElement(ap, {
      ttninjs: s,
      nameInput: r,
      time: v,
      activeCard: p,
      cardNr: d,
      onClickCard: m,
      sectorBeautifier: Zu,
      isToday: i,
      prio: x,
      checkBadge: op,
      getTTHint: b,
      getThumb: E
    });
  },
  lp = {
    picture: "photo_camera",
    video: "play_circle_outline",
    text: "library_books",
    graphic: "insert_photo",
    composite: "video_library"
  };
function cp(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
var dp = function (t) {
  ee(r, a);
  var n = cp(r);
  function r() {
    return q(this, r), n.apply(this, arguments);
  }
  return Q(r, [{
    key: "componentDidMount",
    value: function () {
      this.props.props.activeCard && this.nameInput.focus();
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      this.props.props.activeCard && this.nameInput.focus();
    }
  }, {
    key: "render",
    value: function () {
      var t,
        n = this,
        r = this.props.props,
        i = r.ttninjs,
        a = void 0 === i ? {} : i,
        o = r.headline,
        s = r.cardNr,
        l = void 0 === s ? 0 : s,
        c = r.activeCard,
        d = void 0 === c ? 0 : c,
        u = r.onClickCard,
        p = (r.admin, a.assignments),
        m = void 0 === p ? {} : p,
        f = a.sector,
        g = a.urgency,
        _ = a.fixture,
        y = void 0 === _ || _,
        h = a.description_text;
      a && (t = a.headline);
      var v = function (e) {
        switch (e) {
          case "insert_photo":
            return "#CCBE00";
          case "photo_camera":
            return "#e65100";
          case "library_books":
            return "#7e90ff";
          case "play_circle_outline":
            return "#6bad22";
          case "video_library":
            return "#49230E";
          default:
            return "#222222";
        }
      };
      return y ? e.createElement("div", {
        ref: function (e) {
          n.nameInput = e;
        },
        tabIndex: "0",
        className: "".concat(Ku.card, " ").concat(Ku.textcard, " ").concat(d ? Ku.cardActive : ""),
        onClick: function (e) {
          return u ? u(e, l) : null;
        },
        "data-testid": "planning"
      }, e.createElement(K, {
        style: {
          width: "100%"
        }
      }, f && g && e.createElement(K, {
        direction: "row",
        align: "baseline",
        nowrap: !0,
        justify: "space-between",
        style: {
          padding: "0 15px",
          width: "85%"
        }
      }, e.createElement("div", {
        className: Ku.header,
        style: {
          color: {
            INR: {
              text: "Inrikes",
              color: "#417505"
            },
            UTR: {
              text: "Utrikes",
              color: "#ff5252"
            },
            SPT: {
              text: "Sport",
              color: "#2e3b8c"
            },
            EKO: {
              text: "Ekonomi",
              color: "#661414"
            },
            KLT: {
              text: "Kultur & nöje",
              color: "#fb8c00"
            },
            PRM: {
              text: "Pressmeddelande",
              color: "#4f4f4f"
            },
            undefined: {
              text: "",
              color: "#fff"
            }
          }[f] ? {
            INR: {
              text: "Inrikes",
              color: "#417505"
            },
            UTR: {
              text: "Utrikes",
              color: "#ff5252"
            },
            SPT: {
              text: "Sport",
              color: "#2e3b8c"
            },
            EKO: {
              text: "Ekonomi",
              color: "#661414"
            },
            KLT: {
              text: "Kultur & nöje",
              color: "#fb8c00"
            },
            PRM: {
              text: "Pressmeddelande",
              color: "#4f4f4f"
            },
            undefined: {
              text: "",
              color: "#fff"
            }
          }[f].color : "red"
        }
      }, {
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[f].text.toUpperCase()), e.createElement("div", null, e.createElement(Ap, {
        stretch: !0,
        text: "Prio ".concat(g),
        color: "#e6e6e6",
        style: {
          textAlign: "center",
          margin: 0
        }
      }))), e.createElement("div", {
        className: Ku.headlineText
      }, "".concat(o || t)), e.createElement("section", {
        className: Ku.body
      }, e.createElement("div", {
        className: Ku.bodyText
      }, function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = 75;
        return e.length > t ? e.slice(0, t) + "..." : e;
      }(h))), e.createElement("div", {
        style: {
          width: "100%",
          borderTop: "solid 1px #e3e5e3"
        }
      }), e.createElement("div", {
        className: Ku.footer,
        style: {
          width: "90%"
        }
      }, e.createElement(Qt, {
        top: "0",
        right: "0",
        bottom: "0styles.card",
        left: "0"
      }, e.createElement(en, {
        cols: 12
      }, e.createElement(K, {
        align: "flex-start",
        direction: "column",
        style: {
          padding: "12px 5px",
          width: "100%"
        }
      }, e.createElement("div", {
        className: Ku.hint,
        style: {
          extTransform: a.slug ? "none" : "uppercase"
        }
      }, Object.keys(m).map(function (t, n) {
        var r = m[t].type;
        return e.createElement(nd, {
          key: n,
          icon: lp[r],
          color: v(lp[r]),
          size: "small"
        });
      })))))))) : e.createElement("div", {
        ref: function (e) {
          n.nameInput = e;
        }
      });
    }
  }]), r;
}();
function up(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
var pp = function (t) {
    ee(r, a);
    var n = up(r);
    function r() {
      return q(this, r), n.apply(this, arguments);
    }
    return Q(r, [{
      key: "componentDidMount",
      value: function () {
        this.props.props.activeCard && this.nameInput.focus();
      }
    }, {
      key: "componentDidUpdate",
      value: function () {
        this.props.props.activeCard && this.nameInput.focus();
      }
    }, {
      key: "render",
      value: function () {
        var t = this,
          n = this.props.props,
          r = n.ttninjs,
          i = void 0 === r ? {} : r,
          a = n.headline,
          o = n.datetime;
        n.enddatetime;
        var s,
          l,
          c = n.cardNr,
          d = void 0 === c ? 0 : c,
          u = n.activeCard,
          p = void 0 === u ? 0 : u,
          m = n.onClickCard,
          f = (n.admin, i.sector),
          g = i.subject,
          _ = i.description_text,
          y = "4" === i.body_event.eventstatus;
        i && (s = i.headline, l = i.datetime || i.date);
        var h = Pu(o || l);
        return e.createElement("div", {
          ref: function (e) {
            t.nameInput = e;
          },
          tabIndex: "0",
          className: "".concat(Ku.compactCard, " ").concat(Ku.defaultCard, " ").concat(Ku.textcard, " ").concat(p ? Ku.cardActive : "", " ").concat(y ? Ku.canceled : ""),
          onClick: function (e) {
            return m ? m(e, d) : null;
          },
          "data-testid": "event"
        }, y && e.createElement("div", {
          style: {
            margin: "-13px -1px 10px -15px"
          }
        }, e.createElement(Ap, {
          text: "INSTÄLLT",
          color: "#c62828",
          stretch: !0,
          style: {
            borderRadius: "2px 2px 0px 0px"
          }
        })), e.createElement(K, null, e.createElement(K, {
          direction: "row",
          align: "baseline",
          nowrap: !0,
          justify: "space-between",
          style: {
            width: "95%"
          }
        }, e.createElement("div", {
          className: Ku.header,
          style: {
            color: {
              INR: {
                text: "Inrikes",
                color: "#417505"
              },
              UTR: {
                text: "Utrikes",
                color: "#ff5252"
              },
              SPT: {
                text: "Sport",
                color: "#2e3b8c"
              },
              EKO: {
                text: "Ekonomi",
                color: "#661414"
              },
              KLT: {
                text: "Kultur & nöje",
                color: "#fb8c00"
              },
              PRM: {
                text: "Pressmeddelande",
                color: "#4f4f4f"
              },
              undefined: {
                text: "",
                color: "#fff"
              }
            }[f] ? {
              INR: {
                text: "Inrikes",
                color: "#417505"
              },
              UTR: {
                text: "Utrikes",
                color: "#ff5252"
              },
              SPT: {
                text: "Sport",
                color: "#2e3b8c"
              },
              EKO: {
                text: "Ekonomi",
                color: "#661414"
              },
              KLT: {
                text: "Kultur & nöje",
                color: "#fb8c00"
              },
              PRM: {
                text: "Pressmeddelande",
                color: "#4f4f4f"
              },
              undefined: {
                text: "",
                color: "#fff"
              }
            }[f].color : "red"
          }
        }, {
          INR: {
            text: "Inrikes",
            color: "#417505"
          },
          UTR: {
            text: "Utrikes",
            color: "#ff5252"
          },
          SPT: {
            text: "Sport",
            color: "#2e3b8c"
          },
          EKO: {
            text: "Ekonomi",
            color: "#661414"
          },
          KLT: {
            text: "Kultur & nöje",
            color: "#fb8c00"
          },
          PRM: {
            text: "Pressmeddelande",
            color: "#4f4f4f"
          },
          undefined: {
            text: "",
            color: "#fff"
          }
        }[f].text.toUpperCase())), e.createElement("div", {
          className: Ku.headline
        }, e.createElement("div", null, "".concat(a || s))), e.createElement("div", {
          className: Ku.body
        }, _), e.createElement("div", {
          style: {
            width: "100%",
            borderTop: "solid 1px #e3e5e3"
          }
        }), e.createElement("div", {
          className: Ku.footer,
          style: {
            width: "100%"
          }
        }, e.createElement(Qt, {
          top: "0",
          right: "0",
          bottom: "0styles.card",
          left: "0"
        }, e.createElement(en, {
          cols: 12
        }, e.createElement(K, {
          direction: "row",
          justify: "space-between",
          align: "baseline"
        }, e.createElement("div", {
          className: Ku.time
        }, i.datetime ? Ou(h, "HH:mm", {
          locale: ep
        }) : ""), e.createElement("div", {
          style: {
            padding: "7px 0 0"
          }
        }, g && g.length > 0 && e.createElement("div", {
          className: Ku.subject
        }, g[0].name))))))));
      }
    }]), r;
  }(),
  mp = function (e) {
    var t,
      n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "Normal",
      r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Thumbnail";
    return Object.keys(e).forEach(function (i, a) {
      var o = e[i];
      o.variant === n && o.usage === r && (t = o.href);
    }), t;
  },
  fp = function (t) {
    var r = t.props,
      i = r.ttninjs,
      a = void 0 === i ? {} : i,
      o = r.cardNr,
      s = void 0 === o ? 0 : o,
      l = r.activeCard,
      d = void 0 === l ? 0 : l,
      u = r.onClickCard,
      p = a.description_text,
      m = a.versioncreated,
      f = c(null);
    n(function () {
      r.activeCard && f.current.focus();
    }, [d]);
    var g = Pu(m);
    return e.createElement("div", {
      className: Ku.wrapper
    }, e.createElement("div", {
      className: "".concat(Ku.pictureCard, " ").concat(d ? Ku.cardActive : ""),
      ref: function (e) {
        f.current = e;
      },
      tabIndex: "0",
      onClick: function (e) {
        return u ? u(e, s) : null;
      },
      "data-testid": "picture"
    }, e.createElement("div", null, e.createElement("div", {
      className: Ku.container
    }, e.createElement(K, {
      style: {
        width: "100%"
      },
      direction: "row",
      align: "center",
      justify: "space-around"
    }, e.createElement("img", {
      className: Ku.picture,
      src: mp(a.renditions),
      alt: p && p
    }), e.createElement(K, {
      direction: "row",
      style: {
        width: "100%"
      }
    }, e.createElement("div", {
      className: Ku.infoText
    }, e.createElement(K, {
      style: {
        padding: "0 12px"
      }
    }, p && e.createElement("p", {
      className: Ku.headline
    }, p), m && e.createElement("p", {
      className: Ku.datetime
    }, "".concat(Ou(g, "d MMMM y", {
      locale: ep
    })))))))))));
  },
  gp = function (t) {
    var r = c(null),
      i = t.props,
      a = i.ttninjs,
      o = i.activeCard,
      s = i.cardNr,
      l = i.onClickCard,
      d = i.replaced,
      u = a.header,
      p = a.body,
      m = a.footer,
      f = a.background;
    return n(function () {
      o && r.current.focus();
    }, [o]), e.createElement("div", {
      ref: r,
      tabIndex: "0",
      style: {
        opacity: d ? "0.3" : "1",
        background: f
      },
      className: "".concat(Ku.compactCard, " ").concat(Ku.defaultCard, " ").concat(Ku.textcard, " ").concat(o ? Ku.cardActive : ""),
      onClick: function (e) {
        return l ? l(e, s) : null;
      },
      "data-testid": "custom"
    }, e.createElement(K, null, e.createElement("div", {
      className: Ku.header,
      style: {
        fontSize: 14
      }
    }, e.createElement(Qt, {
      top: "0",
      right: "0",
      bottom: "0",
      left: "0"
    }, e.createElement(en, {
      cols: 12
    }, e.createElement(K, {
      nowrap: !0,
      direction: "row",
      align: "center",
      justify: "space-between",
      style: {
        width: "100%",
        paddingTop: "10px"
      }
    }, u)))), e.createElement("div", {
      className: Ku.body
    }, p), e.createElement("div", {
      style: {
        width: "100%",
        borderTop: "solid 1px #e3e5e3"
      }
    }), e.createElement("div", {
      className: Ku.footer,
      style: {
        width: "100%"
      }
    }, e.createElement(Qt, {
      top: "0",
      right: "0",
      bottom: "0",
      left: "0"
    }, e.createElement(en, {
      cols: 12
    }, e.createElement(K, {
      nowrap: !0,
      direction: "row",
      align: "center",
      justify: "space-between",
      style: {
        width: "100%",
        paddingTop: "10px"
      }
    }, m))))));
  },
  _p = function (t) {
    var n = t.headline,
      r = t.icon,
      i = t.body,
      a = t.left,
      o = t.right,
      s = t.onClick,
      l = t.background,
      c = void 0 === l ? "#fff" : l,
      d = t.children;
    return e.createElement("div", {
      tabIndex: "0",
      className: "".concat(Ku.card, " ").concat(Ku.textcard, " ").concat(Ku.noTTNinjsCard),
      style: {
        background: c
      },
      onClick: function (e) {
        return s ? s() : null;
      }
    }, e.createElement(K, {
      justify: "space-between",
      style: {
        width: "97%"
      }
    }, e.createElement("div", {
      className: Ku.header,
      style: {
        color: "light" === ad(c) ? "inherit" : "#fff"
      }
    }, r ? e.createElement(K, {
      direction: "row",
      nowrap: !0,
      align: "center"
    }, e.createElement(Bl, {
      padding: "0"
    }, e.createElement(nd, {
      icon: r
    })), e.createElement("div", {
      className: Ku.headline
    }, "".concat(n))) : e.createElement("div", {
      className: Ku.headline
    }, "".concat(n))), e.createElement("div", {
      className: Ku.body
    }, i || d), e.createElement(K, {
      justify: "space-between",
      direction: "row",
      style: {
        width: "100%"
      }
    }, e.createElement("div", {
      className: Ku.time
    }, a), e.createElement("div", {
      className: Ku.time
    }, o))));
  },
  yp = function (t) {
    var n = t.ttninjs;
    return n ? function (n) {
      switch (n) {
        case "planning":
          return e.createElement(dp, {
            props: t
          });
        case "event":
          return e.createElement(pp, {
            props: t
          });
        case "picture":
        case "graphic":
          return e.createElement(fp, {
            props: t
          });
        case "custom":
          return e.createElement(gp, {
            props: t
          });
        default:
          return e.createElement(sp, {
            props: t
          });
      }
    }(n.type) : e.createElement(_p, t);
  };
function hp(e, t) {
  return e.density === t.density && !(!e.ttninjs || !t.ttninjs) && e.ttninjs.uri === t.ttninjs.uri && e.activeCard === t.activeCard;
}
var vp = e.memo(yp, hp),
  bp = "badge_badge__34mHT",
  xp = "badge_badgeStandard__3kLeK",
  Ep = "badge_badgePRM__1BEmT",
  kp = "badge_badgeFlash__28ag_";
function Tp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function wp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Tp(Object(n), !0).forEach(function (t) {
      X(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Tp(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.badge_badge__34mHT {\n  font-family: "Roboto", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 18px;\n  padding: 2px 6px;\n  border-radius: 2px;\n  margin-bottom: 8px;\n  margin-right: 0px;\n  display: inline-block;\n  background-color: #ddd;\n  border: solid 1px #ddd; }\n  .badge_badgeStandard__3kLeK {\n    background-color: #2e3b8c;\n    border-color: #2e3b8c;\n    color: #fff;\n    padding: 6px 10px;\n    cursor: pointer;\n    font-size: 16px; }\n  .badge_badgePRM__1BEmT {\n    background-color: #ebe5fd;\n    border-color: #ebe5fd; }\n  .badge_badgeFlash__28ag_ {\n    background-color: #f8e71c;\n    border-color: #f8e71c; }\n');
var Ap = function (t) {
    var n = t.text,
      r = void 0 === n ? "Badge" : n,
      i = t.color,
      a = t.type,
      o = t.style,
      s = t.stretch,
      l = void 0 !== s && s;
    if (r.trim && "" === r.trim()) return null;
    return r.trim && r.trim() && (r.length >= 1 || -1 !== r.indexOf("(") || -1 !== r.indexOf(")")) ? e.createElement("div", {
      "data-testid": "badge",
      style: wp(wp({}, o), {}, {
        width: l ? "100%" : "auto",
        background: i && i,
        color: i && ("dark" === ad(i) ? "#fff" : "#181818"),
        borderColor: i && i
      }),
      className: "".concat(bp, " ").concat(function (e) {
        switch (e) {
          case "PRM":
            return Ep;
          case "flash":
            return kp;
          case "standard":
            return xp;
          default:
            return "";
        }
      }(a))
    }, r.toString()) : null;
  },
  Cp = "search_search__wdRYH",
  Sp = "search_searchInput__4gXuG";
function Np(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.search_search__wdRYH {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  border: solid 1px #dcdcdc;\n  border-radius: 6px;\n  background: #f8f8f8;\n  display: flex;\n  padding: 0;\n  margin: 0;\n  max-width: 580px; }\n\n.search_searchInput__4gXuG {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px;\n  margin: 0 !important;\n  width: 95%;\n  min-width: auto !important;\n  font-size: 18px !important;\n  padding: 14px 40px 14px 16px !important;\n  border: none !important;\n  border-radius: 6px !important;\n  background: none; }\n\n.search_divider__3TdtP {\n  height: 24px;\n  border: none;\n  border-left: solid 1px #EAEAEA;\n  padding: 10 0;\n  width: 0; }\n');
var Op = function (t) {
    ee(r, a);
    var n = Np(r);
    function r(e) {
      var t;
      return q(this, r), (t = n.call(this, e)).state = {
        searchString: e.value || "",
        selected: e.subs && e.subs[0] && (e.selected || e.subs[e.active || 0].title),
        timerId: 0
      }, t._handleChange = t._handleChange.bind(oe(t)), t.reset = t.reset.bind(oe(t)), t.submit = t.submit.bind(oe(t)), t.select = t.select.bind(oe(t)), t.autoSubmitTimer = t.autoSubmitTimer.bind(oe(t)), t;
    }
    return Q(r, [{
      key: "componentDidUpdate",
      value: function (e) {
        this.props.value !== e.value && this.setState({
          searchString: this.props.value ? this.props.value : ""
        });
      }
    }, {
      key: "_handleChange",
      value: function (e) {
        var t = this.props,
          n = t.handleChange,
          r = t.autoSubmit;
        this.setState({
          searchString: e.target.value
        }), n && n(e.target.value), r && this.autoSubmitTimer();
      }
    }, {
      key: "submit",
      value: function (e) {
        var t = this.props.handleSubmit;
        e && e.preventDefault(), t && t(this.state.searchString);
      }
    }, {
      key: "reset",
      value: function (e) {
        var t = this.props.handleSubmit;
        this.setState({
          searchString: ""
        }), t && t("");
      }
    }, {
      key: "select",
      value: function (e) {
        this.setState({
          selected: e
        });
      }
    }, {
      key: "autoSubmitTimer",
      value: function () {
        var e = this.state.timerId;
        if (0 !== e && clearTimeout(e), this.state.searchString.length > 1) {
          var t = setTimeout(this.submit, this.props.timeout ? this.props.timeout : 800);
          this.setState({
            timerId: t
          });
        }
      }
    }, {
      key: "render",
      value: function () {
        var t = this,
          n = this.props,
          r = n.subs,
          i = void 0 === r ? [] : r,
          a = n.placeholder,
          o = n.width,
          s = void 0 === o ? "100%" : o,
          l = n.clearIcon,
          c = i[0] && i.map(function (e) {
            return {
              title: e.title,
              onClick: function (n) {
                t.select(e.title), e.onClick && e.onClick();
              }
            };
          });
        return e.createElement("form", {
          style: {
            width: s
          },
          onSubmit: this.submit
        }, e.createElement("div", {
          className: Cp,
          style: {
            width: s
          }
        }, i.length > 0 ? e.createElement(Dp, {
          selected: this.state.selected,
          data: c,
          stretch: !0,
          slim: !0,
          style: {
            borderTop: 0,
            borderBottom: 0,
            borderLeft: 0,
            minWidth: 70,
            backgroundColor: "#fff"
          }
        }) : null, e.createElement("label", {
          style: {
            marginTop: 0,
            marginRight: 0,
            width: "100%"
          }
        }, e.createElement(K, {
          direction: "row",
          justify: "space-between",
          nowrap: !0,
          align: "center",
          style: {
            width: "inherit"
          }
        }, e.createElement("div", {
          style: {
            flexGrow: i.length > 0 ? 3 : 8,
            display: "flex",
            flexWrap: "nowrap"
          }
        }, e.createElement("input", {
          type: "text",
          value: this.state.searchString,
          placeholder: a || "Sök här",
          className: Sp,
          onChange: this._handleChange,
          onBlur: this.submit
        }), l && e.createElement(Bl, {
          padding: "0px",
          onClick: this.reset
        }, e.createElement(nd, {
          icon: "clear",
          color: "#bdbdbd",
          style: {
            paddingRight: 8,
            paddingLeft: 8
          }
        })), e.createElement(Bl, {
          padding: "0"
        }, e.createElement(nd, {
          icon: "search",
          color: "#3F51BF",
          style: {
            paddingRight: 8,
            paddingLeft: 12
          }
        })))))));
      }
    }]), r;
  }(),
  Rp = "style_dashboardsSelect___qt0C",
  Ip = "style_dashboardsSelectTrigger__3FoyD";
function Lp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function jp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Lp(Object(n), !0).forEach(function (t) {
      X(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Lp(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.style_dashboardsSelect___qt0C {\n  min-width: 320px; }\n  .style_dashboardsSelectTrigger__3FoyD {\n    padding: 10px 15px;\n    border-radius: 4px;\n    border: solid 1px #dfdedc; }\n    .style_dashboardsSelectTrigger-subheader__2vrjc {\n      background-color: red; }\n');
var Dp = function (t) {
    var n = t.footer,
      r = t.selected,
      i = void 0 === r ? "" : r,
      a = t.data,
      o = void 0 === a ? [] : a,
      s = t.keepOpen,
      l = void 0 !== s && s,
      c = t.style,
      d = void 0 === c ? {} : c;
    return e.createElement(tc, {
      position: "left",
      keepOpen: l,
      zonePadding: "0px",
      trigger: e.createElement("div", {
        tabIndex: 0,
        className: Ip,
        style: jp({
          display: "flex",
          justifyContent: "center",
          flexDirection: "row"
        }, d)
      }, e.createElement(K, {
        direction: "row",
        align: "space-between",
        nowrap: !0
      }, e.createElement("div", {
        style: {
          marginRight: 15
        }
      }, i), e.createElement(nd, {
        icon: "keyboard_arrow_down"
      }))),
      content: e.createElement("div", {
        className: Rp
      }, e.createElement(dn, {
        stretch: !0,
        direction: "column",
        data: o
      }), n ? e.createElement("div", {
        className: "dashboaxrds-select-btn"
      }, n) : null)
    });
  },
  Fp = "style_container__SGlqU",
  Mp = "style_header__3rEei",
  Pp = "style_year__pbcu4",
  Bp = "style_arrow__2tQmE",
  Hp = "style_dayNames__8IqJ7",
  zp = "style_date__1Wa7m",
  Up = "style_selected__2bJ_L";
function Wp(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n@import url("https://fonts.googleapis.com/icon?family=Material+Icons");\n.style_container__SGlqU {\n  border-radius: 0px;\n  background: #ffffff;\n  width: 200px; }\n\n.style_header__3rEei {\n  color: rgba(0, 0, 0, 0.87);\n  font-family: "Roboto", sans-serif;\n  font-weight: bolder;\n  font-size: 12px; }\n\n.style_year__pbcu4 {\n  padding-left: 7px; }\n\n.style_arrow__2tQmE i {\n  width: 100%;\n  text-align: center;\n  cursor: pointer;\n  color: rgba(0, 0, 0, 0.87); }\n  .style_arrow__2tQmE i:hover {\n    cursor: pointer;\n    border-radius: 2px;\n    color: #ffffff;\n    background-color: #2e3b8c;\n    -webkit-transition: background-color .4s ease-out;\n    -moz-transition: background-color .4s ease-out;\n    -o-transition: background-color .4s ease-out;\n    transition: background-color .4s ease-out; }\n  .style_arrow__2tQmE i:active {\n    border-radius: 2px;\n    background-color: #1D2559;\n    color: #ffffff; }\n\n.style_dayNames__8IqJ7 {\n  padding: 3px;\n  color: #607D8B;\n  font-family: "Roboto", sans-serif;\n  font-weight: bold;\n  font-size: 10px; }\n\n.style_date__1Wa7m {\n  width: 100%;\n  color: #181818;\n  font-family: "Roboto", sans-serif;\n  font-size: 10px;\n  font-weight: bold;\n  text-align: center; }\n  .style_date__1Wa7m:hover {\n    cursor: pointer;\n    border-radius: 2px;\n    color: #ffffff;\n    background-color: #2e3b8c;\n    -webkit-transition: background-color .4s ease-out;\n    -moz-transition: background-color .4s ease-out;\n    -o-transition: background-color .4s ease-out;\n    transition: background-color .4s ease-out; }\n  .style_date__1Wa7m:active {\n    border-radius: 2px;\n    background-color: #1D2559;\n    color: #ffffff; }\n\n.style_selected__2bJ_L {\n  color: #ffffff;\n  border-radius: 2px;\n  background-color: #3f51bf; }\n\n.style_onClick__3NH10 {\n  border: 1px solid #7E90FF; }\n');
var Xp = function (t) {
    ee(r, a);
    var n = Wp(r);
    function r(e) {
      var t;
      q(this, r), t = n.call(this, e);
      var i = e.date ? new Date(e.date) : new Date();
      return t.state = {
        selectedDate: Ld(i),
        startOfMonth: Fd(i)
      }, t.day = t.day.bind(oe(t)), t.month = t.month.bind(oe(t)), t.header = t.header.bind(oe(t)), t.weekdays = t.weekdays.bind(oe(t)), t.setSelectedDate = t.setSelectedDate.bind(oe(t)), t.setMonth = t.setMonth.bind(oe(t)), t;
    }
    return Q(r, [{
      key: "setSelectedDate",
      value: function (e) {
        var t = this.props.onChange,
          n = void 0 === t ? function () {} : t;
        this.setState({
          selectedDate: e
        }), n(e);
      }
    }, {
      key: "setMonth",
      value: function (e) {
        this.setState({
          startOfMonth: e
        });
      }
    }, {
      key: "header",
      value: function () {
        var t = this,
          n = [];
        return n.push(e.createElement(Gt, {
          cols: 2,
          alignY: "center",
          key: "head2"
        }, e.createElement("div", {
          className: "".concat(Mp, " ").concat(Pp)
        }, Ou(this.state.startOfMonth, "yyyy", {
          locale: ep
        })))), n.push(e.createElement(Gt, {
          cols: 3,
          alignX: "center",
          alignY: "center",
          key: "head1"
        }, e.createElement("div", {
          className: "".concat(Mp)
        }, Ou(this.state.startOfMonth, "MMMM", {
          locale: ep
        })))), n.push(e.createElement(Gt, {
          cols: 1,
          alignY: "center",
          key: "head3",
          className: Bp
        }, e.createElement("i", {
          className: "material-icons",
          onClick: function (e) {
            return t.setMonth(function (e, t) {
              Cd(2, arguments);
              var n = Ad(t);
              return Od(e, -n);
            }(t.state.startOfMonth, 1));
          }
        }, "keyboard_arrow_left"))), n.push(e.createElement(Gt, {
          cols: 1,
          alignY: "center",
          key: "head4",
          className: Bp
        }, e.createElement("i", {
          className: "material-icons",
          onClick: function (e) {
            return t.setMonth(Od(t.state.startOfMonth, 1));
          }
        }, "keyboard_arrow_right"))), n;
      }
    }, {
      key: "weekdays",
      value: function () {
        return ["M", "T", "O", "T", "F", "L", "S"].map(function (t, n) {
          return e.createElement(Gt, {
            cols: 1,
            key: t + n,
            alignX: "center",
            alignY: "center"
          }, e.createElement("div", {
            className: Hp
          }, t));
        });
      }
    }, {
      key: "day",
      value: function (t, n) {
        var r = this;
        return e.createElement(Gt, {
          tag: "div",
          cols: 1,
          key: n,
          alignX: "center",
          alignY: "center"
        }, e.createElement("div", {
          className: "".concat(zp, "  ").concat(Iu(t, this.state.selectedDate) ? Up : "", " "),
          onClick: function (e) {
            r.setSelectedDate(t);
          }
        }, function (e) {
          return Cd(1, arguments), Sd(e).getDate();
        }(t)));
      }
    }, {
      key: "month",
      value: function () {
        for (var e = function (e) {
            Cd(1, arguments);
            var t = Sd(e).getDay();
            return 0 === t && (t = 7), t;
          }(this.state.startOfMonth), t = function (e) {
            Cd(1, arguments);
            var t = Sd(e),
              n = t.getFullYear(),
              r = t.getMonth(),
              i = new Date(0);
            return i.setFullYear(n, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
          }(this.state.startOfMonth), n = 7 * Math.ceil((e + t - 1) / 7), r = [], i = function (e, t) {
            Cd(2, arguments);
            var n = Ad(t);
            return Nd(e, -n);
          }(this.state.startOfMonth, e - 1), a = 0; a < n; a++) r.push(this.day(Nd(i, a), a));
        return r;
      }
    }, {
      key: "render",
      value: function () {
        return e.createElement("div", {
          className: Fp
        }, e.createElement(qt, {
          colspan: 7,
          breakpoints: [0, 400, 800, 1200],
          top: "10px",
          right: "10px",
          bottom: "10px",
          left: "10px",
          gutterX: "2px",
          gutterY: "2px"
        }, this.header(), this.weekdays(), this.month()));
      }
    }]), r;
  }(),
  Gp = "style_labelText__1UdRf",
  Vp = "style_toggleBody__3zpg5",
  Yp = "style_toggleContainer__248hd",
  Kp = "style_inputToggle__5uh2z",
  Zp = "style_off__ZEDiu",
  qp = "style_sliderLine__LlgQ_",
  Jp = "style_on__364rF",
  Qp = "style_sliderNotch__2yTtf";
y("/* WITH LABEL */\nlabel.style_labelText__1UdRf {\n  padding-right: 10px;\n  line-height: normal;\n  font-size: 14px;\n  display: flex;\n  flex: 1;\n  flex-direction: row !important;\n  align-items: center; }\n  label.style_labelText__1UdRf div.style_toggleBody__3zpg5 {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    padding: 0 10px; }\n    label.style_labelText__1UdRf div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd {\n      cursor: pointer;\n      color: #222222;\n      width: 0;\n      height: 15px;\n      position: relative;\n      display: inline-block; }\n      label.style_labelText__1UdRf div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd > * {\n        cursor: pointer; }\n      label.style_labelText__1UdRf div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd input.style_inputToggle__5uh2z {\n        opacity: 0;\n        position: absolute;\n        width: inherit;\n        margin: 0;\n        z-index: 10; }\n        label.style_labelText__1UdRf div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd input.style_inputToggle__5uh2z.style_off__ZEDiu + div.style_sliderLine__LlgQ_ {\n          background-color: rgba(0, 0, 0, 0.16); }\n        label.style_labelText__1UdRf div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd input.style_inputToggle__5uh2z.style_on__364rF + div.style_sliderLine__LlgQ_ {\n          background-color: #CCEDA7; }\n        label.style_labelText__1UdRf div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd input.style_inputToggle__5uh2z.style_off__ZEDiu + div.style_sliderLine__LlgQ_ + div.style_sliderNotch__2yTtf {\n          transform: translateX(0);\n          transition: .3s;\n          z-index: 4;\n          position: absolute;\n          background-color: #ffffff;\n          box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12); }\n        label.style_labelText__1UdRf div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd input.style_inputToggle__5uh2z.style_on__364rF + div.style_sliderLine__LlgQ_ + div.style_sliderNotch__2yTtf {\n          transform: translateX(15px);\n          transition: .3s;\n          z-index: 4;\n          position: absolute;\n          background-color: #6BAD22;\n          box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12); }\n      label.style_labelText__1UdRf div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd div.style_sliderLine__LlgQ_ {\n        width: 34px;\n        height: 14px;\n        border-radius: 30px; }\n        label.style_labelText__1UdRf div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd div.style_sliderLine__LlgQ_::before {\n          content: '';\n          width: 21px;\n          height: 21px; }\n      label.style_labelText__1UdRf div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd div.style_sliderNotch__2yTtf {\n        position: absolute;\n        top: -3px;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        z-index: 5; }\n\n/* WITHOUT LABEL */\ndiv.style_toggleBody__3zpg5 {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  padding: 0 10px; }\n  div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd {\n    cursor: pointer;\n    color: #222222;\n    width: 50px;\n    height: 15px;\n    position: relative;\n    display: inline-block; }\n    div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd > * {\n      cursor: pointer; }\n    div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd input.style_inputToggle__5uh2z {\n      opacity: 0;\n      position: absolute;\n      width: inherit;\n      margin: 0;\n      z-index: 10; }\n      div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd input.style_inputToggle__5uh2z.style_off__ZEDiu + div.style_sliderLine__LlgQ_ {\n        background-color: rgba(0, 0, 0, 0.16); }\n      div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd input.style_inputToggle__5uh2z.style_on__364rF + div.style_sliderLine__LlgQ_ {\n        background-color: #CCEDA7; }\n      div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd input.style_inputToggle__5uh2z.style_off__ZEDiu + div.style_sliderLine__LlgQ_ + div.style_sliderNotch__2yTtf {\n        transform: translateX(0);\n        transition: .3s;\n        z-index: 4;\n        position: absolute;\n        background-color: #ffffff;\n        box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12); }\n      div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd input.style_inputToggle__5uh2z.style_on__364rF + div.style_sliderLine__LlgQ_ + div.style_sliderNotch__2yTtf {\n        transform: translateX(15px);\n        transition: .3s;\n        z-index: 4;\n        position: absolute;\n        background-color: #6BAD22;\n        box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12); }\n    div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd div.style_sliderLine__LlgQ_ {\n      width: 34px;\n      height: 14px;\n      border-radius: 30px; }\n      div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd div.style_sliderLine__LlgQ_::before {\n        content: '';\n        width: 21px;\n        height: 21px; }\n    div.style_toggleBody__3zpg5 div.style_toggleContainer__248hd div.style_sliderNotch__2yTtf {\n      position: absolute;\n      top: -3px;\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      z-index: 5; }\n");
var $p = function (t) {
    var n = t.handleChange,
      r = t.checked,
      i = t.label,
      a = t.name,
      o = t.stretch,
      s = void 0 !== o && o,
      l = r ? Jp : Zp;
    return e.createElement("label", {
      htmlFor: a,
      id: a,
      className: Gp,
      style: {
        justifyContent: s ? "space-between" : "flex-start",
        width: s && "calc(100% - 20px)"
      }
    }, i, e.createElement("div", {
      className: Vp
    }, e.createElement("div", {
      className: Yp
    }, e.createElement("input", {
      className: "".concat(Kp, " ").concat(l),
      type: "checkbox",
      checked: r,
      onChange: function (e) {
        n(e);
      },
      name: a
    }), e.createElement("div", {
      className: qp
    }), e.createElement("div", {
      className: Qp
    }))));
  },
  em = function (e) {
    var t,
      n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "Normal",
      r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Thumbnail";
    return Object.keys(e.renditions).forEach(function (i, a) {
      var o = e.renditions[i];
      o.variant === n && o.usage === r && (t = o.href);
    }), t;
  },
  tm = {
    headingXL: "objectview_headingXL__alkg8",
    subHeading: "objectview_subHeading__1Id0q",
    dat: "objectview_dat__Ks1Q5",
    byline: "objectview_byline__1r7Wx",
    caption: "objectview_caption__2qTqs",
    blockquote: "objectview_blockquote__18uUK",
    bodyText: "objectview_bodyText__2aWmY",
    objectView: "objectview_objectView__e7st3",
    dateAndTime: "objectview_dateAndTime__c5X62",
    headline: "objectview_headline__3PjyG",
    vignette: "objectview_vignette__MQNzz",
    source: "objectview_source__xKeX3",
    descriptionUsage: "objectview_descriptionUsage__3jAdU",
    imageWrapper: "objectview_imageWrapper__3Cbzw",
    slideShowWrapper: "objectview_slideShowWrapper__3paV7",
    closeSlideShowIcon: "objectview_closeSlideShowIcon__1vNZQ"
  };
function nm(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
y('@charset "UTF-8";\n/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.objectview_headingXL__alkg8 {\n  font-family: "Montserrat", sans-serif;\n  font-size: 42px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 52px; }\n\n.objectview_subHeading__1Id0q {\n  font-family: "Roboto", sans-serif;\n  font-size: 20px;\n  font-weight: 400;\n  color: #181818;\n  line-height: 27px; }\n\n.objectview_dat__Ks1Q5, .objectview_byline__1r7Wx {\n  font-family: "Roboto", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.55);\n  text-transform: uppercase;\n  line-height: 18px; }\n\n.objectview_caption__2qTqs {\n  font-family: "Roboto", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 18px;\n  max-width: 280px; }\n\n.objectview_blockquote__18uUK {\n  padding: 0;\n  margin: 0; }\n  .objectview_blockquote__18uUK::before {\n    content: "\\2014  "; }\n\n.objectview_bodyText__2aWmY {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px; }\n\n.objectview_objectView__e7st3 {\n  margin: 0;\n  padding: 0 0 0 15px; }\n  .objectview_objectView__e7st3 .objectview_dateAndTime__c5X62 {\n    font-size: 16px;\n    color: #4f4f4f; }\n  .objectview_objectView__e7st3 .objectview_headline__3PjyG {\n    font-size: 34px;\n    font-family: "Roboto", sans-serif;\n    font-weight: bolder;\n    color: #222222;\n    margin: 0;\n    line-height: 38px; }\n  .objectview_objectView__e7st3 .objectview_vignette__MQNzz::after {\n    content: " ("; }\n  .objectview_objectView__e7st3 .objectview_source__xKeX3::after {\n    content: ")"; }\n  .objectview_objectView__e7st3 .objectview_descriptionUsage__3jAdU {\n    font-family: "Roboto", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    color: rgba(0, 0, 0, 0.75);\n    line-height: 24px;\n    background: #fbf8e2;\n    padding: 20px;\n    margin: 20px 0;\n    border: solid 1px #e8e8e8;\n    border-radius: 5px; }\n  .objectview_objectView__e7st3 .objectview_imageWrapper__3Cbzw {\n    margin-top: 40px; }\n  .objectview_objectView__e7st3 .objectview_slideShowWrapper__3paV7 {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0; }\n    .objectview_objectView__e7st3 .objectview_slideShowWrapper__3paV7 .objectview_closeSlideShowIcon__1vNZQ {\n      position: absolute;\n      top: 20px;\n      right: 20px;\n      z-index: 10;\n      cursor: pointer; }\n');
var rm = function (t) {
  ee(r, a);
  var n = nm(r);
  function r(e) {
    var t;
    return q(this, r), (t = n.call(this, e)).state = {
      isSlideShow: !1,
      startSlide: "0"
    }, t;
  }
  return Q(r, [{
    key: "list",
    value: function () {
      var t = this,
        n = this.props.associations,
        r = void 0 === n ? {} : n;
      return e.createElement(K, null, (Object.keys(r) || []).map(function (n, i) {
        return r[n].renditions ? e.createElement("div", {
          className: tm.imageWrapper,
          onClick: function (e) {
            return t.setState({
              isSlideShow: !0,
              startSlide: JSON.stringify(i)
            });
          },
          key: i
        }, e.createElement("img", {
          src: em(r[n], "Normal", "Thumbnail")
        }), e.createElement("div", {
          className: tm.caption
        }, r[n].description_text), e.createElement("div", {
          className: tm.dat
        }, "FOTO: ", r[n].byline)) : "";
      }));
    }
  }, {
    key: "slideShow",
    value: function () {
      var t = this;
      return e.createElement("div", {
        className: tm.slideShowWrapper
      }, e.createElement("span", {
        className: tm.closeSlideShowIcon,
        onClick: function (e) {
          return t.setState({
            isSlideShow: !1
          });
        }
      }, e.createElement(nd, {
        color: "#fff",
        icon: "clear"
      })));
    }
  }, {
    key: "render",
    value: function () {
      var e = this.props.associations,
        t = void 0 === e ? {} : e;
      return Object.keys(t) ? this.state.isSlideShow ? this.slideShow() : this.list() : "";
    }
  }]), r;
}();
function im(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function am(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? im(Object(n), !0).forEach(function (t) {
      X(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : im(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function om(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
var sm = {
    INR: "Inrikes",
    UTR: "Utrikes",
    EKO: "Ekonomi",
    KLT: "Kultur & nöje",
    SPT: "Sport",
    PRM: "Pressmeddelande"
  },
  lm = function (t) {
    ee(r, a);
    var n = om(r);
    function r(e) {
      var t;
      return q(this, r), (t = n.call(this, e)).state = {
        metaData: !1
      }, t;
    }
    return Q(r, [{
      key: "render",
      value: function () {
        var t,
          n,
          r = this,
          i = this.props,
          a = i.ttninjs,
          o = i.style,
          s = i.onClose,
          l = i.onReplace,
          c = a.copyrightholder,
          d = a.slug,
          u = a.datetime,
          p = a.date,
          m = a.sector,
          f = Pu(u || p);
        return e.createElement("div", {
          style: am({}, o)
        }, e.createElement(C, {
          noLogo: !0,
          update: !0,
          style: {
            position: "sticky",
            top: 0
          },
          left: e.createElement("span", {
            onClick: s,
            style: {
              cursor: "pointer"
            }
          }, e.createElement(nd, {
            icon: "clear"
          })),
          right: e.createElement(K, {
            direction: "row"
          }, a.revisions.length > 1 ? e.createElement(tc, {
            position: "bottom",
            trigger: e.createElement(nd, {
              icon: "settings_backup_restore"
            }),
            content: e.createElement(dn, {
              direction: "column",
              data: a.revisions.map(function (e) {
                return {
                  title: e.slug,
                  onClick: function (t) {
                    return l(t, e.uri);
                  }
                };
              }).reverse()
            })
          }) : null, e.createElement(tc, {
            position: "bottom",
            trigger: e.createElement(nd, {
              icon: "code"
            }),
            content: e.createElement(dn, {
              direction: "column",
              data: [{
                title: "ttninjs",
                onClick: function (e) {
                  return r.setState({
                    metaData: r.state.metaData ? null : "ttninjs"
                  });
                }
              }, {
                type: "url",
                title: "NewsML",
                href: a.uri.replace("http://tt.se/", "https://stage01.a.tt.se/") + ".xml?ak=fbddb2f7-d65d-4849-b232-b52aa0dbaa1b",
                target: "_blank"
              }]
            })
          }))
        }), this.state.metaData ? e.createElement("div", {
          style: {
            padding: 40
          }
        }) : e.createElement(Qt, {
          control: !0
        }, e.createElement(en, {
          cols: 9
        }, e.createElement("div", {
          className: tm.newsObject
        }, a.description_usage ? e.createElement("div", {
          className: tm.descriptionUsage
        }, a.description_usage) : null, e.createElement("div", {
          className: tm.dat
        }, "".concat(d, " ").concat(Ou(f, "dd MMM yyyy - HH:mm", {
          locale: ep
        }))), e.createElement("div", {
          className: "body",
          dangerouslySetInnerHTML: {
            __html: (t = a.body_html5, n = t, n = (n = (n = (n = (n = (n = (n = (n = n.replace(/<h1/gi, "<h1 class='" + tm.headingXL + "'")).replace(/<h4/gi, "<h4 class='" + tm.subHeading + "'")).replace(/<blockquote/gi, "<blockquote class='" + tm.blockquote + "'")).replace(/class="dat"/gi, "class='" + tm.dat + "'")).replace(/class="byline"/gi, "class='" + tm.byline + "'")).replace(/class="vignette"/gi, "class='" + tm.vignette + "'")).replace(/class="source"/gi, "class='" + tm.source + "'")).replace(/class="bodytext"/gi, "class='" + tm.bodyText + "'"))
          }
        }), e.createElement("div", {
          className: tm.dat
        }, e.createElement("div", null, "tt" === c.toLowerCase() ? "TT Nyhetsbyrån" : c), e.createElement("div", {
          style: {
            display: "flex",
            flexDirection: "row"
          }
        }, "".concat(m && sm && sm[m.toUpperCase()] ? sm[m.toUpperCase()] : m, " ").concat(Ou(f, "dd MMM yyyy - HH:mm", {
          locale: ep
        })))))), e.createElement(en, {
          cols: 3
        }, e.createElement(rm, {
          associations: a.associations
        }))));
      }
    }]), r;
  }(),
  cm = {
    headingXL: "eventobject_headingXL__3lBwU",
    subHeading: "eventobject_subHeading__3ceiB",
    dat: "eventobject_dat__2scx-",
    byline: "eventobject_byline__31pkH",
    caption: "eventobject_caption__3MWDh",
    blockquote: "eventobject_blockquote__10Gj7",
    bodyText: "eventobject_bodyText__1afcp",
    objectView: "eventobject_objectView__3sM--",
    dateAndTime: "eventobject_dateAndTime__ny7zF",
    headline: "eventobject_headline__sXI1u",
    vignette: "eventobject_vignette__2QsLN",
    source: "eventobject_source__2tr90",
    descriptionUsage: "eventobject_descriptionUsage__tcl-u",
    imageWrapper: "eventobject_imageWrapper__2-Lxn",
    slideShowWrapper: "eventobject_slideShowWrapper__3f_L7",
    closeSlideShowIcon: "eventobject_closeSlideShowIcon__3BQBb",
    eventObject: "eventobject_eventObject__3oGjn",
    extras: "eventobject_extras__13g8g",
    sector: "eventobject_sector__2kV1R",
    eventTimeSpan: "eventobject_eventTimeSpan__2al3w",
    event: "eventobject_event__1BxWB",
    subject: "eventobject_subject__9KrEA",
    courtcaseNumber: "eventobject_courtcaseNumber__2dlze",
    eventType: "eventobject_eventType__g356l",
    weekday: "eventobject_weekday__17ISx",
    assignment: "eventobject_assignment__o_0i2",
    eventInfo: "eventobject_eventInfo__3T-iG",
    canceled: "eventobject_canceled__19dU1"
  };
y('@charset "UTF-8";\n/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.eventobject_headingXL__3lBwU {\n  font-family: "Montserrat", sans-serif;\n  font-size: 42px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 52px; }\n\n.eventobject_subHeading__3ceiB {\n  font-family: "Roboto", sans-serif;\n  font-size: 20px;\n  font-weight: 400;\n  color: #181818;\n  line-height: 27px; }\n\n.eventobject_dat__2scx-, .eventobject_byline__31pkH {\n  font-family: "Roboto", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.55);\n  text-transform: uppercase;\n  line-height: 18px; }\n\n.eventobject_caption__3MWDh {\n  font-family: "Roboto", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 18px;\n  max-width: 280px; }\n\n.eventobject_blockquote__10Gj7 {\n  padding: 0;\n  margin: 0; }\n  .eventobject_blockquote__10Gj7::before {\n    content: "\\2014  "; }\n\n.eventobject_bodyText__1afcp {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px; }\n\n.eventobject_objectView__3sM-- {\n  margin: 0;\n  padding: 0 0 0 15px; }\n  .eventobject_objectView__3sM-- .eventobject_dateAndTime__ny7zF {\n    font-size: 16px;\n    color: #4f4f4f; }\n  .eventobject_objectView__3sM-- .eventobject_headline__sXI1u {\n    font-size: 34px;\n    font-family: "Roboto", sans-serif;\n    font-weight: bolder;\n    color: #222222;\n    margin: 0;\n    line-height: 38px; }\n  .eventobject_objectView__3sM-- .eventobject_vignette__2QsLN::after {\n    content: " ("; }\n  .eventobject_objectView__3sM-- .eventobject_source__2tr90::after {\n    content: ")"; }\n  .eventobject_objectView__3sM-- .eventobject_descriptionUsage__tcl-u {\n    font-family: "Roboto", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    color: rgba(0, 0, 0, 0.75);\n    line-height: 24px;\n    background: #fbf8e2;\n    padding: 20px;\n    margin: 20px 0;\n    border: solid 1px #e8e8e8;\n    border-radius: 5px; }\n  .eventobject_objectView__3sM-- .eventobject_imageWrapper__2-Lxn {\n    margin-top: 40px; }\n  .eventobject_objectView__3sM-- .eventobject_slideShowWrapper__3f_L7 {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0; }\n    .eventobject_objectView__3sM-- .eventobject_slideShowWrapper__3f_L7 .eventobject_closeSlideShowIcon__3BQBb {\n      position: absolute;\n      top: 20px;\n      right: 20px;\n      z-index: 10;\n      cursor: pointer; }\n\n.eventobject_eventObject__3oGjn {\n  padding: 10px; }\n  .eventobject_eventObject__3oGjn h1 {\n    margin: 20px 0 10px;\n    font-size: 34px;\n    line-height: 38px; }\n  .eventobject_eventObject__3oGjn .eventobject_headline__sXI1u {\n    padding-bottom: 10px; }\n  .eventobject_eventObject__3oGjn h3 {\n    font-size: 16px;\n    margin-bottom: 0; }\n  .eventobject_eventObject__3oGjn .eventobject_extras__13g8g {\n    width: 100%;\n    line-height: 21px;\n    padding: 15px 0; }\n    .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_sector__2kV1R, .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_eventTimeSpan__2al3w, .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_event__1BxWB, .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_subject__9KrEA, .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_courtcaseNumber__2dlze {\n      font-size: 16px !important; }\n    .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_eventType__g356l {\n      font-size: 16px;\n      padding: 0 5px 0 0;\n      margin-bottom: 0; }\n    .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_eventTimeSpan__2al3w {\n      color: #181818;\n      font-size: 16px;\n      margin-bottom: 8px;\n      margin-top: 0;\n      font-weight: bolder; }\n      .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_eventTimeSpan__2al3w .eventobject_weekday__17ISx {\n        text-transform: capitalize; }\n    .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_sector__2kV1R, .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_event__1BxWB, .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_subject__9KrEA, .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_courtcaseNumber__2dlze {\n      color: #4f4f4f;\n      margin: -2px 0; }\n    .eventobject_eventObject__3oGjn .eventobject_extras__13g8g .eventobject_assignment__o_0i2 > * {\n      padding: 5px 0; }\n  .eventobject_eventObject__3oGjn .eventobject_eventInfo__3T-iG {\n    width: 100%;\n    border-top: 1px solid rgba(0, 0, 0, 0.16);\n    font-size: 16px; }\n    .eventobject_eventObject__3oGjn .eventobject_eventInfo__3T-iG p {\n      margin: 0;\n      font-size: 16px !important; }\n    .eventobject_eventObject__3oGjn .eventobject_eventInfo__3T-iG h4 {\n      font-size: 18px;\n      padding-right: 10px;\n      margin-bottom: 0;\n      font-weight: bolder; }\n\n.eventobject_eventObject__3oGjn.eventobject_canceled__19dU1 {\n  text-decoration: line-through; }\n');
var dm = re(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TLDs = "(AAA|AARP|ABARTH|ABB|ABBOTT|ABBVIE|ABC|ABLE|ABOGADO|ABUDHABI|AC|ACADEMY|ACCENTURE|ACCOUNTANT|ACCOUNTANTS|ACO|ACTOR|AD|ADAC|ADS|ADULT|AE|AEG|AERO|AETNA|AF|AFAMILYCOMPANY|AFL|AFRICA|AG|AGAKHAN|AGENCY|AI|AIG|AIGO|AIRBUS|AIRFORCE|AIRTEL|AKDN|AL|ALFAROMEO|ALIBABA|ALIPAY|ALLFINANZ|ALLSTATE|ALLY|ALSACE|ALSTOM|AM|AMERICANEXPRESS|AMERICANFAMILY|AMEX|AMFAM|AMICA|AMSTERDAM|ANALYTICS|ANDROID|ANQUAN|ANZ|AO|AOL|APARTMENTS|APP|APPLE|AQ|AQUARELLE|AR|ARAB|ARAMCO|ARCHI|ARMY|ARPA|ART|ARTE|AS|ASDA|ASIA|ASSOCIATES|AT|ATHLETA|ATTORNEY|AU|AUCTION|AUDI|AUDIBLE|AUDIO|AUSPOST|AUTHOR|AUTO|AUTOS|AVIANCA|AW|AWS|AX|AXA|AZ|AZURE|BA|BABY|BAIDU|BANAMEX|BANANAREPUBLIC|BAND|BANK|BAR|BARCELONA|BARCLAYCARD|BARCLAYS|BAREFOOT|BARGAINS|BASEBALL|BASKETBALL|BAUHAUS|BAYERN|BB|BBC|BBT|BBVA|BCG|BCN|BD|BE|BEATS|BEAUTY|BEER|BENTLEY|BERLIN|BEST|BESTBUY|BET|BF|BG|BH|BHARTI|BI|BIBLE|BID|BIKE|BING|BINGO|BIO|BIZ|BJ|BLACK|BLACKFRIDAY|BLOCKBUSTER|BLOG|BLOOMBERG|BLUE|BM|BMS|BMW|BN|BNPPARIBAS|BO|BOATS|BOEHRINGER|BOFA|BOM|BOND|BOO|BOOK|BOOKING|BOSCH|BOSTIK|BOSTON|BOT|BOUTIQUE|BOX|BR|BRADESCO|BRIDGESTONE|BROADWAY|BROKER|BROTHER|BRUSSELS|BS|BT|BUDAPEST|BUGATTI|BUILD|BUILDERS|BUSINESS|BUY|BUZZ|BV|BW|BY|BZ|BZH|CA|CAB|CAFE|CAL|CALL|CALVINKLEIN|CAM|CAMERA|CAMP|CANCERRESEARCH|CANON|CAPETOWN|CAPITAL|CAPITALONE|CAR|CARAVAN|CARDS|CARE|CAREER|CAREERS|CARS|CASA|CASE|CASEIH|CASH|CASINO|CAT|CATERING|CATHOLIC|CBA|CBN|CBRE|CBS|CC|CD|CEB|CENTER|CEO|CERN|CF|CFA|CFD|CG|CH|CHANEL|CHANNEL|CHARITY|CHASE|CHAT|CHEAP|CHINTAI|CHRISTMAS|CHROME|CHURCH|CI|CIPRIANI|CIRCLE|CISCO|CITADEL|CITI|CITIC|CITY|CITYEATS|CK|CL|CLAIMS|CLEANING|CLICK|CLINIC|CLINIQUE|CLOTHING|CLOUD|CLUB|CLUBMED|CM|CN|CO|COACH|CODES|COFFEE|COLLEGE|COLOGNE|COM|COMCAST|COMMBANK|COMMUNITY|COMPANY|COMPARE|COMPUTER|COMSEC|CONDOS|CONSTRUCTION|CONSULTING|CONTACT|CONTRACTORS|COOKING|COOKINGCHANNEL|COOL|COOP|CORSICA|COUNTRY|COUPON|COUPONS|COURSES|CPA|CR|CREDIT|CREDITCARD|CREDITUNION|CRICKET|CROWN|CRS|CRUISE|CRUISES|CSC|CU|CUISINELLA|CV|CW|CX|CY|CYMRU|CYOU|CZ|DABUR|DAD|DANCE|DATA|DATE|DATING|DATSUN|DAY|DCLK|DDS|DE|DEAL|DEALER|DEALS|DEGREE|DELIVERY|DELL|DELOITTE|DELTA|DEMOCRAT|DENTAL|DENTIST|DESI|DESIGN|DEV|DHL|DIAMONDS|DIET|DIGITAL|DIRECT|DIRECTORY|DISCOUNT|DISCOVER|DISH|DIY|DJ|DK|DM|DNP|DO|DOCS|DOCTOR|DOG|DOMAINS|DOT|DOWNLOAD|DRIVE|DTV|DUBAI|DUCK|DUNLOP|DUPONT|DURBAN|DVAG|DVR|DZ|EARTH|EAT|EC|ECO|EDEKA|EDU|EDUCATION|EE|EG|EMAIL|EMERCK|ENERGY|ENGINEER|ENGINEERING|ENTERPRISES|EPSON|EQUIPMENT|ER|ERICSSON|ERNI|ES|ESQ|ESTATE|ESURANCE|ET|ETISALAT|EU|EUROVISION|EUS|EVENTS|EXCHANGE|EXPERT|EXPOSED|EXPRESS|EXTRASPACE|FAGE|FAIL|FAIRWINDS|FAITH|FAMILY|FAN|FANS|FARM|FARMERS|FASHION|FAST|FEDEX|FEEDBACK|FERRARI|FERRERO|FI|FIAT|FIDELITY|FIDO|FILM|FINAL|FINANCE|FINANCIAL|FIRE|FIRESTONE|FIRMDALE|FISH|FISHING|FIT|FITNESS|FJ|FK|FLICKR|FLIGHTS|FLIR|FLORIST|FLOWERS|FLY|FM|FO|FOO|FOOD|FOODNETWORK|FOOTBALL|FORD|FOREX|FORSALE|FORUM|FOUNDATION|FOX|FR|FREE|FRESENIUS|FRL|FROGANS|FRONTDOOR|FRONTIER|FTR|FUJITSU|FUJIXEROX|FUN|FUND|FURNITURE|FUTBOL|FYI|GA|GAL|GALLERY|GALLO|GALLUP|GAME|GAMES|GAP|GARDEN|GAY|GB|GBIZ|GD|GDN|GE|GEA|GENT|GENTING|GEORGE|GF|GG|GGEE|GH|GI|GIFT|GIFTS|GIVES|GIVING|GL|GLADE|GLASS|GLE|GLOBAL|GLOBO|GM|GMAIL|GMBH|GMO|GMX|GN|GODADDY|GOLD|GOLDPOINT|GOLF|GOO|GOODYEAR|GOOG|GOOGLE|GOP|GOT|GOV|GP|GQ|GR|GRAINGER|GRAPHICS|GRATIS|GREEN|GRIPE|GROCERY|GROUP|GS|GT|GU|GUARDIAN|GUCCI|GUGE|GUIDE|GUITARS|GURU|GW|GY|HAIR|HAMBURG|HANGOUT|HAUS|HBO|HDFC|HDFCBANK|HEALTH|HEALTHCARE|HELP|HELSINKI|HERE|HERMES|HGTV|HIPHOP|HISAMITSU|HITACHI|HIV|HK|HKT|HM|HN|HOCKEY|HOLDINGS|HOLIDAY|HOMEDEPOT|HOMEGOODS|HOMES|HOMESENSE|HONDA|HORSE|HOSPITAL|HOST|HOSTING|HOT|HOTELES|HOTELS|HOTMAIL|HOUSE|HOW|HR|HSBC|HT|HU|HUGHES|HYATT|HYUNDAI|IBM|ICBC|ICE|ICU|ID|IE|IEEE|IFM|IKANO|IL|IM|IMAMAT|IMDB|IMMO|IMMOBILIEN|IN|INC|INDUSTRIES|INFINITI|INFO|ING|INK|INSTITUTE|INSURANCE|INSURE|INT|INTEL|INTERNATIONAL|INTUIT|INVESTMENTS|IO|IPIRANGA|IQ|IR|IRISH|IS|ISMAILI|IST|ISTANBUL|IT|ITAU|ITV|IVECO|JAGUAR|JAVA|JCB|JCP|JE|JEEP|JETZT|JEWELRY|JIO|JLL|JM|JMP|JNJ|JO|JOBS|JOBURG|JOT|JOY|JP|JPMORGAN|JPRS|JUEGOS|JUNIPER|KAUFEN|KDDI|KE|KERRYHOTELS|KERRYLOGISTICS|KERRYPROPERTIES|KFH|KG|KH|KI|KIA|KIM|KINDER|KINDLE|KITCHEN|KIWI|KM|KN|KOELN|KOMATSU|KOSHER|KP|KPMG|KPN|KR|KRD|KRED|KUOKGROUP|KW|KY|KYOTO|KZ|LA|LACAIXA|LAMBORGHINI|LAMER|LANCASTER|LANCIA|LAND|LANDROVER|LANXESS|LASALLE|LAT|LATINO|LATROBE|LAW|LAWYER|LB|LC|LDS|LEASE|LECLERC|LEFRAK|LEGAL|LEGO|LEXUS|LGBT|LI|LIDL|LIFE|LIFEINSURANCE|LIFESTYLE|LIGHTING|LIKE|LILLY|LIMITED|LIMO|LINCOLN|LINDE|LINK|LIPSY|LIVE|LIVING|LIXIL|LK|LLC|LLP|LOAN|LOANS|LOCKER|LOCUS|LOFT|LOL|LONDON|LOTTE|LOTTO|LOVE|LPL|LPLFINANCIAL|LR|LS|LT|LTD|LTDA|LU|LUNDBECK|LUPIN|LUXE|LUXURY|LV|LY|MA|MACYS|MADRID|MAIF|MAISON|MAKEUP|MAN|MANAGEMENT|MANGO|MAP|MARKET|MARKETING|MARKETS|MARRIOTT|MARSHALLS|MASERATI|MATTEL|MBA|MC|MCKINSEY|MD|ME|MED|MEDIA|MEET|MELBOURNE|MEME|MEMORIAL|MEN|MENU|MERCKMSD|METLIFE|MG|MH|MIAMI|MICROSOFT|MIL|MINI|MINT|MIT|MITSUBISHI|MK|ML|MLB|MLS|MM|MMA|MN|MO|MOBI|MOBILE|MODA|MOE|MOI|MOM|MONASH|MONEY|MONSTER|MORMON|MORTGAGE|MOSCOW|MOTO|MOTORCYCLES|MOV|MOVIE|MP|MQ|MR|MS|MSD|MT|MTN|MTR|MU|MUSEUM|MUTUAL|MV|MW|MX|MY|MZ|NA|NAB|NAGOYA|NAME|NATIONWIDE|NATURA|NAVY|NBA|NC|NE|NEC|NET|NETBANK|NETFLIX|NETWORK|NEUSTAR|NEW|NEWHOLLAND|NEWS|NEXT|NEXTDIRECT|NEXUS|NF|NFL|NG|NGO|NHK|NI|NICO|NIKE|NIKON|NINJA|NISSAN|NISSAY|NL|NO|NOKIA|NORTHWESTERNMUTUAL|NORTON|NOW|NOWRUZ|NOWTV|NP|NR|NRA|NRW|NTT|NU|NYC|NZ|OBI|OBSERVER|OFF|OFFICE|OKINAWA|OLAYAN|OLAYANGROUP|OLDNAVY|OLLO|OM|OMEGA|ONE|ONG|ONL|ONLINE|ONYOURSIDE|OOO|OPEN|ORACLE|ORANGE|ORG|ORGANIC|ORIGINS|OSAKA|OTSUKA|OTT|OVH|PA|PAGE|PANASONIC|PARIS|PARS|PARTNERS|PARTS|PARTY|PASSAGENS|PAY|PCCW|PE|PET|PF|PFIZER|PG|PH|PHARMACY|PHD|PHILIPS|PHONE|PHOTO|PHOTOGRAPHY|PHOTOS|PHYSIO|PICS|PICTET|PICTURES|PID|PIN|PING|PINK|PIONEER|PIZZA|PK|PL|PLACE|PLAY|PLAYSTATION|PLUMBING|PLUS|PM|PN|PNC|POHL|POKER|POLITIE|PORN|POST|PR|PRAMERICA|PRAXI|PRESS|PRIME|PRO|PROD|PRODUCTIONS|PROF|PROGRESSIVE|PROMO|PROPERTIES|PROPERTY|PROTECTION|PRU|PRUDENTIAL|PS|PT|PUB|PW|PWC|PY|QA|QPON|QUEBEC|QUEST|QVC|RACING|RADIO|RAID|RE|READ|REALESTATE|REALTOR|REALTY|RECIPES|RED|REDSTONE|REDUMBRELLA|REHAB|REISE|REISEN|REIT|RELIANCE|REN|RENT|RENTALS|REPAIR|REPORT|REPUBLICAN|REST|RESTAURANT|REVIEW|REVIEWS|REXROTH|RICH|RICHARDLI|RICOH|RIGHTATHOME|RIL|RIO|RIP|RMIT|RO|ROCHER|ROCKS|RODEO|ROGERS|ROOM|RS|RSVP|RU|RUGBY|RUHR|RUN|RW|RWE|RYUKYU|SA|SAARLAND|SAFE|SAFETY|SAKURA|SALE|SALON|SAMSCLUB|SAMSUNG|SANDVIK|SANDVIKCOROMANT|SANOFI|SAP|SARL|SAS|SAVE|SAXO|SB|SBI|SBS|SC|SCA|SCB|SCHAEFFLER|SCHMIDT|SCHOLARSHIPS|SCHOOL|SCHULE|SCHWARZ|SCIENCE|SCJOHNSON|SCOR|SCOT|SD|SE|SEARCH|SEAT|SECURE|SECURITY|SEEK|SELECT|SENER|SERVICES|SES|SEVEN|SEW|SEX|SEXY|SFR|SG|SH|SHANGRILA|SHARP|SHAW|SHELL|SHIA|SHIKSHA|SHOES|SHOP|SHOPPING|SHOUJI|SHOW|SHOWTIME|SHRIRAM|SI|SILK|SINA|SINGLES|SITE|SJ|SK|SKI|SKIN|SKY|SKYPE|SL|SLING|SM|SMART|SMILE|SN|SNCF|SO|SOCCER|SOCIAL|SOFTBANK|SOFTWARE|SOHU|SOLAR|SOLUTIONS|SONG|SONY|SOY|SPACE|SPORT|SPOT|SPREADBETTING|SR|SRL|SS|ST|STADA|STAPLES|STAR|STATEBANK|STATEFARM|STC|STCGROUP|STOCKHOLM|STORAGE|STORE|STREAM|STUDIO|STUDY|STYLE|SU|SUCKS|SUPPLIES|SUPPLY|SUPPORT|SURF|SURGERY|SUZUKI|SV|SWATCH|SWIFTCOVER|SWISS|SX|SY|SYDNEY|SYMANTEC|SYSTEMS|SZ|TAB|TAIPEI|TALK|TAOBAO|TARGET|TATAMOTORS|TATAR|TATTOO|TAX|TAXI|TC|TCI|TD|TDK|TEAM|TECH|TECHNOLOGY|TEL|TEMASEK|TENNIS|TEVA|TF|TG|TH|THD|THEATER|THEATRE|TIAA|TICKETS|TIENDA|TIFFANY|TIPS|TIRES|TIROL|TJ|TJMAXX|TJX|TK|TKMAXX|TL|TM|TMALL|TN|TO|TODAY|TOKYO|TOOLS|TOP|TORAY|TOSHIBA|TOTAL|TOURS|TOWN|TOYOTA|TOYS|TR|TRADE|TRADING|TRAINING|TRAVEL|TRAVELCHANNEL|TRAVELERS|TRAVELERSINSURANCE|TRUST|TRV|TT|TUBE|TUI|TUNES|TUSHU|TV|TVS|TW|TZ|UA|UBANK|UBS|UG|UK|UNICOM|UNIVERSITY|UNO|UOL|UPS|US|UY|UZ|VA|VACATIONS|VANA|VANGUARD|VC|VE|VEGAS|VENTURES|VERISIGN|VERSICHERUNG|VET|VG|VI|VIAJES|VIDEO|VIG|VIKING|VILLAS|VIN|VIP|VIRGIN|VISA|VISION|VIVA|VIVO|VLAANDEREN|VN|VODKA|VOLKSWAGEN|VOLVO|VOTE|VOTING|VOTO|VOYAGE|VU|VUELOS|WALES|WALMART|WALTER|WANG|WANGGOU|WATCH|WATCHES|WEATHER|WEATHERCHANNEL|WEBCAM|WEBER|WEBSITE|WED|WEDDING|WEIBO|WEIR|WF|WHOSWHO|WIEN|WIKI|WILLIAMHILL|WIN|WINDOWS|WINE|WINNERS|WME|WOLTERSKLUWER|WOODSIDE|WORK|WORKS|WORLD|WOW|WS|WTC|WTF|XBOX|XEROX|XFINITY|XIHUAN|XIN|XN--11B4C3D|XN--1CK2E1B|XN--1QQW23A|XN--2SCRJ9C|XN--30RR7Y|XN--3BST00M|XN--3DS443G|XN--3E0B707E|XN--3HCRJ9C|XN--3OQ18VL8PN36A|XN--3PXU8K|XN--42C2D9A|XN--45BR5CYL|XN--45BRJ9C|XN--45Q11C|XN--4GBRIM|XN--54B7FTA0CC|XN--55QW42G|XN--55QX5D|XN--5SU34J936BGSG|XN--5TZM5G|XN--6FRZ82G|XN--6QQ986B3XL|XN--80ADXHKS|XN--80AO21A|XN--80AQECDR1A|XN--80ASEHDB|XN--80ASWG|XN--8Y0A063A|XN--90A3AC|XN--90AE|XN--90AIS|XN--9DBQ2A|XN--9ET52U|XN--9KRT00A|XN--B4W605FERD|XN--BCK1B9A5DRE4C|XN--C1AVG|XN--C2BR7G|XN--CCK2B3B|XN--CG4BKI|XN--CLCHC0EA0B2G2A9GCD|XN--CZR694B|XN--CZRS0T|XN--CZRU2D|XN--D1ACJ3B|XN--D1ALF|XN--E1A4C|XN--ECKVDTC9D|XN--EFVY88H|XN--FCT429K|XN--FHBEI|XN--FIQ228C5HS|XN--FIQ64B|XN--FIQS8S|XN--FIQZ9S|XN--FJQ720A|XN--FLW351E|XN--FPCRJ9C3D|XN--FZC2C9E2C|XN--FZYS8D69UVGM|XN--G2XX48C|XN--GCKR3F0F|XN--GECRJ9C|XN--GK3AT1E|XN--H2BREG3EVE|XN--H2BRJ9C|XN--H2BRJ9C8C|XN--HXT814E|XN--I1B6B1A6A2E|XN--IMR513N|XN--IO0A7I|XN--J1AEF|XN--J1AMH|XN--J6W193G|XN--JLQ61U9W7B|XN--JVR189M|XN--KCRX77D1X4A|XN--KPRW13D|XN--KPRY57D|XN--KPU716F|XN--KPUT3I|XN--L1ACC|XN--LGBBAT1AD8J|XN--MGB9AWBF|XN--MGBA3A3EJT|XN--MGBA3A4F16A|XN--MGBA7C0BBN0A|XN--MGBAAKC7DVF|XN--MGBAAM7A8H|XN--MGBAB2BD|XN--MGBAH1A3HJKRD|XN--MGBAI9AZGQP6J|XN--MGBAYH7GPA|XN--MGBBH1A|XN--MGBBH1A71E|XN--MGBC0A9AZCG|XN--MGBCA7DZDO|XN--MGBCPQ6GPA1A|XN--MGBERP4A5D4AR|XN--MGBGU82A|XN--MGBI4ECEXP|XN--MGBPL2FH|XN--MGBT3DHD|XN--MGBTX2B|XN--MGBX4CD0AB|XN--MIX891F|XN--MK1BU44C|XN--MXTQ1M|XN--NGBC5AZD|XN--NGBE9E0A|XN--NGBRX|XN--NODE|XN--NQV7F|XN--NQV7FS00EMA|XN--NYQY26A|XN--O3CW4H|XN--OGBPF8FL|XN--OTU796D|XN--P1ACF|XN--P1AI|XN--PBT977C|XN--PGBS0DH|XN--PSSY2U|XN--Q7CE6A|XN--Q9JYB4C|XN--QCKA1PMC|XN--QXA6A|XN--QXAM|XN--RHQV96G|XN--ROVU88B|XN--RVC1E0AM3E|XN--S9BRJ9C|XN--SES554G|XN--T60B56A|XN--TCKWE|XN--TIQ49XQYJ|XN--UNUP4Y|XN--VERMGENSBERATER-CTB|XN--VERMGENSBERATUNG-PWB|XN--VHQUV|XN--VUQ861B|XN--W4R85EL8FHU5DNRA|XN--W4RS40L|XN--WGBH1C|XN--WGBL6A|XN--XHQ521B|XN--XKC2AL3HYE2A|XN--XKC2DL3A5EE0H|XN--Y9A3AQ|XN--YFRO4I67O|XN--YGBI2AMMX|XN--ZFR164B|XXX|XYZ|YACHTS|YAHOO|YAMAXUN|YANDEX|YE|YODOBASHI|YOGA|YOKOHAMA|YOU|YOUTUBE|YT|YUN|ZA|ZAPPOS|ZARA|ZERO|ZIP|ZM|ZONE|ZUERICH|ZW|TEST)";
  }),
  um = re(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.openingParenthesis = "([\"'{", t.closingParenthesis = ")]\"'}", t.parenthesis = t.openingParenthesis.split("").map(function (e, n) {
      return "" + e + t.closingParenthesis.charAt(n);
    }), t.htmlAttributes = ["src", "data", "href", "cite", "formaction", "icon", "manifest", "poster", "codebase", "background", "profile", "usemap", "itemtype", "action", "longdesc", "classid", "archive"], t.nonLatinAlphabetRanges = "\\u0041-\\u005A\\u0061-\\u007A\\u00AA\\u00B5\\u00BA\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0\\u08A2-\\u08AC\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097F\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C33\\u0C35-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191C\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2183\\u2184\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005\\u3006\\u3031-\\u3035\\u303B\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA697\\uA6A0-\\uA6E5\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA793\\uA7A0-\\uA7AA\\uA7F8-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA80-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC", t.TLDs = dm.TLDs;
  }),
  pm = re(function (e, t) {
    function n(e, t, n) {
      return "function" == typeof n ? n(e, t) : n;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.transform = function (e, t) {
      var r = "",
        i = 1 / 0,
        a = {},
        o = !1;
      if (t && t.specialTransform) for (var s = 0; s < t.specialTransform.length; s++) {
        var l = t.specialTransform[s];
        if (l.test.test(e.string)) return l.transform(e.string, e);
      }
      return t && t.exclude && n(e.string, e, t.exclude) ? e.string : (t && t.protocol && (r = n(e.string, e, t.protocol)), e.protocol ? r = "" : r || (r = e.isEmail ? "mailto:" : e.isFile ? "file:///" : "http://"), t && t.truncate && (i = n(e.string, e, t.truncate)), t && t.middleTruncation && (o = n(e.string, e, t.middleTruncation)), t && t.attributes && (a = n(e.string, e, t.attributes)), "<a " + Object.keys(a).map(function (e) {
        return !0 === a[e] ? e : e + '="' + a[e] + '" ';
      }).join(" ") + 'href="' + r + e.string + '">' + (e.string.length > i ? o ? e.string.substring(0, Math.floor(i / 2)) + "…" + e.string.substring(e.string.length - Math.ceil(i / 2), e.string.length) : e.string.substring(0, i) + "…" : e.string) + "</a>");
    };
  }),
  mm = re(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = "([a-z0-9]+(-+[a-z0-9]+)*\\.)+(" + um.TLDs + ")",
      r = "a-zA-Z\\d\\-._~\\!$&*+,;=:@%'\"\\[\\]()",
      i = "((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)",
      a = "\\[(([a-f0-9:]+:+)+[a-f0-9]+)\\]",
      o = "(https?:|ftps?:)\\/\\/",
      s = "(((" + o + ")?(" + n + "|" + i + "|(" + o + ")(" + a + "|" + ("([a-z0-9]+(-+[a-z0-9]+)*\\.)+([a-z0-9][a-z0-9-]{0," + (Math.max.apply(te, um.TLDs.split("|").map(function (e) {
        return e.length;
      })) - 2) + "}[a-z0-9])") + "))(?!@\\w)(:(\\d{1,5}))?)|(((https?:|ftps?:)\\/\\/)\\S+))",
      l = s + "((((\\/(([" + r + "]+(\\/[" + r + um.nonLatinAlphabetRanges + "]*)*))?)?)((\\?([" + r + "\\/?]*))?)((\\#([" + r + "\\/?]*))?))?\\b((([" + r + "\\/" + um.nonLatinAlphabetRanges + "][a-zA-Z\\d\\-_~+=\\/" + um.nonLatinAlphabetRanges + "]+)?))+)";
    t.email = "\\b(mailto:)?([a-z0-9!#$%&'*+=?^_`{|}~-]+(\\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*)@(" + n + "|" + i + ")\\b", t.url = "(" + l + ")|(\\b" + s + "(((\\/(([a-zA-Z\\d\\-._~\\!$&*+,;=:@%'\"\\[\\]()]+(\\/[a-zA-Z\\d\\-._~\\!$&*+,;=:@%'\"\\[\\]()]*)*))?)?)((\\?([a-zA-Z\\d\\-._~\\!$&*+,;=:@%'\"\\[\\]()\\/?]*))?)((\\#([a-zA-Z\\d\\-._~\\!$&*+,;=:@%'\"\\[\\]()\\/?]*))?))?\\b(([\\/]?))+)", t.file = "(file:\\/\\/\\/)([a-z]+:(\\/|\\\\)+)?([\\w.]+([\\/\\\\]?)+)+", t.final = "(" + t.url + ")|(" + t.email + ")|(" + t.file + ")", t.finalRegex = new RegExp(t.final, "gi"), t.ipRegex = new RegExp("^(" + i + "|" + a + ")$", "i"), t.emailRegex = new RegExp("^(" + t.email + ")$", "i"), t.fileRegex = new RegExp("^(" + t.file + ")$", "i"), t.urlRegex = new RegExp("^(" + t.url + ")$", "i");
    var c = {
      isURL: 0,
      isEmail: 0,
      isFile: 0,
      file: {
        fileName: 0,
        protocol: 0
      },
      email: {
        protocol: 0,
        local: 0,
        host: 0
      },
      url: {
        ipv4: 0,
        ipv6: 0,
        ipv4Confirmation: 0,
        byProtocol: 0,
        port: 0,
        protocol1: 0,
        protocol2: 0,
        protocol3: 0,
        protocolWithDomain: 0,
        path: 0,
        secondPartOfPath: 0,
        query: 0,
        fragment: 0
      }
    };
    t.iidxes = c;
    for (var d = ["file:///some/file/path/filename.pdf", "mailto:e+_mail.me@sub.domain.com", "http://sub.domain.co.uk:3000/p/a/t/h_(asd)/h?q=abc123#dfdf", "http://www.عربي.com", "http://127.0.0.1:3000/p/a/t_(asd)/h?q=abc123#dfdf", "http://[2a00:1450:4025:401::67]/k/something", "a.org/abc/ი_გგ"].join(" "), u = null, p = 0; null !== (u = t.finalRegex.exec(d));) 0 === p && (c.isFile = u.lastIndexOf(u[0]), c.file.fileName = u.indexOf("filename.pdf"), c.file.protocol = u.indexOf("file:///")), 1 === p && (c.isEmail = u.lastIndexOf(u[0]), c.email.protocol = u.indexOf("mailto:"), c.email.local = u.indexOf("e+_mail.me"), c.email.host = u.indexOf("sub.domain.com")), 2 === p && (c.isURL = u.lastIndexOf(u[0]), c.url.protocol1 = u.indexOf("http://"), c.url.protocolWithDomain = u.indexOf("http://sub.domain.co.uk:3000"), c.url.port = u.indexOf("3000"), c.url.path = u.indexOf("/p/a/t/h_(asd)/h"), c.url.query = u.indexOf("q=abc123"), c.url.fragment = u.indexOf("dfdf")), 3 === p && (c.url.byProtocol = u.lastIndexOf("http://www.عربي.com"), c.url.protocol2 = u.lastIndexOf("http://")), 4 === p && (c.url.ipv4 = u.indexOf("127.0.0.1"), c.url.ipv4Confirmation = u.indexOf("0.")), 5 === p && (c.url.ipv6 = u.indexOf("2a00:1450:4025:401::67"), c.url.protocol3 = u.lastIndexOf("http://")), 6 === p && (c.url.secondPartOfPath = u.indexOf("გგ")), p++;
  }),
  fm = re(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.checkParenthesis = function (e, t, n, r) {
      return r === t && (n.split(e).length - n.split(t).length == 1 || e === t && n.split(e).length % 2 == 0 || void 0);
    }, t.maximumAttrLength = um.htmlAttributes.sort(function (e, t) {
      return t.length - e.length;
    })[0].length, t.isInsideAttribute = function (e) {
      return /\s[a-z0-9-]+=('|")$/i.test(e) || /: ?url\(('|")?$/i.test(e);
    }, t.isInsideAnchorTag = function (e, t, n) {
      for (var r = e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), i = new RegExp("(?=(<a))(?!([\\s\\S]*)(<\\/a>)(" + r + "))[\\s\\S]*?(" + r + ")(?!\"|')", "gi"), a = null; null !== (a = i.exec(t));) {
        if (a.index + a[0].length === n) return !0;
      }
      return !1;
    };
  }),
  gm = ne(re(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = function (e) {
        for (var t = [], n = null, r = function () {
            var r = n.index,
              i = r + n[0].length,
              a = n[0];
            if ("/" === e.charAt(i) && (a += e.charAt(i), i++), um.closingParenthesis.indexOf(e.charAt(i)) > -1 && um.parenthesis.forEach(function (t) {
              var n = t.charAt(0),
                r = t.charAt(1);
              fm.checkParenthesis(n, r, a, e.charAt(i)) && (a += e.charAt(i), i++);
            }), -1 !== ['""', "''", "()"].indexOf(e.charAt(r - 1) + e.charAt(i)) && fm.isInsideAttribute(e.substring(r - fm.maximumAttrLength - 15, r))) return "continue";
            if (e.substring(i, e.length).indexOf("</a>") > -1 && e.substring(0, r).indexOf("<a") > -1 && fm.isInsideAnchorTag(a, e, i)) return "continue";
            if (n[mm.iidxes.isURL]) {
              var o = (n[mm.iidxes.url.path] || "") + (n[mm.iidxes.url.secondPartOfPath] || "") || void 0,
                s = n[mm.iidxes.url.protocol1] || n[mm.iidxes.url.protocol2] || n[mm.iidxes.url.protocol3];
              t.push({
                start: r,
                end: i,
                string: a,
                isURL: !0,
                protocol: s,
                port: n[mm.iidxes.url.port],
                ipv4: n[mm.iidxes.url.ipv4Confirmation] ? n[mm.iidxes.url.ipv4] : void 0,
                ipv6: n[mm.iidxes.url.ipv6],
                host: n[mm.iidxes.url.byProtocol] ? void 0 : (n[mm.iidxes.url.protocolWithDomain] || "").substr((s || "").length),
                confirmedByProtocol: !!n[mm.iidxes.url.byProtocol],
                path: n[mm.iidxes.url.byProtocol] ? void 0 : o,
                query: n[mm.iidxes.url.query] || void 0,
                fragment: n[mm.iidxes.url.fragment] || void 0
              });
            } else if (n[mm.iidxes.isFile]) {
              var l = a.substr(8);
              t.push({
                start: r,
                end: i,
                string: a,
                isFile: !0,
                protocol: n[mm.iidxes.file.protocol],
                filename: n[mm.iidxes.file.fileName],
                filePath: l,
                fileDirectory: l.substr(0, l.length - n[mm.iidxes.file.fileName].length)
              });
            } else n[mm.iidxes.isEmail] ? t.push({
              start: r,
              end: i,
              string: a,
              isEmail: !0,
              local: n[mm.iidxes.email.local],
              protocol: n[mm.iidxes.email.protocol],
              host: n[mm.iidxes.email.host]
            }) : t.push({
              start: r,
              end: i,
              string: a
            });
          }; null !== (n = mm.finalRegex.exec(e));) r();
        return t;
      },
      r = function (e) {
        var t = "string" == typeof e ? {
            input: e,
            options: void 0,
            extensions: void 0
          } : e,
          r = t.input,
          i = t.options,
          a = t.extensions;
        if (a) for (var o = 0; o < a.length; o++) {
          var s = a[o];
          r = r.replace(s.test, s.transform);
        }
        var l = n(r),
          c = "";
        for (o = 0; o < l.length; o++) c = (c || (0 === o ? r.substring(0, l[o].start) : "")) + pm.transform(l[o], i) + (l[o + 1] ? r.substring(l[o].end, l[o + 1].start) : r.substring(l[o].end));
        return c || r;
      };
    r.list = function (e) {
      return n(e);
    }, r.validate = {
      ip: function (e) {
        return mm.ipRegex.test(e);
      },
      email: function (e) {
        return mm.emailRegex.test(e);
      },
      file: function (e) {
        return mm.fileRegex.test(e);
      },
      url: function (e) {
        return mm.urlRegex.test(e) || mm.ipRegex.test(e);
      }
    }, t.default = r;
  })),
  _m = function (t) {
    var n = t.accreditation,
      r = gm({
        input: n,
        options: {
          attributes: {
            target: "_blank"
          }
        }
      });
    return e.createElement(e.Fragment, null, n ? e.createElement(K, {
      direction: "column",
      align: "baseline"
    }, e.createElement("h4", null, "Ackreditering"), e.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: r
      }
    })) : "");
  },
  ym = function (t) {
    var n = t.address,
      r = t.organizercity;
    return e.createElement(e.Fragment, null, n ? e.createElement(K, {
      direction: "column",
      align: "baseline"
    }, e.createElement("h4", null, "Adress"), e.createElement("p", null, n), r ? e.createElement("p", null, r) : "") : "");
  },
  hm = function (t) {
    var n = t.organizermail,
      r = t.organizerphone,
      i = t.organizerurl;
    return e.createElement(e.Fragment, null, n ? e.createElement(K, {
      direction: "column",
      align: "baseline"
    }, e.createElement("h4", null, "Kontakt: e-post"), e.createElement("p", null, e.createElement("a", {
      href: "mailto:".concat(n)
    }, n))) : "", r ? e.createElement(K, {
      direction: "column",
      align: "baseline"
    }, e.createElement("h4", null, "Kontakt: telefon"), e.createElement("p", null, e.createElement("a", {
      href: "tel:".concat(r)
    }, r))) : "", i ? e.createElement(K, {
      direction: "column",
      align: "baseline"
    }, e.createElement("h4", null, "Kontakt: webb"), e.createElement("p", null, e.createElement("a", {
      target: "_blank",
      href: i
    }, i))) : "");
  },
  vm = function (t) {
    var n = t.organizer;
    return e.createElement(e.Fragment, null, n ? e.createElement(K, {
      direction: "column",
      align: "baseline"
    }, e.createElement("h4", null, "Arrangör"), e.createElement("p", null, t.organizer)) : "");
  },
  bm = {
    picture: {
      icon: "photo_camera",
      text: "Bild",
      color: "#e65100"
    },
    video: {
      icon: "play_circle_outline",
      text: "Video",
      color: "#6bad22"
    },
    text: {
      icon: "library_books",
      text: "Text",
      color: "#7e90ff"
    },
    graphic: {
      icon: "insert_photo",
      text: "Grafik",
      color: "#CCBE00"
    },
    composite: {
      icon: "insert_photo",
      text: "Bild/video",
      color: "#222222"
    }
  },
  xm = function (t) {
    var n = t.ttninjs,
      r = void 0 === n ? {} : n,
      i = r.courtcasenumber,
      a = r.headline,
      o = r.date,
      s = r.body_text,
      l = r.subject,
      c = r.datetime,
      d = r.enddatetime,
      u = r.slug,
      p = r.slugline,
      m = r.sector,
      f = r.versioncreated,
      g = r.body_event,
      _ = void 0 === g ? {} : g,
      y = _.accreditation,
      h = _.address,
      v = _.eventtype,
      b = _.eventstatus,
      x = _.organizer,
      E = _.organizercity,
      k = _.organizermail,
      T = _.organizerphone,
      w = _.organizerurl,
      A = "4" === b,
      C = function (e) {
        return e.slice(11, 16).replace(":", ".");
      },
      S = function (e, t) {
        return Ou(new Date(e), t, {
          locale: ep
        });
      },
      N = f.slice(0, 10),
      O = S(N, "d"),
      R = S(N, "MMMM").toLowerCase(),
      I = f.slice(0, 4),
      L = f.replace("T", "").slice(10, 15),
      j = S(o, "d"),
      D = S(o, "iiii"),
      F = S(o, "MMMM").toLowerCase(),
      M = S(o, "y"),
      P = s.replace(new RegExp(/\n/, "g") || new RegExp(/\\n/, "g"), "<br />").split("\\n").join("<br />"),
      B = d && d !== c ? "- ".concat(C(d)) : "",
      H = c && d,
      z = H ? "".concat(j, " ").concat(F, " ").concat(I, " kl ").concat(C(c), " ").concat(B) : "",
      U = (u || p) && e.createElement("p", null, u || p),
      W = e.createElement("p", {
        className: cm.eventTimeSpan
      }, e.createElement("span", {
        className: cm.weekday
      }, "".concat(D)), " ".concat(j, " ").concat(F, " ").concat(M)),
      X = e.createElement("p", {
        className: cm.eventTimeSpan
      }, e.createElement("span", {
        className: cm.weekday
      }, "".concat(D)), " ", "".concat(z)),
      G = H ? X : W,
      V = v && e.createElement("p", {
        className: cm.event
      }, "Evenemangstyp: ".concat(v)),
      Y = "Rättsligt" === v && i && e.createElement("p", {
        className: cm.courtcaseNumber
      }, "Målnummer: ".concat(i)),
      Z = l && e.createElement("p", {
        className: cm.subject
      }, "Ämne: " + l.map(function (e) {
        return e.name;
      }).join(" • ")),
      q = m && e.createElement("p", {
        className: cm.sector
      }, m ? "Sektion: ".concat(function (e) {
        switch (e) {
          case "INR":
            return "INRIKES";
          case "UTR":
            return "UTRIKES";
          case "EKO":
            return "EKONOMI";
          case "KLT":
            return "KULTUR & NÖJE";
          case "SPT":
            return "SPORT";
          case "PRM":
            return "PRESSMEDDELANDE";
          default:
            return "NYHET";
        }
      }(m)) : "");
    return e.createElement("div", {
      className: "".concat(cm.objectView, " ").concat(cm.eventObject, " ").concat(A ? cm.canceled : "")
    }, A && e.createElement(Ap, {
      text: "INSTÄLLT",
      color: "#c62828",
      style: {
        marginBottom: "0px"
      }
    }), e.createElement("p", {
      className: cm.dateAndTime
    }, "Publicerad ".concat(O, " ").concat(R, " ").concat(I, " ").concat(L)), e.createElement("h1", {
      className: cm.headline
    }, a), r.description_usage ? e.createElement("div", {
      className: "description-usage"
    }, r.description_usage) : null, e.createElement("section", null, e.createElement("div", {
      className: cm.body,
      dangerouslySetInnerHTML: {
        __html: P
      }
    })), e.createElement("section", {
      className: cm.extras
    }, G, V, Y, Z, q, U), e.createElement(K, {
      direction: "column"
    }, e.createElement("section", {
      className: cm.eventInfo
    }, e.createElement(vm, {
      organizer: x
    }), e.createElement(ym, {
      address: h,
      organizercity: E
    }), e.createElement(_m, {
      accreditation: y
    }), e.createElement(hm, {
      organizerphone: T,
      organizermail: k,
      organizerurl: w
    }))));
  },
  Em = function (e) {
    var t,
      n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "Normal",
      r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Thumbnail";
    return Object.keys(e).forEach(function (i, a) {
      var o = e[i];
      o.variant === n && o.usage === r && (t = o.href);
    }), t;
  };
function km(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Tm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? km(Object(n), !0).forEach(function (t) {
      X(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : km(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function wm(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = le(e);
    if (t) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return se(this, n);
  };
}
var Am = function (t) {
    ee(r, a);
    var n = wm(r);
    function r(e) {
      var t;
      return q(this, r), (t = n.call(this, e)).state = {
        metaData: !1
      }, t;
    }
    return Q(r, [{
      key: "render",
      value: function () {
        var t = this.props,
          n = t.ttninjs,
          r = t.style,
          i = t.onTagClick,
          a = t.setModal,
          o = n.uri,
          s = n.byline,
          l = n.commissioncode,
          c = n.date,
          d = n.versionstored,
          u = n.copyrightholder,
          p = n.source,
          m = n.originaltransmissionreference,
          f = n.headline,
          g = n.description_text,
          _ = n.usageterms,
          y = n.subject;
        return e.createElement("div", {
          style: Tm({}, r)
        }, e.createElement("a", {
          href: n.uri
        }, e.createElement("div", {
          style: {
            backgroundImage: "url(".concat(Em(n.renditions, "Normal", "Preview")),
            backgroundSize: "contain",
            height: 400,
            backgroundColor: "#000",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center"
          }
        })), e.createElement("div", {
          style: {
            padding: 15,
            background: "#181818",
            color: "#fff"
          }
        }, e.createElement(C, {
          noLogo: !0,
          transparent: !0,
          level: "secondary",
          left: e.createElement(wd, {
            level: "secondary",
            text: "Visa bilden på app.tt.se",
            handleClick: function () {
              window.location.href = "https://app.tt.se/bildobjekt/image/".concat(function (e) {
                return e.split("/")[e.split("/").length - 1];
              }(n.uri));
            }
          }),
          right: e.createElement(Bl, {
            onClick: function (e) {
              a("share");
            }
          }, e.createElement(nd, {
            color: "#fff",
            icon: "share"
          }))
        }), e.createElement("h2", {
          style: {
            color: "#fff"
          }
        }, f), e.createElement("p", null, g), e.createElement("p", null, e.createElement("strong", null, _)), e.createElement("ul", null, e.createElement("li", null, "ID: ", o), e.createElement("li", null, "Foto: ", s, " (byline)"), e.createElement("li", null, "Fotografkod: ", l, " (commissioncode)"), e.createElement("li", null, "Fotodatum: ", c, " (date)"), e.createElement("li", null, "Ankomstdatum: ", d, " (versionstored)"), e.createElement("li", null, "Upphovsman: ", u, " (copyrightholder)"), e.createElement("li", null, "Källa: ", p, " (source)"), e.createElement("li", null, "Ursprungs-ID: ", m, " (originaltransmissionreference)"), e.createElement("li", null, "Filstorlek: !!!"), e.createElement("li", null, "Bredd x höjd: !!!")), e.createElement(K, {
          direction: "row",
          align: "center",
          justify: "flex-start"
        }, y.map(function (t) {
          return e.createElement(Ks, {
            text: t.code,
            onClick: function (e) {
              console.log("onTagClick", i), i(t.code);
            }
          });
        }))));
      }
    }]), r;
  }(),
  Cm = function (t) {
    var n = t.assignment,
      r = n.type,
      i = n.headline;
    return e.createElement(K, {
      direction: "row",
      align: "baseline"
    }, e.createElement(nd, {
      size: "small",
      color: bm[r].color,
      icon: bm[r].icon
    }), e.createElement("div", {
      style: {
        paddingLeft: 10
      }
    }, e.createElement("span", {
      style: {
        color: bm[r].color,
        fontWeight: "bolder"
      }
    }, e.createElement("strong", null, bm[r].text)), e.createElement("div", null, i)));
  },
  Sm = "planningobject_bodyText__YQsNM",
  Nm = "planningobject_objectView__1JFUr",
  Om = "planningobject_dateAndTime__2EnpK",
  Rm = "planningobject_headline__3VWdw",
  Im = "planningobject_planningObject__Toomv",
  Lm = "planningobject_extras__2dxWn",
  jm = "planningobject_sector__3XD_d",
  Dm = "planningobject_slugline__2o0o7",
  Fm = "planningobject_eventTimeSpan__kPxJu",
  Mm = "planningobject_assignment__3nlg5",
  Pm = "planningobject_coverage__Hao6A";
y('@charset "UTF-8";\n/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\n.planningobject_headingXL__CK4wp {\n  font-family: "Montserrat", sans-serif;\n  font-size: 42px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 52px; }\n\n.planningobject_subHeading__3WNne {\n  font-family: "Roboto", sans-serif;\n  font-size: 20px;\n  font-weight: 400;\n  color: #181818;\n  line-height: 27px; }\n\n.planningobject_dat__2lu_A, .planningobject_byline__3e11_ {\n  font-family: "Roboto", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.55);\n  text-transform: uppercase;\n  line-height: 18px; }\n\n.planningobject_caption__1BE-v {\n  font-family: "Roboto", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 18px;\n  max-width: 280px; }\n\n.planningobject_blockquote__fUxKi {\n  padding: 0;\n  margin: 0; }\n  .planningobject_blockquote__fUxKi::before {\n    content: "\\2014  "; }\n\n.planningobject_bodyText__YQsNM {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px; }\n\n.planningobject_objectView__1JFUr {\n  margin: 0;\n  padding: 0 0 0 15px; }\n  .planningobject_objectView__1JFUr .planningobject_dateAndTime__2EnpK {\n    font-size: 16px;\n    color: #4f4f4f; }\n  .planningobject_objectView__1JFUr .planningobject_headline__3VWdw {\n    font-size: 34px;\n    font-family: "Roboto", sans-serif;\n    font-weight: bolder;\n    color: #222222;\n    margin: 0;\n    line-height: 38px; }\n  .planningobject_objectView__1JFUr .planningobject_vignette__3goOK::after {\n    content: " ("; }\n  .planningobject_objectView__1JFUr .planningobject_source__9iHXj::after {\n    content: ")"; }\n  .planningobject_objectView__1JFUr .planningobject_descriptionUsage__1Wg-w {\n    font-family: "Roboto", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    color: rgba(0, 0, 0, 0.75);\n    line-height: 24px;\n    background: #fbf8e2;\n    padding: 20px;\n    margin: 20px 0;\n    border: solid 1px #e8e8e8;\n    border-radius: 5px; }\n  .planningobject_objectView__1JFUr .planningobject_imageWrapper__3V-e_ {\n    margin-top: 40px; }\n  .planningobject_objectView__1JFUr .planningobject_slideShowWrapper__JU9wQ {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0; }\n    .planningobject_objectView__1JFUr .planningobject_slideShowWrapper__JU9wQ .planningobject_closeSlideShowIcon__2doXM {\n      position: absolute;\n      top: 20px;\n      right: 20px;\n      z-index: 10;\n      cursor: pointer; }\n\n.planningobject_planningObject__Toomv .planningobject_bodyText__YQsNM {\n  font-family: "Roboto", sans-serif;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 20px; }\n\n.planningobject_planningObject__Toomv .planningobject_extras__2dxWn {\n  width: 100%;\n  line-height: 21px;\n  padding: 0 0 15px 0; }\n  .planningobject_planningObject__Toomv .planningobject_extras__2dxWn .planningobject_sector__3XD_d, .planningobject_planningObject__Toomv .planningobject_extras__2dxWn .planningobject_slugline__2o0o7, .planningobject_planningObject__Toomv .planningobject_extras__2dxWn .planningobject_eventTimeSpan__kPxJu {\n    font-size: 16px !important;\n    margin: -2px 0; }\n  .planningobject_planningObject__Toomv .planningobject_extras__2dxWn .planningobject_eventTimeSpan__kPxJu {\n    font-weight: bolder;\n    color: #181818; }\n  .planningobject_planningObject__Toomv .planningobject_extras__2dxWn .planningobject_sector__3XD_d, .planningobject_planningObject__Toomv .planningobject_extras__2dxWn .planningobject_slugline__2o0o7 {\n    color: #4f4f4f; }\n  .planningobject_planningObject__Toomv .planningobject_extras__2dxWn .planningobject_assignment__3nlg5 > * {\n    padding: 5px 0; }\n\n.planningobject_planningObject__Toomv .planningobject_coverage__Hao6A {\n  padding: 5px 0 10px 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.16);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.16); }\n');
var Bm = function (t) {
    var n = t.ttninjs,
      r = void 0 === n ? {} : n,
      i = r.subject,
      a = r.date,
      o = r.body_text,
      s = r.datetime,
      l = r.enddatetime,
      c = r.versioncreated,
      d = r.headline,
      u = r.slugline,
      p = r.slug,
      m = r.sector,
      f = r.assignments,
      g = void 0 === f ? {} : f,
      _ = [];
    for (var y in g) _.push(g[y]);
    var h = function (e) {
        var t = e.split("");
        return "0" === t[0] ? t[1] : t.join("");
      },
      v = function (e) {
        switch (e) {
          case "INR":
            return "INRIKES";
          case "UTR":
            return "UTRIKES";
          case "EKO":
            return "EKONOMI";
          case "KLT":
            return "KULTUR & NÖJE";
          case "SPT":
            return "SPORT";
          case "PRM":
            return "PRESSMEDDELANDE";
          default:
            return "NYHET";
        }
      },
      b = function (e) {
        return e.slice(11, 16).replace(":", ".");
      };
    return e.createElement("div", {
      className: "".concat(Nm, " ").concat(Im)
    }, e.createElement("p", {
      className: Om
    }, "Publicerad ".concat(h(c.slice(8, 10)), " ").concat(Ou(new Date(c.slice(0, 10)), "MMMM", {
      locale: ep
    }).toLowerCase(), " ").concat(c.slice(0, 4), " ").concat(c.replace("T", "").slice(10, 15))), e.createElement("h1", {
      className: Rm
    }, d), e.createElement("p", {
      className: Sm
    }, o), e.createElement("section", {
      className: Lm
    }, e.createElement("p", {
      style: {
        fontSize: "16px"
      },
      className: Fm
    }, s && l ? "".concat(b(s), " ").concat(l !== s ? " - " + b(l) : "", " ").concat(Ou(new Date(a), "iiii", {
      locale: ep
    }), " ").concat(h(a.slice(8, 10)), " ").concat(Ou(new Date(a), "MMMM", {
      locale: ep
    }).toLowerCase()) : ""), e.createElement("p", {
      className: jm
    }, i ? "".concat(v(m), " (").concat(i.map(function (e) {
      return " ".concat(e.name);
    }), " )") : v(m)), e.createElement("p", {
      className: Dm
    }, u || p ? u || p : "")), e.createElement("section", {
      className: Pm
    }, e.createElement(K, {
      direction: "column"
    }, _.map(function (t, n) {
      return e.createElement("div", {
        className: Mm,
        key: n,
        style: {
          marginTop: "20px"
        }
      }, e.createElement(K, {
        direction: "column",
        align: "left"
      }, e.createElement(Cm, {
        assignment: t,
        style: {
          color: "red"
        }
      })));
    }))));
  },
  Hm = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    return e.split("/")[e.split("/").length - 1];
  };
function zm(n) {
  var r = j(t(null), 2),
    i = r[0],
    a = r[1],
    o = n.ttninjs,
    s = void 0 === o ? {} : o,
    l = n.index,
    c = n.header,
    d = n.onClose,
    u = n.onTagClick,
    p = n.router,
    m = n.admin,
    f = void 0 !== m && m,
    g = function (e) {
      return a(null);
    },
    _ = [{
      id: "share",
      heading: "Dela direktlänk till bild",
      content: e.createElement(K, null, e.createElement(Bs, {
        ctaText: "Kopiera",
        text: "https://labb.tt.se/bild/o?id=".concat(Hm(s.uri))
      })),
      footer: e.createElement("div", null, e.createElement(wd, {
        level: "secondary",
        text: "Stäng",
        handleClick: g
      }))
    }];
  return e.createElement("div", null, e.createElement("div", null, e.createElement(jc, {
    active: i,
    components: _,
    reset: g
  })), function () {
    if (!s || !s.type) return null;
    switch (s.type) {
      case "text":
        return e.createElement(lm, {
          key: l,
          ttninjs: s,
          admin: f
        });
      case "event":
        return e.createElement(xm, {
          key: l,
          ttninjs: s,
          admin: f
        });
      case "picture":
        return e.createElement(Am, {
          key: l,
          ttninjs: s,
          admin: f,
          onTagClick: u,
          setModal: a,
          router: p
        });
      case "planning":
        return e.createElement(Bm, {
          key: l,
          ttninjs: s,
          header: c,
          admin: f,
          onClose: d
        });
      default:
        return null;
    }
  }());
}
var Um = {
    uri: "http://tt.se/media/text/190709-midsommar-1003001",
    type: "text",
    originaltransmissionreference: "1003001",
    charcount: 3083,
    mimetype: "text/html",
    representationtype: "complete",
    profile: "PUBL",
    versioncreated: "2019-07-09T09:15:33+02:00",
    job: "479936",
    pubstatus: "usable",
    copyrightholder: "TT",
    language: "sv",
    urgency: 4,
    webprio: 3,
    source: "TT",
    description_text: "Den svenska sommartraditionen perverteras av en hednisk sekt som vittrar blod i midnattssolen. ”Hereditary” var inte bara 2018 års bästa skräckfilm. Ari Asters långfilmsregidebut var också en av förra årets bästa filmer över huvud taget. Förväntningarna",
    body_text: 'Filmrecension: Mästerlig midsommarskräck\nFilmrecension TT\nDen svenska sommartraditionen perverteras av en hednisk sekt som vittrar blod i midnattssolen.\n”Hereditary” var inte bara 2018 års bästa skräckfilm. Ari Asters långfilmsregidebut var också en av förra årets bästa filmer över huvud taget.\nFörväntningarna på uppföljaren har varit minst sagt högt ställda. Aster har i intervjuer talat om att hans målsättning var att göra en skandinavisk variant av den brittiska skräckfilmen ”The Wicker Man” (”Dödlig skörd”, 1973). Där hamnade en troende polisman på en avlägsen ö, och under sökandet efter en försvunnen flicka upptäcker han att ön befolkas av en kult som ägnar sig åt fruktbarhetsriter.\nI ”Midsommar” möter vi Dani (Florence Pugh), traumatiserad efter en familjetragedi. Hon följer med sin pojkvän Christian (relationen har gått i stå och han väntar på ett tillfälle att göra slut) och några av dennes vänner till Sverige för att fira midsommar. De lockas dit av kompisen Pelle (Vilhelm Blomgren), som tar med dem till den avlägsna by i Hälsingland där hans familj bor. De tillresta möts av blonda människor klädda i vitt, av leenden och gästfrihet, men blir snart varse att det bakom alla leenden finns någonting betydligt mörkare – de får tidigt en (mycket grafiskt skildrad) demonstration av begreppet ättestupa.\nSkräckfilmer utspelar sig ofta i mörker – nattetid är det lättare för monstren att smyga på oss, och ger filmskaparen möjlighet att komma med så kallade "jump scares". Aster är inte ute efter att få oss att hoppa högt i biostolen, ”Midsommar” utspelas till största delen i badande solljus. Liksom han gjorde i ”Hereditary” är han ute efter att bygga upp en stämning, som nästan lite subtilt kommer krypande och som skapar den där sortens obehagskänsla som är svår att skaka av sig även efter att filmen är slut.\n”Midsommar” känns stundtals som en psykedelisk tripp, en mardröm som de involverade inte kan ta sig ur utan där de i stället med öppna ögon och näst intill frivilligt går mot katastrofen. Aster berättar med långa, ibland nästan stillastående tagningar, att förfalla till intensivt klippande är inte hans stil. Han för in oss i sina scener med nästan omärkliga inzoomningar och ger oss möjlighet att studera och upptäcka detaljer (bara detta är en given orsak att se filmen flera gånger).\nHär finns den yttre berättelsen om kulten i Hälsingland, men det är också en film om skräcken över att bli lämnad ensam. Efter familjetragedin står Dani helt ensam, förhållandet med Christian är ansträngt och hon känns som en person som nu söker en ny tillvaro, en fast mark att stå på.\n”Midsommar” är en ny mästerlig skräckfilm av Ari Aster. Han är bara drygt 30 år gammal. Det ska bli oerhört intressant att följa hans karriär.\nGunnar Rehlin/TT\nsdltdc7fdc8–NormalHires.jpg Skräckfilmen "Midsommar" följer en hednisk sekt i Hälsingland. Pressbild.\nNordisk Film\nsdltdc6f543–NormalHires.jpg Christian (Jack Reynor) och hans flickvän Dani (Florence Pugh) håller på att tappa gnistan i sitt förhållande, något som ställs på sin spets när de besöker Sverige och träffar en särskilt brutal midsommar-sekt. Pressbild.\nNordisk film\n\nFakta: Midsommar\nOriginaltitel: Midsommar\nGenre: Skräckfilm\nRegi: Ari Aster\nSkådespelare: Florence Pugh, Jack Reynor, William Jackson Harper, Vilhelm Blomgren, Will Poulter, Liv Mjönes, Anna Åström, Julia Ragnarsson, Isabelle Grill, Louise Peterhoff, Björn Andrésen, Gunnel Fred, Anki Larsson.\nLängd: 140 minuter\nÅldersgräns: 15 år\nBetyg: 5\n\n',
    associations: {
      a001: {
        byline: "Nordisk Film",
        description_text: 'Skräckfilmen "Midsommar" följer en hednisk sekt i Hälsingland. Pressbild.',
        mimetype: "image/jpeg",
        representationtype: "incomplete",
        type: "picture",
        uri: "http://tt.se/media/image/sdltdc7fdc8",
        renditions: {
          r00: {
            usage: "Hires",
            variant: "Normal",
            mimetype: "image/jpeg",
            href: "https://beta.tt.se/media/text/190709-midsommar-1003001/a001_NormalHires.jpg",
            sizeinbytes: 3524373,
            width: 6e3,
            height: 4e3,
            printsize: 72e6
          },
          r01: {
            usage: "Preview",
            variant: "Normal",
            mimetype: "image/jpeg",
            href: "https://beta.tt.se/media/text/190709-midsommar-1003001/a001_NormalPreview.jpg",
            sizeinbytes: 257745,
            width: 1024,
            height: 683
          },
          r02: {
            usage: "Preview",
            variant: "Watermark",
            mimetype: "image/jpeg",
            href: "https://beta.tt.se/media/text/190709-midsommar-1003001/a001_WatermarkPreview.jpg",
            width: 1024,
            height: 683
          },
          r03: {
            usage: "Thumbnail",
            variant: "Normal",
            mimetype: "image/jpeg",
            href: "https://beta.tt.se/media/text/190709-midsommar-1003001/a001_NormalThumbnail.jpg",
            sizeinbytes: 29730,
            width: 256,
            height: 171
          }
        }
      },
      a002: {
        byline: "Nordisk film",
        description_text: "Christian (Jack Reynor) och hans flickvän Dani (Florence Pugh) håller på att tappa gnistan i sitt förhållande, något som ställs på sin spets när de besöker Sverige och träffar en särskilt brutal midsommar-sekt. Pressbild.",
        mimetype: "image/jpeg",
        representationtype: "incomplete",
        type: "picture",
        uri: "http://tt.se/media/image/sdltdc6f543",
        renditions: {
          r00: {
            usage: "Hires",
            variant: "Normal",
            mimetype: "image/jpeg",
            href: "https://beta.tt.se/media/text/190709-midsommar-1003001/a002_NormalHires.jpg",
            sizeinbytes: 579683,
            width: 2580,
            height: 1720,
            printsize: 13312800
          },
          r01: {
            usage: "Preview",
            variant: "Normal",
            mimetype: "image/jpeg",
            href: "https://beta.tt.se/media/text/190709-midsommar-1003001/a002_NormalPreview.jpg",
            sizeinbytes: 195469,
            width: 1024,
            height: 683
          },
          r02: {
            usage: "Preview",
            variant: "Watermark",
            mimetype: "image/jpeg",
            href: "https://beta.tt.se/media/text/190709-midsommar-1003001/a002_WatermarkPreview.jpg",
            width: 1024,
            height: 683
          },
          r03: {
            usage: "Thumbnail",
            variant: "Normal",
            mimetype: "image/jpeg",
            href: "https://beta.tt.se/media/text/190709-midsommar-1003001/a002_NormalThumbnail.jpg",
            sizeinbytes: 23128,
            width: 256,
            height: 171
          }
        }
      }
    },
    body_html5: '<html><head><title>Filmrecension: Mästerlig midsommarskräck</title></head><body><article><section data-charcount="2749"><h1>Filmrecension: Mästerlig midsommarskräck</h1><div class="dat"><span class="vignette">Filmrecension</span><span class="source">TT</span></div><h4><p>Den svenska sommartraditionen perverteras av en hednisk sekt som vittrar blod i midnattssolen.</p></h4><div class="bodytext"><p>”Hereditary” var inte bara 2018 års bästa skräckfilm. Ari Asters långfilmsregidebut var också en av förra årets bästa filmer över huvud taget.</p><p>Förväntningarna på uppföljaren har varit minst sagt högt ställda. Aster har i intervjuer talat om att hans målsättning var att göra en skandinavisk variant av den brittiska skräckfilmen ”The Wicker Man” (”Dödlig skörd”, 1973). Där hamnade en troende polisman på en avlägsen ö, och under sökandet efter en försvunnen flicka upptäcker han att ön befolkas av en kult som ägnar sig åt fruktbarhetsriter.</p><p>I ”Midsommar” möter vi Dani (Florence Pugh), traumatiserad efter en familjetragedi. Hon följer med sin pojkvän Christian (relationen har gått i stå och han väntar på ett tillfälle att göra slut) och några av dennes vänner till Sverige för att fira midsommar. De lockas dit av kompisen Pelle (Vilhelm Blomgren), som tar med dem till den avlägsna by i Hälsingland där hans familj bor. De tillresta möts av blonda människor klädda i vitt, av leenden och gästfrihet, men blir snart varse att det bakom alla leenden finns någonting betydligt mörkare – de får tidigt en (mycket grafiskt skildrad) demonstration av begreppet ättestupa.</p><p>Skräckfilmer utspelar sig ofta i mörker – nattetid är det lättare för monstren att smyga på oss, och ger filmskaparen möjlighet att komma med så kallade "jump scares". Aster är inte ute efter att få oss att hoppa högt i biostolen, ”Midsommar” utspelas till största delen i badande solljus. Liksom han gjorde i ”Hereditary” är han ute efter att bygga upp en stämning, som nästan lite subtilt kommer krypande och som skapar den där sortens obehagskänsla som är svår att skaka av sig även efter att filmen är slut.</p><p>”Midsommar” känns stundtals som en psykedelisk tripp, en mardröm som de involverade inte kan ta sig ur utan där de i stället med öppna ögon och näst intill frivilligt går mot katastrofen. Aster berättar med långa, ibland nästan stillastående tagningar, att förfalla till intensivt klippande är inte hans stil. Han för in oss i sina scener med nästan omärkliga inzoomningar och ger oss möjlighet att studera och upptäcka detaljer (bara detta är en given orsak att se filmen flera gånger).</p><p>Här finns den yttre berättelsen om kulten i Hälsingland, men det är också en film om skräcken över att bli lämnad ensam. Efter familjetragedin står Dani helt ensam, förhållandet med Christian är ansträngt och hon känns som en person som nu söker en ny tillvaro, en fast mark att stå på.</p><p>”Midsommar” är en ny mästerlig skräckfilm av Ari Aster. Han är bara drygt 30 år gammal. Det ska bli oerhört intressant att följa hans karriär.</p></div><div class="byline">Gunnar Rehlin/TT</div> <figure><img src="https://beta.tt.se/media/text/190709-midsommar-1003001/a001_NormalThumbnail.jpg" alt="Skräckfilmen \'Midsommar\' följer en hednisk sekt i Hälsingland. Pressbild. " data-assoc-ref="a001" data-uri="http://tt.se/media/image/sdltdc7fdc8" data-preview-src="https://beta.tt.se/media/text/190709-midsommar-1003001/a001_NormalPreview.jpg"/><div class="byline">Nordisk Film</div><figcaption>Skräckfilmen "Midsommar" följer en hednisk sekt i Hälsingland. Pressbild.</figcaption></figure> <figure><img src="https://beta.tt.se/media/text/190709-midsommar-1003001/a002_NormalThumbnail.jpg" alt="Christian (Jack Reynor) och hans flickvän Dani (Florence Pugh) håller på att tappa gnistan i sitt förhållande, något som ställs på sin spets när de besöker Sverige och träffar en särskilt brutal midsommar-sekt. Pressbild. " data-assoc-ref="a002" data-uri="http://tt.se/media/image/sdltdc6f543" data-preview-src="https://beta.tt.se/media/text/190709-midsommar-1003001/a002_NormalPreview.jpg"/><div class="byline">Nordisk film</div><figcaption>Christian (Jack Reynor) och hans flickvän Dani (Florence Pugh) håller på att tappa gnistan i sitt förhållande, något som ställs på sin spets när de besöker Sverige och träffar en särskilt brutal midsommar-sekt. Pressbild.</figcaption></figure> </section><aside class="facts" data-charcount="334"><h1>Fakta: Midsommar</h1><div class="bodytext"><p>Originaltitel: Midsommar</p><p>Genre: Skräckfilm</p><p>Regi: Ari Aster</p><p>Skådespelare: Florence Pugh, Jack Reynor, William Jackson Harper, Vilhelm Blomgren, Will Poulter, Liv Mjönes, Anna Åström, Julia Ragnarsson, Isabelle Grill, Louise Peterhoff, Björn Andrésen, Gunnel Fred, Anki Larsson.</p><p>Längd: 140 minuter</p><p>Åldersgräns: 15 år</p><p>Betyg: 5</p></div></aside></article></body></html>',
    body_ttnitf: '<TTNITF><HEAD><MODVER ID="1:00" VER="04"><DEST ID="1:05">ALL</DEST><FIFO ID="1:20" FFNO="27"><FIFOVER ID="1:22" FFVERNO="03"><SERVID ID="1:30">TT</SERVID><NR ID="1:40">1003001</NR><PRODID ID="1:50" TKOD="NOJ"><DATESENT ID="1:70">20190709</DATESENT><TIMESENT ID="1:80">091533+0200</TIMESENT><UNO ID="1:100">20190709:TT:1003001:0</UNO><RECVER ID="2:00" VERNO="04"><TEXTTYP ID="2:03">01:PUBL</TEXTTYP><SLUGG ID="2:05">midsommar</SLUGG><URG ID="2:10" PRIO="4"><SUBREF ID="2:12">TT:01000000:KLT</SUBREF><SUBREF ID="2:12">TT:20000005:FLM</SUBREF><FIXID ID="2:22">RCS</FIXID><KEYWORD ID="2:25">MISC=Midsommar</KEYWORD><KEYWORD ID="2:25">NONE=Vilhelm Blomgren</KEYWORD><KEYWORD ID="2:25">PER=Ari Aster</KEYWORD><KEYWORD ID="2:25">GEODATA=18.643501,60.128161</KEYWORD><HEADLINE ID="2:105">Filmrecension: M&auml;sterlig midsommarskr&auml;ck</HEADLINE><HSOURCE ID="2:115">TT</HSOURCE><CAPTION ID="2:120">Den svenska sommartraditionen perverteras av en hednisk sekt som vittrar blod i midnattssolen. "Hereditary" var inte bara 2018 &aring;rs b&auml;sta skr&auml;ckfilm. Ari Asters l&aring;ngfilmsregidebut var ocks&aring; en av f&ouml;rra &aring;rets b&auml;sta filmer &ouml;ver huvud taget. F&ouml;rv&auml;ntningarna</CAPTION><WRITER ID="2:122"> krv ssu </WRITER><LANG ID="2:135">sv</LANG><SIZEMODE ID="7:10" SIZMOD="1"><MAXSUBSIZE ID="7:20">6247</MAXSUBSIZE><SIZEANNO ID="7:90">3493</SIZEANNO></HEAD><BODY ID="8:10"><TEXT><RUBRIK>Filmrecension: M&auml;sterlig midsommarskr&auml;ck</RUBRIK><DAT><ORT>Filmrecension</ORT><SOURCE>TT</SOURCE></DAT><INGRESS><P>Den svenska sommartraditionen perverteras av en hednisk sekt som vittrar blod i midnattssolen.</P></INGRESS><BRODTEXT><P>"Hereditary" var inte bara 2018 &aring;rs b&auml;sta skr&auml;ckfilm. Ari Asters l&aring;ngfilmsregidebut var ocks&aring; en av f&ouml;rra &aring;rets b&auml;sta filmer &ouml;ver huvud taget.</P><P>F&ouml;rv&auml;ntningarna p&aring; uppf&ouml;ljaren har varit minst sagt h&ouml;gt st&auml;llda. Aster har i intervjuer talat om att hans m&aring;ls&auml;ttning var att g&ouml;ra en skandinavisk variant av den brittiska skr&auml;ckfilmen "The Wicker Man" ("D&ouml;dlig sk&ouml;rd", 1973). D&auml;r hamnade en troende polisman p&aring; en avl&auml;gsen &ouml;, och under s&ouml;kandet efter en f&ouml;rsvunnen flicka uppt&auml;cker han att &ouml;n befolkas av en kult som &auml;gnar sig &aring;t fruktbarhetsriter.</P><P>I "Midsommar" m&ouml;ter vi Dani (Florence Pugh), traumatiserad efter en familjetragedi. Hon f&ouml;ljer med sin pojkv&auml;n Christian (relationen har g&aring;tt i st&aring; och han v&auml;ntar p&aring; ett tillf&auml;lle att g&ouml;ra slut) och n&aring;gra av dennes v&auml;nner till Sverige f&ouml;r att fira midsommar. De lockas dit av kompisen Pelle (Vilhelm Blomgren), som tar med dem till den avl&auml;gsna by i H&auml;lsingland d&auml;r hans familj bor. De tillresta m&ouml;ts av blonda m&auml;nniskor kl&auml;dda i vitt, av leenden och g&auml;stfrihet, men blir snart varse att det bakom alla leenden finns n&aring;gonting betydligt m&ouml;rkare &tstr; de f&aring;r tidigt en (mycket grafiskt skildrad) demonstration av begreppet &auml;ttestupa.</P><P>Skr&auml;ckfilmer utspelar sig ofta i m&ouml;rker &tstr; nattetid &auml;r det l&auml;ttare f&ouml;r monstren att smyga p&aring; oss, och ger filmskaparen m&ouml;jlighet att komma med s&aring; kallade "jump scares". Aster &auml;r inte ute efter att f&aring; oss att hoppa h&ouml;gt i biostolen, "Midsommar" utspelas till st&ouml;rsta delen i badande solljus. Liksom han gjorde i "Hereditary" &auml;r han ute efter att bygga upp en st&auml;mning, som n&auml;stan lite subtilt kommer krypande och som skapar den d&auml;r sortens obehagsk&auml;nsla som &auml;r sv&aring;r att skaka av sig &auml;ven efter att filmen &auml;r slut.</P><P>"Midsommar" k&auml;nns stundtals som en psykedelisk tripp, en mardr&ouml;m som de involverade inte kan ta sig ur utan d&auml;r de i st&auml;llet med &ouml;ppna &ouml;gon och n&auml;st intill frivilligt g&aring;r mot katastrofen. Aster ber&auml;ttar med l&aring;nga, ibland n&auml;stan stillast&aring;ende tagningar, att f&ouml;rfalla till intensivt klippande &auml;r inte hans stil. Han f&ouml;r in oss i sina scener med n&auml;stan om&auml;rkliga inzoomningar och ger oss m&ouml;jlighet att studera och uppt&auml;cka detaljer (bara detta &auml;r en given orsak att se filmen flera g&aring;nger).</P><P>H&auml;r finns den yttre ber&auml;ttelsen om kulten i H&auml;lsingland, men det &auml;r ocks&aring; en film om skr&auml;cken &ouml;ver att bli l&auml;mnad ensam. Efter familjetragedin st&aring;r Dani helt ensam, f&ouml;rh&aring;llandet med Christian &auml;r anstr&auml;ngt och hon k&auml;nns som en person som nu s&ouml;ker en ny tillvaro, en fast mark att st&aring; p&aring;.</P><P>"Midsommar" &auml;r en ny m&auml;sterlig skr&auml;ckfilm av Ari Aster. Han &auml;r bara drygt 30 &aring;r gammal. Det ska bli oerh&ouml;rt intressant att f&ouml;lja hans karri&auml;r.</P></BRODTEXT><BYLINE>Gunnar Rehlin/TT</BYLINE> <BILD><BILDFIL>http://tt.se/media/image/sdltdc7fdc8</BILDFIL><BILDTEXT><P>Skr&auml;ckfilmen "Midsommar" f&ouml;ljer en hednisk sekt i H&auml;lsingland. Pressbild.</P></BILDTEXT><BILDSKAPARE>Nordisk Film</BILDSKAPARE></BILD><BILD><BILDFIL>http://tt.se/media/image/sdltdc6f543</BILDFIL><BILDTEXT><P>Christian (Jack Reynor) och hans flickv&auml;n Dani (Florence Pugh) h&aring;ller p&aring; att tappa gnistan i sitt f&ouml;rh&aring;llande, n&aring;got som st&auml;lls p&aring; sin spets n&auml;r de bes&ouml;ker Sverige och tr&auml;ffar en s&auml;rskilt brutal midsommar-sekt. Pressbild.</P></BILDTEXT><BILDSKAPARE>Nordisk film</BILDSKAPARE></BILD></TEXT><TEXT><RUBRIK>Fakta: Midsommar</RUBRIK><BRODTEXT><P>Originaltitel: Midsommar</P><P>Genre: Skr&auml;ckfilm</P><P>Regi: Ari Aster</P><P>Sk&aring;despelare: Florence Pugh, Jack Reynor, William Jackson Harper, Vilhelm Blomgren, Will Poulter, Liv Mj&ouml;nes, Anna &Aring;str&ouml;m, Julia Ragnarsson, Isabelle Grill, Louise Peterhoff, Bj&ouml;rn Andr&eacute;sen, Gunnel Fred, Anki Larsson.</P><P>L&auml;ngd: 140 minuter</P><P>&Aring;ldersgr&auml;ns: 15 &aring;r</P><P>Betyg: 5</P></BRODTEXT></TEXT></BODY><ENDSIZE ID="9:10">3493</ENDSIZE></TTNITF>',
    body_npdoc: '<npexchange xmlns="http://www.infomaker.se/npexchange/3.5" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" version="3.5"><origin><user id="47">MEDIAEXPORT02 TYPE_SERVICE</user><organization id="3">TT Redaktion</organization><systemId>TT</systemId><systemVersion>4.9.33</systemVersion><systemRelease/></origin><article guid="urn:uuid:21583555-fc34-4ebc-b6e5-cb9dc29f6b2d" id="1003001" refType="Article" uuid="21583555-fc34-4ebc-b6e5-cb9dc29f6b2d"><archive_id>0</archive_id><article_type_id id="158">RECENSION</article_type_id><background_material>false</background_material><backup_version>10</backup_version><char_size_factor>0.0</char_size_factor><created_date>2019-07-08T09:01:51+02:00</created_date><created_user_id cellular="0721776993" email="kristoffer.viita@tt.se" firstName="Kristoffer" id="654" initials="krv" lastName="Viita/TT">Kristoffer Viita/TT</created_user_id><data_version>10</data_version><department_id id="14">Nyheter</department_id><dirty_flag>0</dirty_flag><geodata><kml xmlns="http://www.opengis.net/kml/2.2" xmlns:ns2="http://www.w3.org/2005/Atom" xmlns:ns3="urn:oasis:names:tc:ciq:xsdschema:xAL:2.0"><Document><ExtendedData><Data name="np_version"><value>1.2</value></Data></ExtendedData><Placemark><name>Sverige</name><address>Sverige</address><description/><Point><coordinates>18.643501,60.128161</coordinates></Point></Placemark></Document></kml></geodata><guid>urn:uuid:21583555-fc34-4ebc-b6e5-cb9dc29f6b2d</guid><inherit_layout>false</inherit_layout><job_id guid="urn:uuid:08f4ad6a-5bff-4764-b8c3-4f00c1850a60" id="479936" uuid="08f4ad6a-5bff-4764-b8c3-4f00c1850a60"/><label>0</label><layout_status>0</layout_status><layout_type>0</layout_type><layout_type_changed>false</layout_type_changed><media_id id="1" shortName="PRT">Print</media_id><name>midsommar</name><organization_id id="3" shortName="TTRED">TT Redaktion</organization_id><page_span_count>0</page_span_count><prio>0</prio><product_id id="7" shortName="TTRED">TT Redaktion</product_id><pub_start>2019-07-10T00:00:00+02:00</pub_start><pub_stop>future</pub_stop><publication_date_id id="13217" publicationDate="2019-07-10">2019-07-10</publication_date_id><removed_date>future</removed_date><removed_flag>false</removed_flag><resp_user_id cellular="0721776993" email="kristoffer.viita@tt.se" firstName="Kristoffer" id="654" initials="krv" lastName="Viita/TT">Kristoffer Viita/TT</resp_user_id><restored_date>1970-01-01T01:00:00+01:00</restored_date><restored_flag>0</restored_flag><secret>false</secret><section_hierarchy><section_id id="38" name="Nöje och Kultur" shortName="NOJ"/></section_hierarchy><section_id id="38" shortName="NOJ">Nöje och Kultur</section_id><slug>Filmrecension: Mästerlig midsom</slug><status id="7">Klar</status><sub_product_id id="23" shortName="TTRED">TT Redaktion</sub_product_id><tags><tags><tag category="LOC" ignored="true" name="Hälsingland" type="EntityTag"/><tag category="LOC" ignored="true" name="Sverige" type="EntityTag"/><tag category="MISC" name="Midsommar" type="EntityTag"/><tag category="NONE" name="Vilhelm Blomgren" type="EntityTag"/><tag category="ORG" ignored="true" name="TT" type="EntityTag"/><tag category="PER" ignored="true" name="Anki Larsson" type="EntityTag"/><tag category="PER" ignored="true" name="Anna Åström" type="EntityTag"/><tag category="PER" name="Ari Aster" type="EntityTag"/><tag category="PER" ignored="true" name="Ari Asters" type="EntityTag"/><tag category="PER" ignored="true" name="Björn Andrésen" type="EntityTag"/><tag category="PER" ignored="true" name="Christian" type="EntityTag"/><tag category="PER" ignored="true" name="Dani" type="EntityTag"/><tag category="PER" ignored="true" name="Florence Pugh" type="EntityTag"/><tag category="PER" ignored="true" name="Gunnel Fred" type="EntityTag"/><tag category="PER" ignored="true" name="Isabelle Grill" type="EntityTag"/><tag category="PER" ignored="true" name="Jack Reynor" type="EntityTag"/><tag category="PER" ignored="true" name="Julia Ragnarsson" type="EntityTag"/><tag category="PER" ignored="true" name="Liv Mjönes" type="EntityTag"/><tag category="PER" ignored="true" name="Louise Peterhoff" type="EntityTag"/><tag category="PER" ignored="true" name="Pelle ( Vilhelm Blomgren" type="EntityTag"/><tag category="PER" ignored="true" name="Will Poulter" type="EntityTag"/><tag category="PER" ignored="true" name="William Jackson Harper" type="EntityTag"/><tag category="TOPIC" name="Film" type="TopicTag"/><tag category="TOPIC" name="Kultur, konst och nöje" type="TopicTag"/></tags></tags><updated_date>2019-07-09T09:15:29+02:00</updated_date><updated_user_id cellular="0738294805" email="sofia.sundstrom@tt.se" firstName="Sofia" id="739" initials="ssu" lastName="Sundström/TT">Sofia Sundström/TT</updated_user_id><userdata><userdata><webbprio valueId="3">Vanlig</webbprio><texttyp valueId="1">PUBL</texttyp><prio valueId="4">4</prio><det_STO valueId="">false</det_STO><week valueId="0">0</week><kundarea valueId="1111">-FEATUREAREOR-</kundarea></userdata></userdata><articleparts><articlepart guid="urn:uuid:7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02" id="1790801" refType="ArticlePart" uuid="7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02"><article_id guid="urn:uuid:21583555-fc34-4ebc-b6e5-cb9dc29f6b2d" id="1003001" uuid="21583555-fc34-4ebc-b6e5-cb9dc29f6b2d"/><article_part_type_id category="article" id="1">Artikel</article_part_type_id><char_size_factor>0.0</char_size_factor><created_date>2019-07-08T09:01:51+02:00</created_date><created_user_id cellular="0721776993" email="kristoffer.viita@tt.se" firstName="Kristoffer" id="654" initials="krv" lastName="Viita/TT">Kristoffer Viita/TT</created_user_id><guid>urn:uuid:7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02</guid><layout_id>1</layout_id><secret>false</secret><sortkey>0.5</sortkey><textlength>2692</textlength><textlength_mm>0</textlength_mm><total_textlength>2749</total_textlength><updated_date>2019-07-08T15:39:06+02:00</updated_date><updated_user_id cellular="0738294805" email="sofia.sundstrom@tt.se" firstName="Sofia" id="739" initials="ssu" lastName="Sundström/TT">Sofia Sundström/TT</updated_user_id><data><npdoc xmlns="http://www.infomaker.se/npdoc/2.1" version="2.1" xml:lang="sv"><headline><p>Filmrecension: Mästerlig midsommarskräck</p></headline><pagedateline><p>Filmrecension</p></pagedateline><dateline customName="Källa"><p>(TT)</p></dateline><leadin><p>Den svenska sommartraditionen perverteras av en hednisk sekt som vittrar blod i midnattssolen.</p></leadin><body><p>”Hereditary” var inte bara 2018 års bästa skräckfilm. Ari Asters långfilmsregidebut var också en av förra årets bästa filmer över huvud taget.</p><p>Förväntningarna på uppföljaren har varit minst sagt högt ställda. Aster har i intervjuer talat om att hans målsättning var att göra en skandinavisk variant av den brittiska skräckfilmen ”The Wicker Man” (”Dödlig skörd”, 1973). Där hamnade en troende polisman på en avlägsen ö, och under sökandet efter en försvunnen flicka upptäcker han att ön befolkas av en kult som ägnar sig åt fruktbarhetsriter.</p><p>I ”Midsommar” möter vi Dani (Florence Pugh), traumatiserad efter en familjetragedi. Hon följer med sin pojkvän Christian (relationen har gått i stå och han väntar på ett tillfälle att göra slut) och några av dennes vänner till Sverige för att fira midsommar. De lockas dit av kompisen Pelle (Vilhelm Blomgren), som tar med dem till den avlägsna by i Hälsingland där hans familj bor. De tillresta möts av blonda människor klädda i vitt, av leenden och gästfrihet, men blir snart varse att det bakom alla leenden finns någonting betydligt mörkare – de får tidigt en (mycket grafiskt skildrad) demonstration av begreppet ättestupa.</p><p>Skräckfilmer utspelar sig ofta i mörker – nattetid är det lättare för monstren att smyga på oss, och ger filmskaparen möjlighet att komma med så kallade "jump scares". Aster är inte ute efter att få oss att hoppa högt i biostolen, ”Midsommar” utspelas till största delen i badande solljus. Liksom han gjorde i ”Hereditary” är han ute efter att bygga upp en stämning, som nästan lite subtilt kommer krypande och som skapar den där sortens obehagskänsla som är svår att skaka av sig även efter att filmen är slut.</p><p>”Midsommar” känns stundtals som en psykedelisk tripp, en mardröm som de involverade inte kan ta sig ur utan där de i stället med öppna ögon och näst intill frivilligt går mot katastrofen. Aster berättar med långa, ibland nästan stillastående tagningar, att förfalla till intensivt klippande är inte hans stil. Han för in oss i sina scener med nästan omärkliga inzoomningar och ger oss möjlighet att studera och upptäcka detaljer (bara detta är en given orsak att se filmen flera gånger).</p><p>Här finns den yttre berättelsen om kulten i Hälsingland, men det är också en film om skräcken över att bli lämnad ensam. Efter familjetragedin står Dani helt ensam, förhållandet med Christian är ansträngt och hon känns som en person som nu söker en ny tillvaro, en fast mark att stå på.</p><p>”Midsommar” är en ny mästerlig skräckfilm av Ari Aster. Han är bara drygt 30 år gammal. Det ska bli oerhört intressant att följa hans karriär.</p></body></npdoc></data><imagecontainers><imagecontainer guid="urn:uuid:50ea79ad-24ad-4b61-bfec-74f053c8a77a" id="888204" refType="ImageContainer" uuid="50ea79ad-24ad-4b61-bfec-74f053c8a77a"><article_id guid="urn:uuid:21583555-fc34-4ebc-b6e5-cb9dc29f6b2d" id="1003001" uuid="21583555-fc34-4ebc-b6e5-cb9dc29f6b2d"/><article_part_id guid="urn:uuid:7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02" id="1790801" uuid="7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02"/><crop_exists>false</crop_exists><guid>urn:uuid:50ea79ad-24ad-4b61-bfec-74f053c8a77a</guid><image_id guid="urn:uuid:6fa3dcdc-668d-4a09-a4e8-1e08d24004ee" id="535619" uuid="6fa3dcdc-668d-4a09-a4e8-1e08d24004ee"/><label>0</label><layout_id>1</layout_id><name>Bild - 1</name><secret>false</secret><sortkey>5.992310449541053E307</sortkey><textlength>74</textlength><total_textlength>74</total_textlength><data><npdoc xmlns="http://www.infomaker.se/npdoc/2.1" version="2.1" xml:lang="sv"><caption><p>Skräckfilmen "Midsommar" följer en hednisk sekt i Hälsingland. Pressbild.</p></caption></npdoc></data><image guid="urn:uuid:6fa3dcdc-668d-4a09-a4e8-1e08d24004ee" id="535619" refType="Image" uuid="6fa3dcdc-668d-4a09-a4e8-1e08d24004ee"><archive_id>0</archive_id><background_material>false</background_material><backup_crc>0</backup_crc><byte_size>0</byte_size><caption_proposed>DSCF8772.RAF**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**</caption_proposed><colorspace>RGB</colorspace><created_date>2019-07-08T09:33:49+02:00</created_date><created_user_id cellular="0721776993" email="kristoffer.viita@tt.se" firstName="Kristoffer" id="654" initials="krv" lastName="Viita/TT">Kristoffer Viita/TT</created_user_id><crop_exists>false</crop_exists><custom1>D3A528A8411C4552 96E2E5C347094642</custom1><description>DSCF8772.RAF**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**</description><document_creation_date>1970-01-01T01:00:00+01:00</document_creation_date><external_system_id id="53">TT Bildsättning</external_system_id><file_creator>0</file_creator><file_ext>.jpg</file_ext><file_type>0</file_type><guid>urn:uuid:6fa3dcdc-668d-4a09-a4e8-1e08d24004ee</guid><height>4000</height><image_author_name>Csaba Aknay</image_author_name><image_type>Plain</image_type><imagelinks><imagelink created_user_id="654" department_id="14" image_id="535619" job_id="479936" removed_flag="false"/></imagelinks><is_placeable>false</is_placeable><is_production_image>false</is_production_image><metadata><metadata><document><jpeg><width>6000</width><height>4000</height><color_space>RGB</color_space><num_components>3</num_components><data_precision>8</data_precision><comment/><jfif_units>0</jfif_units><jfif_x_density>556</jfif_x_density><jfif_y_density>556</jfif_y_density><photoshop4><iptc>none<CustomField2>tdc7fdc8</CustomField2><SupplementalCategory>ttplugin</SupplementalCategory><Keyword>midsommar</Keyword><SpecialInstructions>**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**</SpecialInstructions><CreatedDate>Tue Oct 02 00:00:00 CEST 2018</CreatedDate><Byline>Csaba Aknay</Byline><BylineTitle>8888</BylineTitle><Caption>DSCF8772.RAF**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**</Caption></iptc></photoshop4><exif><ImageDescription>DSCF8772.RAF**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**</ImageDescription><Orientation>1</Orientation><XResolution>3000000/10000</XResolution><YResolution>3000000/10000</YResolution><ResolutionUnit>2</ResolutionUnit><Software>QuickTime 7.7.3</Software><DateTime>Wed Jun 05 16:45:50 CEST 2019</DateTime><Artist>Csaba Aknay</Artist><YCbCrPositioning>1</YCbCrPositioning><ExposureTime>1/250</ExposureTime><FNumber>45/10</FNumber><ExposureProgram>1</ExposureProgram><ISOSpeedRatings>320</ISOSpeedRatings><ExifVersion>none</ExifVersion><DateTimeOriginal>Tue Oct 02 11:14:03 CEST 2018</DateTimeOriginal><DateTimeDigitized>Tue Oct 02 11:14:03 CEST 2018</DateTimeDigitized><ShutterSpeedValue>7965784/1000000</ShutterSpeedValue><ApertureValue>433985/100000</ApertureValue><BrightnessValue>735/100</BrightnessValue><ExposureBiasValue>0/100</ExposureBiasValue><MaxApertureValue>300/100</MaxApertureValue><MeteringMode>2</MeteringMode><LightSource>0</LightSource><Flash>0</Flash><FocalLength>5500/100</FocalLength><ColorSpace>1</ColorSpace><ExifImageWidth>6000</ExifImageWidth><ExifImageLength>4000</ExifImageLength><FocalPlaneXResolution>83663736/32768</FocalPlaneXResolution><FocalPlaneYResolution>83663736/32768</FocalPlaneYResolution><FocalPlaneResolutionUnit>3</FocalPlaneResolutionUnit><SensingMethod>2</SensingMethod><FileSource>none</FileSource><SceneType>none</SceneType><Compression>6</Compression><ThumbnailOffset>none</ThumbnailOffset><ThumbnailLength>none</ThumbnailLength><exif_thumbnail>image/jpeg</exif_thumbnail></exif><xmp><photoshop><DateCreated>ttplugin</DateCreated><Urgency>2</Urgency><ColorMode>3</ColorMode><ICCProfile>sRGB IEC61966-2.1</ICCProfile><AuthorsPosition>8888</AuthorsPosition><Instructions>**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**</Instructions><SupplementalCategories>ttplugin</SupplementalCategories></photoshop><tiff><ResolutionUnit>2</ResolutionUnit><YResolution>30000000/100000</YResolution><XResolution>30000000/100000</XResolution><YCbCrPositioning>1</YCbCrPositioning><Orientation>1</Orientation><NativeDigest>256,257,258,259,262,274,277,284,530,531,282,283,296,301,318,319,529,532,306,270,271,272,305,315,33432;D98A6A2D2693FB1274BB9CB00D092E4F</NativeDigest></tiff><xmp><CreateDate>2018-10-02T11:14:03:00</CreateDate><ModifyDate>2019-06-05T16:45:50 02:00</ModifyDate><CreatorTool>Color Factory 8.0</CreatorTool><XMPFileStamps>2019-07-08T09:29:32 02:00, 2019-07-08T09:29:32 02:00</XMPFileStamps></xmp><exif><SceneType>1</SceneType><FileSource>3</FileSource><DateTimeOriginal>2018-10-02T11:14:03:00</DateTimeOriginal><ExifVersion>0220</ExifVersion><SubjectDistanceRange>0</SubjectDistanceRange><Sharpness>2</Sharpness><SceneCaptureType>0</SceneCaptureType><FocalLengthIn35mmFilm>83</FocalLengthIn35mmFilm><WhiteBalance>0</WhiteBalance><ExposureMode>1</ExposureMode><CustomRendered>0</CustomRendered><SensingMethod>2</SensingMethod><FocalPlaneResolutionUnit>3</FocalPlaneResolutionUnit><FocalPlaneYResolution>83663736/32768</FocalPlaneYResolution><FocalPlaneXResolution>83663736/32768</FocalPlaneXResolution><FocalLength>5500/100</FocalLength><LightSource>0</LightSource><MeteringMode>2</MeteringMode><MaxApertureValue>300/100</MaxApertureValue><ExposureBiasValue>0/100</ExposureBiasValue><BrightnessValue>735/100</BrightnessValue><ApertureValue>433985/100000</ApertureValue><ShutterSpeedValue>7965784/1000000</ShutterSpeedValue><ExposureProgram>1</ExposureProgram><FNumber>45/10</FNumber><ExposureTime>1/250</ExposureTime><NativeDigest>36864,40960,40961,37121,37122,40962,40963,37510,40964,36867,36868,33434,33437,34850,34852,34855,34856,37377,37378,37379,37380,37381,37382,37383,37384,37385,37386,37396,41483,41484,41486,41487,41488,41492,41493,41495,41728,41729,41730,41985,41986,41987,41988,41989,41990,41991,41992,41993,41994,41995,41996,42016,0,2,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,20,22,23,24,25,26,27,28,30;27ABD15CE690769F8088D8B15A63206F</NativeDigest><PixelXDimension>6000</PixelXDimension><PixelYDimension>4000</PixelYDimension><Fired>False</Fired><Return>0</Return><Mode>0</Mode><Function>False</Function><RedEyeMode>False</RedEyeMode><ISOSpeedRatings>320</ISOSpeedRatings><UserComment>DSCF8772.RAF</UserComment><lang>x-default</lang></exif><xmpMM><DocumentID>xmp.did:046EB063C5F34CE6 BC5790E55353A93D</DocumentID><OriginalDocumentID>xmp.did:046EB063C5F34CE6 BC5790E55353A93D</OriginalDocumentID><InstanceID>xmp.iid:A12E7BB1F68545AE A1D2FD6CEA073406</InstanceID></xmpMM><fwr><UniqueId>D3A528A8411C4552 96E2E5C347094642</UniqueId><ShortUniqueId>3485579470</ShortUniqueId></fwr><dc><description>DSCF8772.RAF**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**</description><lang>x-default</lang><subject>midsommar</subject><creator>Csaba Aknay</creator></dc><expressionmedia><CatalogSets>Key Set</CatalogSets></expressionmedia><mediapro><CatalogSets>Key Set</CatalogSets></mediapro></xmp></jpeg><distiller><width>6000</width><height>4000</height><resolution>300.0</resolution><si_width>508</si_width><si_height>338</si_height><file_size>3615294</file_size><mimetype>image/jpeg</mimetype><color_space>RGB</color_space><orientation>1</orientation></distiller></document><archiveinfo><image_description class="java.lang.String" param0="metadata:/*/photoshop*/iptc/Caption">DSCF8772.RAF**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**</image_description><image_author class="java.lang.String" param0="metadata:/*/photoshop*/iptc/Byline">Csaba Aknay</image_author><image_date class="java.util.Date" param0="{yyyy-MM-dd,HH.mm}" param1="{metadata:/*/photoshop*/iptc/CreatedDate*,metadata:/*/exif/DateTimeOriginal}">2018-10-02 00.00</image_date><image_location class="java.lang.String" param0="metadata:/*/photoshop*/iptc/City"/></archiveinfo></metadata></metadata><mimetype>image/jpeg</mimetype><name>sdltdc7fdc8_NormalHires.jpg</name><no_archiving>false</no_archiving><organization_id id="3" shortName="TTRED">TT Redaktion</organization_id><orientation>1</orientation><original_id>0</original_id><original_removed>future</original_removed><prio>0</prio><ref_id>0</ref_id><removed_date>future</removed_date><removed_flag>false</removed_flag><resolution>300</resolution><secret>false</secret><status id="14">Förbehandlad</status><storelocation_id id="16"/><storepath>sdltdc7fdc8_NormalHires.jpg?ak=f93cc90c-eb29-4a87-8768-5773f6eed073&amp;agr=51988</storepath><system_links><system_link><external_system_id id="53" system_type="OTHER">TT Bildsättning</external_system_id><external_id>http://tt.se/media/image/sdltdc7fdc8</external_id></system_link></system_links><updated_date>2019-07-08T09:33:57+02:00</updated_date><updated_user_id custom2="false" firstName="MEDIADISTILLER03" id="105" lastName="TYPE_SERVICE">MEDIADISTILLER03 TYPE_SERVICE</updated_user_id><width>6000</width><width_mm>6000</width_mm><data src="535619_sdltdc7fdc8_NormalHires.jpg"/></image><bylines><byline id="1062255" refType="Byline"><article_part_id guid="urn:uuid:7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02" id="1790801" uuid="7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02"/><byline_type_id id="8">Byline</byline_type_id><image_container_id guid="urn:uuid:50ea79ad-24ad-4b61-bfec-74f053c8a77a" id="888204" uuid="50ea79ad-24ad-4b61-bfec-74f053c8a77a"/><sortkey>0.5</sortkey><userinfo><userdata><firstname>Nordisk Film</firstname></userdata></userinfo></byline></bylines></imagecontainer><imagecontainer guid="urn:uuid:af0774fe-8bf8-402e-8a05-d18eff0bfc40" id="888205" refType="ImageContainer" uuid="af0774fe-8bf8-402e-8a05-d18eff0bfc40"><article_id guid="urn:uuid:21583555-fc34-4ebc-b6e5-cb9dc29f6b2d" id="1003001" uuid="21583555-fc34-4ebc-b6e5-cb9dc29f6b2d"/><article_part_id guid="urn:uuid:7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02" id="1790801" uuid="7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02"/><crop_exists>false</crop_exists><guid>urn:uuid:af0774fe-8bf8-402e-8a05-d18eff0bfc40</guid><image_id guid="urn:uuid:b3fc510b-9f72-4795-bba9-8c9e9bc9fed4" id="535620" uuid="b3fc510b-9f72-4795-bba9-8c9e9bc9fed4"/><label>0</label><layout_id>2</layout_id><name>Bild - 2</name><secret>false</secret><sortkey>1.1984620899082105E308</sortkey><textlength>222</textlength><total_textlength>222</total_textlength><data><npdoc xmlns="http://www.infomaker.se/npdoc/2.1" version="2.1" xml:lang="sv"><caption><p>Christian (Jack Reynor) och hans flickvän Dani (Florence Pugh) håller på att tappa gnistan i sitt förhållande, något som ställs på sin spets när de besöker Sverige och träffar en särskilt brutal midsommar-sekt. Pressbild.</p></caption></npdoc></data><image guid="urn:uuid:b3fc510b-9f72-4795-bba9-8c9e9bc9fed4" id="535620" refType="Image" uuid="b3fc510b-9f72-4795-bba9-8c9e9bc9fed4"><archive_id>0</archive_id><background_material>false</background_material><backup_crc>0</backup_crc><byte_size>0</byte_size><caption_proposed>This image released by A24 shows Jack Reynor and Florence Pugh, right, in a scene from the horror film "Midsommar." (Gabor Kotschy/A24 via AP)</caption_proposed><colorspace>RGB</colorspace><created_date>2019-07-08T09:34:50+02:00</created_date><created_user_id cellular="0721776993" email="kristoffer.viita@tt.se" firstName="Kristoffer" id="654" initials="krv" lastName="Viita/TT">Kristoffer Viita/TT</created_user_id><crop_exists>false</crop_exists><custom1>8371D599812B44B6 B0368F0033F69FC8</custom1><description>This image released by A24 shows Jack Reynor and Florence Pugh, right, in a scene from the horror film "Midsommar." (Gabor Kotschy/A24 via AP)</description><document_creation_date>1970-01-01T01:00:00+01:00</document_creation_date><external_system_id id="53">TT Bildsättning</external_system_id><file_creator>0</file_creator><file_ext>.jpg</file_ext><file_type>0</file_type><guid>urn:uuid:b3fc510b-9f72-4795-bba9-8c9e9bc9fed4</guid><height>1720</height><image_author_name>Gabor Kotschy</image_author_name><image_type>Plain</image_type><imagelinks><imagelink created_user_id="654" department_id="14" image_id="535620" job_id="479936" removed_flag="false"/></imagelinks><is_placeable>false</is_placeable><is_production_image>false</is_production_image><metadata><metadata><document><jpeg><width>2580</width><height>1720</height><color_space>RGB</color_space><num_components>3</num_components><data_precision>8</data_precision><comment/><jfif_units>1</jfif_units><jfif_x_density>556</jfif_x_density><jfif_y_density>556</jfif_y_density><photoshop4><iptc>none<CustomField2>tdc6f543</CustomField2><ImageName>Film Review - Midsommar</ImageName><Category>A</Category><SupplementalCategory>ENT</SupplementalCategory><SpecialInstructions>AP PROVIDES ACCESS TO THIS THIRD PARTY PHOTO SOLELY TO ILLUSTRATE NEWS REPORTING OR COMMENTARY ON FACTS DEPICTED IN IMAGE; MUST BE USED WITHIN 14 DAYS FROM TRANSMISSION; NO ARCHIVING; NO LICENSING; MANDATORY CREDIT.</SpecialInstructions><CreatedDate>Wed Sep 05 00:00:00 CEST 2018</CreatedDate><Byline>Gabor Kotschy</Byline><BylineTitle>436</BylineTitle><Credit>AP</Credit><Source>TT NYHETSBYRÅN/ NTB Scanpix</Source><Caption>This image released by A24 shows Jack Reynor and Florence Pugh, right, in a scene from the horror film "Midsommar." (Gabor Kotschy/A24 via AP)</Caption><OriginalTransmissionReference>Film_Review_-_Midsommar_95961.jpg-7ab79.jpg</OriginalTransmissionReference></iptc></photoshop4><exif><ImageWidth>6000</ImageWidth><ImageLength>4000</ImageLength><BitsPerSample>8</BitsPerSample><ImageDescription>This image released by A24 shows Jack Reynor and Florence Pugh, right, in a scene from the horror film "Midsommar." (Gabor Kotschy/A24 via AP)</ImageDescription><Make>FUJIFILM</Make><Model>X-Pro2</Model><Orientation>1</Orientation><SamplesPerPixel>3</SamplesPerPixel><XResolution>3000000/10000</XResolution><YResolution>3000000/10000</YResolution><ResolutionUnit>2</ResolutionUnit><Software>Adobe Photoshop CS5.1 Macintosh</Software><DateTime>Tue Apr 30 18:43:25 CEST 2019</DateTime><Artist>Gabor Kotschy</Artist><Copyright>A24</Copyright><ExposureTime>1/8000</ExposureTime><FNumber>2/1</FNumber><ExposureProgram>1</ExposureProgram><ISOSpeedRatings>250</ISOSpeedRatings><ExifVersion>none</ExifVersion><DateTimeOriginal>Wed Sep 05 13:22:05 CEST 2018</DateTimeOriginal><DateTimeDigitized>Wed Sep 05 13:22:05 CEST 2018</DateTimeDigitized><ShutterSpeedValue>12965784/1000000</ShutterSpeedValue><ApertureValue>2/1</ApertureValue><BrightnessValue>903/100</BrightnessValue><ExposureBiasValue>0/100</ExposureBiasValue><MaxApertureValue>200/100</MaxApertureValue><MeteringMode>2</MeteringMode><LightSource>0</LightSource><Flash>0</Flash><FocalLength>9000/100</FocalLength><ColorSpace>2</ColorSpace><ExifImageWidth>2580/-1610416124</ExifImageWidth><ExifImageLength>1720/-1576140795</ExifImageLength><FocalPlaneXResolution>83663736/32768</FocalPlaneXResolution><FocalPlaneYResolution>83663736/32768</FocalPlaneYResolution><FocalPlaneResolutionUnit>3</FocalPlaneResolutionUnit><SensingMethod>2</SensingMethod><FileSource>none</FileSource><SceneType>none</SceneType><Compression>6</Compression><ThumbnailOffset>none</ThumbnailOffset><ThumbnailLength>none</ThumbnailLength><exif_thumbnail>image/jpeg</exif_thumbnail></exif><xmp><photoshop><Category>A</Category><Instructions>AP PROVIDES ACCESS TO THIS THIRD PARTY PHOTO SOLELY TO ILLUSTRATE NEWS REPORTING OR COMMENTARY ON FACTS DEPICTED IN IMAGE; MUST BE USED WITHIN 14 DAYS FROM TRANSMISSION; NO ARCHIVING; NO LICENSING; MANDATORY CREDIT.</Instructions><TransmissionReference>Film_Review_-_Midsommar_95961.jpg-7ab79.jpg</TransmissionReference><DateCreated>ENT</DateCreated><ICCProfile>Adobe RGB (1998)</ICCProfile><AuthorsPosition>436</AuthorsPosition><Credit>AP</Credit><Source>TT NYHETSBYRÅN/ NTB Scanpix</Source><Urgency>9</Urgency><ColorMode>3</ColorMode><SupplementalCategories>ENT</SupplementalCategories></photoshop><xmp><CreateDate>2018-09-05T13:22:05:00</CreateDate><Rating>2</Rating><ModifyDate>2019-06-27T17:04:30 02:00</ModifyDate><MetadataDate>2019-06-27T17:04:30 02:00</MetadataDate><CreatorTool>Color Factory 8.0</CreatorTool><XMPFileStamps>2019-06-27T17:04:30 02:00, 2019-06-27T17:04:30 02:00</XMPFileStamps></xmp><dc><format>image/jpeg</format><description>This image released by A24 shows Jack Reynor and Florence Pugh, right, in a scene from the horror film "Midsommar." (Gabor Kotschy/A24 via AP)</description><lang>x-default, x-default, x-default</lang><title>Film Review - Midsommar</title><creator>Gabor Kotschy</creator><rights>A24</rights></dc><plus><ImageSupplierImageID>de0e92e6-1975-4865-823c-bfaec90a6308</ImageSupplierImageID><ImageSupplierName>AP</ImageSupplierName></plus><xmpMM><DocumentID>xmp.did:FD745BE1508D452C BD66C7FE4D99ADAE</DocumentID><OriginalDocumentID>xmp.did:FD745BE1508D452C BD66C7FE4D99ADAE</OriginalDocumentID><InstanceID>xmp.iid:2CF9131536C447BD 8E2F31A7458F909A</InstanceID></xmpMM><fwl><CreatedTime>132205 0000</CreatedTime></fwl><exif><PixelXDimension>2580</PixelXDimension><PixelYDimension>1720</PixelYDimension><DateTimeOriginal>2018-09-05T13:22:05:00</DateTimeOriginal><ExposureTime>1/8000</ExposureTime><FNumber>2/1</FNumber><ExposureProgram>1</ExposureProgram><ExifVersion>48 50 51 48</ExifVersion><ShutterSpeedValue>12965784/1000000</ShutterSpeedValue><ApertureValue>2/1</ApertureValue><BrightnessValue>903/100</BrightnessValue><ExposureBiasValue>0/100</ExposureBiasValue><MaxApertureValue>200/100</MaxApertureValue><MeteringMode>2</MeteringMode><LightSource>0</LightSource><FocalLength>9000/100</FocalLength><ColorSpace>65535</ColorSpace><FocalPlaneXResolution>83663736/32768</FocalPlaneXResolution><FocalPlaneYResolution>83663736/32768</FocalPlaneYResolution><FocalPlaneResolutionUnit>3</FocalPlaneResolutionUnit><SensingMethod>2</SensingMethod><CustomRendered>0</CustomRendered><ExposureMode>1</ExposureMode><WhiteBalance>0</WhiteBalance><FocalLengthIn35mmFilm>135</FocalLengthIn35mmFilm><SceneCaptureType>0</SceneCaptureType><Sharpness>2</Sharpness><SubjectDistanceRange>0</SubjectDistanceRange><ISOSpeedRatings>250</ISOSpeedRatings><Fired>False</Fired><Return>0</Return><Mode>0</Mode><RedEyeMode>False</RedEyeMode></exif><tiff><Make>FUJIFILM</Make><Model>X-Pro2</Model><Orientation>1</Orientation><XResolution>30000000/100000</XResolution><YResolution>30000000/100000</YResolution><ResolutionUnit>2</ResolutionUnit></tiff><fwr><UniqueId>8371D599812B44B6 B0368F0033F69FC8</UniqueId><ShortUniqueId>3486823644</ShortUniqueId></fwr><Iptc4xmpExt><RegOrgId>AP Item Id, AP Friendly Key</RegOrgId><RegItemId>de0e92e6-1975-4865-823c-bfaec90a6308, 19178542095961</RegItemId></Iptc4xmpExt></xmp></jpeg><distiller><width>2580</width><height>1720</height><resolution>300.0</resolution><si_width>218</si_width><si_height>145</si_height><file_size>576156</file_size><mimetype>image/jpeg</mimetype><color_space>RGB</color_space><orientation>1</orientation></distiller></document><archiveinfo><image_description class="java.lang.String" param0="metadata:/*/photoshop*/iptc/Caption">This image released by A24 shows Jack Reynor and Florence Pugh, right, in a scene from the horror film "Midsommar." (Gabor Kotschy/A24 via AP)</image_description><image_author class="java.lang.String" param0="metadata:/*/photoshop*/iptc/Byline">Gabor Kotschy</image_author><image_date class="java.util.Date" param0="{yyyy-MM-dd,HH.mm}" param1="{metadata:/*/photoshop*/iptc/CreatedDate*,metadata:/*/exif/DateTimeOriginal}">2018-09-05 00.00</image_date><image_location class="java.lang.String" param0="metadata:/*/photoshop*/iptc/City"/></archiveinfo></metadata></metadata><mimetype>image/jpeg</mimetype><name>sdltdc6f543_NormalHires.jpg</name><no_archiving>false</no_archiving><organization_id id="3" shortName="TTRED">TT Redaktion</organization_id><orientation>1</orientation><original_id>0</original_id><original_removed>future</original_removed><prio>0</prio><ref_id>0</ref_id><removed_date>future</removed_date><removed_flag>false</removed_flag><resolution>300</resolution><secret>false</secret><status id="14">Förbehandlad</status><storelocation_id id="16"/><storepath>sdltdc6f543_NormalHires.jpg?ak=f93cc90c-eb29-4a87-8768-5773f6eed073&amp;agr=51988</storepath><system_links><system_link><external_system_id id="53" system_type="OTHER">TT Bildsättning</external_system_id><external_id>http://tt.se/media/image/sdltdc6f543</external_id></system_link></system_links><updated_date>2019-07-08T09:34:56+02:00</updated_date><updated_user_id custom2="false" firstName="MEDIADISTILLER03" id="105" lastName="TYPE_SERVICE">MEDIADISTILLER03 TYPE_SERVICE</updated_user_id><width>2580</width><width_mm>2580</width_mm><data src="535620_sdltdc6f543_NormalHires.jpg"/></image><bylines><byline id="1062256" refType="Byline"><article_part_id guid="urn:uuid:7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02" id="1790801" uuid="7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02"/><byline_type_id id="8">Byline</byline_type_id><image_container_id guid="urn:uuid:af0774fe-8bf8-402e-8a05-d18eff0bfc40" id="888205" uuid="af0774fe-8bf8-402e-8a05-d18eff0bfc40"/><sortkey>0.5</sortkey><userinfo><userdata><firstname>Nordisk film</firstname></userdata></userinfo></byline></bylines></imagecontainer></imagecontainers><bylines><byline id="1062186" refType="Byline"><article_part_id guid="urn:uuid:7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02" id="1790801" uuid="7eb5af52-4be1-45b2-a10b-d8bd3a7e8a02"/><byline_type_id id="8">Byline</byline_type_id><sortkey>0.5</sortkey><userinfo><userdata><firstname>Gunnar</firstname><lastname>Rehlin/TT</lastname></userdata></userinfo></byline></bylines></articlepart><articlepart guid="urn:uuid:7a9ea741-b859-483e-9e3e-7971fb921d5e" id="1790830" refType="ArticlePart" uuid="7a9ea741-b859-483e-9e3e-7971fb921d5e"><article_id guid="urn:uuid:21583555-fc34-4ebc-b6e5-cb9dc29f6b2d" id="1003001" uuid="21583555-fc34-4ebc-b6e5-cb9dc29f6b2d"/><article_part_type_id category="article" id="3">Fakta</article_part_type_id><char_size_factor>0.0</char_size_factor><created_date>2019-07-08T09:16:45+02:00</created_date><created_user_id cellular="0721776993" email="kristoffer.viita@tt.se" firstName="Kristoffer" id="654" initials="krv" lastName="Viita/TT">Kristoffer Viita/TT</created_user_id><guid>urn:uuid:7a9ea741-b859-483e-9e3e-7971fb921d5e</guid><layout_id>1</layout_id><secret>false</secret><sortkey>8.988465674311579E307</sortkey><textlength>318</textlength><textlength_mm>0</textlength_mm><total_textlength>334</total_textlength><updated_date>2019-07-09T09:14:27+02:00</updated_date><updated_user_id cellular="0738294805" email="sofia.sundstrom@tt.se" firstName="Sofia" id="739" initials="ssu" lastName="Sundström/TT">Sofia Sundström/TT</updated_user_id><data><npdoc xmlns="http://www.infomaker.se/npdoc/2.1" version="2.1" xml:lang="sv"><headline><p>Fakta: Midsommar</p></headline><body><p>Originaltitel: Midsommar</p><p>Genre: Skräckfilm</p><p>Regi: Ari Aster</p><p>Skådespelare: Florence Pugh, Jack Reynor, William Jackson Harper, Vilhelm Blomgren, Will Poulter, Liv Mjönes, Anna Åström, Julia Ragnarsson, Isabelle Grill, Louise Peterhoff, Björn Andrésen, Gunnel Fred, Anki Larsson.</p><p>Längd: 140 minuter</p><p>Åldersgräns: 15 år</p><p>Betyg: 5</p></body></npdoc></data></articlepart></articleparts></article></npexchange>',
    person: [{
      name: "Ari Aster",
      scheme: "http://tt.se/spec/person/1.0"
    }],
    subject: [{
      code: "20000005",
      name: "Film",
      rel: "classifies",
      scheme: "http://tt.se/spec/subref/1.0"
    }, {
      code: "01000000",
      name: "Konst, kultur och nöje",
      rel: "classifies",
      scheme: "http://tt.se/spec/subref/1.0"
    }],
    place: [{
      scheme: "http://tt.se/spec/place/1.0",
      geometry_geojson: {
        coordinates: [18.643501, 60.128161],
        type: "Point"
      },
      name: "Sverige"
    }],
    byline: "Gunnar Rehlin/TT",
    headline: "Filmrecension: Mästerlig midsommarskräck",
    slug: "midsommar",
    bylines: [{
      byline: "Gunnar Rehlin/TT",
      firstname: "Gunnar",
      lastname: "Rehlin",
      role: "",
      email: "",
      jobtitle: "",
      phone: "",
      initials: "",
      affiliation: "TT"
    }, {
      byline: "",
      firstname: "",
      lastname: "",
      role: "Ansvarig",
      email: "",
      internal: "true",
      jobtitle: "",
      phone: "",
      initials: "krv",
      affiliation: "TT"
    }, {
      byline: "",
      firstname: "",
      lastname: "",
      role: "Redigering",
      email: "",
      internal: "true",
      jobtitle: "",
      phone: "",
      initials: "ssu",
      affiliation: "TT"
    }, {
      byline: "Nordisk Film /TT",
      firstname: "Nordisk Film",
      lastname: "",
      role: "Fotograf",
      email: "",
      jobtitle: "",
      phone: "",
      initials: "",
      affiliation: "TT"
    }, {
      byline: "Nordisk film /TT",
      firstname: "Nordisk film",
      lastname: "",
      role: "Fotograf",
      email: "",
      jobtitle: "",
      phone: "",
      initials: "",
      affiliation: "TT"
    }],
    _matchObject: {
      "npdoc.name": ["midsommar"],
      "npdoc.kundarea": [],
      "npdoc.article_part_type_id": ["Artikel", "Fakta"],
      "npdoc.department_id": ["Nyheter"],
      "npdoc.section_id": ["Nöje och Kultur"],
      "npdoc.texttyp": ["PUBL"],
      "npdoc.article_type_id": ["RECENSION"],
      "npdoc.webbprio": ["3"],
      "npdoc.source": "TT",
      "npdoc.printpm": "",
      "ttninjs.slug": "midsommar",
      "ttninjs.subject": ["20000005", "01000000"],
      "ttninjs.person": ["Ari Aster"]
    },
    revisions: [{
      uri: "http://tt.se/media/text/190709-midsommar-1003001",
      slug: "midsommar"
    }],
    _associations: [{
      byline: "Nordisk Film",
      description_text: 'Skräckfilmen "Midsommar" följer en hednisk sekt i Hälsingland. Pressbild.',
      mimetype: "image/jpeg",
      representationtype: "incomplete",
      type: "picture",
      uri: "http://tt.se/media/image/sdltdc7fdc8",
      renditions: {
        r00: {
          usage: "Hires",
          variant: "Normal",
          mimetype: "image/jpeg",
          href: "http://scanpix.no/seno/senoeks.cgi?/M/Q_/nl/io43/transit/tdc7fdc8.jpg",
          sizeinbytes: 3524373,
          width: 6e3,
          height: 4e3,
          printsize: 72e6
        },
        r01: {
          usage: "Preview",
          variant: "Normal",
          mimetype: "image/jpeg",
          href: "http://scanpix.no/previews2/td/c/7f/tdc7fdc8.jpg",
          sizeinbytes: 257745,
          width: 1024,
          height: 683
        },
        r02: {
          usage: "Preview",
          variant: "Watermark",
          mimetype: "image/jpeg",
          href: "http://scanpix.no/previews2/td/c/7f/w_sw_tdc7fdc8.jpg",
          width: 1024,
          height: 683
        },
        r03: {
          usage: "Thumbnail",
          variant: "Normal",
          mimetype: "image/jpeg",
          href: "http://preview.scanpix.no/thumbs2/td/c/7f/tdc7fdc8.jpg",
          sizeinbytes: 29730,
          width: 256,
          height: 171
        }
      }
    }, {
      byline: "Nordisk film",
      description_text: "Christian (Jack Reynor) och hans flickvän Dani (Florence Pugh) håller på att tappa gnistan i sitt förhållande, något som ställs på sin spets när de besöker Sverige och träffar en särskilt brutal midsommar-sekt. Pressbild.",
      mimetype: "image/jpeg",
      representationtype: "incomplete",
      type: "picture",
      uri: "http://tt.se/media/image/sdltdc6f543",
      renditions: {
        r00: {
          usage: "Hires",
          variant: "Normal",
          mimetype: "image/jpeg",
          href: "http://scanpix.no/seno/senoeks.cgi?/M/Q_/nl/io28/sp_04/tdc6f543.jpg",
          sizeinbytes: 579683,
          width: 2580,
          height: 1720,
          printsize: 13312800
        },
        r01: {
          usage: "Preview",
          variant: "Normal",
          mimetype: "image/jpeg",
          href: "http://scanpix.no/previews2/td/c/6f/tdc6f543.jpg",
          sizeinbytes: 195469,
          width: 1024,
          height: 683
        },
        r02: {
          usage: "Preview",
          variant: "Watermark",
          mimetype: "image/jpeg",
          href: "http://scanpix.no/previews2/td/c/6f/w_sw_tdc6f543.jpg",
          width: 1024,
          height: 683
        },
        r03: {
          usage: "Thumbnail",
          variant: "Normal",
          mimetype: "image/jpeg",
          href: "http://preview.scanpix.no/thumbs2/td/c/6f/tdc6f543.jpg",
          sizeinbytes: 23128,
          width: 256,
          height: 171
        }
      }
    }],
    _subject: ["20000005", "01000000"],
    _person: ["Ari Aster"],
    _place: ["Sverige"],
    _keywords_suggest: {
      input: ["Film", "Konst, kultur och nöje", "Ari Aster", "Sverige"]
    },
    _byline_suggest: {
      input: "GUNNAR REHLIN"
    },
    _geometry: {
      coordinates: [18.643501, 60.128161],
      type: "Point"
    },
    _search_term_suggest: {
      input: ["filmrecension mästerlig midsommarskräck", "film", "konst kultur och nöje", "ari aster", "sverige", "den", "svenska", "sommartraditionen", "perverteras", "av", "en", "hednisk", "sekt", "som", "vittrar", "blod", "i", "midnattssolen", "hereditary", "var", "inte", "bara", "års", "bästa", "skräckfilm", "ari", "asters", "långfilmsregidebut", "var", "också", "en", "av", "förra", "årets", "bästa", "filmer", "över", "huvud", "taget", "förväntningarna"]
    },
    _place_suggest: {
      input: ["sverige"]
    },
    _weekday: "tue",
    product: [{
      code: "TTNOJKUL",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Kultur och nöje"
    }, {
      code: "TTREC",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Recension"
    }, {
      code: "TWNOJ",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Webb kultur och nöje"
    }, {
      code: "TTNOJKUL0",
      name: "Arkiv",
      scheme: "http://tt.se/spec/product/1.0"
    }, {
      code: "TTREC0",
      name: "Arkiv",
      scheme: "http://tt.se/spec/product/1.0"
    }, {
      code: "TWNOJ0",
      name: "Arkiv",
      scheme: "http://tt.se/spec/product/1.0"
    }],
    _product: ["TTNOJKUL", "TTREC", "TWNOJ", "TTNOJKUL0", "TTREC0", "TWNOJ0"],
    _ident: ["1003001", "190709-midsommar-1003001"],
    datetime: "2019-07-09T09:15:33+02:00",
    _tstamp: "2019-07-09T09:15:33+02:00",
    addendum: [],
    sector: "KLT"
  },
  Wm = {
    type: "picture",
    mimetype: "image/jpeg",
    representationtype: "complete",
    pubstatus: "commissioned",
    copyrightholder: "TT Nyhetsbyrån",
    product: [{
      code: "FOTO",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Foto"
    }, {
      code: "FOSDLTWO",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Foto SDL2"
    }, {
      code: "FOUPPD",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Foto Uppdrag"
    }, {
      code: "FOHAND",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Foto Handout"
    }, {
      code: "FOTT",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Foto TT"
    }, {
      code: "FOKULTT",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Foto TT Kultur & nöje"
    }, {
      code: "FOKUL",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Foto Kultur & nöje"
    }, {
      code: "FOGNRE",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Foto Genre"
    }, {
      code: "FOGNREKUL",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Foto Genre Kultur & nöje"
    }, {
      code: "FONOR",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Foto Nordiskt"
    }, {
      code: "FOSO",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Foto Sociala medier"
    }, {
      code: "FOTO0",
      name: "Arkiv",
      scheme: "http://tt.se/spec/product/1.0"
    }, {
      code: "FOHAND0",
      name: "Arkiv",
      scheme: "http://tt.se/spec/product/1.0"
    }],
    place: [{
      name: "STOCKHOLM",
      rel: "city",
      scheme: "http://tt.se/spec/place/1.0"
    }, {
      name: "SVERIGE",
      rel: "country",
      scheme: "http://tt.se/spec/place/1.0"
    }],
    renditions: {
      r00: {
        usage: "Hires",
        variant: "Normal",
        mimetype: "image/jpeg",
        href: "https://beta.tt.se/media/image/sdlejSgPSOmiEE_NormalHires.jpg",
        sizeinbytes: 3784156,
        width: 5337,
        height: 3558
      },
      r01: {
        usage: "Preview",
        variant: "Normal",
        mimetype: "image/jpeg",
        href: "https://beta.tt.se/media/image/sdlejSgPSOmiEE_NormalPreview.jpg",
        sizeinbytes: 446567,
        width: 1024,
        height: 683
      },
      r02: {
        usage: "Preview",
        variant: "Watermark",
        mimetype: "image/jpeg",
        href: "https://beta.tt.se/media/image/sdlejSgPSOmiEE_WatermarkPreview.jpg",
        sizeinbytes: 446567,
        width: 1024,
        height: 683
      },
      r03: {
        usage: "Thumbnail",
        variant: "Normal",
        mimetype: "image/jpeg",
        href: "https://thumbnail.tt.se/media/image/sdlejSgPSOmiEE_NormalThumbnail.jpg",
        sizeinbytes: 37876,
        width: 256,
        height: 171
      }
    },
    profile: "PUBL",
    _ident: ["ejSgPSOmiEE", "sdlejSgPSOmiEE"],
    headline: "SNÖSÄTRA GRAFFITI",
    description_text: "BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG STOCKHOLM 20200730\r\nStora delar av Snösätra, ett slags fristad för graffiti, ska rivas. \r\nFoto: Erik Simander / TT / kod 11720\r\n\r\n**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**",
    byline: "Erik Simander/TT",
    commissioncode: "8888",
    commissionedby: ["16110"],
    source: "TT NYHETSBYRÅN",
    usageterms: "BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**",
    uri: "http://tt.se/media/image/sdlejSgPSOmiEE",
    date: "2020-07-30",
    versioncreated: "2020-07-30T00:00:00+00:00",
    versionstored: "2020-07-30T11:42:38+00:00",
    _tstamp: "2020-07-30T11:42:39+00:00",
    subject: [{
      code: "ttgenre",
      name: "ttgenre",
      scheme: "http://tt.se/spec/keyword/1.0"
    }, {
      code: "graffiti",
      name: "graffiti",
      scheme: "http://tt.se/spec/keyword/1.0"
    }, {
      code: "snösätra",
      name: "snösätra",
      scheme: "http://tt.se/spec/keyword/1.0"
    }],
    _matchObject: {
      "sdl.primary": !1,
      "sdl.originalFilename": "ERSI-20200730-00498.jpg",
      "sdl.dateArchived": "2020-07-30T11:42:38.766562Z",
      "sdl.archivedBy": "sdl-importer-main-398-jwxgj",
      "sdl.credit": "TT NYHETSBYRÅN",
      "sdl.status": "visible",
      "sdl.dateCreated": {
        date: "2020-07-30T11:07:39",
        precision: "SECOND"
      },
      "sdl.headline": "WEB_INRIKES",
      "sdl.source": "TT NYHETSBYRÅN",
      "sdl.title": "SNÖSÄTRA GRAFFITI",
      "sdl.instructions": "BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**",
      "sdl.description": "BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG STOCKHOLM 20200730\r\nStora delar av Snösätra, ett slags fristad för graffiti, ska rivas. \r\nFoto: Erik Simander / TT / kod 11720\r\n\r\n**BILDEN FÅR ENDAST PUBLICERAS TILLSAMMANS MED TT:S URSPRUNGLIGA TEXT OCH FÅR INTE ÅTERANVÄNDAS I ANDRA SAMMANHANG**",
      "sdl.creator": "Erik Simander/TT",
      "sdl.creditLine": "TT NYHETSBYRÅN",
      "sdl.category": "ACE",
      "sdl.supplementalCategory": "ttplugin",
      "sdl.keywords": ["ttgenre", "graffiti", "snösätra"],
      "sdl.city": "STOCKHOLM",
      "sdl.countryName": "SVERIGE",
      "sdl.commissionCode": "8888",
      "sdl.assets": [{
        fileType: "PREVIEW_256",
        size: {
          width: 256,
          height: 171
        },
        fileSize: 37876,
        mimeType: "image/jpeg"
      }, {
        fileType: "PREVIEW_512",
        size: {
          width: 512,
          height: 342
        },
        fileSize: 132481,
        mimeType: "image/jpeg"
      }, {
        fileType: "PREVIEW_1024",
        size: {
          width: 1024,
          height: 683
        },
        fileSize: 446567,
        mimeType: "image/jpeg"
      }, {
        fileType: "HIGHRES_1",
        size: {
          width: 5337,
          height: 3558
        },
        fileSize: 3784156,
        mimeType: "image/jpeg"
      }],
      "sdl.exportInfo": [{
        timestamp: "2020-07-30T12:26:40.561+0000",
        username: "metasweden",
        originalUsernames: ["16110"],
        type: "HIGHRES_1",
        accessType: "DOWNLOAD",
        data: {
          userId: 30651,
          remoteIp: "34.255.210.172",
          targetType: "HTTP"
        }
      }],
      "sdl.bylineTitle": "8888",
      "sdl.mediaType": "image",
      "sdl.mediaId": "ejSgPSOmiEE",
      "sdl.refPtr": "ejSgPSOmiEE"
    },
    _subject: ["ttgenre", "graffiti", "snösätra"],
    _place: ["STOCKHOLM", "SVERIGE"],
    _keywords_suggest: {
      input: ["ttgenre", "graffiti", "snösätra", "STOCKHOLM", "SVERIGE"]
    },
    _byline_suggest: {
      input: "ERIK SIMANDER"
    },
    _search_term_suggest: {
      input: ["snösätra graffiti", "ttgenre", "graffiti", "snösätra", "stockholm", "sverige", "bilden", "får", "endast", "publiceras", "tillsammans", "med", "tts", "ursprungliga", "text", "och", "får", "inte", "återanvändas", "i", "andra", "sammanhang", "stockholm", "stora", "delar", "av", "snösätra", "ett", "slags", "fristad", "för", "graffiti", "ska", "rivas", "foto", "erik", "simander", "tt", "kod", "bilden", "får", "endast", "publiceras", "tillsammans", "med", "tts", "ursprungliga", "text", "och", "får", "inte", "återanvändas", "i", "andra", "sammanhang"]
    },
    _place_suggest: {
      input: ["stockholm", "sverige"]
    },
    _weekday: "thu",
    _product: ["FOTO", "FOSDLTWO", "FOUPPD", "FOHAND", "FOTT", "FOKULTT", "FOKUL", "FOGNRE", "FOGNREKUL", "FONOR", "FOSO", "FOTO0", "FOHAND0"]
  },
  Xm = {
    uri: "http://tt.se/media/event/03C99854-2B4A-418D-98B6-A50FE4888FD4",
    type: "event",
    originaltransmissionreference: "03C99854-2B4A-418D-98B6-A50FE4888FD4",
    charcount: 39,
    mimetype: "text/html",
    representationtype: "complete",
    sector: "INR",
    profile: "DATA",
    version: "1",
    versioncreated: "2020-05-15T15:01:16+02:00",
    job: "",
    pubstatus: "usable",
    copyrightholder: "TT",
    week: 21,
    language: "sv",
    urgency: 9,
    source: "TT",
    date: "2020-05-24",
    enddate: "2020-05-24",
    description_text: "Trav: Lottning till Elitloppet (17.30).",
    body_text: "Trav: Lottning till Elitloppet (17.30).",
    subject: [{
      code: "15000000",
      name: "Sport",
      rel: "classifies",
      scheme: "http://tt.se/spec/subref/1.0/"
    }, {
      rel: "eventtype",
      scheme: "http://tt.se/spec/eventtype/1.1/",
      code: "12",
      name: "Sport"
    }],
    organisation: [{
      name: "Elitloppet",
      scheme: "http://tt.se/spec/Organisation/1.0/"
    }],
    object: [{
      name: "Elitloppet Trav",
      scheme: "http://tt.se/spec/object/1.0/"
    }],
    headline: "Trav: Lottning till Elitloppet",
    event: [{
      scheme: "http://tt.se/spec/event/text/1.0/",
      name: "Week of planned activity",
      code: "21",
      rel: "Week"
    }],
    slug: "",
    body_html5: '<html><body><article><section><h1>Trav: Lottning till Elitloppet</h1><div class="dat"><span class="vignette">S&#xF6;ndag 24 Maj 2020</span><span class="source">TT</span></div><div class="bodytext"><p>Trav: Lottning till Elitloppet (17.30).</p></div></section></article></body></html>',
    _matchObject: {
      "planning.code": "event",
      "imnml.name": "",
      "imnml.kundarea": [],
      "imnml.texttyp": ["INFO"],
      "imnml.section": ["INR"],
      "imnml.department": ["Nyheter"],
      "imnml.webbprio": ["0"],
      "imnml.source": "TT",
      "ttninjs.slug": "",
      "ttkal.date": "2020-05-24",
      "ttkal.external": !0
    },
    body_event: {
      arena: "",
      address: "",
      organizer: "",
      organizerurl: "",
      organizerphone: "",
      organizermail: "",
      organizeraddress: "",
      organizercity: "",
      organizercountry: "",
      eventtype: "Sport",
      eventtype_text: "Sport",
      accreditation: "",
      createddate: "2020-05-14T03:05:08+02:00",
      changeddate: "2020-05-15T05:05:44+02:00"
    },
    body_richhtml5: '<![CDATA[<html><body><article><section><h1>Trav: Lottning till Elitloppet</h1><div class="dat"><span class="vignette">S&#xF6;ndag 24 Maj 2020</span><span class="source">TT</span></div><div class="bodytext"><p>Trav: Lottning till Elitloppet (17.30).</p></div></section></article></body></html>]]>',
    _tstamp: "2020-05-15T15:01:16+02:00",
    fixture: [],
    _subject: ["15000000", "12"],
    _organisation: ["Elitloppet"],
    _object: ["Elitloppet Trav"],
    _event: ["21"],
    _keywords_suggest: {
      input: ["Week of planned activity"]
    },
    _search_term_suggest: {
      input: ["trav lottning till elitloppet", "sport", "sport", "elitloppet", "elitloppet trav", "week of planned activity", "trav", "lottning", "till", "elitloppet"]
    },
    _weekday: "sun",
    product: [{
      code: "KAL",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Kalender"
    }, {
      code: "KLSPTU",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Kalender Sport Utrikes"
    }],
    _product: ["KAL", "KLSPTU"],
    _ident: ["03C99854-2B4A-418D-98B6-A50FE4888FD4"]
  },
  Gm = {
    uri: "http://tt.se/media/job/cf45bb63-48fe-4fad-96fb-0015c0c43d1b",
    type: "planning",
    originaltransmissionreference: "cf45bb63-48fe-4fad-96fb-0015c0c43d1b",
    charcount: 0,
    mimetype: "text/html",
    representationtype: "complete",
    sector: "INR",
    profile: "INFO",
    version: "2",
    versioncreated: "2020-05-14T10:47:40+02:00",
    job: "cf45bb63-48fe-4fad-96fb-0015c0c43d1b",
    pubstatus: "usable",
    copyrightholder: "TT",
    week: 20,
    language: "sv",
    urgency: 3,
    source: "TT",
    date: "2020-05-14",
    enddate: "2020-05-14",
    datetime: "2020-05-14T08:30:00+02:00",
    enddatetime: "2020-05-14T08:30:00+02:00",
    description_text: "",
    body_text: "",
    subject: [{
      code: "06000000",
      name: "Miljö och natur",
      rel: "classifies",
      scheme: "http://tt.se/spec/subref/1.0/"
    }],
    headline: "Ängsplantering för biologisk mångfald",
    event: [{
      scheme: "http://tt.se/spec/event/text/1.0/",
      name: "Untitled",
      code: "947E78E9-EEA9-4CA8-8FCD-2E404523D306",
      rel: "Event"
    }],
    slug: "",
    body_html5: '<html><body><article><section><h1>&#xC4;ngsplantering f&#xF6;r biologisk m&#xE5;ngfald</h1><div class="dat"><span class="vignette">Torsdag 14 Maj 2020, klockan 08:30</span><span class="source">TT</span></div><div class="bodytext"><p/></div></section></article></body></html>',
    _matchObject: {
      "planning.code": ["ny"],
      "imnml.name": [""],
      "imnml.kundarea": [],
      "imnml.texttyp": ["INFO"],
      "imnml.section": ["INR"],
      "imnml.department": ["Nyheter"],
      "imnml.webbprio": ["0"],
      "imnml.source": "TT",
      "imnml.etikett": "",
      "ttninjs.slug": ""
    },
    body_richhtml5: '<![CDATA[<html><body><article><section><h1>&#xC4;ngsplantering f&#xF6;r biologisk m&#xE5;ngfald</h1><div class="dat"><span class="vignette">Torsdag 14 Maj 2020, klockan 08:30</span><span class="source">TT</span></div><div class="bodytext"><p/></div></section></article></body></html>]]>',
    assignments: {},
    _tstamp: "2020-05-14T10:47:40+02:00",
    fixture: [],
    _subject: ["06000000"],
    _event: ["947E78E9-EEA9-4CA8-8FCD-2E404523D306"],
    _keywords_suggest: {
      input: ["Untitled"]
    },
    _search_term_suggest: {
      input: ["ängsplantering för biologisk mångfald", "miljö och natur", "untitled"]
    },
    _weekday: "thu",
    product: [{
      code: "PLNNY",
      scheme: "http://tt.se/spec/product/1.0",
      name: "Planering nyheter"
    }],
    _product: ["PLNNY"],
    _ident: ["cf45bb63-48fe-4fad-96fb-0015c0c43d1b"]
  },
  Vm = {
    sys: {
      space: {
        sys: {
          type: "Link",
          linkType: "Space",
          id: "qkrg69mv1uhf"
        }
      },
      id: "5o2Gy0X3utKuNv0B8LNZq9",
      type: "Entry",
      createdAt: "2020-05-30T21:17:33.350Z",
      updatedAt: "2020-06-29T14:41:37.698Z",
      environment: {
        sys: {
          id: "master",
          type: "Link",
          linkType: "Environment"
        }
      },
      revision: 7,
      contentType: {
        sys: {
          type: "Link",
          linkType: "ContentType",
          id: "sitemap"
        }
      },
      locale: "sv"
    },
    fields: {
      slug: "main2",
      title: "TT Better",
      menu: [{
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "BqKLJonlsGrz4cWGR5JzM",
          type: "Entry",
          createdAt: "2020-02-13T13:41:52.308Z",
          updatedAt: "2020-05-30T19:23:39.397Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 2,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Nyheter",
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "12XwTqGFFuvOQ7MQkmMnC6",
              type: "Entry",
              createdAt: "2020-02-13T13:37:50.822Z",
              updatedAt: "2020-07-08T10:05:17.630Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 6,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Nyheter",
              url: "/om/nyheter",
              image: {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "49Ws0JQHnWzz4Lg0N0RRd1",
                  type: "Asset",
                  createdAt: "2020-03-22T21:11:51.262Z",
                  updatedAt: "2020-06-02T19:06:43.583Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 2,
                  locale: "sv"
                },
                fields: {
                  title: "nyheter-noti200x200",
                  file: {
                    url: "//images.ctfassets.net/qkrg69mv1uhf/49Ws0JQHnWzz4Lg0N0RRd1/18b19337304094297ca3a70554ca33ea/news-ikon-img.jpg",
                    details: {
                      size: 30557,
                      image: {
                        width: 400,
                        height: 400
                      }
                    },
                    fileName: "news-ikon-img.jpg",
                    contentType: "image/jpeg"
                  }
                }
              },
              subheader: "Nyheter från TT",
              linktype: "internal"
            }
          }],
          menu: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "79s01TXJ7o7n6bfW4nPnbV",
              type: "Entry",
              createdAt: "2020-05-30T19:23:35.411Z",
              updatedAt: "2020-06-03T06:07:13.426Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 4,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "menu"
                }
              },
              locale: "sv"
            },
            fields: {
              title: "Nyheter sub",
              link: [{
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "2aCsE78UkrLt4ibBpiQDB5",
                  type: "Entry",
                  createdAt: "2020-06-02T18:17:39.454Z",
                  updatedAt: "2020-06-25T08:39:46.030Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 4,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "link"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  text: "Nyhetstjänsten",
                  url: "/om/nyheter/nyhetstjansten",
                  subheader: "Sub nyheter"
                }
              }, {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "5tmdl3hJsofEpNXpqIh9GA",
                  type: "Entry",
                  createdAt: "2020-05-30T19:23:31.106Z",
                  updatedAt: "2020-05-30T19:23:31.106Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 1,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "link"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  text: "Bevakning",
                  url: "/om/nyheter/bevakning"
                }
              }, {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "3pnrhEclUw1b7oXNLE3Aj6",
                  type: "Entry",
                  createdAt: "2020-06-03T06:06:25.165Z",
                  updatedAt: "2020-06-03T06:11:04.893Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 2,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "link"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  text: "Live",
                  url: "/om/nyheter/live"
                }
              }]
            }
          }]
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "3CqvYy6ZuxX7nsVxKwHwsj",
          type: "Entry",
          createdAt: "2020-02-13T13:43:15.329Z",
          updatedAt: "2020-05-29T15:12:32.806Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 2,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Bild",
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "7uUzYSmpu87qTbTVlism84",
              type: "Entry",
              createdAt: "2020-02-13T13:42:48.046Z",
              updatedAt: "2020-07-08T10:05:34.542Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 10,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Bild",
              url: "/om/bild",
              image: {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "6R5iKV1ZMwvBgk6xAZUbiR",
                  type: "Asset",
                  createdAt: "2020-03-22T21:12:36.076Z",
                  updatedAt: "2020-06-02T19:16:50.347Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 2,
                  locale: "sv"
                },
                fields: {
                  title: "bild-noti200x200",
                  file: {
                    url: "//images.ctfassets.net/qkrg69mv1uhf/6R5iKV1ZMwvBgk6xAZUbiR/59c3de9613c278a658e6d3db7d1fefaf/bild-1-ikon.jpg",
                    details: {
                      size: 30367,
                      image: {
                        width: 398,
                        height: 398
                      }
                    },
                    fileName: "bild-1-ikon.jpg",
                    contentType: "image/jpeg"
                  }
                }
              },
              subheader: "Foto, video och grafik",
              linktype: "internal"
            }
          }],
          menu: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "3LxX2RZwpGzDTtKCH8id8J",
              type: "Entry",
              createdAt: "2020-05-29T15:12:26.965Z",
              updatedAt: "2020-06-29T12:35:10.665Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 8,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "menu"
                }
              },
              locale: "sv"
            },
            fields: {
              title: "BildSub",
              link: [{
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "1NsjEdI6HvUzbqCwNYV9ED",
                  type: "Entry",
                  createdAt: "2020-05-29T15:12:20.230Z",
                  updatedAt: "2020-07-08T15:54:47.305Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 5,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "link"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  text: "Kom i gång",
                  url: "/om/bild/kom-i-gang"
                }
              }, {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "2yiySQmrjYITLmqEM85Kto",
                  type: "Entry",
                  createdAt: "2020-06-02T13:12:40.710Z",
                  updatedAt: "2020-07-08T15:50:35.752Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 6,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "link"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  text: "Priser och paket",
                  url: "/om/bild/priser-och-paket"
                }
              }, {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "7dCCKwcx45DwRN3V8NeVrq",
                  type: "Entry",
                  createdAt: "2020-06-29T11:20:54.084Z",
                  updatedAt: "2020-06-29T11:31:48.784Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 2,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "link"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  text: "Boka fotograf",
                  url: "/om/bild/boka-fotograf"
                }
              }]
            }
          }]
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "7H3HHvdsGuulc1hs1wrVQi",
          type: "Entry",
          createdAt: "2020-02-13T13:44:06.278Z",
          updatedAt: "2020-02-13T13:44:06.278Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Via TT",
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "1hBkzkw3bjMa4SuQ1KtyXI",
              type: "Entry",
              createdAt: "2020-02-13T13:43:54.077Z",
              updatedAt: "2020-07-10T09:14:42.093Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 8,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Via TT",
              url: "/om/via-tt",
              image: {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "2OeyqIJTFfKeQ1haYTP6oE",
                  type: "Asset",
                  createdAt: "2020-03-04T15:17:56.691Z",
                  updatedAt: "2020-03-22T21:14:11.623Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 2,
                  locale: "sv"
                },
                fields: {
                  title: "lunch niceday howyougonnacomeonmtvwithhalfamoustache prematurebalding",
                  file: {
                    url: "//images.ctfassets.net/qkrg69mv1uhf/2OeyqIJTFfKeQ1haYTP6oE/4c9dfde4df0cd61f77399fee0db4a096/via-tt-noti200x200.jpg",
                    details: {
                      size: 5965,
                      image: {
                        width: 200,
                        height: 200
                      }
                    },
                    fileName: "via-tt-noti200x200.jpg",
                    contentType: "image/jpeg"
                  }
                }
              },
              subheader: "Ett enkelt pressverktyg",
              linktype: "internal"
            }
          }]
        }
      }],
      link: [{
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "880Wtkpa7KhSfkjq0pWOu",
          type: "Entry",
          createdAt: "2020-02-13T13:35:40.399Z",
          updatedAt: "2020-07-08T10:06:02.628Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 8,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "link"
            }
          },
          locale: "sv"
        },
        fields: {
          text: "Startsidan",
          url: "/",
          linktype: "internal"
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "5m0zwzNFHO1KDQJXTIFzdp",
          type: "Entry",
          createdAt: "2020-02-13T13:47:18.411Z",
          updatedAt: "2020-07-08T10:06:11.018Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 4,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "link"
            }
          },
          locale: "sv"
        },
        fields: {
          text: "Om TT",
          url: "/om/om-oss",
          linktype: "internal"
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "7dNwbGKXOq7pEkO7nGt3RI",
          type: "Entry",
          createdAt: "2020-02-13T13:48:20.539Z",
          updatedAt: "2020-07-08T10:06:20.893Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 11,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "link"
            }
          },
          locale: "sv"
        },
        fields: {
          text: "Produkter",
          url: "/om/produkter",
          linktype: "internal"
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "7lg6TY1ESGx8hQXHgcJEZK",
          type: "Entry",
          createdAt: "2020-02-13T13:49:12.133Z",
          updatedAt: "2020-02-13T13:49:12.133Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "link"
            }
          },
          locale: "sv"
        },
        fields: {
          text: "Karriär",
          url: "https://jobb.tt.se/",
          linktype: "external"
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "2uSK54RSW1mJ6sVRKezpIV",
          type: "Entry",
          createdAt: "2020-02-13T13:49:37.630Z",
          updatedAt: "2020-02-13T13:49:37.630Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "link"
            }
          },
          locale: "sv"
        },
        fields: {
          text: "Kundsupport",
          url: "https://support.tt.se/hc/sv",
          linktype: "external"
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "4Imeg81eTpzv7VqJHSDRww",
          type: "Entry",
          createdAt: "2020-02-13T13:50:03.060Z",
          updatedAt: "2020-02-13T13:50:03.060Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "link"
            }
          },
          locale: "sv"
        },
        fields: {
          text: "Kontakt",
          url: "https://tt.se/kontakt/",
          linktype: "internal"
        }
      }],
      footer: {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "8qPDDadi9EbLvBAUoQcRG",
          type: "Entry",
          createdAt: "2020-02-13T10:06:07.751Z",
          updatedAt: "2020-05-09T19:19:44.507Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 3,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "footer"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Wrapper footer",
          footer: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "4BGauFE8tQQKbfsk5H0ndD",
              type: "Entry",
              createdAt: "2020-02-13T10:05:06.545Z",
              updatedAt: "2020-05-28T13:42:22.226Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 6,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "footer"
                }
              },
              locale: "sv"
            },
            fields: {
              title: "Upper footer",
              menu: [{
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "omZkAt5xpg6MmkBHTrOyw",
                  type: "Entry",
                  createdAt: "2020-02-13T09:57:47.401Z",
                  updatedAt: "2020-06-02T17:08:09.789Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 6,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "menu"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  title: "Produkter",
                  header: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "6CAP5fKRUmri3Hqf0jszuw",
                      type: "Entry",
                      createdAt: "2020-02-13T09:53:27.132Z",
                      updatedAt: "2020-06-02T17:10:01.003Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 2,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "header"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      header: "Produkter"
                    }
                  }],
                  link: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "3bjcbB0LZ5JeTAnQt7dDfE",
                      type: "Entry",
                      createdAt: "2020-02-13T09:54:36.669Z",
                      updatedAt: "2020-05-30T15:52:43.265Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 2,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Nyheter",
                      url: "/om/nyheter"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "3JHQPEHCgQC9rWg5WxCUv",
                      type: "Entry",
                      createdAt: "2020-02-13T09:54:57.604Z",
                      updatedAt: "2020-02-13T09:54:57.604Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Bildbank",
                      url: "https://tt.se/bild/"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "6yxBdsPgD4DBTM4AuKfRZE",
                      type: "Entry",
                      createdAt: "2020-02-13T09:55:15.294Z",
                      updatedAt: "2020-02-13T09:55:15.294Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Via TT",
                      url: "https://tt.se/via-tt/"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "2oYfsbhQ9Y3kYo1qGoEYJo",
                      type: "Entry",
                      createdAt: "2020-02-13T09:57:33.476Z",
                      updatedAt: "2020-06-17T12:07:10.766Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 3,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Fler produkter",
                      url: "/om/produkter"
                    }
                  }]
                }
              }, {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "6rBJKtbW4aHOdomRLxSOBZ",
                  type: "Entry",
                  createdAt: "2020-02-13T10:08:38.402Z",
                  updatedAt: "2020-02-13T10:08:38.402Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 1,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "menu"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  title: "Beställ",
                  header: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "3joBMqjRbXaKlLhLgXv2B6",
                      type: "Entry",
                      createdAt: "2020-02-13T10:06:34.668Z",
                      updatedAt: "2020-02-13T10:06:34.668Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "header"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      header: "Beställ"
                    }
                  }],
                  link: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "1VcPdJDRJ2zVQPtl1ueO2H",
                      type: "Entry",
                      createdAt: "2020-02-13T10:06:59.723Z",
                      updatedAt: "2020-02-13T10:06:59.723Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Boka fotograf",
                      url: "https://tt.se/boka-fotograf/"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "3kbg5UyLrNPFeICMLhXpFT",
                      type: "Entry",
                      createdAt: "2020-02-13T10:07:54.132Z",
                      updatedAt: "2020-06-25T08:41:30.840Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 3,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Nyhetstjänsten",
                      url: "/om/nyheter/nyhetstjansten"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "Pf9eVN8cghjSxHg94Io6V",
                      type: "Entry",
                      createdAt: "2020-02-13T10:08:16.308Z",
                      updatedAt: "2020-02-13T10:08:16.308Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Grafikuppdrag",
                      url: "https://tt.se/infografik/"
                    }
                  }]
                }
              }, {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "7CfiEwMzjqOUcNiRHiKwS0",
                  type: "Entry",
                  createdAt: "2020-02-13T10:10:38.841Z",
                  updatedAt: "2020-07-09T09:19:35.195Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 4,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "menu"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  title: "Företag",
                  header: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "39Rx4F4lPSnqZxeMSHkLx8",
                      type: "Entry",
                      createdAt: "2020-02-13T10:08:54.647Z",
                      updatedAt: "2020-02-13T10:08:54.647Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "header"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      header: "Företag"
                    }
                  }],
                  link: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "1qxGAkhEEBbyqruuTrZi6i",
                      type: "Entry",
                      createdAt: "2020-02-13T10:09:14.864Z",
                      updatedAt: "2020-06-29T14:54:19.571Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 2,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Om TT",
                      url: "/om/om-oss"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "4we3xzvo83af3shcSlYPmL",
                      type: "Entry",
                      createdAt: "2020-02-13T10:09:40.282Z",
                      updatedAt: "2020-02-13T10:09:40.282Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Karriär",
                      url: "https://tt.se/om-oss/lediga-jobb/"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "5kYihAZMRu63pusy9RFEC1",
                      type: "Entry",
                      createdAt: "2020-07-09T08:28:53.483Z",
                      updatedAt: "2020-07-09T08:47:23.992Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 2,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Sociala medier",
                      url: "/om/sociala-medier",
                      linktype: "internal"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "623QU6R9q1XbbkPfZHabno",
                      type: "Entry",
                      createdAt: "2020-02-13T10:10:08.766Z",
                      updatedAt: "2020-02-13T10:10:08.766Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Blogg",
                      url: "https://tt.se/blogg/"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "4LoYohsrtBk0702dC6soov",
                      type: "Entry",
                      createdAt: "2020-02-13T10:10:30.610Z",
                      updatedAt: "2020-02-13T10:10:30.610Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Press",
                      url: "https://tt.se/press/"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "1pGatd1s56uUHVAV58D6Yv",
                      type: "Entry",
                      createdAt: "2020-06-04T09:01:10.895Z",
                      updatedAt: "2020-06-04T09:01:10.895Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Utvecklare",
                      url: "https://developer.tt.se"
                    }
                  }]
                }
              }, {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "RFKGKk6bFeZs1Ap0hWnAh",
                  type: "Entry",
                  createdAt: "2020-02-13T10:13:30.245Z",
                  updatedAt: "2020-07-01T07:24:06.508Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 4,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "menu"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  title: "Support",
                  header: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "6x5RMDWYzQdavkEI2o6l4O",
                      type: "Entry",
                      createdAt: "2020-02-13T10:10:54.743Z",
                      updatedAt: "2020-02-13T10:10:54.743Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "header"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      header: "Support"
                    }
                  }],
                  link: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "1UvhTBqhAdpaBI7nzmHi7X",
                      type: "Entry",
                      createdAt: "2020-02-13T10:11:22.420Z",
                      updatedAt: "2020-02-13T10:11:22.420Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Kontakt",
                      url: "https://tt.se/kontakt/"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "56a7majAodifogG1kekBjt",
                      type: "Entry",
                      createdAt: "2020-02-13T10:11:58.479Z",
                      updatedAt: "2020-06-02T20:43:13.876Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 2,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Kundsupport",
                      url: "https://support.tt.se/hc/sv"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "6eQ7NNiiuBAEsGS0GKKXeY",
                      type: "Entry",
                      createdAt: "2020-02-13T10:12:42.852Z",
                      updatedAt: "2020-02-13T10:12:42.852Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Vanliga frågor",
                      url: "https://support.tt.se/hc/sv/categories/201931357-Vanliga-fr%C3%A5gor"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "7p2q1oZ6bbTN6YhRvhzCiG",
                      type: "Entry",
                      createdAt: "2020-07-01T07:23:57.403Z",
                      updatedAt: "2020-07-01T07:23:57.403Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "TT-språket",
                      url: "https://tt.se/tt-spraket/",
                      linktype: "external"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "7gmLSIiZSAzPhRTffBrSBK",
                      type: "Entry",
                      createdAt: "2020-04-21T13:38:00.577Z",
                      updatedAt: "2020-07-01T07:37:47.183Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 3,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Sajtkarta",
                      url: "/om/sajtkarta"
                    }
                  }]
                }
              }, {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "1gpBVdnst24xEsoyEzkUlZ",
                  type: "Entry",
                  createdAt: "2020-02-13T10:15:34.904Z",
                  updatedAt: "2020-04-21T13:39:01.712Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 2,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "menu"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  title: "Allmänna villkor",
                  header: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "54gGE75elq2QCLN7Yth4vr",
                      type: "Entry",
                      createdAt: "2020-02-13T10:14:12.906Z",
                      updatedAt: "2020-02-13T10:14:12.906Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "header"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      header: "Allmänna villkor"
                    }
                  }],
                  link: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "6vkbIbaSdTL0bLfbG6O7v6",
                      type: "Entry",
                      createdAt: "2020-04-21T13:38:52.115Z",
                      updatedAt: "2020-04-21T13:38:52.115Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Cookies",
                      url: "https://tt.se/"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "5kS4t6185m0WKoIefMrFcp",
                      type: "Entry",
                      createdAt: "2020-02-13T10:15:26.637Z",
                      updatedAt: "2020-02-13T10:15:26.637Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Sekretess och villkor",
                      url: "https://tt.se/gdpr/"
                    }
                  }]
                }
              }],
              slug: "upper"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "1zI9JCBh6S6D03lVRGqoNk",
              type: "Entry",
              createdAt: "2020-02-13T10:16:24.619Z",
              updatedAt: "2020-05-09T19:20:00.590Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 3,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "footer"
                }
              },
              locale: "sv"
            },
            fields: {
              title: "Bottom footer",
              menu: [{
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "1l9GCXIGrKePkMvbFedcJv",
                  type: "Entry",
                  createdAt: "2020-02-13T10:17:57.857Z",
                  updatedAt: "2020-02-13T10:17:57.857Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 1,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "menu"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  title: "Växel",
                  header: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "2sK7wZORNp6BhkfKHWmOXw",
                      type: "Entry",
                      createdAt: "2020-02-13T10:16:49.906Z",
                      updatedAt: "2020-02-13T10:16:49.906Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "header"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      header: "Växel"
                    }
                  }],
                  link: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "1S9JE057M31NyC0PMZYX58",
                      type: "Entry",
                      createdAt: "2020-02-13T10:17:50.425Z",
                      updatedAt: "2020-02-13T10:17:50.425Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "08-692 26 00"
                    }
                  }]
                }
              }, {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "6xHS4DETcSBYMuvgsZz4j",
                  type: "Entry",
                  createdAt: "2020-02-13T10:20:01.410Z",
                  updatedAt: "2020-02-13T10:20:01.410Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 1,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "menu"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  title: "Försäljning och support",
                  header: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "WoJP25LdXMhJdJJ9UQtBQ",
                      type: "Entry",
                      createdAt: "2020-02-13T10:18:15.310Z",
                      updatedAt: "2020-02-13T10:18:15.310Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "header"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      header: "Försäljning och support"
                    }
                  }],
                  link: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "1q4XOW9zCdSIdU3b0hoOPX",
                      type: "Entry",
                      createdAt: "2020-02-13T10:18:37.142Z",
                      updatedAt: "2020-02-13T10:18:37.142Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "08-692 26 00"
                    }
                  }, {
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "5apomgcGGxGPn5NSbHPtw",
                      type: "Entry",
                      createdAt: "2020-02-13T10:19:38.770Z",
                      updatedAt: "2020-02-13T10:19:38.770Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Skicka e-post",
                      url: "https://tt.se/kontakt/"
                    }
                  }]
                }
              }, {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "6ylYTpmvgChcth9YyRDBjU",
                  type: "Entry",
                  createdAt: "2020-02-13T10:21:20.346Z",
                  updatedAt: "2020-02-13T10:21:20.346Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 1,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "menu"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  title: "Tipsa redaktionen",
                  header: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "32hezsLn5eVf490FPfl9Mm",
                      type: "Entry",
                      createdAt: "2020-02-13T10:20:38.360Z",
                      updatedAt: "2020-02-13T10:20:38.360Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "header"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      header: "Tipsa redaktionen"
                    }
                  }],
                  link: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "4MAkaIGirguHW45ZsBcbCF",
                      type: "Entry",
                      createdAt: "2020-02-13T10:21:05.853Z",
                      updatedAt: "2020-02-13T10:21:05.853Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "Skicka e-post",
                      url: "https://tt.se/om-oss/kontakt/tipsa-oss/"
                    }
                  }]
                }
              }, {
                sys: {
                  space: {
                    sys: {
                      type: "Link",
                      linkType: "Space",
                      id: "qkrg69mv1uhf"
                    }
                  },
                  id: "78X9J3evdrenNYxIuMosNt",
                  type: "Entry",
                  createdAt: "2020-02-13T10:22:22.003Z",
                  updatedAt: "2020-02-13T10:22:22.003Z",
                  environment: {
                    sys: {
                      id: "master",
                      type: "Link",
                      linkType: "Environment"
                    }
                  },
                  revision: 1,
                  contentType: {
                    sys: {
                      type: "Link",
                      linkType: "ContentType",
                      id: "menu"
                    }
                  },
                  locale: "sv"
                },
                fields: {
                  title: "About us",
                  link: [{
                    sys: {
                      space: {
                        sys: {
                          type: "Link",
                          linkType: "Space",
                          id: "qkrg69mv1uhf"
                        }
                      },
                      id: "1GA5BBW3OkD9vqnPoK6P4p",
                      type: "Entry",
                      createdAt: "2020-02-13T10:22:17.241Z",
                      updatedAt: "2020-02-13T10:22:17.241Z",
                      environment: {
                        sys: {
                          id: "master",
                          type: "Link",
                          linkType: "Environment"
                        }
                      },
                      revision: 1,
                      contentType: {
                        sys: {
                          type: "Link",
                          linkType: "ContentType",
                          id: "link"
                        }
                      },
                      locale: "sv"
                    },
                    fields: {
                      text: "About us",
                      url: "https://tt.se/en/about-us/"
                    }
                  }]
                }
              }],
              slug: "bottom"
            }
          }],
          slug: "wrapper"
        }
      }
    }
  },
  Ym = [{
    sys: {
      space: {
        sys: {
          type: "Link",
          linkType: "Space",
          id: "qkrg69mv1uhf"
        }
      },
      id: "4BGauFE8tQQKbfsk5H0ndD",
      type: "Entry",
      createdAt: "2020-02-13T10:05:06.545Z",
      updatedAt: "2020-05-28T13:42:22.226Z",
      environment: {
        sys: {
          id: "master",
          type: "Link",
          linkType: "Environment"
        }
      },
      revision: 6,
      contentType: {
        sys: {
          type: "Link",
          linkType: "ContentType",
          id: "footer"
        }
      },
      locale: "sv"
    },
    fields: {
      title: "Upper footer",
      menu: [{
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "omZkAt5xpg6MmkBHTrOyw",
          type: "Entry",
          createdAt: "2020-02-13T09:57:47.401Z",
          updatedAt: "2020-06-02T17:08:09.789Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 6,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Produkter",
          header: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "6CAP5fKRUmri3Hqf0jszuw",
              type: "Entry",
              createdAt: "2020-02-13T09:53:27.132Z",
              updatedAt: "2020-06-02T17:10:01.003Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 2,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "header"
                }
              },
              locale: "sv"
            },
            fields: {
              header: "Produkter"
            }
          }],
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "3bjcbB0LZ5JeTAnQt7dDfE",
              type: "Entry",
              createdAt: "2020-02-13T09:54:36.669Z",
              updatedAt: "2020-05-30T15:52:43.265Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 2,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Nyheter",
              url: "/om/nyheter"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "3JHQPEHCgQC9rWg5WxCUv",
              type: "Entry",
              createdAt: "2020-02-13T09:54:57.604Z",
              updatedAt: "2020-02-13T09:54:57.604Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Bildbank",
              url: "https://tt.se/bild/"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "6yxBdsPgD4DBTM4AuKfRZE",
              type: "Entry",
              createdAt: "2020-02-13T09:55:15.294Z",
              updatedAt: "2020-02-13T09:55:15.294Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Via TT",
              url: "https://tt.se/via-tt/"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "2oYfsbhQ9Y3kYo1qGoEYJo",
              type: "Entry",
              createdAt: "2020-02-13T09:57:33.476Z",
              updatedAt: "2020-06-17T12:07:10.766Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 3,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Fler produkter",
              url: "/om/produkter"
            }
          }]
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "6rBJKtbW4aHOdomRLxSOBZ",
          type: "Entry",
          createdAt: "2020-02-13T10:08:38.402Z",
          updatedAt: "2020-02-13T10:08:38.402Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Beställ",
          header: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "3joBMqjRbXaKlLhLgXv2B6",
              type: "Entry",
              createdAt: "2020-02-13T10:06:34.668Z",
              updatedAt: "2020-02-13T10:06:34.668Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "header"
                }
              },
              locale: "sv"
            },
            fields: {
              header: "Beställ"
            }
          }],
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "1VcPdJDRJ2zVQPtl1ueO2H",
              type: "Entry",
              createdAt: "2020-02-13T10:06:59.723Z",
              updatedAt: "2020-02-13T10:06:59.723Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Boka fotograf",
              url: "https://tt.se/boka-fotograf/"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "3kbg5UyLrNPFeICMLhXpFT",
              type: "Entry",
              createdAt: "2020-02-13T10:07:54.132Z",
              updatedAt: "2020-06-25T08:41:30.840Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 3,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Nyhetstjänsten",
              url: "/om/nyheter/nyhetstjansten"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "Pf9eVN8cghjSxHg94Io6V",
              type: "Entry",
              createdAt: "2020-02-13T10:08:16.308Z",
              updatedAt: "2020-02-13T10:08:16.308Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Grafikuppdrag",
              url: "https://tt.se/infografik/"
            }
          }]
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "7CfiEwMzjqOUcNiRHiKwS0",
          type: "Entry",
          createdAt: "2020-02-13T10:10:38.841Z",
          updatedAt: "2020-07-09T09:19:35.195Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 4,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Företag",
          header: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "39Rx4F4lPSnqZxeMSHkLx8",
              type: "Entry",
              createdAt: "2020-02-13T10:08:54.647Z",
              updatedAt: "2020-02-13T10:08:54.647Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "header"
                }
              },
              locale: "sv"
            },
            fields: {
              header: "Företag"
            }
          }],
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "1qxGAkhEEBbyqruuTrZi6i",
              type: "Entry",
              createdAt: "2020-02-13T10:09:14.864Z",
              updatedAt: "2020-06-29T14:54:19.571Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 2,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Om TT",
              url: "/om/om-oss"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "4we3xzvo83af3shcSlYPmL",
              type: "Entry",
              createdAt: "2020-02-13T10:09:40.282Z",
              updatedAt: "2020-02-13T10:09:40.282Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Karriär",
              url: "https://tt.se/om-oss/lediga-jobb/"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "5kYihAZMRu63pusy9RFEC1",
              type: "Entry",
              createdAt: "2020-07-09T08:28:53.483Z",
              updatedAt: "2020-07-09T08:47:23.992Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 2,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Sociala medier",
              url: "/om/sociala-medier",
              linktype: "internal"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "623QU6R9q1XbbkPfZHabno",
              type: "Entry",
              createdAt: "2020-02-13T10:10:08.766Z",
              updatedAt: "2020-02-13T10:10:08.766Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Blogg",
              url: "https://tt.se/blogg/"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "4LoYohsrtBk0702dC6soov",
              type: "Entry",
              createdAt: "2020-02-13T10:10:30.610Z",
              updatedAt: "2020-02-13T10:10:30.610Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Press",
              url: "https://tt.se/press/"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "1pGatd1s56uUHVAV58D6Yv",
              type: "Entry",
              createdAt: "2020-06-04T09:01:10.895Z",
              updatedAt: "2020-06-04T09:01:10.895Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Utvecklare",
              url: "https://developer.tt.se"
            }
          }]
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "RFKGKk6bFeZs1Ap0hWnAh",
          type: "Entry",
          createdAt: "2020-02-13T10:13:30.245Z",
          updatedAt: "2020-07-01T07:24:06.508Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 4,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Support",
          header: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "6x5RMDWYzQdavkEI2o6l4O",
              type: "Entry",
              createdAt: "2020-02-13T10:10:54.743Z",
              updatedAt: "2020-02-13T10:10:54.743Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "header"
                }
              },
              locale: "sv"
            },
            fields: {
              header: "Support"
            }
          }],
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "1UvhTBqhAdpaBI7nzmHi7X",
              type: "Entry",
              createdAt: "2020-02-13T10:11:22.420Z",
              updatedAt: "2020-02-13T10:11:22.420Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Kontakt",
              url: "https://tt.se/kontakt/"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "56a7majAodifogG1kekBjt",
              type: "Entry",
              createdAt: "2020-02-13T10:11:58.479Z",
              updatedAt: "2020-06-02T20:43:13.876Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 2,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Kundsupport",
              url: "https://support.tt.se/hc/sv"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "6eQ7NNiiuBAEsGS0GKKXeY",
              type: "Entry",
              createdAt: "2020-02-13T10:12:42.852Z",
              updatedAt: "2020-02-13T10:12:42.852Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Vanliga frågor",
              url: "https://support.tt.se/hc/sv/categories/201931357-Vanliga-fr%C3%A5gor"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "7p2q1oZ6bbTN6YhRvhzCiG",
              type: "Entry",
              createdAt: "2020-07-01T07:23:57.403Z",
              updatedAt: "2020-07-01T07:23:57.403Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "TT-språket",
              url: "https://tt.se/tt-spraket/",
              linktype: "external"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "7gmLSIiZSAzPhRTffBrSBK",
              type: "Entry",
              createdAt: "2020-04-21T13:38:00.577Z",
              updatedAt: "2020-07-01T07:37:47.183Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 3,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Sajtkarta",
              url: "/om/sajtkarta"
            }
          }]
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "1gpBVdnst24xEsoyEzkUlZ",
          type: "Entry",
          createdAt: "2020-02-13T10:15:34.904Z",
          updatedAt: "2020-04-21T13:39:01.712Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 2,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Allmänna villkor",
          header: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "54gGE75elq2QCLN7Yth4vr",
              type: "Entry",
              createdAt: "2020-02-13T10:14:12.906Z",
              updatedAt: "2020-02-13T10:14:12.906Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "header"
                }
              },
              locale: "sv"
            },
            fields: {
              header: "Allmänna villkor"
            }
          }],
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "6vkbIbaSdTL0bLfbG6O7v6",
              type: "Entry",
              createdAt: "2020-04-21T13:38:52.115Z",
              updatedAt: "2020-04-21T13:38:52.115Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Cookies",
              url: "https://tt.se/"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "5kS4t6185m0WKoIefMrFcp",
              type: "Entry",
              createdAt: "2020-02-13T10:15:26.637Z",
              updatedAt: "2020-02-13T10:15:26.637Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Sekretess och villkor",
              url: "https://tt.se/gdpr/"
            }
          }]
        }
      }],
      slug: "upper"
    }
  }, {
    sys: {
      space: {
        sys: {
          type: "Link",
          linkType: "Space",
          id: "qkrg69mv1uhf"
        }
      },
      id: "1zI9JCBh6S6D03lVRGqoNk",
      type: "Entry",
      createdAt: "2020-02-13T10:16:24.619Z",
      updatedAt: "2020-05-09T19:20:00.590Z",
      environment: {
        sys: {
          id: "master",
          type: "Link",
          linkType: "Environment"
        }
      },
      revision: 3,
      contentType: {
        sys: {
          type: "Link",
          linkType: "ContentType",
          id: "footer"
        }
      },
      locale: "sv"
    },
    fields: {
      title: "Bottom footer",
      menu: [{
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "1l9GCXIGrKePkMvbFedcJv",
          type: "Entry",
          createdAt: "2020-02-13T10:17:57.857Z",
          updatedAt: "2020-02-13T10:17:57.857Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Växel",
          header: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "2sK7wZORNp6BhkfKHWmOXw",
              type: "Entry",
              createdAt: "2020-02-13T10:16:49.906Z",
              updatedAt: "2020-02-13T10:16:49.906Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "header"
                }
              },
              locale: "sv"
            },
            fields: {
              header: "Växel"
            }
          }],
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "1S9JE057M31NyC0PMZYX58",
              type: "Entry",
              createdAt: "2020-02-13T10:17:50.425Z",
              updatedAt: "2020-02-13T10:17:50.425Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "08-692 26 00"
            }
          }]
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "6xHS4DETcSBYMuvgsZz4j",
          type: "Entry",
          createdAt: "2020-02-13T10:20:01.410Z",
          updatedAt: "2020-02-13T10:20:01.410Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Försäljning och support",
          header: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "WoJP25LdXMhJdJJ9UQtBQ",
              type: "Entry",
              createdAt: "2020-02-13T10:18:15.310Z",
              updatedAt: "2020-02-13T10:18:15.310Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "header"
                }
              },
              locale: "sv"
            },
            fields: {
              header: "Försäljning och support"
            }
          }],
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "1q4XOW9zCdSIdU3b0hoOPX",
              type: "Entry",
              createdAt: "2020-02-13T10:18:37.142Z",
              updatedAt: "2020-02-13T10:18:37.142Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "08-692 26 00"
            }
          }, {
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "5apomgcGGxGPn5NSbHPtw",
              type: "Entry",
              createdAt: "2020-02-13T10:19:38.770Z",
              updatedAt: "2020-02-13T10:19:38.770Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Skicka e-post",
              url: "https://tt.se/kontakt/"
            }
          }]
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "6ylYTpmvgChcth9YyRDBjU",
          type: "Entry",
          createdAt: "2020-02-13T10:21:20.346Z",
          updatedAt: "2020-02-13T10:21:20.346Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "Tipsa redaktionen",
          header: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "32hezsLn5eVf490FPfl9Mm",
              type: "Entry",
              createdAt: "2020-02-13T10:20:38.360Z",
              updatedAt: "2020-02-13T10:20:38.360Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "header"
                }
              },
              locale: "sv"
            },
            fields: {
              header: "Tipsa redaktionen"
            }
          }],
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "4MAkaIGirguHW45ZsBcbCF",
              type: "Entry",
              createdAt: "2020-02-13T10:21:05.853Z",
              updatedAt: "2020-02-13T10:21:05.853Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "Skicka e-post",
              url: "https://tt.se/om-oss/kontakt/tipsa-oss/"
            }
          }]
        }
      }, {
        sys: {
          space: {
            sys: {
              type: "Link",
              linkType: "Space",
              id: "qkrg69mv1uhf"
            }
          },
          id: "78X9J3evdrenNYxIuMosNt",
          type: "Entry",
          createdAt: "2020-02-13T10:22:22.003Z",
          updatedAt: "2020-02-13T10:22:22.003Z",
          environment: {
            sys: {
              id: "master",
              type: "Link",
              linkType: "Environment"
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: "Link",
              linkType: "ContentType",
              id: "menu"
            }
          },
          locale: "sv"
        },
        fields: {
          title: "About us",
          link: [{
            sys: {
              space: {
                sys: {
                  type: "Link",
                  linkType: "Space",
                  id: "qkrg69mv1uhf"
                }
              },
              id: "1GA5BBW3OkD9vqnPoK6P4p",
              type: "Entry",
              createdAt: "2020-02-13T10:22:17.241Z",
              updatedAt: "2020-02-13T10:22:17.241Z",
              environment: {
                sys: {
                  id: "master",
                  type: "Link",
                  linkType: "Environment"
                }
              },
              revision: 1,
              contentType: {
                sys: {
                  type: "Link",
                  linkType: "ContentType",
                  id: "link"
                }
              },
              locale: "sv"
            },
            fields: {
              text: "About us",
              url: "https://tt.se/en/about-us/"
            }
          }]
        }
      }],
      slug: "bottom"
    }
  }],
  Km = '<newsMessage>\n\x3c!--  spec at http://tt.se/spec/newsml  --\x3e\n<header>\n<sent>2019-07-31T11:53:43+02:00</sent>\n<sender>tt.se</sender>\n<signal qcode="nmsig:atomic"/>\n</header>\n<itemSet>\n<packageItem guid="http://tt.se/media/text/190709-midsommar-1003001-pack" version="1" standard="NewsML-G2" standardversion="2.20" conformance="power" xml:lang="sv">\n<catalogRef href="http://www.iptc.org/std/catalog/catalog.IPTC-G2-Standards_24.xml"/>\n<catalogRef href="http://tt.se/spec/catalog/catalog.tt-g2.1_0.xml"/>\n<itemMeta>\n<itemClass qcode="ninat:text"/>\n<provider qcode="nprov:TT"/>\n<versionCreated>2019-07-09T09:15:33+02:00</versionCreated>\n<pubStatus qcode="stat:usable"/>\n</itemMeta>\n<groupSet root="root">\n<group id="root" role="group:main">\n<itemRef residref="http://tt.se/media/text/190709-midsommar-1003001"/>\n<groupRef idref="media"/>\n</group>\n<group id="media" role="group:package" mode="pgrmod:bag">\n<itemRef residref="http://tt.se/media/image/sdltdc7fdc8">\n<altId type="tt:associd">a001</altId>\n</itemRef>\n<itemRef residref="http://tt.se/media/image/sdltdc6f543">\n<altId type="tt:associd">a002</altId>\n</itemRef>\n</group>\n</groupSet>\n</packageItem>\n<newsItem guid="http://tt.se/media/text/190709-midsommar-1003001" version="1" standard="NewsML-G2" standardversion="2.20" conformance="power">\n<catalogRef href="http://www.iptc.org/std/catalog/catalog.IPTC-G2-Standards_24.xml"/>\n<catalogRef href="http://tt.se/spec/catalog/catalog.tt-g2.1_0.xml"/>\n<rightsInfo>\n<copyrightHolder uri="http://tt.se/copyright">\n<name>TT</name>\n</copyrightHolder>\n</rightsInfo>\n<itemMeta>\n<itemClass qcode="ninat:text"/>\n<provider qcode="nprov:TT"/>\n<versionCreated>2019-07-09T09:15:33+02:00</versionCreated>\n<pubStatus qcode="stat:usable"/>\n</itemMeta>\n<contentMeta>\n\x3c!--  urgency is defined at http://tt.se/spec/prio/1.0  --\x3e\n<urgency>4</urgency>\n<contentCreated>2019-07-09T09:15:33+02:00</contentCreated>\n<language tag="sv"/>\n<subject type="cpnat:abstract" qcode="medtop:20000005" typeuri="http://tt.se/spec/subref/1.0">\n<name>Film</name>\n</subject>\n<subject type="cpnat:abstract" qcode="medtop:01000000" typeuri="http://tt.se/spec/subref/1.0">\n<name>Konst, kultur och nöje</name>\n</subject>\n<subject type="tt:product" literal="TTNOJKUL" typeuri="http://tt.se/spec/product/1.0">\n<name>Kultur och nöje</name>\n</subject>\n<subject type="tt:product" literal="TTREC" typeuri="http://tt.se/spec/product/1.0">\n<name>Recension</name>\n</subject>\n<subject type="tt:product" literal="TWNOJ" typeuri="http://tt.se/spec/product/1.0">\n<name>Webb kultur och nöje</name>\n</subject>\n<subject type="tt:product" literal="TTNOJKUL0" typeuri="http://tt.se/spec/product/1.0">\n<name>Arkiv</name>\n</subject>\n<subject type="tt:product" literal="TTREC0" typeuri="http://tt.se/spec/product/1.0">\n<name>Arkiv</name>\n</subject>\n<subject type="tt:product" literal="TWNOJ0" typeuri="http://tt.se/spec/product/1.0">\n<name>Arkiv</name>\n</subject>\n<subject type="cpnat:person" typeuri="http://tt.se/spec/person/1.0">\n<name>Ari Aster</name>\n</subject>\n<subject type="cpnat:place" typeuri="http://tt.se/spec/place/1.0" literal="plc_sverige">\n<name>Sverige</name>\n</subject>\n<slugline>midsommar</slugline>\n<headline>Filmrecension: Mästerlig midsommarskräck</headline>\n<description role="drol:caption">\nDen svenska sommartraditionen perverteras av en hednisk sekt som vittrar blod i midnattssolen. ”Hereditary” var inte bara 2018 års bästa skräckfilm. Ari Asters långfilmsregidebut var också en av förra årets bästa filmer över huvud taget. Förväntningarna\n</description>\n<contentMetaExtProperty type="ttext:profile" literal="PUBL"/>\n<contentMetaExtProperty type="ttext:representationtype" literal="complete"/>\n<contentMetaExtProperty type="ttext:job" literal="479936"/>\n<contentMetaExtProperty type="ttext:webprio" literal="3"/>\n<contentMetaExtProperty type="ttext:charcount" literal="3083"/>\n<contentMetaExtProperty type="ttext:originaltransmissionreference" literal="1003001"/>\n<contentMetaExtProperty type="ttext:datetime" literal="2019-07-09T09:15:33+02:00"/>\n<contentMetaExtProperty type="ttext:sector" literal="KLT"/>\n<revisions xmlns="http://tt.se/spec/newsml">\n<revisionItem reluri="http://tt.se/media/text/190709-midsommar-1003001">\n<slug>midsommar</slug>\n</revisionItem>\n</revisions>\n<bylines xmlns="http://tt.se/spec/newsml">\n<bylineItem>\n<byline>Gunnar Rehlin/TT</byline>\n<firstname>Gunnar</firstname>\n<lastname>Rehlin</lastname>\n<role/>\n<email/>\n<jobtitle/>\n<phone/>\n<initials/>\n<affiliation>TT</affiliation>\n</bylineItem>\n<bylineItem>\n<byline/>\n<firstname/>\n<lastname/>\n<role>Ansvarig</role>\n<email/>\n<internal>true</internal>\n<jobtitle/>\n<phone/>\n<initials>krv</initials>\n<affiliation>TT</affiliation>\n</bylineItem>\n<bylineItem>\n<byline/>\n<firstname/>\n<lastname/>\n<role>Redigering</role>\n<email/>\n<internal>true</internal>\n<jobtitle/>\n<phone/>\n<initials>ssu</initials>\n<affiliation>TT</affiliation>\n</bylineItem>\n<bylineItem>\n<byline>Nordisk Film /TT</byline>\n<firstname>Nordisk Film</firstname>\n<lastname/>\n<role>Fotograf</role>\n<email/>\n<jobtitle/>\n<phone/>\n<initials/>\n<affiliation>TT</affiliation>\n</bylineItem>\n<bylineItem>\n<byline>Nordisk film /TT</byline>\n<firstname>Nordisk film</firstname>\n<lastname/>\n<role>Fotograf</role>\n<email/>\n<jobtitle/>\n<phone/>\n<initials/>\n<affiliation>TT</affiliation>\n</bylineItem>\n</bylines>\n</contentMeta>\n<assert literal="plc_sverige">\n<type qcode="cpnat:geoArea"/>\n<name>Sverige</name>\n<geoAreaDetails>\n<position latitude="60.128161" longitude="18.643501"/>\n</geoAreaDetails>\n</assert>\n<contentSet>\n\x3c!--  this html5 is valid XML  --\x3e\n<inlineXML contenttype="text/html">\n<html>\n<head>\n<title>Filmrecension: Mästerlig midsommarskräck</title>\n</head>\n<body>\n<article>\n<section data-charcount="2749">\n<h1>Filmrecension: Mästerlig midsommarskräck</h1>\n<div class="dat">\n<span class="vignette">Filmrecension</span>\n<span class="source">TT</span>\n</div>\n<h4>\n<p>\nDen svenska sommartraditionen perverteras av en hednisk sekt som vittrar blod i midnattssolen.\n</p>\n</h4>\n<div class="bodytext">\n<p>\n”Hereditary” var inte bara 2018 års bästa skräckfilm. Ari Asters långfilmsregidebut var också en av förra årets bästa filmer över huvud taget.\n</p>\n<p>\nFörväntningarna på uppföljaren har varit minst sagt högt ställda. Aster har i intervjuer talat om att hans målsättning var att göra en skandinavisk variant av den brittiska skräckfilmen ”The Wicker Man” (”Dödlig skörd”, 1973). Där hamnade en troende polisman på en avlägsen ö, och under sökandet efter en försvunnen flicka upptäcker han att ön befolkas av en kult som ägnar sig åt fruktbarhetsriter.\n</p>\n<p>\nI ”Midsommar” möter vi Dani (Florence Pugh), traumatiserad efter en familjetragedi. Hon följer med sin pojkvän Christian (relationen har gått i stå och han väntar på ett tillfälle att göra slut) och några av dennes vänner till Sverige för att fira midsommar. De lockas dit av kompisen Pelle (Vilhelm Blomgren), som tar med dem till den avlägsna by i Hälsingland där hans familj bor. De tillresta möts av blonda människor klädda i vitt, av leenden och gästfrihet, men blir snart varse att det bakom alla leenden finns någonting betydligt mörkare – de får tidigt en (mycket grafiskt skildrad) demonstration av begreppet ättestupa.\n</p>\n<p>\nSkräckfilmer utspelar sig ofta i mörker – nattetid är det lättare för monstren att smyga på oss, och ger filmskaparen möjlighet att komma med så kallade "jump scares". Aster är inte ute efter att få oss att hoppa högt i biostolen, ”Midsommar” utspelas till största delen i badande solljus. Liksom han gjorde i ”Hereditary” är han ute efter att bygga upp en stämning, som nästan lite subtilt kommer krypande och som skapar den där sortens obehagskänsla som är svår att skaka av sig även efter att filmen är slut.\n</p>\n<p>\n”Midsommar” känns stundtals som en psykedelisk tripp, en mardröm som de involverade inte kan ta sig ur utan där de i stället med öppna ögon och näst intill frivilligt går mot katastrofen. Aster berättar med långa, ibland nästan stillastående tagningar, att förfalla till intensivt klippande är inte hans stil. Han för in oss i sina scener med nästan omärkliga inzoomningar och ger oss möjlighet att studera och upptäcka detaljer (bara detta är en given orsak att se filmen flera gånger).\n</p>\n<p>\nHär finns den yttre berättelsen om kulten i Hälsingland, men det är också en film om skräcken över att bli lämnad ensam. Efter familjetragedin står Dani helt ensam, förhållandet med Christian är ansträngt och hon känns som en person som nu söker en ny tillvaro, en fast mark att stå på.\n</p>\n<p>\n”Midsommar” är en ny mästerlig skräckfilm av Ari Aster. Han är bara drygt 30 år gammal. Det ska bli oerhört intressant att följa hans karriär.\n</p>\n</div>\n<div class="byline">Gunnar Rehlin/TT</div>\n<figure>\n<img src="https://beta.tt.se/media/text/190709-midsommar-1003001/a001_NormalThumbnail.jpg" alt="Skräckfilmen \'Midsommar\' följer en hednisk sekt i Hälsingland. Pressbild. " data-assoc-ref="a001" data-uri="http://tt.se/media/image/sdltdc7fdc8" data-preview-src="https://beta.tt.se/media/text/190709-midsommar-1003001/a001_NormalPreview.jpg"/>\n<div class="byline">Nordisk Film</div>\n<figcaption>\nSkräckfilmen "Midsommar" följer en hednisk sekt i Hälsingland. Pressbild.\n</figcaption>\n</figure>\n<figure>\n<img src="https://beta.tt.se/media/text/190709-midsommar-1003001/a002_NormalThumbnail.jpg" alt="Christian (Jack Reynor) och hans flickvän Dani (Florence Pugh) håller på att tappa gnistan i sitt förhållande, något som ställs på sin spets när de besöker Sverige och träffar en särskilt brutal midsommar-sekt. Pressbild. " data-assoc-ref="a002" data-uri="http://tt.se/media/image/sdltdc6f543" data-preview-src="https://beta.tt.se/media/text/190709-midsommar-1003001/a002_NormalPreview.jpg"/>\n<div class="byline">Nordisk film</div>\n<figcaption>\nChristian (Jack Reynor) och hans flickvän Dani (Florence Pugh) håller på att tappa gnistan i sitt förhållande, något som ställs på sin spets när de besöker Sverige och träffar en särskilt brutal midsommar-sekt. Pressbild.\n</figcaption>\n</figure>\n</section>\n<aside class="facts" data-charcount="334">\n<h1>Fakta: Midsommar</h1>\n<div class="bodytext">\n<p>Originaltitel: Midsommar</p>\n<p>Genre: Skräckfilm</p>\n<p>Regi: Ari Aster</p>\n<p>\nSkådespelare: Florence Pugh, Jack Reynor, William Jackson Harper, Vilhelm Blomgren, Will Poulter, Liv Mjönes, Anna Åström, Julia Ragnarsson, Isabelle Grill, Louise Peterhoff, Björn Andrésen, Gunnel Fred, Anki Larsson.\n</p>\n<p>Längd: 140 minuter</p>\n<p>Åldersgräns: 15 år</p>\n<p>Betyg: 5</p>\n</div>\n</aside>\n</article>\n</body>\n</html>\n</inlineXML>\n</contentSet>\n</newsItem>\n<newsItem guid="http://tt.se/media/image/sdltdc7fdc8" version="1" standard="NewsML-G2" standardversion="2.20" conformance="power">\n<catalogRef href="http://www.iptc.org/std/catalog/catalog.IPTC-G2-Standards_24.xml"/>\n<catalogRef href="http://tt.se/spec/catalog/catalog.tt-g2.1_0.xml"/>\n<itemMeta>\n<itemClass qcode="ninat:picture"/>\n<provider qcode="nprov:TT"/>\n\x3c!--\nThis <versionCreated> is faked to make the XML validate. It does not reflect the creation time of this <newsItem>. \n--\x3e\n<versionCreated>2019-07-09T09:15:33+02:00</versionCreated>\n</itemMeta>\n<contentMeta>\n<description role="drol:caption">\nSkräckfilmen "Midsommar" följer en hednisk sekt i Hälsingland. Pressbild.\n</description>\n<contentMetaExtProperty type="ttext:representationtype" literal="incomplete"/>\n</contentMeta>\n<contentSet>\n<remoteContent href="https://beta.tt.se/media/text/190709-midsommar-1003001/a001_NormalHires.jpg" contenttype="image/jpeg" rendition="rnd:highRes" size="3524373" width="6000" height="4000">\n<remoteContentExtProperty type="ttrend:variant" literal="Normal"/>\n<remoteContentExtProperty type="ttrend:usage" literal="Hires"/>\n</remoteContent>\n<remoteContent href="https://beta.tt.se/media/text/190709-midsommar-1003001/a001_NormalPreview.jpg" contenttype="image/jpeg" rendition="rnd:preview" size="257745" width="1024" height="683">\n<remoteContentExtProperty type="ttrend:variant" literal="Normal"/>\n<remoteContentExtProperty type="ttrend:usage" literal="Preview"/>\n</remoteContent>\n<remoteContent href="https://beta.tt.se/media/text/190709-midsommar-1003001/a001_WatermarkPreview.jpg" contenttype="image/jpeg" width="1024" height="683">\n<remoteContentExtProperty type="ttrend:variant" literal="Watermark"/>\n<remoteContentExtProperty type="ttrend:usage" literal="Preview"/>\n</remoteContent>\n<remoteContent href="https://beta.tt.se/media/text/190709-midsommar-1003001/a001_NormalThumbnail.jpg" contenttype="image/jpeg" rendition="rnd:thumbnail" size="29730" width="256" height="171">\n<remoteContentExtProperty type="ttrend:variant" literal="Normal"/>\n<remoteContentExtProperty type="ttrend:usage" literal="Thumbnail"/>\n</remoteContent>\n</contentSet>\n</newsItem>\n<newsItem guid="http://tt.se/media/image/sdltdc6f543" version="1" standard="NewsML-G2" standardversion="2.20" conformance="power">\n<catalogRef href="http://www.iptc.org/std/catalog/catalog.IPTC-G2-Standards_24.xml"/>\n<catalogRef href="http://tt.se/spec/catalog/catalog.tt-g2.1_0.xml"/>\n<itemMeta>\n<itemClass qcode="ninat:picture"/>\n<provider qcode="nprov:TT"/>\n\x3c!--\nThis <versionCreated> is faked to make the XML validate. It does not reflect the creation time of this <newsItem>. \n--\x3e\n<versionCreated>2019-07-09T09:15:33+02:00</versionCreated>\n</itemMeta>\n<contentMeta>\n<description role="drol:caption">\nChristian (Jack Reynor) och hans flickvän Dani (Florence Pugh) håller på att tappa gnistan i sitt förhållande, något som ställs på sin spets när de besöker Sverige och träffar en särskilt brutal midsommar-sekt. Pressbild.\n</description>\n<contentMetaExtProperty type="ttext:representationtype" literal="incomplete"/>\n</contentMeta>\n<contentSet>\n<remoteContent href="https://beta.tt.se/media/text/190709-midsommar-1003001/a002_NormalHires.jpg" contenttype="image/jpeg" rendition="rnd:highRes" size="579683" width="2580" height="1720">\n<remoteContentExtProperty type="ttrend:variant" literal="Normal"/>\n<remoteContentExtProperty type="ttrend:usage" literal="Hires"/>\n</remoteContent>\n<remoteContent href="https://beta.tt.se/media/text/190709-midsommar-1003001/a002_NormalPreview.jpg" contenttype="image/jpeg" rendition="rnd:preview" size="195469" width="1024" height="683">\n<remoteContentExtProperty type="ttrend:variant" literal="Normal"/>\n<remoteContentExtProperty type="ttrend:usage" literal="Preview"/>\n</remoteContent>\n<remoteContent href="https://beta.tt.se/media/text/190709-midsommar-1003001/a002_WatermarkPreview.jpg" contenttype="image/jpeg" width="1024" height="683">\n<remoteContentExtProperty type="ttrend:variant" literal="Watermark"/>\n<remoteContentExtProperty type="ttrend:usage" literal="Preview"/>\n</remoteContent>\n<remoteContent href="https://beta.tt.se/media/text/190709-midsommar-1003001/a002_NormalThumbnail.jpg" contenttype="image/jpeg" rendition="rnd:thumbnail" size="23128" width="256" height="171">\n<remoteContentExtProperty type="ttrend:variant" literal="Normal"/>\n<remoteContentExtProperty type="ttrend:usage" literal="Thumbnail"/>\n</remoteContent>\n</contentSet>\n</newsItem>\n</itemSet>\n</newsMessage>',
  Zm = function (e) {
    return {
      INR: {
        text: "Inrikes",
        color: "#417505"
      },
      UTR: {
        text: "Utrikes",
        color: "#ff5252"
      },
      SPT: {
        text: "Sport",
        color: "#2e3b8c"
      },
      EKO: {
        text: "Ekonomi",
        color: "#661414"
      },
      KLT: {
        text: "Kultur & nöje",
        color: "#fb8c00"
      },
      PRM: {
        text: "Pressmeddelande",
        color: "#4f4f4f"
      },
      undefined: {
        text: "",
        color: "#fff"
      }
    };
  },
  qm = "searchresult_searchResult__1L5O-",
  Jm = "searchresult_headline__2miyf",
  Qm = "searchresult_compact__1Jz6u",
  $m = "searchresult_bodyText__1RdwI",
  ef = "searchresult_footer__1SUEZ",
  tf = "searchresult_timeAndSector__3Mqe9",
  nf = "searchresult_footerDivider__18A-u",
  rf = "searchresult_textResult__3Wm4X",
  af = "searchresult_image__1YnrO",
  of = "searchresult_prio1__3dfs8",
  sf = "searchresult_prio2__2576M",
  lf = "searchresult_prio3__SjCOw",
  cf = "searchresult_eventResult__3g6Em",
  df = "searchresult_month__2jrcv",
  uf = "searchresult_planningResult__3dHvV",
  pf = "searchresult_date__18HyX",
  mf = "searchresult_selected__3n61l",
  ff = "searchresult_canceled__1bLn5";
y(".searchresult_searchResult__1L5O- {\n  cursor: pointer;\n  font-family: Roboto;\n  color: #222222;\n  border-bottom: solid 1px rgba(0, 0, 0, 0.16); }\n  .searchresult_searchResult__1L5O- .searchresult_headline__2miyf {\n    font-size: 20px;\n    font-weight: 500;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: 0.25px;\n    margin-bottom: 7px; }\n  .searchresult_searchResult__1L5O- .searchresult_headline__2miyf.searchresult_compact__1Jz6u {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden; }\n  .searchresult_searchResult__1L5O- .searchresult_bodyText__1RdwI {\n    font-size: 14px;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.64;\n    letter-spacing: 0.18px;\n    margin-bottom: 9px;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden; }\n  .searchresult_searchResult__1L5O- .searchresult_footer__1SUEZ {\n    font-size: 12px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: 0.15px;\n    color: #737373;\n    margin-bottom: 8px; }\n    .searchresult_searchResult__1L5O- .searchresult_footer__1SUEZ .searchresult_timeAndSector__3Mqe9 {\n      text-transform: uppercase; }\n    .searchresult_searchResult__1L5O- .searchresult_footer__1SUEZ .searchresult_footerDivider__18A-u {\n      margin: 0 5px; }\n  .searchresult_searchResult__1L5O- .searchresult_textResult__3Wm4X .searchresult_image__1YnrO {\n    min-height: 108px;\n    max-height: 108px;\n    min-width: 108px;\n    max-width: 108px;\n    height: 108px;\n    width: 108px;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #efefef; }\n  .searchresult_searchResult__1L5O- .searchresult_textResult__3Wm4X .searchresult_prio1__3dfs8 {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 10px;\n    width: 10px;\n    border: solid 3px #fff;\n    border-radius: 50%;\n    background: #C62828; }\n  .searchresult_searchResult__1L5O- .searchresult_textResult__3Wm4X .searchresult_prio2__2576M {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 10px;\n    width: 10px;\n    border: solid 3px #fff;\n    border-radius: 50%;\n    background: #FFB74D; }\n  .searchresult_searchResult__1L5O- .searchresult_textResult__3Wm4X .searchresult_prio3__SjCOw {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 10px;\n    width: 10px;\n    border: solid 3px #fff;\n    border-radius: 50%;\n    background: #ffed00; }\n  .searchresult_searchResult__1L5O- .searchresult_eventResult__3g6Em .searchresult_day__2zf2F, .searchresult_searchResult__1L5O- .searchresult_eventResult__3g6Em .searchresult_month__2jrcv, .searchresult_searchResult__1L5O- .searchresult_planningResult__3dHvV .searchresult_day__2zf2F, .searchresult_searchResult__1L5O- .searchresult_planningResult__3dHvV .searchresult_month__2jrcv {\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.36;\n    letter-spacing: normal; }\n  .searchresult_searchResult__1L5O- .searchresult_eventResult__3g6Em .searchresult_date__18HyX, .searchresult_searchResult__1L5O- .searchresult_planningResult__3dHvV .searchresult_date__18HyX {\n    font-size: 20px;\n    font-weight: 500;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: 0.25px; }\n  .searchresult_searchResult__1L5O- .searchresult_eventResult__3g6Em .searchresult_timeAndSector__3Mqe9, .searchresult_searchResult__1L5O- .searchresult_planningResult__3dHvV .searchresult_timeAndSector__3Mqe9 {\n    color: #222;\n    font-weight: bold; }\n\n.searchresult_searchResult__1L5O-.searchresult_selected__3n61l {\n  background: #e6e9ff; }\n\n.searchresult_eventResult__3g6Em.searchresult_canceled__1bLn5 {\n  text-decoration: line-through; }\n");
var gf = function (t) {
    var n = t.src;
    return e.createElement("div", {
      className: af
    }, e.createElement("img", {
      src: n,
      alt: ""
    }));
  },
  _f = function (t) {
    var n = t.ttninjs,
      r = t.compact,
      i = n.headline,
      a = n.description_text,
      o = n.datetime,
      s = n.sector,
      l = n.slug,
      c = n.slugline,
      d = n.associations,
      u = n.webprio,
      p = n.copyrightholder,
      m = n.urgency,
      f = new Date(o),
      g = "".concat({
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[s] ? {
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[s].text : s);
    return e.createElement("div", {
      className: rf
    }, e.createElement(Qt, {
      padding: "0px"
    }, e.createElement(en, {
      cols: r ? 12 : 10,
      style: r ? null : {
        paddingRight: "40px"
      }
    }, "PRM" === s && e.createElement(Ap, {
      type: "PRM",
      text: "Pressmeddelande från ".concat(p)
    }), 1 === m && e.createElement(Ap, {
      type: "flash",
      text: "TT-FLASH"
    }), e.createElement("div", {
      className: "".concat(Jm, " ").concat(r ? Qm : "")
    }, i), !r && e.createElement("div", {
      className: $m
    }, a), e.createElement("div", {
      className: ef
    }, e.createElement("span", {
      className: tf
    }, Lu(f) ? "".concat(function (e, t, n, r) {
      return "".concat(Ou(e, "HH:mm", {
        locale: ep
      }), " • ").concat(n(r)[t] ? "".concat(n(r)[t].text) : "".concat(t));
    }(f, s, Zm)) : "".concat(function (e) {
      var t;
      try {
        t = Ou(e, "dd MMM yyyy - HH:mm", {
          locale: ep
        });
      } catch (n) {
        console.error("Kunde inte formatera tid:", e), t = e;
      }
      return t;
    }(f), " • ").concat(g)), e.createElement("span", null, " • ".concat(c || l)))), !r && e.createElement(en, {
      cols: 2,
      alignX: "right"
    }, d ? e.createElement(gf, {
      src: function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = e[Object.keys(e)[0]],
          n = t && t.renditions ? t.renditions : {},
          r = Object.keys(n).filter(function (e) {
            return "Normal" === n[e].variant && "Thumbnail" === n[e].usage;
          }),
          i = n[r];
        return i ? i.href : null;
      }(d)
    }) : "PRM" !== s ? e.createElement(Wc, null) : e.createElement("div", null), e.createElement("div", {
      className: function () {
        switch (u) {
          case 1:
            return of;
          case 2:
            return sf;
          case 3:
            return lf;
        }
      }()
    }))));
  },
  yf = function (e) {
    switch (e) {
      case "insert_photo":
        return "#CCBE00";
      case "photo_camera":
        return "#e65100";
      case "library_books":
        return "#7e90ff";
      case "play_circle_outline":
        return "#6bad22";
      case "video_library":
        return "#49230E";
      default:
        return "#222222";
    }
  },
  hf = {
    picture: "photo_camera",
    video: "play_circle_outline",
    text: "library_books",
    graphic: "insert_photo",
    composite: "video_library"
  },
  vf = function (t) {
    var n = t.ttninjs,
      r = t.compact,
      i = n.date,
      a = n.sector,
      o = n.headline,
      s = n.description_text,
      l = n.slugline,
      c = n.assignments,
      d = void 0 === c ? {} : c,
      u = n.urgency,
      p = new Date(i),
      m = Ou(p, "dd", {
        locale: ep
      }),
      f = Ou(p, "MMM", {
        locale: ep
      }),
      g = "".concat({
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[a] ? {
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[a].text : a),
      _ = {
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[a] ? {
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[a].color : "#737373",
      y = Ci(new Set(Object.values(d).map(function (e) {
        return e.type;
      })));
    return e.createElement("div", {
      className: uf
    }, e.createElement(Qt, {
      padding: "0px"
    }, e.createElement(en, {
      cols: 1
    }, e.createElement("div", {
      className: pf
    }, m), e.createElement("div", {
      className: df
    }, f)), e.createElement(en, {
      cols: 8
    }, e.createElement("div", {
      className: "".concat(Jm, " ").concat(r ? Qm : "")
    }, o), !r && e.createElement("div", {
      className: $m
    }, s), e.createElement("div", {
      className: ef
    }, e.createElement("div", null, e.createElement("span", {
      className: tf,
      style: {
        color: _
      }
    }, g), e.createElement("span", null, l && " • ".concat(l))))), e.createElement(en, {
      cols: 3
    }, e.createElement(K, {
      direction: "row"
    }, e.createElement(Ap, {
      text: "Prio ".concat(u),
      color: "#e6e6e6",
      style: {
        textAlign: "center",
        marginRight: 10
      }
    }), y.map(function (t, n) {
      return e.createElement(nd, {
        key: "icon-".concat(n),
        icon: hf[t],
        color: yf(hf[t]),
        size: "small",
        style: {
          marginRight: "10px"
        }
      });
    })))));
  },
  bf = function (t) {
    var n = t.ttninjs,
      r = t.compact,
      i = n.datetime,
      a = n.date,
      o = n.sector,
      s = n.headline,
      l = n.description_text,
      c = n.subject,
      d = "4" === n.body_event.eventstatus,
      u = i ? new Date(i) : new Date(a),
      p = Ou(u, "dd", {
        locale: ep
      }),
      m = Ou(u, "MMM", {
        locale: ep
      }),
      f = "".concat({
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[o] ? {
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[o].text : o),
      g = {
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[o] ? {
        INR: {
          text: "Inrikes",
          color: "#417505"
        },
        UTR: {
          text: "Utrikes",
          color: "#ff5252"
        },
        SPT: {
          text: "Sport",
          color: "#2e3b8c"
        },
        EKO: {
          text: "Ekonomi",
          color: "#661414"
        },
        KLT: {
          text: "Kultur & nöje",
          color: "#fb8c00"
        },
        PRM: {
          text: "Pressmeddelande",
          color: "#4f4f4f"
        },
        undefined: {
          text: "",
          color: "#fff"
        }
      }[o].color : "#737373";
    return e.createElement("div", {
      className: "".concat(cf, " ").concat(d ? ff : "")
    }, e.createElement(Qt, {
      padding: "0px"
    }, e.createElement(en, {
      cols: 1
    }, e.createElement("div", {
      className: pf
    }, p), e.createElement("div", {
      className: df
    }, m)), e.createElement(en, {
      cols: 11
    }, d && e.createElement(Ap, {
      text: "INSTÄLLT",
      color: "#c62828"
    }), e.createElement("div", {
      className: "".concat(Jm, " ").concat(r ? Qm : "")
    }, s), !r && e.createElement("div", {
      className: $m
    }, l), e.createElement("div", {
      className: ef
    }, e.createElement("span", {
      className: tf
    }, "".concat(i ? "".concat(Ou(u, "HH:mm", {
      locale: ep
    }), " • ") : "")), e.createElement("span", {
      className: tf,
      style: {
        color: g
      }
    }, f), e.createElement("span", {
      className: nf
    }, "|"), c.length && e.createElement("span", null, Ci(new Set(c.map(function (e) {
      return e.name;
    }))).join(" • "))))));
  },
  xf = function (t) {
    switch (t.ttninjs.type) {
      case "text":
        return e.createElement(_f, t);
      case "planning":
        return e.createElement(vf, t);
      case "event":
        return e.createElement(bf, t);
      default:
        return e.createElement(_f, t);
    }
  },
  Ef = function (e, t) {
    return e.selected === t.selected && e.compact === t.compact;
  },
  kf = e.memo(function (t) {
    var r = t.selected,
      i = t.handleSelect,
      a = c();
    return n(function () {
      r && a.current.scrollIntoView({
        block: "nearest"
      });
    }, [r]), e.createElement("div", {
      ref: a,
      className: "".concat(qm, " ").concat(r ? mf : ""),
      onClick: i
    }, e.createElement(Bl, {
      stretch: !0,
      padding: "20px 20px 22px 20px"
    }, e.createElement(xf, t)));
  }, Ef),
  Tf = [[{
    hex: "#E6E9FF",
    name: "Indigo, Lighter"
  }, {
    hex: "#7E90FF",
    name: "Indigo, Light"
  }, {
    hex: "#3F51BF",
    name: "Indigo, Primary"
  }, {
    hex: "#2E3B8C",
    name: "Indigo, Dark"
  }, {
    hex: "#1D2559",
    name: "Indigo, Darker"
  }, {
    hex: "#31333B",
    name: "Indigo, Text"
  }], [{
    hex: "#E8F2F8",
    name: "Steal, Lighter"
  }, {
    hex: "#7FA5B8",
    name: "Steal, Light"
  }, {
    hex: "#607D8B",
    name: "Steal"
  }, {
    hex: "#4C565C",
    name: "Steal Dark, Primary"
  }, {
    hex: "#222629",
    name: "Steal, Darker"
  }, {
    hex: "#222629",
    name: "Steal, Text"
  }], [{
    hex: "#DAE6E1",
    name: "Green, Lighter"
  }, {
    hex: "#95C7B4",
    name: "Green, Light"
  }, {
    hex: "#5B8C79",
    name: "Green, Primary"
  }, {
    hex: "#3A594D",
    name: "Green, Dark"
  }, {
    hex: "#263B33",
    name: "Green, Darker"
  }, {
    hex: "#293430",
    name: "Green, Text"
  }], [{
    hex: "#EEFFDA",
    name: "Okgreen, Lighter"
  }, {
    hex: "#CCEDA7",
    name: "Okgreen, Light"
  }, {
    hex: "#6BAD22",
    name: "Okgreen"
  }, {
    hex: "#417505",
    name: "Okgreen, Dark"
  }, {
    hex: "#203B02",
    name: "Okgreen, Darker"
  }, {
    hex: "#202618",
    name: "Okgreen, Text"
  }], [{
    hex: "#FFFCE6",
    name: "Yellow, Lighter"
  }, {
    hex: "#FFF9C1",
    name: "Yellow, Light"
  }, {
    hex: "#FFED00",
    name: "Yellow, Primary"
  }, {
    hex: "#CCBE00",
    name: "Yellow, Dark"
  }, {
    hex: "#4D4700",
    name: "Yellow, Darker"
  }, {
    hex: "#302F21",
    name: "Yellow, Text"
  }], [{
    hex: "#FFE0B2",
    name: "Orange, Lighter"
  }, {
    hex: "#FFB74D",
    name: "Orange, Light"
  }, {
    hex: "#FB8C00",
    name: "Orange"
  }, {
    hex: "#E65100",
    name: "Orange Dark, Primary"
  }, {
    hex: "#A63A00",
    name: "Orange, Darker"
  }, {
    hex: "#49230E",
    name: "Orange, Text"
  }], [{
    hex: "#FFF0F0",
    name: "Red, Lighter"
  }, {
    hex: "#EF9A9A",
    name: "Red, Light"
  }, {
    hex: "#FF5252",
    name: "Red, Primary"
  }, {
    hex: "#C62828",
    name: "Red, Dark"
  }, {
    hex: "#661414",
    name: "Red, Darker"
  }, {
    hex: "#471414",
    name: "Red, Text"
  }], [{
    hex: "#181818",
    name: "Black, Brand"
  }], [{
    hex: "#F1F1F1",
    name: "Sky, Lighter"
  }, {
    hex: "#F8F8F8",
    name: "Sky, Light"
  }, {
    hex: "#E8E8E8",
    name: "Sky"
  }, {
    hex: "#9E9E9E",
    name: "Sky, Dark"
  }], [{
    hex: "rgba(0,0,0,.55)",
    name: "Ink, Lighter"
  }, {
    hex: "rgba(0,0,0,.75)",
    name: "Ink, Light"
  }, {
    hex: "rgba(0,0,0,.87)",
    name: "Ink"
  }]],
  wf = function (t) {
    var n = t.onChange;
    return e.createElement(K, {
      direction: "row"
    }, Tf.map(function (t, r) {
      return e.createElement(K, {
        key: r,
        style: {
          marginRight: 20,
          marginBottom: 20
        },
        direction: "column"
      }, t.map(function (t, r) {
        return e.createElement("div", {
          key: r,
          onClick: function (e) {
            return n(t.hex);
          }
        }, n ? e.createElement(K, {
          align: "center",
          direction: "row"
        }, e.createElement("div", {
          style: {
            background: t.hex,
            height: 30,
            width: 30,
            margin: 4,
            borderRadius: 3
          }
        }), e.createElement("div", null, t.name)) : e.createElement(tc, {
          trigger: e.createElement(K, {
            align: "center",
            direction: "row"
          }, e.createElement("div", {
            style: {
              background: t.hex,
              height: 30,
              width: 30,
              margin: 4,
              borderRadius: 3
            }
          }), e.createElement("div", null, t.name)),
          content: e.createElement("div", {
            style: {
              padding: 20
            }
          }, t.hex),
          position: "bottom"
        }));
      }));
    }));
  },
  Af = "fonts_headingXL__3e3yZ",
  Cf = "fonts_headingLarge__B3UE1",
  Sf = "fonts_headingMedium__2Rnjt",
  Nf = "fonts_heading__3Kg_G",
  Of = "fonts_subheading__2q94i",
  Rf = "fonts_body2__335gR",
  If = "fonts_body1__3azUu",
  Lf = "fonts_caption__3t8e1",
  jf = "fonts_subheadingLabel__nnzEo";
y('/*\n    - Fonts\n    - Sizes\n    - Weights\n    - Line Heights\n    - Brand Colors\n    - Colors\n    - Space\n    General Classes\n      - Headings\n*/\n/* ---- Fonts ---- */\n@import url("https://fonts.googleapis.com/css?family=Montserrat");\n@import url("https://fonts.googleapis.com/css?family=Roboto");\n/* ---- Sizes ---- */\n/* ---- Sizes Phones ---- */\n/* ---- Weights ---- */\n/* ---- Line Heights ---- */\n/* ---- Spacing ---- */\n/* ---- Brand Colors ---- */\n/* ---- Colors ---- */\n/* ---- General Classes ---- */\nth, td {\n  padding: 10px;\n  border: none;\n  margin: 0;\n  border-bottom: solid 1px #D8D8D8; }\n\n.fonts_headingXL__3e3yZ {\n  font-family: "Montserrat", sans-serif;\n  font-size: 72px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 93px; }\n\n.fonts_headingLarge__B3UE1 {\n  font-family: "Montserrat", sans-serif;\n  font-size: 42px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 52px; }\n\n.fonts_headingMedium__2Rnjt {\n  font-family: "Roboto", sans-serif;\n  font-size: 28px;\n  font-weight: 600;\n  color: #222;\n  line-height: 36px; }\n\n.fonts_heading__3Kg_G {\n  font-family: "Roboto", sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 27px; }\n\n.fonts_subheading__2q94i {\n  font-family: "Roboto", sans-serif;\n  font-size: 20px;\n  font-weight: 400;\n  color: #181818;\n  line-height: 27px; }\n\n.fonts_body2__335gR {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px; }\n\n.fonts_body1__3azUu {\n  font-family: "Roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 24px; }\n\n.fonts_caption__3t8e1 {\n  font-family: "Roboto", sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 18px; }\n\n.fonts_subheadingLabel__nnzEo {\n  font-family: "Roboto", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.55);\n  text-transform: uppercase;\n  line-height: 18px; }\n');
var Df = function () {
    return e.createElement("div", null, e.createElement("h3", null, "Desktop"), e.createElement("table", null, e.createElement("thead", null, e.createElement("tr", null, e.createElement("th", null, " "), e.createElement("th", null, "Font"), e.createElement("th", null, "Weight"), e.createElement("th", null, "Size"), e.createElement("th", null, "Line"), e.createElement("th", null, "Character"))), e.createElement("tbody", null, e.createElement("tr", null, e.createElement("td", {
      className: Af
    }, "HeadingXL"), e.createElement("td", null, "Montserrat"), e.createElement("td", null, "SemiBold"), e.createElement("td", null, "76pt"), e.createElement("td", null, "93"), e.createElement("td", null, "-")), e.createElement("tr", null, e.createElement("td", {
      className: Cf
    }, "HeadingLarge"), e.createElement("td", null, "Montserrat"), e.createElement("td", null, "SemiBold"), e.createElement("td", null, "42pt"), e.createElement("td", null, "52"), e.createElement("td", null, "-")), e.createElement("tr", null, e.createElement("td", {
      className: Sf
    }, "HeadingMedium"), e.createElement("td", null, "Montserrat"), e.createElement("td", null, "SemiBold"), e.createElement("td", null, "28pt"), e.createElement("td", null, "36"), e.createElement("td", null, "-")), e.createElement("tr", null, e.createElement("td", {
      className: Nf
    }, "Heading"), e.createElement("td", null, "Roboto"), e.createElement("td", null, "SemiBold"), e.createElement("td", null, "20pt"), e.createElement("td", null, "27"), e.createElement("td", null, "-")), e.createElement("tr", null, e.createElement("td", {
      className: Of
    }, "Subheading"), e.createElement("td", null, "Roboto"), e.createElement("td", null, "Regular"), e.createElement("td", null, "20pt"), e.createElement("td", null, "27"), e.createElement("td", null, "0,2")), e.createElement("tr", null, e.createElement("td", {
      className: Rf
    }, "Body 2"), e.createElement("td", null, "Roboto"), e.createElement("td", null, "Medium"), e.createElement("td", null, "16pt"), e.createElement("td", null, "24"), e.createElement("td", null, "0,2")), e.createElement("tr", null, e.createElement("td", {
      className: If
    }, "Body 1"), e.createElement("td", null, "Roboto"), e.createElement("td", null, "Regular"), e.createElement("td", null, "16pt"), e.createElement("td", null, "24"), e.createElement("td", null, "-")), e.createElement("tr", null, e.createElement("td", {
      className: Lf
    }, "Caption"), e.createElement("td", null, "Roboto"), e.createElement("td", null, "Regular"), e.createElement("td", null, "12pt"), e.createElement("td", null, "18"), e.createElement("td", null, "-")), e.createElement("tr", null, e.createElement("td", {
      className: jf
    }, "Subheading label"), e.createElement("td", null, "Roboto"), e.createElement("td", null, "Regular"), e.createElement("td", null, "13pt"), e.createElement("td", null, "18"), e.createElement("td", null, "-")))));
  },
  Ff = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = e,
      n = function (e) {
        return e.fields ? Object.assign({}, e.fields) : e;
      },
      r = function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        return t.map(function (t) {
          var r = n(t),
            i = n(t);
          for (var a in r) Array.isArray(i[a]) && (i[a] = e(i[a]));
          return i;
        });
      },
      i = r(t);
    return i;
  };
export { Al as Article, Ys as Avatar, Ap as Badge, en as Box, Fn as Breadcrumb, wd as Button, Bc as CMSData, vp as Card, Ks as Chip, Bs as Clipboard, wf as Colors, gc as Dashboard, Xp as Datepicker, Dp as Dropdown, $s as Expandable, Is as FieldArray, ll as Filter, cl as FilterBlock, fl as FilterDate, ml as FilterList, dl as FilterRadioList, _l as FilterViewer, Df as Fonts, R as Footer, js as Form, Hc as FormData, Qt as Grid, C as Header, fd as Hero, Wl as Hover, nd as Icon, Jc as Leaflet, K as List, Wc as Logo, dn as Menu, yn as Message, jc as Modal, mn as Notice, zm as ObjectView, Tl as Picture, tc as PopOver, Dc as ProfileData, zc as Props, Vl as Responsive, H as Root, Op as Search, kf as SearchResult, Ql as Sidebar, Nn as SiteMenu, id as Spinner, Fc as TTninjsData, W as Table, Il as Tabs, sp as TextCard, xl as Toast, $p as Toggle, Ic as Tour, Bl as Zone, Ff as contentCleaner, Ym as footer, Km as newsmlText, Vm as siteMap, Xm as ttninjsEvent, Wm as ttninjsPicture, Gm as ttninjsPlanning, Um as ttninjsText };